import { mobileAtom } from "../stores/layout";
import clsx from "clsx";
import { useAtomValue } from "jotai";

const IconBox = ({ isActive = false, useAnimation = false }) => {
  const isMobile = useAtomValue(mobileAtom);
  const showAnimation = isActive && useAnimation;

  if (isMobile) {
    return (
      <svg
        className="section_bg"
        xmlns="http://www.w3.org/2000/svg"
        id="_레이어_1"
        version="1.1"
        viewBox="0 0 360 640"
      >
        <defs>
          <style>
            {`.st0 {
        fill: none !important;
      }

      .st1 {
        fill: #3a32f5;
      }

      .st2 {
        fill: #040000;
      }

      .st3 {
        fill: #221714;
      }`}
          </style>
        </defs>
        <g
          className={clsx({
            animation_left: showAnimation,
            complete: !showAnimation,
          })}
        >
          <g>
            <path
              className="st3"
              d="M1.94,50.48c.61,0,1.16.11,1.65.34s.9.54,1.23.93c.34.39.59.84.77,1.36s.27,1.07.27,1.65-.09,1.14-.27,1.66-.44.98-.77,1.36-.75.7-1.23.92c-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34-.9-.53-1.23-.92-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65.44-.97.77-1.36c.34-.39.75-.7,1.23-.93s1.03-.34,1.65-.34ZM1.94,51.65c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1s-.14.76-.14,1.15.05.77.14,1.15c.1.37.24.71.44,1s.46.53.77.71c.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1,.1-.37.14-.76.14-1.15s-.05-.77-.14-1.15-.24-.71-.44-1c-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
            />
            <path
              className="st3"
              d="M6.25,50.68h1.49l2.05,6.48h.02l2.1-6.48h1.46l-2.8,8.19h-1.59s-2.73-8.19-2.73-8.19Z"
            />
            <path
              className="st3"
              d="M14.18,50.68h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
            />
            <path
              className="st3"
              d="M21.35,50.68h1.51l3.74,6.03h.02v-6.03h1.36v8.19h-1.51l-3.73-6.02h-.03v6.02h-1.36v-8.19Z"
            />
            <path
              className="st3"
              d="M33.82,56.14c0,.31.05.58.16.8.11.22.26.4.45.54.19.14.41.24.66.31s.52.1.81.1c.31,0,.58-.04.8-.11.22-.07.4-.17.54-.28s.24-.25.3-.4c.06-.15.09-.3.09-.45,0-.31-.07-.54-.21-.69-.14-.15-.3-.25-.46-.32-.29-.11-.63-.21-1.01-.3-.39-.1-.86-.22-1.43-.37-.35-.09-.64-.21-.88-.36-.23-.15-.42-.32-.56-.5-.14-.18-.24-.38-.29-.58-.06-.21-.09-.42-.09-.63,0-.41.09-.77.26-1.07s.4-.55.68-.75.6-.35.96-.44c.36-.1.72-.14,1.09-.14.43,0,.83.06,1.21.17.38.11.71.28,1,.5s.51.5.68.82c.17.33.25.7.25,1.13h-1.43c-.04-.53-.22-.9-.54-1.12-.32-.22-.73-.33-1.23-.33-.17,0-.34.02-.52.05s-.34.09-.48.17c-.15.08-.27.19-.36.33s-.14.31-.14.52c0,.29.09.52.27.68s.41.29.71.37c.03,0,.15.04.36.1.21.06.45.12.71.19s.51.14.76.2c.25.07.43.11.53.14.27.08.5.2.7.34.2.15.37.31.5.5s.23.39.3.6c.06.21.1.43.1.64,0,.46-.09.85-.28,1.18s-.43.59-.74.8-.65.36-1.04.45c-.39.1-.79.14-1.19.14-.47,0-.91-.06-1.32-.17-.41-.11-.77-.29-1.08-.53-.31-.24-.55-.54-.73-.91s-.28-.81-.29-1.31h1.43,0Z"
            />
            <path
              className="st3"
              d="M42.5,50.68h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19h.01ZM41.99,55.61h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
            />
            <path
              className="st3"
              d="M47.96,50.68h5.65v1.24h-4.22v2.14h3.7v1.17h-3.7v3.64h-1.43v-8.19Z"
            />
            <path
              className="st3"
              d="M54.76,50.68h5.89v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19h0Z"
            />
            <polygon
              className="st1"
              points="53.9 16.42 51.69 16.42 51.69 -19.16 5.39 -19.16 5.39 -21.36 53.9 -21.36 53.9 16.42"
            />
            <polygon
              className="st3"
              points="53.24 21.56 4.73 21.56 4.73 -16.07 6.93 -16.07 6.93 19.35 53.24 19.35 53.24 21.56"
            />
            <path
              className="st3"
              d="M47.04,13.97H11.59V-6.52h35.46V13.97h0ZM13.79,11.77h31.04V-4.31H13.79V11.77Z"
            />
            <rect
              className="st0"
              x="-7.98"
              y="-38.5"
              width="74.6"
              height="74.6"
            />
          </g>
          <g>
            <path
              className="st3"
              d="M130.91,50.68h2.02l2.26,6.41h.02l2.2-6.41h2v8.19h-1.36v-6.32h-.02l-2.27,6.32h-1.18l-2.27-6.32h-.02v6.32h-1.36v-8.19h-.02Z"
            />
            <path className="st3" d="M141.13,50.68h1.43v8.19h-1.43v-8.19Z" />
            <path
              className="st3"
              d="M149.84,53.28c-.06-.24-.15-.45-.25-.65-.11-.2-.24-.37-.41-.52s-.37-.26-.59-.34c-.23-.08-.49-.12-.79-.12-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1s-.14.76-.14,1.15.05.77.14,1.15c.1.37.24.71.44,1s.46.53.77.71c.32.18.69.26,1.13.26.32,0,.6-.06.85-.17.24-.11.45-.26.63-.46s.31-.42.41-.68c.1-.26.16-.54.19-.84h1.4c-.03.49-.14.94-.32,1.34s-.42.76-.73,1.05-.67.52-1.08.68-.87.24-1.36.24c-.61,0-1.16-.11-1.65-.34-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36c-.18-.52-.27-1.07-.27-1.66s.09-1.13.27-1.65.44-.97.77-1.36c.34-.39.75-.7,1.23-.93s1.03-.34,1.65-.34c.46,0,.89.06,1.3.19.41.13.76.31,1.07.55s.56.53.75.88c.19.34.31.74.36,1.18h-1.43Z"
            />
            <path
              className="st3"
              d="M152.6,50.68h3.91c.9,0,1.58.19,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97-.11.26-.25.46-.4.62s-.3.27-.45.34-.26.11-.33.14v.02c.12.02.25.05.4.11.14.06.27.16.4.29.12.13.22.31.3.52s.12.48.12.8c0,.48.04.92.11,1.31.07.39.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58-.02-.21-.03-.42-.03-.62,0-.37-.02-.7-.07-.97s-.13-.5-.25-.68-.29-.31-.5-.4c-.21-.08-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19.03ZM154.03,54.4h2.35c.46,0,.81-.11,1.04-.33s.36-.54.36-.98c0-.26-.04-.47-.11-.64-.08-.16-.18-.29-.32-.38-.13-.09-.29-.15-.46-.18-.17-.03-.35-.05-.53-.05h-2.33v2.56h0Z"
            />
            <path
              className="st3"
              d="M164.16,50.48c.61,0,1.16.11,1.65.34s.9.54,1.23.93c.34.39.59.84.77,1.36s.27,1.07.27,1.65-.09,1.14-.27,1.66c-.18.52-.44.98-.77,1.36s-.75.7-1.23.92c-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92-.34-.39-.59-.84-.77-1.36-.18-.52-.27-1.07-.27-1.66s.09-1.13.27-1.65c.18-.52.44-.97.77-1.36.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34ZM164.16,51.65c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1s.46.53.77.71c.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1,.1-.37.14-.76.14-1.15s-.05-.77-.14-1.15-.24-.71-.44-1-.46-.53-.77-.71c-.32-.18-.69-.26-1.13-.26Z"
            />
            <path
              className="st3"
              d="M168.58,50.68h1.46l1.48,6.26h.02l1.65-6.26h1.47l1.61,6.26h.02l1.53-6.26h1.46l-2.26,8.19h-1.46l-1.64-6.26h-.02l-1.67,6.26h-1.48l-2.16-8.19h-.01Z"
            />
            <path
              className="st3"
              d="M182.12,50.68h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19h.01ZM181.61,55.61h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
            />
            <path
              className="st3"
              d="M185.94,50.68h1.49l2.05,6.48h.02l2.1-6.48h1.46l-2.8,8.19h-1.59l-2.73-8.19h0Z"
            />
            <path
              className="st3"
              d="M193.87,50.68h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19h0Z"
            />
            <path
              className="st3"
              d="M205.23,56.14c0,.31.05.58.16.8.11.22.26.4.45.54s.41.24.66.31.52.1.81.1c.31,0,.58-.04.8-.11s.4-.17.54-.28.24-.25.3-.4.09-.3.09-.45c0-.31-.07-.54-.21-.69-.14-.15-.3-.25-.46-.32-.29-.11-.63-.21-1.01-.3-.39-.1-.86-.22-1.43-.37-.35-.09-.64-.21-.88-.36-.23-.15-.42-.32-.56-.5s-.24-.38-.29-.58c-.06-.21-.09-.42-.09-.63,0-.41.09-.77.26-1.07s.4-.55.68-.75.6-.35.96-.44c.36-.1.72-.14,1.09-.14.43,0,.83.06,1.21.17.38.11.71.28,1,.5s.51.5.68.82c.17.33.25.7.25,1.13h-1.43c-.04-.53-.22-.9-.54-1.12-.32-.22-.73-.33-1.23-.33-.17,0-.34.02-.52.05-.18.03-.34.09-.48.17-.15.08-.27.19-.36.33s-.14.31-.14.52c0,.29.09.52.27.68.18.16.41.29.71.37.03,0,.15.04.36.1.21.06.45.12.71.19.26.07.51.14.76.2.25.07.43.11.53.14.27.08.5.2.7.34.2.15.37.31.5.5s.23.39.3.6c.06.21.1.43.1.64,0,.46-.09.85-.28,1.18s-.43.59-.74.8c-.31.21-.65.36-1.04.45-.39.1-.79.14-1.19.14-.47,0-.91-.06-1.32-.17-.41-.11-.77-.29-1.08-.53-.31-.24-.55-.54-.73-.91s-.28-.81-.29-1.31h1.43-.01Z"
            />
            <path
              className="st3"
              d="M213.91,50.68h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19h.01ZM213.4,55.61h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
            />
            <path
              className="st3"
              d="M219.37,50.68h5.65v1.24h-4.22v2.14h3.7v1.17h-3.7v3.64h-1.43v-8.19Z"
            />
            <path
              className="st3"
              d="M226.17,50.68h5.89v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19h.01Z"
            />
            <polygon
              className="st1"
              points="205.29 14.28 203.09 14.28 203.09 -16.43 154.15 -16.43 154.15 -18.64 205.29 -18.64 205.29 14.28"
            />
            <polygon
              className="st3"
              points="204.63 18.84 153.48 18.84 153.48 -13.84 155.69 -13.84 155.69 16.63 204.63 16.63 204.63 18.84"
            />
            <path
              className="st3"
              d="M192.62,13.09h-33.19V-12.16h33.19V13.09ZM161.63,10.88h28.78V-9.95h-28.78V10.88Z"
            />
            <rect
              className="st3"
              x="196.23"
              y="-.58"
              width="3.69"
              height="2.21"
            />
            <rect
              className="st0"
              x="142.09"
              y="-38.5"
              width="74.6"
              height="74.6"
            />
          </g>
          <g>
            <path
              className="st3"
              d="M278.49,50.68h3.39c.63,0,1.17.11,1.63.32s.83.51,1.12.88c.29.37.51.8.65,1.3.14.5.21,1.03.21,1.59s-.07,1.1-.21,1.59c-.14.5-.36.93-.65,1.3s-.67.66-1.12.88c-.46.21-1,.32-1.63.32h-3.39v-8.19h0ZM279.93,57.7h1.41c.56,0,1.01-.07,1.37-.22s.63-.36.84-.62c.2-.26.34-.57.41-.93s.11-.74.11-1.15-.04-.8-.11-1.15c-.07-.36-.21-.67-.41-.93-.2-.26-.48-.47-.84-.62-.36-.15-.81-.22-1.37-.22h-1.41v5.85h0Z"
            />
            <path className="st3" d="M286.77,50.68h1.43v8.19h-1.43v-8.19Z" />
            <path
              className="st3"
              d="M290.9,56.14c0,.31.05.58.16.8.11.22.26.4.45.54s.41.24.66.31.52.1.81.1c.31,0,.58-.04.8-.11s.4-.17.54-.28.24-.25.3-.4.09-.3.09-.45c0-.31-.07-.54-.21-.69-.14-.15-.3-.25-.46-.32-.29-.11-.63-.21-1.01-.3-.39-.1-.86-.22-1.43-.37-.35-.09-.64-.21-.88-.36-.23-.15-.42-.32-.56-.5s-.24-.38-.29-.58c-.06-.21-.09-.42-.09-.63,0-.41.09-.77.26-1.07s.4-.55.68-.75.6-.35.96-.44c.36-.1.72-.14,1.09-.14.43,0,.83.06,1.21.17.38.11.71.28,1,.5s.51.5.68.82c.17.33.25.7.25,1.13h-1.43c-.04-.53-.22-.9-.54-1.12-.32-.22-.73-.33-1.23-.33-.17,0-.34.02-.52.05s-.34.09-.48.17c-.15.08-.27.19-.36.33s-.14.31-.14.52c0,.29.09.52.27.68s.41.29.71.37c.03,0,.15.04.36.1.21.06.45.12.71.19.26.07.51.14.76.2.25.07.43.11.53.14.27.08.5.2.7.34.2.15.37.31.5.5s.23.39.3.6c.07.21.1.43.1.64,0,.46-.09.85-.28,1.18s-.43.59-.74.8-.65.36-1.04.45c-.39.1-.79.14-1.19.14-.47,0-.91-.06-1.32-.17-.41-.11-.77-.29-1.08-.53-.31-.24-.55-.54-.73-.91s-.28-.81-.29-1.31h1.43,0Z"
            />
            <path
              className="st3"
              d="M297.36,50.68h1.43v3.26h3.73v-3.26h1.43v8.19h-1.43v-3.69h-3.73v3.69h-1.43v-8.19Z"
            />
            <path
              className="st3"
              d="M304.87,50.68h1.46l1.48,6.26h.02l1.65-6.26h1.47l1.61,6.26h.02l1.53-6.26h1.46l-2.26,8.19h-1.46l-1.64-6.26h-.02l-1.67,6.26h-1.48l-2.16-8.19h0Z"
            />
            <path
              className="st3"
              d="M318.41,50.68h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19h0ZM317.9,55.61h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
            />
            <path
              className="st3"
              d="M324.8,56.14c0,.31.05.58.16.8.11.22.26.4.45.54s.41.24.66.31.52.1.81.1c.31,0,.58-.04.8-.11s.4-.17.54-.28.24-.25.3-.4.09-.3.09-.45c0-.31-.07-.54-.21-.69-.14-.15-.3-.25-.46-.32-.29-.11-.63-.21-1.02-.3-.39-.1-.86-.22-1.43-.37-.35-.09-.64-.21-.88-.36-.23-.15-.42-.32-.56-.5-.14-.18-.24-.38-.29-.58-.06-.21-.09-.42-.09-.63,0-.41.09-.77.26-1.07s.4-.55.68-.75.6-.35.96-.44c.36-.1.72-.14,1.09-.14.43,0,.83.06,1.21.17.38.11.71.28,1,.5s.51.5.68.82c.17.33.25.7.25,1.13h-1.43c-.04-.53-.22-.9-.54-1.12-.32-.22-.73-.33-1.23-.33-.17,0-.34.02-.52.05s-.34.09-.48.17c-.15.08-.27.19-.36.33s-.14.31-.14.52c0,.29.09.52.27.68s.41.29.71.37c.03,0,.15.04.36.1.21.06.45.12.71.19.26.07.51.14.76.2.25.07.43.11.53.14.27.08.5.2.7.34.2.15.36.31.5.5.13.19.23.39.3.6.06.21.1.43.1.64,0,.46-.09.85-.28,1.18s-.43.59-.74.8-.65.36-1.04.45c-.39.1-.79.14-1.19.14-.47,0-.91-.06-1.32-.17-.41-.11-.77-.29-1.08-.53-.31-.24-.55-.54-.73-.91s-.28-.81-.29-1.31h1.43Z"
            />
            <path
              className="st3"
              d="M331.26,50.68h1.43v3.26h3.73v-3.26h1.43v8.19h-1.43v-3.69h-3.73v3.69h-1.43v-8.19Z"
            />
            <path
              className="st3"
              d="M339.58,50.68h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
            />
            <path
              className="st3"
              d="M346.8,50.68h3.91c.9,0,1.58.19,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97-.11.26-.25.46-.4.62s-.3.27-.45.34c-.15.07-.26.11-.33.14v.02c.12.02.25.05.4.11.14.06.27.16.4.29.12.13.22.31.3.52s.12.48.12.8c0,.48.04.92.11,1.31.07.39.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58-.02-.21-.03-.42-.03-.62,0-.37-.02-.7-.07-.97s-.13-.5-.25-.68-.29-.31-.5-.4c-.21-.08-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19.03ZM348.24,54.4h2.35c.46,0,.81-.11,1.04-.33s.36-.54.36-.98c0-.26-.04-.47-.12-.64-.08-.16-.18-.29-.32-.38s-.29-.15-.46-.18c-.17-.03-.35-.05-.53-.05h-2.33v2.56h0Z"
            />
            <path
              className="st3"
              d="M359,56.14c0,.31.05.58.16.8.11.22.26.4.45.54s.41.24.66.31.52.1.81.1c.31,0,.58-.04.8-.11s.4-.17.54-.28.24-.25.3-.4.09-.3.09-.45c0-.31-.07-.54-.21-.69-.14-.15-.3-.25-.46-.32-.29-.11-.63-.21-1.02-.3-.39-.1-.86-.22-1.43-.37-.35-.09-.64-.21-.88-.36-.23-.15-.42-.32-.56-.5-.14-.18-.24-.38-.29-.58-.06-.21-.09-.42-.09-.63,0-.41.09-.77.26-1.07s.4-.55.68-.75.6-.35.96-.44c.36-.1.72-.14,1.09-.14.43,0,.83.06,1.21.17.38.11.71.28,1,.5s.51.5.68.82c.17.33.25.7.25,1.13h-1.43c-.04-.53-.22-.9-.54-1.12-.32-.22-.73-.33-1.23-.33-.17,0-.34.02-.52.05s-.34.09-.48.17c-.15.08-.27.19-.36.33s-.14.31-.14.52c0,.29.09.52.27.68s.41.29.71.37c.03,0,.15.04.36.1.21.06.45.12.71.19.26.07.51.14.76.2.25.07.43.11.53.14.27.08.5.2.7.34.2.15.36.31.5.5.13.19.23.39.3.6.06.21.1.43.1.64,0,.46-.09.85-.28,1.18s-.43.59-.74.8-.65.36-1.04.45c-.39.1-.79.14-1.19.14-.47,0-.91-.06-1.32-.17-.41-.11-.77-.29-1.08-.53-.31-.24-.55-.54-.73-.91s-.28-.81-.29-1.31h1.43Z"
            />
            <polygon
              className="st1"
              points="352.36 18.62 350.15 18.62 350.15 -21.39 305.62 -21.39 305.62 -23.6 352.36 -23.6 352.36 18.62"
            />
            <polygon
              className="st3"
              points="351.7 23.8 304.96 23.8 304.96 -17.98 307.17 -17.98 307.17 21.59 351.7 21.59 351.7 23.8"
            />
            <path
              className="st3"
              d="M347.17,19.25h-37.02V-11.78h37.02v31.04h0ZM312.36,17.05h32.61V-9.58h-32.61v26.62h0Z"
            />
            <path
              className="st3"
              d="M336.72,18.76l-1.76-1.33c1.03-1.37,1.58-3.01,1.58-4.73,0-4.34-3.53-7.87-7.87-7.87s-7.87,3.53-7.87,7.87c0,1.72.54,3.36,1.58,4.73l-1.76,1.33c-1.32-1.76-2.02-3.85-2.02-6.05,0-5.56,4.52-10.08,10.08-10.08s10.08,4.52,10.08,10.08c0,2.2-.7,4.3-2.02,6.05h-.02Z"
            />
            <rect
              className="st0"
              x="292.17"
              y="-38.5"
              width="74.6"
              height="74.6"
            />
          </g>
          <g>
            <path
              className="st3"
              d="M4.58,169.85h5.65v1.24h-4.22v2.14h3.7v1.17h-3.7v3.64h-1.43s0-8.19,0-8.19Z"
            />
            <path
              className="st3"
              d="M11.38,169.85h3.91c.9,0,1.58.19,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97s-.25.46-.4.62c-.15.16-.3.27-.45.34s-.26.11-.33.14v.02c.12.02.25.05.4.11.14.06.27.16.4.29.12.13.22.31.3.52s.12.48.12.8c0,.48.04.92.11,1.31s.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58s-.03-.42-.03-.62c0-.37-.02-.7-.07-.97s-.13-.5-.25-.68-.29-.31-.5-.4-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19.03ZM12.81,173.58h2.35c.46,0,.81-.11,1.04-.33.23-.22.36-.54.36-.98,0-.26-.04-.47-.11-.64s-.18-.29-.32-.38-.29-.15-.46-.18-.35-.05-.53-.05h-2.33s0,2.56,0,2.56Z"
            />
            <path
              className="st3"
              d="M19.46,169.85h5.89v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19h0Z"
            />
            <path
              className="st3"
              d="M26.68,169.85h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98s0-8.19,0-8.19Z"
            />
            <path
              className="st3"
              d="M33.66,169.85h6.23v1.09l-4.77,5.86h4.89v1.24h-6.71v-1.17l4.77-5.78h-4.4v-1.24h0Z"
            />
            <path
              className="st3"
              d="M41.13,169.85h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98s0-8.19,0-8.19Z"
            />
            <path
              className="st3"
              d="M48.36,169.85h3.91c.9,0,1.58.19,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97s-.25.46-.4.62c-.15.16-.3.27-.45.34s-.26.11-.33.14v.02c.12.02.25.05.4.11.14.06.27.16.4.29.12.13.22.31.3.52.08.21.12.48.12.8,0,.48.04.92.11,1.31s.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58s-.03-.42-.03-.62c0-.37-.02-.7-.07-.97s-.13-.5-.25-.68-.29-.31-.5-.4-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19.03ZM49.79,173.58h2.35c.46,0,.81-.11,1.04-.33s.36-.54.36-.98c0-.26-.04-.47-.12-.64-.08-.16-.18-.29-.32-.38-.13-.09-.29-.15-.46-.18s-.35-.05-.53-.05h-2.33v2.56h0Z"
            />
            <rect
              className="st3"
              x="28.21"
              y="102.17"
              width="2.21"
              height="16.36"
            />
            <rect
              className="st3"
              x="28.46"
              y="106.27"
              width="6.66"
              height="2.21"
              transform="translate(-66.61 53.93) rotate(-45)"
            />
            <rect
              className="st3"
              x="25.98"
              y="104.04"
              width="2.21"
              height="6.66"
              transform="translate(-67.99 50.6) rotate(-45)"
            />
            <rect
              className="st3"
              x="21.13"
              y="106.25"
              width="2.21"
              height="16.36"
              transform="translate(-87.98 76.47) rotate(-60)"
            />
            <rect
              className="st3"
              x="19.79"
              y="107.47"
              width="2.21"
              height="6.66"
              transform="translate(-27.96 9.18) rotate(-15)"
            />
            <rect
              className="st3"
              x="15.21"
              y="113.78"
              width="6.66"
              height="2.21"
              transform="translate(-29.12 8.72) rotate(-15.01)"
            />
            <rect
              className="st3"
              x="14.05"
              y="121.51"
              width="16.36"
              height="2.21"
              transform="translate(-58.33 27.54) rotate(-30)"
            />
            <rect
              className="st3"
              x="17.32"
              y="118.63"
              width="2.21"
              height="6.66"
              transform="translate(-104.15 108.19) rotate(-75)"
            />
            <rect
              className="st3"
              x="17.44"
              y="124.94"
              width="6.66"
              height="2.21"
              transform="translate(-106.36 113.51) rotate(-75.01)"
            />
            <rect
              className="st3"
              x="28.21"
              y="118.53"
              width="2.21"
              height="16.36"
            />
            <rect
              className="st3"
              x="23.51"
              y="128.58"
              width="6.66"
              height="2.21"
              transform="translate(-83.84 56.96) rotate(-45)"
            />
            <rect
              className="st3"
              x="30.44"
              y="126.34"
              width="2.21"
              height="6.66"
              transform="translate(-82.45 60.28) rotate(-45)"
            />
            <rect
              className="st3"
              x="35.29"
              y="114.44"
              width="2.21"
              height="16.36"
              transform="translate(-87.99 92.83) rotate(-60)"
            />
            <rect
              className="st3"
              x="36.62"
              y="122.92"
              width="2.21"
              height="6.66"
              transform="translate(-31.39 14.07) rotate(-15)"
            />
            <rect
              className="st3"
              x="36.76"
              y="121.07"
              width="6.66"
              height="2.21"
              transform="translate(-30.27 14.55) rotate(-15.01)"
            />
            <rect
              className="st3"
              x="28.23"
              y="113.34"
              width="16.36"
              height="2.21"
              transform="translate(-52.34 33.54) rotate(-30)"
            />
            <rect
              className="st3"
              x="39.11"
              y="111.77"
              width="2.21"
              height="6.66"
              transform="translate(-81.37 124.15) rotate(-75)"
            />
            <rect
              className="st3"
              x="34.53"
              y="109.92"
              width="6.66"
              height="2.21"
              transform="translate(-79.18 118.84) rotate(-74.99)"
            />
            <polygon
              className="st1"
              points="52.06 135.15 49.86 135.15 49.86 96.84 7.67 96.84 7.67 94.64 52.06 94.64 52.06 135.15"
            />
            <polygon
              className="st3"
              points="50.96 140.13 6.57 140.13 6.57 99.94 8.77 99.94 8.77 137.93 50.96 137.93 50.96 140.13"
            />
            <rect
              className="st0"
              x="-7.98"
              y="81.55"
              width="74.6"
              height="74.6"
            />
          </g>
          <g>
            <polygon
              className="st1"
              points="202.14 135.15 199.93 135.15 199.93 96.84 157.74 96.84 157.74 94.64 202.14 94.64 202.14 135.15"
            />
            <polygon
              className="st3"
              points="201.03 140.13 156.64 140.13 156.64 99.94 158.85 99.94 158.85 137.93 201.03 137.93 201.03 140.13"
            />
            <path
              className="st2"
              d="M186.15,129.6h-13.52c-2.64,0-4.78-2.14-4.78-4.78v-18.4h2.21v18.4c0,1.42,1.15,2.57,2.57,2.57h13.52c1.42,0,2.57-1.15,2.57-2.57v-18.4h2.21v18.4c0,2.64-2.14,4.78-4.78,4.78h0Z"
            />
            <polygon
              className="st2"
              points="187.72 133.11 171.06 133.11 171.06 128.99 173.27 128.99 173.27 130.9 185.51 130.9 185.51 128.99 187.72 128.99 187.72 133.11"
            />
            <path
              className="st3"
              d="M153.35,161.66h1.51l3.74,6.03h.02v-6.03h1.37v8.19h-1.51l-3.73-6.02h-.03v6.02h-1.37v-8.19h0Z"
            />
            <path
              className="st3"
              d="M165.17,161.47c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.36.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66-.44.97-.77,1.36c-.34.39-.75.7-1.23.92-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34ZM165.17,162.64c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1s.46.53.77.71c.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1,.1-.37.14-.76.14-1.15s-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1s-.46-.53-.77-.71c-.32-.18-.69-.26-1.13-.26Z"
            />
            <path
              className="st3"
              d="M170.35,161.66h1.51l3.74,6.03h.02v-6.03h1.37v8.19h-1.51l-3.73-6.02h-.03v6.02h-1.37v-8.19h0Z"
            />
            <path className="st3" d="M178.37,166.11h3.34v1.24h-3.34v-1.24Z" />
            <path
              className="st3"
              d="M184.09,167.12c0,.31.05.58.16.8s.26.4.45.54.41.24.66.31c.25.07.52.1.81.1.31,0,.58-.04.8-.11s.4-.17.54-.28.24-.25.3-.4.09-.3.09-.45c0-.31-.07-.54-.21-.69s-.3-.25-.46-.32c-.29-.11-.63-.21-1.01-.3-.39-.1-.86-.22-1.43-.37-.35-.09-.64-.21-.88-.36-.23-.15-.42-.32-.56-.5s-.24-.38-.29-.58-.09-.42-.09-.63c0-.41.09-.77.26-1.07s.4-.55.68-.75.6-.35.96-.44.72-.14,1.09-.14c.43,0,.83.06,1.21.17s.71.28,1,.5.51.49.68.82c.17.32.25.7.25,1.13h-1.43c-.04-.53-.22-.9-.54-1.12-.32-.22-.73-.33-1.23-.33-.17,0-.34.02-.52.05s-.34.09-.48.17c-.15.08-.27.19-.36.33-.1.14-.14.31-.14.52,0,.29.09.52.27.68s.41.29.71.37c.03,0,.15.04.36.1s.45.12.71.19c.26.07.51.14.76.2.25.07.43.11.53.14.27.08.5.2.7.34.2.15.36.31.5.5s.23.39.3.6.1.43.1.64c0,.46-.09.85-.28,1.18s-.43.59-.74.8-.65.36-1.04.45c-.39.1-.79.14-1.19.14-.47,0-.91-.06-1.32-.17s-.77-.29-1.08-.53-.55-.54-.73-.91-.28-.81-.29-1.31h1.43-.01Z"
            />
            <path
              className="st3"
              d="M190.58,161.66h1.43v6.95h4.16v1.24h-5.6v-8.19h.01Z"
            />
            <path className="st3" d="M197.16,161.66h1.43v8.19h-1.43v-8.19Z" />
            <path
              className="st3"
              d="M200.35,161.66h3.61c.58,0,1.05.08,1.42.25s.65.38.85.63c.2.25.33.53.41.83.07.3.11.57.11.83s-.04.53-.11.82c-.07.29-.21.57-.41.82s-.48.46-.85.63c-.37.16-.84.25-1.42.25h-2.18v3.14h-1.43v-8.19h0ZM201.78,165.54h2.1c.16,0,.32-.02.49-.07s.32-.12.46-.22.26-.24.34-.41.13-.39.13-.65-.04-.49-.12-.67-.18-.32-.31-.42c-.13-.1-.28-.17-.45-.21-.17-.04-.35-.06-.54-.06h-2.12v2.71h.02Z"
            />
            <path
              className="st3"
              d="M128.95,180.88c0,.31.05.58.16.8s.26.4.45.54.41.24.66.31c.25.07.52.1.81.1.31,0,.58-.04.8-.11s.4-.17.54-.28.24-.25.3-.4.09-.3.09-.45c0-.31-.07-.54-.21-.69s-.3-.25-.46-.32c-.29-.11-.63-.21-1.01-.3-.39-.1-.86-.22-1.43-.37-.35-.09-.64-.21-.88-.36-.23-.15-.42-.32-.56-.5s-.24-.38-.29-.58-.09-.42-.09-.63c0-.41.09-.77.26-1.07.17-.3.4-.55.68-.75s.6-.35.96-.44.72-.14,1.09-.14c.43,0,.83.06,1.21.17s.71.28,1,.5.51.49.68.82c.17.32.25.7.25,1.13h-1.43c-.04-.53-.22-.9-.54-1.12-.32-.22-.73-.33-1.23-.33-.17,0-.34.02-.52.05s-.34.09-.48.17c-.15.08-.27.19-.36.33-.1.14-.14.31-.14.52,0,.29.09.52.27.68s.41.29.71.37c.03,0,.15.04.36.1s.45.12.71.19c.26.07.51.14.76.2.25.07.43.11.53.14.27.08.5.2.7.34.2.15.36.31.5.5s.23.39.3.6.1.43.1.64c0,.46-.09.85-.28,1.18s-.43.59-.74.8-.65.36-1.04.45c-.39.1-.79.14-1.19.14-.47,0-.91-.06-1.32-.17s-.77-.29-1.08-.53-.55-.54-.73-.91-.28-.81-.29-1.31h1.43-.01Z"
            />
            <path className="st3" d="M135.44,175.42h1.43v8.19h-1.43v-8.19Z" />
            <path
              className="st3"
              d="M138.63,175.42h1.43v6.95h4.16v1.24h-5.6v-8.19h.01Z"
            />
            <path className="st3" d="M145.21,175.42h1.43v8.19h-1.43v-8.19Z" />
            <path
              className="st3"
              d="M153.93,178.03c-.06-.24-.15-.45-.25-.65-.11-.2-.24-.37-.41-.52-.17-.14-.37-.26-.59-.34-.23-.08-.49-.12-.79-.12-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1s.46.53.77.71c.32.18.69.26,1.13.26.32,0,.6-.06.85-.17s.45-.26.63-.46c.18-.2.31-.42.41-.68s.16-.54.2-.84h1.4c-.03.49-.14.94-.32,1.34-.18.41-.42.76-.73,1.05-.31.29-.67.52-1.08.68-.41.16-.87.24-1.36.24-.61,0-1.16-.11-1.65-.34-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34.46,0,.89.06,1.3.19.4.13.76.31,1.07.55s.56.53.75.88c.19.34.31.74.36,1.18h-1.44Z"
            />
            <path
              className="st3"
              d="M160.17,175.23c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.36.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66-.44.97-.77,1.36c-.34.39-.75.7-1.23.92-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34ZM160.17,176.4c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1s.46.53.77.71c.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1,.1-.37.14-.76.14-1.15s-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1s-.46-.53-.77-.71c-.32-.18-.69-.26-1.13-.26Z"
            />
            <path
              className="st3"
              d="M165.34,175.42h1.51l3.74,6.03h.02v-6.03h1.37v8.19h-1.51l-3.73-6.02h-.03v6.02h-1.37v-8.19h0Z"
            />
            <path
              className="st3"
              d="M173.68,175.42h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19h0Z"
            />
            <path
              className="st3"
              d="M184.09,175.42h3.98c.73,0,1.32.17,1.77.5.44.34.67.84.67,1.53,0,.41-.1.77-.3,1.06s-.49.52-.87.68v.02c.5.11.89.35,1.15.72s.39.84.39,1.39c0,.32-.06.62-.17.9s-.29.52-.54.72-.56.36-.94.48-.84.18-1.36.18h-3.76v-8.19h-.02ZM185.52,178.85h2.34c.34,0,.63-.1.86-.29.23-.19.34-.48.34-.84,0-.41-.1-.7-.31-.87-.21-.17-.5-.25-.89-.25h-2.34v2.26h0ZM185.52,182.44h2.53c.44,0,.77-.11,1.02-.34.24-.23.36-.54.36-.96s-.12-.72-.36-.93c-.24-.22-.58-.33-1.02-.33h-2.53v2.56Z"
            />
            <path
              className="st3"
              d="M195.65,175.23c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.36.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66-.44.97-.77,1.36c-.34.39-.75.7-1.23.92-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34ZM195.65,176.4c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1s.46.53.77.71c.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1,.1-.37.14-.76.14-1.15s-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1s-.46-.53-.77-.71c-.32-.18-.69-.26-1.13-.26Z"
            />
            <path
              className="st3"
              d="M200.1,175.42h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24h-.01Z"
            />
            <path
              className="st3"
              d="M206.9,175.42h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24h-.01Z"
            />
            <path
              className="st3"
              d="M217.97,175.23c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.36.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66-.44.97-.77,1.36c-.34.39-.75.7-1.23.92-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34ZM217.97,176.4c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1s.46.53.77.71c.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1,.1-.37.14-.76.14-1.15s-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1s-.46-.53-.77-.71c-.32-.18-.69-.26-1.13-.26Z"
            />
            <path
              className="st3"
              d="M223.18,175.42h2.02l2.26,6.41h.02l2.2-6.41h2v8.19h-1.37v-6.32h-.02l-2.27,6.32h-1.18l-2.27-6.32h-.02v6.32h-1.36v-8.19h0Z"
            />
            <rect
              className="st0"
              x="142.09"
              y="81.55"
              width="74.6"
              height="74.6"
            />
          </g>
          <g>
            <polygon
              className="st1"
              points="353.16 132.39 350.96 132.39 350.96 96.59 306.87 96.59 306.87 94.39 353.16 94.39 353.16 132.39"
            />
            <path
              className="st3"
              d="M353.16,141.79h-47.4v-41.03h2.21v35.14h45.19v5.88h0ZM307.97,139.58h42.99v-1.47h-42.99v1.47Z"
            />
            <path
              className="st3"
              d="M326.08,176.82h-.92l-.22-.96c-.38.44-.76.74-1.15.91-.38.17-.82.25-1.32.25-.61,0-1.16-.11-1.65-.34s-.9-.53-1.23-.92-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65.44-.97.77-1.37c.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34.44,0,.87.06,1.27.18s.76.29,1.07.53c.31.23.57.53.78.88s.34.76.39,1.22h-1.4c-.04-.27-.12-.5-.25-.71s-.28-.37-.48-.51c-.19-.14-.4-.24-.64-.31-.24-.07-.49-.1-.75-.1-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15.24.71.44,1,.46.53.77.71.69.26,1.13.26c.37,0,.69-.04.98-.14.28-.1.52-.25.72-.45.19-.2.34-.43.44-.72.1-.28.15-.6.16-.94h-2.18v-1.09h3.49v4.31-.02Z"
            />
            <path
              className="st3"
              d="M329.83,168.64h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19h0ZM329.32,173.57h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
            />
            <path
              className="st3"
              d="M336.23,174.1c0,.31.05.58.16.8.11.22.26.4.45.54s.41.24.66.31c.25.07.52.1.81.1.31,0,.58-.04.8-.11s.4-.17.54-.28.24-.25.3-.4.09-.3.09-.45c0-.31-.07-.54-.21-.69s-.3-.25-.46-.32c-.29-.11-.63-.21-1.02-.3-.39-.1-.86-.22-1.43-.37-.35-.09-.64-.21-.88-.36-.23-.15-.42-.32-.56-.5s-.24-.38-.29-.58c-.06-.21-.09-.42-.09-.63,0-.41.09-.77.26-1.07s.4-.55.68-.75.6-.35.96-.44c.36-.1.72-.14,1.09-.14.43,0,.83.06,1.21.17s.71.28,1,.5.51.5.68.82c.17.33.25.7.25,1.13h-1.43c-.04-.53-.22-.9-.54-1.12s-.73-.33-1.23-.33c-.17,0-.34.02-.52.05s-.34.09-.48.17-.27.19-.36.33c-.1.14-.14.31-.14.52,0,.29.09.52.27.68s.41.29.71.37c.03,0,.15.04.36.1.21.06.45.12.71.19.26.07.51.14.76.2s.43.11.53.14c.27.08.5.2.7.34.2.15.36.31.5.5.13.19.23.39.3.6.06.21.1.43.1.64,0,.46-.09.85-.28,1.18-.19.33-.43.59-.74.8s-.65.36-1.04.45c-.39.1-.79.14-1.19.14-.47,0-.91-.06-1.32-.17s-.77-.29-1.08-.53-.55-.54-.73-.91-.28-.81-.29-1.31h1.43Z"
            />
            <path
              className="st2"
              d="M329.46,130.31c-3.5,0-6.79-1.36-9.27-3.84-2.48-2.48-3.84-5.77-3.84-9.27s1.36-6.79,3.84-9.27,5.77-3.84,9.27-3.84,6.79,1.36,9.27,3.84c2.48,2.48,3.84,5.77,3.84,9.27s-1.36,6.79-3.84,9.27c-2.48,2.48-5.77,3.84-9.27,3.84ZM329.46,106.31c-2.79,0-5.58,1.06-7.71,3.19s-3.19,4.8-3.19,7.71,1.13,5.65,3.19,7.71c4.25,4.25,11.17,4.25,15.41,0,4.25-4.25,4.25-11.16,0-15.41-2.13-2.13-4.92-3.19-7.71-3.19h0Z"
            />
            <path
              className="st2"
              d="M329.46,123.04c-1.5,0-2.99-.57-4.13-1.71-2.28-2.28-2.28-5.98,0-8.26s5.98-2.28,8.26,0,2.28,5.98,0,8.26c-1.14,1.14-2.63,1.71-4.13,1.71ZM329.46,113.57c-.93,0-1.86.35-2.57,1.06-1.42,1.42-1.42,3.72,0,5.14s3.72,1.42,5.14,0,1.42-3.72,0-5.14c-.71-.71-1.64-1.06-2.57-1.06Z"
            />
            <rect
              className="st2"
              x="319.63"
              y="104.14"
              width="2.21"
              height="8.69"
              transform="translate(17.23 258.57) rotate(-45)"
            />
            <rect
              className="st2"
              x="337.09"
              y="121.58"
              width="2.21"
              height="8.69"
              transform="translate(10.01 276.03) rotate(-45)"
            />
            <rect
              className="st2"
              x="333.85"
              y="107.37"
              width="8.69"
              height="2.21"
              transform="translate(22.35 270.91) rotate(-45)"
            />
            <rect
              className="st2"
              x="316.39"
              y="124.83"
              width="8.69"
              height="2.21"
              transform="translate(4.89 263.68) rotate(-45)"
            />
            <rect
              className="st0"
              x="292.17"
              y="81.55"
              width="74.6"
              height="74.6"
            />
          </g>
        </g>
        <g
          className={clsx({
            animation_right: showAnimation,
            complete: !showAnimation,
          })}
        >
          <polygon
            className="st1"
            points="346.91 262.94 344.71 262.94 344.71 224.04 313.07 224.04 313.07 221.83 346.91 221.83 346.91 262.94"
          />
          <polygon
            className="st3"
            points="345.81 267.98 311.97 267.98 311.97 227.2 314.17 227.2 314.17 265.77 345.81 265.77 345.81 267.98"
          />
          <polygon
            className="st1"
            points="37.19 260.44 34.98 260.44 34.98 222.16 14.84 222.16 14.84 219.95 37.19 219.95 37.19 260.44"
          />
          <polygon
            className="st3"
            points="36.08 267.35 13.73 267.35 13.73 226.32 15.94 226.32 15.94 265.15 36.08 265.15 36.08 267.35"
          />
          <path
            className="st2"
            d="M284.64,294.41h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19h0ZM284.14,299.34h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st2"
            d="M290.08,294.41h2.02l2.26,6.41h.02l2.2-6.41h2v8.19h-1.37v-6.32h-.02l-2.27,6.32h-1.18l-2.27-6.32h-.02v6.32h-1.36v-8.19h-.01Z"
          />
          <path
            className="st2"
            d="M300.3,294.41h3.61c.58,0,1.05.08,1.42.25.37.17.65.38.85.63s.33.53.41.83c.07.3.11.57.11.83s-.04.53-.11.82c-.07.29-.21.57-.41.82s-.48.46-.85.63c-.37.16-.84.25-1.42.25h-2.18v3.14h-1.43v-8.19h0ZM301.73,298.29h2.1c.16,0,.32-.02.49-.07.17-.05.32-.12.46-.22.14-.1.26-.24.34-.41s.13-.39.13-.65-.04-.49-.12-.67c-.08-.18-.18-.32-.31-.42s-.28-.17-.45-.21c-.17-.04-.35-.06-.54-.06h-2.12v2.71h.02Z"
          />
          <path
            className="st2"
            d="M307.95,294.41h1.43v6.95h4.16v1.24h-5.6v-8.19h.01Z"
          />
          <path
            className="st2"
            d="M314.53,294.41h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st2"
            d="M330.47,297.02c-.06-.24-.15-.45-.25-.65-.11-.2-.24-.37-.41-.52-.17-.14-.37-.26-.59-.34-.23-.08-.49-.12-.79-.12-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1s.46.53.77.71c.32.18.69.26,1.13.26.32,0,.6-.06.85-.17s.45-.26.63-.46c.18-.2.31-.42.41-.68s.16-.54.2-.84h1.4c-.03.49-.14.94-.32,1.34-.18.41-.42.76-.73,1.05-.31.29-.67.52-1.08.68-.41.16-.87.24-1.36.24-.61,0-1.16-.11-1.65-.34s-.9-.53-1.23-.92-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65.44-.97.77-1.36.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34.46,0,.89.06,1.3.19.4.13.76.31,1.07.55s.56.53.75.88c.19.34.31.74.36,1.18h-1.44Z"
          />
          <path
            className="st2"
            d="M335.42,294.41h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19h0ZM334.91,299.34h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st2"
            d="M340.87,294.41h3.61c.58,0,1.05.08,1.42.25.37.17.65.38.85.63s.33.53.41.83c.07.3.11.57.11.83s-.04.53-.11.82c-.07.29-.21.57-.41.82s-.48.46-.85.63c-.37.16-.84.25-1.42.25h-2.18v3.14h-1.43v-8.19h0ZM342.31,298.29h2.1c.16,0,.32-.02.49-.07.17-.05.32-.12.46-.22.14-.1.26-.24.34-.41s.13-.39.13-.65-.04-.49-.12-.67c-.08-.18-.18-.32-.31-.42s-.28-.17-.45-.21c-.17-.04-.35-.06-.54-.06h-2.12v2.71h.02Z"
          />
          <path
            className="st2"
            d="M349.87,294.41h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19h0ZM349.36,299.34h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st2"
            d="M360.85,297.02c-.06-.24-.15-.45-.25-.65-.11-.2-.24-.37-.41-.52-.17-.14-.37-.26-.59-.34-.23-.08-.49-.12-.79-.12-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1s.46.53.77.71c.32.18.69.26,1.13.26.32,0,.6-.06.85-.17s.45-.26.63-.46c.18-.2.31-.42.41-.68s.16-.54.2-.84h1.4c-.03.49-.14.94-.32,1.34-.18.41-.42.76-.73,1.05-.31.29-.67.52-1.08.68-.41.16-.87.24-1.36.24-.61,0-1.16-.11-1.65-.34s-.9-.53-1.23-.92-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65.44-.97.77-1.36.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34.46,0,.89.06,1.3.19.4.13.76.31,1.07.55s.56.53.75.88c.19.34.31.74.36,1.18h-1.44Z"
          />
          <polygon
            className="st1"
            points="339.09 222.93 336.89 222.93 336.89 220.41 322.47 220.41 322.47 222.93 320.26 222.93 320.26 218.21 339.09 218.21 339.09 222.93"
          />
          <path
            className="st2"
            d="M320.67,239.1h8.24v1.63c-.63.71-1.2,1.45-1.72,2.21-.52.76-.97,1.57-1.35,2.43-.38.85-.7,1.76-.94,2.71-.24.95-.4,1.97-.48,3.06h-2.15c.07-.95.23-1.89.49-2.82.26-.93.59-1.83,1-2.7s.88-1.71,1.42-2.51c.54-.8,1.12-1.55,1.74-2.25h-6.24v-1.75h0Z"
          />
          <path
            className="st2"
            d="M330.94,238.86h2.15v10.43h6.24v1.86h-8.4v-12.28h.01Z"
          />
          <rect
            className="st3"
            x="314.65"
            y="267.62"
            width="2.21"
            height="2.41"
          />
          <rect
            className="st3"
            x="340.71"
            y="267.62"
            width="2.21"
            height="2.41"
          />
          <polygon
            className="st3"
            points="170.19 238.95 156.64 238.95 156.64 223.39 158.84 223.39 158.84 236.75 170.19 236.75 170.19 238.95"
          />
          <polygon
            className="st1"
            points="202.13 233.97 199.93 233.97 199.93 220.29 157.74 220.29 157.74 218.09 202.13 218.09 202.13 233.97"
          />
          <path
            className="st3"
            d="M193.43,268.17h-2.21v-2.02c0-1.93.55-3.57,1.08-5.16.55-1.64,1.12-3.33,1.12-5.46v-11.74c0-1.01-.82-1.83-1.83-1.83s-1.83.82-1.83,1.83c0,.61-.49,1.1-1.1,1.1s-1.1-.49-1.1-1.1v-2.2c0-1.01-.82-1.83-1.83-1.83s-1.83.82-1.83,1.83c0,.61-.49,1.1-1.1,1.1s-1.1-.49-1.1-1.1v-2.2c0-1.01-.82-1.83-1.83-1.83s-1.83.82-1.83,1.83c0,.61-.49,1.1-1.1,1.1s-1.1-.49-1.1-1.1v-10.27c0-1.01-.82-1.83-1.83-1.83s-1.83.82-1.83,1.83v20.55c0,.47-.3.89-.74,1.04-.44.16-.93,0-1.23-.36-1.8-2.27-2.91-3.63-3.58-4.31-.84-.85-1.69-1.15-2.16-1.15-1.12,0-1.83.29-2.25.55.8,1.44,2.12,4.4,4.73,10.38.71,1.61,1.63,2.88,2.53,4.1,1.39,1.89,2.7,3.68,2.7,6.22v2.02h-2.21v-2.02c0-1.82-1-3.19-2.27-4.92-.92-1.26-1.97-2.69-2.77-4.52-3.77-8.63-4.71-10.35-4.91-10.69-.05-.05-.1-.11-.14-.17-.24-.37-.23-.85.02-1.22.22-.32,1.49-1.94,4.57-1.94,1.21,0,2.6.67,3.72,1.79.45.44,1.01,1.1,1.79,2.04v-17.41c0-2.23,1.81-4.04,4.04-4.04s4.04,1.81,4.04,4.04v6.68c.55-.28,1.17-.44,1.83-.44,1.78,0,3.29,1.16,3.83,2.76.6-.35,1.3-.55,2.04-.55,1.78,0,3.29,1.16,3.83,2.76.6-.35,1.3-.55,2.04-.55,2.23,0,4.04,1.81,4.04,4.04v11.74c0,2.48-.65,4.43-1.23,6.16-.5,1.48-.97,2.89-.97,4.46v2.02h-.04ZM160.51,246.32c.14.04.29.05.46.02-.16.03-.31.02-.46-.02Z"
          />
          <path
            className="st2"
            d="M148.93,287.34c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.36.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66-.44.97-.77,1.36c-.34.39-.75.7-1.23.92-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34ZM148.93,288.51c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1s.46.53.77.71c.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1,.1-.37.14-.76.14-1.15s-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1s-.46-.53-.77-.71c-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st2"
            d="M154.1,287.53h1.51l3.74,6.03h.02v-6.03h1.37v8.19h-1.51l-3.73-6.02h-.03v6.02h-1.37v-8.19h0Z"
          />
          <path
            className="st2"
            d="M162.44,287.53h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19h0Z"
          />
          <path className="st2" d="M169.35,291.98h3.34v1.24h-3.34v-1.24Z" />
          <path
            className="st2"
            d="M173.35,287.53h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24h-.01Z"
          />
          <path
            className="st2"
            d="M184.41,287.34c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.36.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66-.44.97-.77,1.36c-.34.39-.75.7-1.23.92-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34ZM184.41,288.51c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1s.46.53.77.71c.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1,.1-.37.14-.76.14-1.15s-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1s-.46-.53-.77-.71c-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st2"
            d="M189.55,287.53h1.43v4.77c0,.28,0,.55.04.84.03.28.1.54.23.76.13.23.32.41.57.56.26.15.62.22,1.08.22s.83-.07,1.08-.22c.26-.15.45-.33.57-.56.13-.23.2-.48.23-.76s.04-.56.04-.84v-4.77h1.43v5.24c0,.53-.08.99-.24,1.38s-.39.72-.68.98-.65.46-1.06.59-.87.2-1.38.2-.96-.07-1.38-.2c-.41-.13-.77-.33-1.06-.59s-.52-.59-.68-.98c-.16-.39-.24-.85-.24-1.38v-5.24h.02Z"
          />
          <path
            className="st2"
            d="M203.45,290.13c-.06-.24-.15-.45-.25-.65-.11-.2-.24-.37-.41-.52-.17-.14-.37-.26-.59-.34-.23-.08-.49-.12-.79-.12-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1s.46.53.77.71c.32.18.69.26,1.13.26.32,0,.6-.06.85-.17s.45-.26.63-.46c.18-.2.31-.42.41-.68s.16-.54.2-.84h1.4c-.03.49-.14.94-.32,1.34-.18.41-.42.76-.73,1.05-.31.29-.67.52-1.08.68s-.87.24-1.36.24c-.61,0-1.16-.11-1.65-.34-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34.46,0,.89.06,1.3.19.4.13.76.31,1.07.55s.56.53.75.88c.19.34.31.74.36,1.18h-1.44Z"
          />
          <path
            className="st2"
            d="M206.17,287.53h1.43v3.26h3.73v-3.26h1.43v8.19h-1.43v-3.69h-3.73v3.69h-1.43v-8.19Z"
          />
          <path
            className="st2"
            d="M156.49,301.29h3.98c.73,0,1.32.17,1.77.5.44.34.67.84.67,1.53,0,.41-.1.77-.3,1.06s-.49.52-.87.68v.02c.5.11.89.35,1.15.72s.39.84.39,1.39c0,.32-.06.62-.17.9s-.29.52-.54.72-.56.36-.94.48c-.38.12-.84.18-1.36.18h-3.76v-8.19h-.02ZM157.92,304.72h2.34c.34,0,.63-.1.86-.29s.34-.48.34-.84c0-.41-.1-.7-.31-.87-.21-.17-.5-.25-.89-.25h-2.34v2.26h0ZM157.92,308.31h2.53c.44,0,.77-.11,1.02-.34.24-.23.36-.54.36-.96s-.12-.72-.36-.93c-.24-.22-.58-.33-1.02-.33h-2.53v2.56h0Z"
          />
          <path
            className="st2"
            d="M164.47,301.29h1.43v4.77c0,.28,0,.55.04.84.03.28.1.54.23.76.13.23.32.41.57.56.26.15.62.22,1.08.22s.83-.07,1.08-.22c.26-.15.45-.33.57-.56.13-.23.2-.48.23-.76s.04-.56.04-.84v-4.77h1.43v5.24c0,.53-.08.99-.24,1.38s-.39.72-.68.98-.65.46-1.06.59-.87.2-1.38.2-.96-.07-1.38-.2c-.41-.13-.77-.33-1.06-.59s-.52-.59-.68-.98c-.16-.39-.24-.85-.24-1.38v-5.24h.02Z"
          />
          <path
            className="st2"
            d="M172.06,301.29h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24h-.01Z"
          />
          <path
            className="st2"
            d="M178.86,301.29h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24h-.01Z"
          />
          <path
            className="st2"
            d="M189.93,301.1c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.36.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66-.44.97-.77,1.36c-.34.39-.75.7-1.23.92-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34ZM189.93,302.27c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1s.46.53.77.71c.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1,.1-.37.14-.76.14-1.15s-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1s-.46-.53-.77-.71c-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st2"
            d="M195.1,301.29h1.51l3.74,6.03h.02v-6.03h1.37v8.19h-1.51l-3.73-6.02h-.03v6.02h-1.37v-8.19h0Z"
          />
          <rect
            className="st3"
            x="181.02"
            y="236.19"
            width="21.08"
            height="2.21"
          />
          <path
            className="st2"
            d="M1.53,294.41h3.91c.9,0,1.58.2,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97s-.25.46-.4.62-.3.27-.45.34c-.15.07-.26.11-.33.14v.02c.12.02.25.05.4.12.14.06.27.16.4.29.12.13.22.31.3.52.08.21.12.48.12.8,0,.48.04.92.11,1.31.07.39.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58s-.03-.42-.03-.62c0-.37-.02-.7-.07-.97s-.13-.5-.25-.68-.29-.31-.5-.4c-.21-.08-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19.02ZM2.97,298.14h2.35c.46,0,.81-.11,1.04-.33.24-.22.36-.54.36-.98,0-.26-.04-.47-.11-.64-.08-.16-.18-.29-.32-.38-.13-.09-.29-.15-.46-.18s-.35-.05-.53-.05h-2.33s0,2.56,0,2.56Z"
          />
          <path
            className="st2"
            d="M18.32,297.02c-.06-.24-.15-.45-.25-.65-.11-.2-.24-.37-.41-.52-.17-.14-.37-.26-.59-.34-.23-.08-.49-.12-.79-.12-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1s.46.53.77.71c.32.18.69.26,1.13.26.32,0,.6-.06.85-.17s.45-.26.63-.46c.18-.2.31-.42.41-.68s.16-.54.2-.84h1.4c-.03.49-.14.94-.32,1.34-.18.41-.42.76-.73,1.05-.31.29-.67.52-1.08.68s-.87.24-1.36.24c-.61,0-1.16-.11-1.65-.34s-.9-.53-1.23-.92-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65.44-.97.77-1.36.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34.46,0,.89.06,1.3.19.4.13.76.31,1.07.55s.56.53.75.88c.19.34.31.74.36,1.18h-1.44Z"
          />
          <path
            className="st2"
            d="M21.08,294.41h1.43v6.95h4.16v1.24h-5.6v-8.19h.01Z"
          />
          <path
            className="st2"
            d="M27.66,294.41h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98s0-8.19,0-8.19Z"
          />
          <path
            className="st2"
            d="M37.07,294.41h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19h.01ZM36.57,299.34h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st2"
            d="M42.48,294.41h1.51l3.74,6.03h.02v-6.03h1.37v8.19h-1.51l-3.73-6.02h-.03v6.02h-1.37s0-8.19,0-8.19Z"
          />
          <path className="st2" d="M50.81,294.41h1.43v8.19h-1.43v-8.19Z" />
          <path
            className="st2"
            d="M53.95,294.41h1.51l3.74,6.03h.02v-6.03h1.37v8.19h-1.51l-3.73-6.02h-.03v6.02h-1.37s0-8.19,0-8.19Z"
          />
          <path
            className="st2"
            d="M69.43,302.6h-.92l-.22-.96c-.38.44-.76.74-1.15.91-.38.17-.82.25-1.32.25-.61,0-1.16-.11-1.65-.34-.49-.23-.9-.53-1.23-.92-.34-.39-.59-.84-.77-1.36s-.27-1.07-.27-1.66.09-1.13.27-1.65.44-.97.77-1.36c.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34.44,0,.87.06,1.27.18s.76.29,1.07.53c.31.23.57.53.78.88s.34.76.39,1.22h-1.4c-.04-.27-.12-.5-.25-.71s-.29-.37-.48-.51-.41-.24-.64-.31c-.24-.07-.49-.1-.75-.1-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26.37,0,.69-.04.97-.14s.52-.25.72-.45.34-.43.44-.72.15-.6.16-.94h-2.18v-1.09h3.49v4.31l.02-.03Z"
          />
          <path
            className="st3"
            d="M44.44,239.13h-18.96v-2.21h18.96c1.89,0,3.43-1.54,3.43-3.43s-1.54-3.43-3.43-3.43c-.29,0-1.9.13-1.9,1.44h-2.21c0-2.81,2.67-3.61,4.08-3.64,3.13,0,5.66,2.53,5.66,5.63s-2.53,5.64-5.63,5.64h0Z"
          />
          <path
            className="st3"
            d="M44.39,261.59c-1.43-.03-4.11-.83-4.11-3.64h2.21c0,.23.09,1.38,1.93,1.44,1.86,0,3.4-1.54,3.4-3.43s-1.54-3.43-3.43-3.43h-18.96v-2.21h18.96c3.11,0,5.63,2.53,5.63,5.63s-2.53,5.64-5.63,5.64Z"
          />
          <path
            className="st3"
            d="M55.79,246.38h-30.31v-2.21h30.31c1.89,0,3.43-1.54,3.43-3.43s-1.54-3.43-3.43-3.43c-.29,0-1.9.13-1.9,1.44h-2.21c0-2.81,2.67-3.61,4.08-3.64,3.13,0,5.66,2.53,5.66,5.63s-2.53,5.63-5.64,5.63h0Z"
          />
          <rect className="st3" x="5.78" y="236.92" width="5.5" height="2.21" />
          <rect
            className="st3"
            x="-2.23"
            y="236.92"
            width="5.5"
            height="2.21"
          />
          <rect className="st3" x="5.78" y="244.18" width="5.5" height="2.21" />
          <rect
            className="st3"
            x="-2.23"
            y="244.18"
            width="5.5"
            height="2.21"
          />
          <rect className="st3" x="5.78" y="250.32" width="5.5" height="2.21" />
          <rect
            className="st3"
            x="-2.23"
            y="250.32"
            width="5.5"
            height="2.21"
          />
          <path
            className="st3"
            d="M278.49,420.5h3.39c.63,0,1.17.11,1.63.32.46.21.83.51,1.12.88s.51.8.65,1.3c.14.5.21,1.03.21,1.59s-.07,1.1-.21,1.59c-.14.5-.36.93-.65,1.3s-.67.66-1.12.88c-.46.21-1,.32-1.63.32h-3.39v-8.19h0ZM279.92,427.52h1.41c.56,0,1.01-.07,1.37-.22s.63-.36.84-.62c.2-.26.34-.57.41-.93s.11-.74.11-1.15-.04-.8-.11-1.15c-.07-.36-.21-.67-.41-.93-.2-.26-.48-.47-.84-.62s-.81-.22-1.37-.22h-1.41v5.85h0Z"
          />
          <path className="st3" d="M286.77,420.5h1.43v8.19h-1.43v-8.19Z" />
          <path
            className="st3"
            d="M290.9,425.96c0,.31.05.58.16.8.11.22.26.4.45.54s.41.24.66.31.52.1.81.1c.31,0,.58-.04.8-.11.22-.07.4-.17.54-.28s.24-.25.3-.4.09-.3.09-.45c0-.31-.07-.54-.21-.69-.14-.15-.3-.25-.46-.32-.29-.11-.63-.21-1.01-.3-.39-.1-.86-.22-1.43-.37-.35-.09-.64-.21-.88-.36-.23-.15-.42-.32-.56-.5s-.24-.38-.29-.58c-.06-.21-.09-.42-.09-.63,0-.41.09-.77.26-1.07.17-.3.4-.55.68-.75s.6-.35.96-.44c.36-.1.72-.14,1.09-.14.43,0,.83.06,1.21.17.38.11.71.28,1,.5s.51.5.68.82c.17.33.25.7.25,1.13h-1.43c-.04-.53-.22-.9-.54-1.12s-.73-.33-1.23-.33c-.17,0-.34.02-.52.05s-.34.09-.48.17c-.15.08-.27.19-.36.33s-.14.31-.14.52c0,.29.09.52.27.68s.41.29.71.37c.03,0,.15.04.36.1s.45.12.71.19c.26.07.51.14.76.2.25.07.43.11.53.14.27.08.5.2.7.34.2.15.37.31.5.5s.23.39.3.6c.07.21.1.43.1.64,0,.46-.09.85-.28,1.18s-.43.59-.74.8-.65.36-1.04.45c-.39.1-.79.14-1.19.14-.47,0-.91-.06-1.32-.17-.41-.11-.77-.29-1.08-.53s-.55-.54-.73-.91-.28-.81-.29-1.31h1.43,0Z"
          />
          <path
            className="st3"
            d="M297.35,420.5h1.43v3.26h3.73v-3.26h1.43v8.19h-1.43v-3.69h-3.73v3.69h-1.43v-8.19Z"
          />
          <path
            className="st3"
            d="M304.87,420.5h1.46l1.48,6.26h.02l1.65-6.26h1.47l1.61,6.26h.02l1.53-6.26h1.46l-2.26,8.19h-1.46l-1.64-6.26h-.02l-1.67,6.26h-1.48l-2.16-8.19h0Z"
          />
          <path
            className="st3"
            d="M318.4,420.5h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19h0ZM317.9,425.43h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st3"
            d="M324.8,425.96c0,.31.05.58.16.8.11.22.26.4.45.54s.41.24.66.31.52.1.81.1c.31,0,.58-.04.8-.11.22-.07.4-.17.54-.28s.24-.25.3-.4.09-.3.09-.45c0-.31-.07-.54-.21-.69-.14-.15-.3-.25-.46-.32-.29-.11-.63-.21-1.02-.3-.39-.1-.86-.22-1.43-.37-.35-.09-.64-.21-.88-.36-.23-.15-.42-.32-.56-.5-.14-.18-.24-.38-.29-.58-.06-.21-.09-.42-.09-.63,0-.41.09-.77.26-1.07.17-.3.4-.55.68-.75s.6-.35.96-.44c.36-.1.72-.14,1.09-.14.43,0,.83.06,1.21.17.38.11.71.28,1,.5s.51.5.68.82c.17.33.25.7.25,1.13h-1.43c-.04-.53-.22-.9-.54-1.12s-.73-.33-1.23-.33c-.17,0-.34.02-.52.05s-.34.09-.48.17c-.15.08-.27.19-.36.33s-.14.31-.14.52c0,.29.09.52.27.68s.41.29.71.37c.03,0,.15.04.36.1s.45.12.71.19c.26.07.51.14.76.2.25.07.43.11.53.14.27.08.5.2.7.34.2.15.36.31.5.5.13.19.23.39.3.6.06.21.1.43.1.64,0,.46-.09.85-.28,1.18s-.43.59-.74.8-.65.36-1.04.45c-.39.1-.79.14-1.19.14-.47,0-.91-.06-1.32-.17-.41-.11-.77-.29-1.08-.53s-.55-.54-.73-.91-.28-.81-.29-1.31h1.43Z"
          />
          <path
            className="st3"
            d="M331.26,420.5h1.43v3.26h3.73v-3.26h1.43v8.19h-1.43v-3.69h-3.73v3.69h-1.43v-8.19Z"
          />
          <path
            className="st3"
            d="M339.57,420.5h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st3"
            d="M346.8,420.5h3.91c.9,0,1.58.19,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97-.11.26-.25.46-.4.62s-.3.27-.45.34c-.15.07-.26.11-.33.14v.02c.12.02.25.05.4.11.14.06.27.16.4.29.12.13.22.31.3.52s.12.48.12.8c0,.48.04.92.11,1.31.07.39.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58s-.03-.42-.03-.62c0-.37-.02-.7-.07-.97s-.13-.5-.25-.68-.29-.31-.5-.4c-.21-.08-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19.03ZM348.23,424.23h2.35c.46,0,.81-.11,1.04-.33s.36-.54.36-.98c0-.26-.04-.47-.12-.64-.08-.16-.18-.29-.32-.38s-.29-.15-.46-.18c-.17-.03-.35-.05-.53-.05h-2.33v2.56h0Z"
          />
          <path
            className="st3"
            d="M359,425.96c0,.31.05.58.16.8.11.22.26.4.45.54s.41.24.66.31.52.1.81.1c.31,0,.58-.04.8-.11.22-.07.4-.17.54-.28s.24-.25.3-.4.09-.3.09-.45c0-.31-.07-.54-.21-.69-.14-.15-.3-.25-.46-.32-.29-.11-.63-.21-1.02-.3-.39-.1-.86-.22-1.43-.37-.35-.09-.64-.21-.88-.36-.23-.15-.42-.32-.56-.5-.14-.18-.24-.38-.29-.58-.06-.21-.09-.42-.09-.63,0-.41.09-.77.26-1.07.17-.3.4-.55.68-.75s.6-.35.96-.44c.36-.1.72-.14,1.09-.14.43,0,.83.06,1.21.17.38.11.71.28,1,.5s.51.5.68.82c.17.33.25.7.25,1.13h-1.43c-.04-.53-.22-.9-.54-1.12s-.73-.33-1.23-.33c-.17,0-.34.02-.52.05s-.34.09-.48.17c-.15.08-.27.19-.36.33s-.14.31-.14.52c0,.29.09.52.27.68s.41.29.71.37c.03,0,.15.04.36.1s.45.12.71.19c.26.07.51.14.76.2.25.07.43.11.53.14.27.08.5.2.7.34.2.15.36.31.5.5.13.19.23.39.3.6.06.21.1.43.1.64,0,.46-.09.85-.28,1.18s-.43.59-.74.8-.65.36-1.04.45c-.39.1-.79.14-1.19.14-.47,0-.91-.06-1.32-.17-.41-.11-.77-.29-1.08-.53s-.55-.54-.73-.91-.28-.81-.29-1.31h1.43Z"
          />
          <path
            className="st3"
            d="M1.94,420.3c.61,0,1.16.11,1.65.34s.9.54,1.23.93c.34.39.59.84.77,1.36s.27,1.07.27,1.65-.09,1.14-.27,1.66-.44.98-.77,1.36-.75.7-1.23.92c-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34-.9-.53-1.23-.92-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65.44-.97.77-1.36c.34-.39.75-.7,1.23-.93s1.03-.34,1.65-.34ZM1.94,421.47c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1s-.14.76-.14,1.15.05.77.14,1.15c.1.37.24.71.44,1s.46.53.77.71c.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1,.1-.37.14-.76.14-1.15s-.05-.77-.14-1.15-.24-.71-.44-1c-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st3"
            d="M6.24,420.5h1.49l2.05,6.48h.02l2.1-6.48h1.46l-2.8,8.19h-1.59s-2.73-8.19-2.73-8.19Z"
          />
          <path
            className="st3"
            d="M14.18,420.5h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st3"
            d="M21.34,420.5h1.51l3.74,6.03h.02v-6.03h1.36v8.19h-1.51l-3.73-6.02h-.03v6.02h-1.36v-8.19Z"
          />
          <path
            className="st3"
            d="M33.81,425.96c0,.31.05.58.16.8s.26.4.45.54c.19.14.41.24.66.31s.52.1.81.1c.31,0,.58-.04.8-.11.22-.07.4-.17.54-.28s.24-.25.3-.4c.06-.15.09-.3.09-.45,0-.31-.07-.54-.21-.69s-.3-.25-.46-.32c-.29-.11-.63-.21-1.01-.3-.39-.1-.86-.22-1.43-.37-.35-.09-.64-.21-.88-.36-.23-.15-.42-.32-.56-.5-.14-.18-.24-.38-.29-.58-.06-.21-.09-.42-.09-.63,0-.41.09-.77.26-1.07.17-.3.4-.55.68-.75s.6-.35.96-.44c.36-.1.72-.14,1.09-.14.43,0,.83.06,1.21.17.38.11.71.28,1,.5s.51.5.68.82c.17.33.25.7.25,1.13h-1.43c-.04-.53-.22-.9-.54-1.12s-.73-.33-1.23-.33c-.17,0-.34.02-.52.05s-.34.09-.48.17c-.15.08-.27.19-.36.33s-.14.31-.14.52c0,.29.09.52.27.68s.41.29.71.37c.03,0,.15.04.36.1s.45.12.71.19.51.14.76.2c.25.07.43.11.53.14.27.08.5.2.7.34.2.15.37.31.5.5s.23.39.3.6c.06.21.1.43.1.64,0,.46-.09.85-.28,1.18s-.43.59-.74.8-.65.36-1.04.45c-.39.1-.79.14-1.19.14-.47,0-.91-.06-1.32-.17-.41-.11-.77-.29-1.08-.53s-.55-.54-.73-.91-.28-.81-.29-1.31h1.43,0Z"
          />
          <path
            className="st3"
            d="M42.49,420.5h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19h.01ZM41.99,425.43h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st3"
            d="M47.95,420.5h5.65v1.24h-4.22v2.14h3.7v1.17h-3.7v3.64h-1.43v-8.19h0Z"
          />
          <path
            className="st3"
            d="M54.75,420.5h5.89v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19h0Z"
          />
          <path
            className="st3"
            d="M130.9,420.5h2.02l2.26,6.41h.02l2.2-6.41h2v8.19h-1.36v-6.32h-.02l-2.27,6.32h-1.18l-2.27-6.32h-.02v6.32h-1.36v-8.19h-.02Z"
          />
          <path className="st3" d="M141.12,420.5h1.43v8.19h-1.43v-8.19Z" />
          <path
            className="st3"
            d="M149.84,423.1c-.06-.24-.15-.45-.25-.65-.11-.2-.24-.37-.41-.52s-.37-.26-.59-.34c-.23-.08-.49-.12-.79-.12-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1s-.14.76-.14,1.15.05.77.14,1.15c.1.37.24.71.44,1s.46.53.77.71c.32.18.69.26,1.13.26.32,0,.6-.06.85-.17.24-.11.45-.26.63-.46s.31-.42.41-.68c.1-.26.16-.54.19-.84h1.4c-.03.49-.14.94-.32,1.34s-.42.76-.73,1.05c-.31.29-.67.52-1.08.68s-.87.24-1.36.24c-.61,0-1.16-.11-1.65-.34-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36c-.18-.52-.27-1.07-.27-1.66s.09-1.13.27-1.65.44-.97.77-1.36c.34-.39.75-.7,1.23-.93s1.03-.34,1.65-.34c.46,0,.89.06,1.3.19s.76.31,1.07.55.56.53.75.88c.19.34.31.74.36,1.18h-1.43Z"
          />
          <path
            className="st3"
            d="M152.59,420.5h3.91c.9,0,1.58.19,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97s-.25.46-.4.62-.3.27-.45.34-.26.11-.33.14v.02c.12.02.25.05.4.11.14.06.27.16.4.29.12.13.22.31.3.52s.12.48.12.8c0,.48.04.92.11,1.31.07.39.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58s-.03-.42-.03-.62c0-.37-.02-.7-.07-.97s-.13-.5-.25-.68-.29-.31-.5-.4c-.21-.08-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19.03ZM154.02,424.23h2.35c.46,0,.81-.11,1.04-.33s.36-.54.36-.98c0-.26-.04-.47-.11-.64-.08-.16-.18-.29-.32-.38-.13-.09-.29-.15-.46-.18-.17-.03-.35-.05-.53-.05h-2.33v2.56h0Z"
          />
          <path
            className="st3"
            d="M164.15,420.3c.61,0,1.16.11,1.65.34s.9.54,1.23.93c.34.39.59.84.77,1.36s.27,1.07.27,1.65-.09,1.14-.27,1.66c-.18.52-.44.98-.77,1.36s-.75.7-1.23.92c-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92-.34-.39-.59-.84-.77-1.36-.18-.52-.27-1.07-.27-1.66s.09-1.13.27-1.65c.18-.52.44-.97.77-1.36.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34ZM164.15,421.47c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1s.46.53.77.71c.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1,.1-.37.14-.76.14-1.15s-.05-.77-.14-1.15-.24-.71-.44-1-.46-.53-.77-.71c-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st3"
            d="M168.58,420.5h1.46l1.48,6.26h.02l1.65-6.26h1.47l1.61,6.26h.02l1.53-6.26h1.46l-2.26,8.19h-1.46l-1.64-6.26h-.02l-1.67,6.26h-1.48l-2.16-8.19h-.01Z"
          />
          <path
            className="st3"
            d="M182.11,420.5h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19h.01ZM181.61,425.43h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st3"
            d="M185.93,420.5h1.49l2.05,6.48h.02l2.1-6.48h1.46l-2.8,8.19h-1.59l-2.73-8.19h0Z"
          />
          <path
            className="st3"
            d="M193.87,420.5h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19h0Z"
          />
          <path
            className="st3"
            d="M205.22,425.96c0,.31.05.58.16.8s.26.4.45.54.41.24.66.31.52.1.81.1c.31,0,.58-.04.8-.11.22-.07.4-.17.54-.28s.24-.25.3-.4.09-.3.09-.45c0-.31-.07-.54-.21-.69s-.3-.25-.46-.32c-.29-.11-.63-.21-1.01-.3-.39-.1-.86-.22-1.43-.37-.35-.09-.64-.21-.88-.36-.23-.15-.42-.32-.56-.5s-.24-.38-.29-.58c-.06-.21-.09-.42-.09-.63,0-.41.09-.77.26-1.07.17-.3.4-.55.68-.75s.6-.35.96-.44c.36-.1.72-.14,1.09-.14.43,0,.83.06,1.21.17.38.11.71.28,1,.5s.51.5.68.82c.17.33.25.7.25,1.13h-1.43c-.04-.53-.22-.9-.54-1.12-.32-.22-.73-.33-1.23-.33-.17,0-.34.02-.52.05-.18.03-.34.09-.48.17-.15.08-.27.19-.36.33s-.14.31-.14.52c0,.29.09.52.27.68.18.16.41.29.71.37.03,0,.15.04.36.1s.45.12.71.19c.26.07.51.14.76.2.25.07.43.11.53.14.27.08.5.2.7.34.2.15.37.31.5.5s.23.39.3.6c.06.21.1.43.1.64,0,.46-.09.85-.28,1.18s-.43.59-.74.8c-.31.21-.65.36-1.04.45-.39.1-.79.14-1.19.14-.47,0-.91-.06-1.32-.17-.41-.11-.77-.29-1.08-.53s-.55-.54-.73-.91-.28-.81-.29-1.31h1.43-.01Z"
          />
          <path
            className="st3"
            d="M213.9,420.5h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19h.01ZM213.4,425.43h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st3"
            d="M219.36,420.5h5.65v1.24h-4.22v2.14h3.7v1.17h-3.7v3.64h-1.43v-8.19h0Z"
          />
          <path
            className="st3"
            d="M226.16,420.5h5.89v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19h.01Z"
          />
          <polygon
            className="st1"
            points="53.89 386.24 51.69 386.24 51.69 350.67 5.38 350.67 5.38 348.46 53.89 348.46 53.89 386.24"
          />
          <polygon
            className="st3"
            points="53.23 391.38 4.72 391.38 4.72 353.75 6.93 353.75 6.93 389.18 53.23 389.18 53.23 391.38"
          />
          <path
            className="st3"
            d="M47.04,383.8H11.58v-20.49h35.46v20.49ZM13.79,381.59h31.04v-16.08H13.79v16.08Z"
          />
          <rect
            className="st3"
            x="11.44"
            y="355.94"
            width="35.54"
            height="2.21"
          />
          <polygon
            className="st1"
            points="205.29 384.1 203.08 384.1 203.08 353.39 154.14 353.39 154.14 351.18 205.29 351.18 205.29 384.1"
          />
          <polygon
            className="st3"
            points="204.63 388.66 153.48 388.66 153.48 355.99 155.68 355.99 155.68 386.45 204.63 386.45 204.63 388.66"
          />
          <path
            className="st3"
            d="M192.61,382.91h-33.19v-25.24h33.19v25.24ZM161.62,380.7h28.78v-20.83h-28.78v20.83Z"
          />
          <rect
            className="st3"
            x="196.22"
            y="358.11"
            width="3.69"
            height="2.21"
          />
          <rect
            className="st3"
            x="196.22"
            y="363.67"
            width="3.69"
            height="2.21"
          />
          <rect
            className="st3"
            x="196.22"
            y="369.24"
            width="3.69"
            height="2.21"
          />
          <polygon
            className="st1"
            points="352.35 388.44 350.15 388.44 350.15 348.43 305.62 348.43 305.62 346.22 352.35 346.22 352.35 388.44"
          />
          <polygon
            className="st3"
            points="351.69 393.62 304.96 393.62 304.96 351.85 307.16 351.85 307.16 391.42 351.69 391.42 351.69 393.62"
          />
          <path
            className="st3"
            d="M347.17,389.08h-37.02v-31.04h37.02v31.04ZM312.35,386.87h32.61v-26.62h-32.61v26.62h0Z"
          />
          <rect
            className="st3"
            x="327.55"
            y="359.14"
            width="2.21"
            height="8.06"
          />
          <rect
            className="st3"
            x="317.38"
            y="360.89"
            width="8.07"
            height="2.21"
            transform="translate(-161.83 333.3) rotate(-45)"
          />
          <rect
            className="st3"
            x="334.8"
            y="357.95"
            width="2.21"
            height="8.07"
            transform="translate(-157.58 343.55) rotate(-45)"
          />
          <path
            className="st3"
            d="M336.72,388.59l-1.76-1.33c1.03-1.37,1.58-3.01,1.58-4.73,0-4.34-3.53-7.87-7.87-7.87s-7.87,3.53-7.87,7.87c0,1.72.54,3.36,1.58,4.73l-1.76,1.33c-1.32-1.76-2.02-3.85-2.02-6.05,0-5.56,4.52-10.08,10.08-10.08s10.08,4.52,10.08,10.08c0,2.2-.7,4.3-2.02,6.05h-.02Z"
          />
          <rect
            className="st3"
            x="310.63"
            y="352.12"
            width="36.25"
            height="2.21"
          />
          <rect
            className="st0"
            x="-7.99"
            y="206.34"
            width="74.6"
            height="74.6"
          />
          <rect
            className="st0"
            x="142.09"
            y="206.34"
            width="74.6"
            height="74.6"
          />
          <rect
            className="st0"
            x="292.16"
            y="206.34"
            width="74.6"
            height="74.6"
          />
          <rect
            className="st0"
            x="-7.99"
            y="331.32"
            width="74.6"
            height="74.6"
          />
          <rect
            className="st0"
            x="142.09"
            y="331.32"
            width="74.6"
            height="74.6"
          />
          <rect
            className="st0"
            x="292.16"
            y="331.32"
            width="74.6"
            height="74.6"
          />
        </g>
        <g
          className={clsx({
            animation_left: showAnimation,
            complete: !showAnimation,
          })}
        >
          <polygon
            className="st1"
            points="339.1 592.76 336.89 592.76 336.89 590.24 322.48 590.24 322.48 592.76 320.27 592.76 320.27 588.03 339.1 588.03 339.1 592.76"
          />
          <g>
            <path
              className="st3"
              d="M4.58,539.67h5.65v1.24h-4.22v2.14h3.7v1.17h-3.7v3.64h-1.43s0-8.19,0-8.19Z"
            />
            <path
              className="st3"
              d="M11.38,539.67h3.91c.9,0,1.58.19,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97-.11.26-.25.46-.4.62s-.3.27-.45.34-.26.11-.33.14v.02c.12.02.25.05.4.11.14.06.27.16.4.29.12.13.22.31.3.52s.12.48.12.8c0,.48.04.92.11,1.31s.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58s-.03-.42-.03-.62c0-.37-.02-.7-.07-.97s-.13-.5-.25-.68-.29-.31-.5-.4-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19.03ZM12.81,543.4h2.35c.46,0,.81-.11,1.04-.33.23-.22.36-.54.36-.98,0-.26-.04-.47-.11-.64s-.18-.29-.32-.38-.29-.15-.46-.18-.35-.05-.53-.05h-2.33s0,2.56,0,2.56Z"
            />
            <path
              className="st3"
              d="M19.46,539.67h5.89v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19h0Z"
            />
            <path
              className="st3"
              d="M26.68,539.67h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98s0-8.19,0-8.19Z"
            />
            <path
              className="st3"
              d="M33.66,539.67h6.23v1.09l-4.77,5.86h4.89v1.24h-6.71v-1.17l4.77-5.78h-4.4v-1.24h0Z"
            />
            <path
              className="st3"
              d="M41.13,539.67h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98s0-8.19,0-8.19Z"
            />
            <path
              className="st3"
              d="M48.36,539.67h3.91c.9,0,1.58.19,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97s-.25.46-.4.62-.3.27-.45.34-.26.11-.33.14v.02c.12.02.25.05.4.11.14.06.27.16.4.29.12.13.22.31.3.52.08.21.12.48.12.8,0,.48.04.92.11,1.31s.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58s-.03-.42-.03-.62c0-.37-.02-.7-.07-.97-.05-.27-.13-.5-.25-.68s-.29-.31-.5-.4-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19.03ZM49.79,543.4h2.35c.46,0,.81-.11,1.04-.33s.36-.54.36-.98c0-.26-.04-.47-.12-.64-.08-.16-.18-.29-.32-.38-.13-.09-.29-.15-.46-.18-.17-.03-.35-.05-.53-.05h-2.33v2.56h0Z"
            />
            <rect
              className="st3"
              x="28.21"
              y="471.99"
              width="2.21"
              height="16.36"
            />
            <rect
              className="st3"
              x="28.46"
              y="476.09"
              width="6.66"
              height="2.21"
              transform="translate(-328.12 162.24) rotate(-45)"
            />
            <rect
              className="st3"
              x="25.98"
              y="473.87"
              width="2.21"
              height="6.66"
              transform="translate(-329.5 158.92) rotate(-45)"
            />
            <rect
              className="st3"
              x="21.12"
              y="476.08"
              width="2.21"
              height="16.36"
              transform="translate(-408.27 261.38) rotate(-60)"
            />
            <rect
              className="st3"
              x="19.77"
              y="477.3"
              width="2.21"
              height="6.66"
              transform="translate(-123.69 21.78) rotate(-15)"
            />
            <rect
              className="st3"
              x="15.23"
              y="483.59"
              width="6.66"
              height="2.21"
              transform="translate(-124.9 21.34) rotate(-15.01)"
            />
            <rect
              className="st3"
              x="14.05"
              y="491.34"
              width="16.36"
              height="2.21"
              transform="translate(-243.24 77.09) rotate(-30)"
            />
            <rect
              className="st3"
              x="17.3"
              y="488.46"
              width="2.21"
              height="6.66"
              transform="translate(-461.39 382.29) rotate(-75)"
            />
            <rect
              className="st3"
              x="17.44"
              y="494.79"
              width="6.66"
              height="2.21"
              transform="translate(-463.62 387.7) rotate(-75.01)"
            />
            <rect
              className="st3"
              x="28.21"
              y="488.35"
              width="2.21"
              height="16.36"
            />
            <rect
              className="st3"
              x="23.51"
              y="498.4"
              width="6.66"
              height="2.21"
              transform="translate(-345.34 165.28) rotate(-45)"
            />
            <rect
              className="st3"
              x="30.45"
              y="496.15"
              width="2.21"
              height="6.66"
              transform="translate(-343.95 168.61) rotate(-45)"
            />
            <rect
              className="st3"
              x="35.3"
              y="484.25"
              width="2.21"
              height="16.36"
              transform="translate(-408.26 277.74) rotate(-60)"
            />
            <rect
              className="st3"
              x="36.61"
              y="492.75"
              width="2.21"
              height="6.66"
              transform="translate(-127.11 26.66) rotate(-15)"
            />
            <rect
              className="st3"
              x="36.77"
              y="490.88"
              width="6.66"
              height="2.21"
              transform="translate(-126.05 27.17) rotate(-15.01)"
            />
            <rect
              className="st3"
              x="28.22"
              y="483.16"
              width="16.36"
              height="2.21"
              transform="translate(-237.26 83.08) rotate(-30)"
            />
            <rect
              className="st3"
              x="39.11"
              y="481.57"
              width="2.21"
              height="6.66"
              transform="translate(-438.57 398.24) rotate(-75)"
            />
            <rect
              className="st3"
              x="34.52"
              y="479.75"
              width="6.66"
              height="2.21"
              transform="translate(-436.4 392.88) rotate(-74.99)"
            />
            <polygon
              className="st1"
              points="52.06 504.97 49.86 504.97 49.86 466.67 7.67 466.67 7.67 464.46 52.06 464.46 52.06 504.97"
            />
            <polygon
              className="st3"
              points="50.96 509.95 6.57 509.95 6.57 469.76 8.77 469.76 8.77 507.75 50.96 507.75 50.96 509.95"
            />
            <rect
              className="st0"
              x="-7.98"
              y="451.37"
              width="74.6"
              height="74.6"
            />
          </g>
          <g>
            <polygon
              className="st1"
              points="202.14 504.97 199.93 504.97 199.93 466.67 157.74 466.67 157.74 464.46 202.14 464.46 202.14 504.97"
            />
            <polygon
              className="st3"
              points="201.03 509.95 156.64 509.95 156.64 469.76 158.85 469.76 158.85 507.75 201.03 507.75 201.03 509.95"
            />
            <path
              className="st2"
              d="M186.15,499.42h-13.52c-2.64,0-4.78-2.14-4.78-4.78v-18.4h2.21v18.4c0,1.42,1.15,2.57,2.57,2.57h13.52c1.42,0,2.57-1.15,2.57-2.57v-18.4h2.21v18.4c0,2.64-2.14,4.78-4.78,4.78h0Z"
            />
            <polygon
              className="st2"
              points="187.72 502.93 171.06 502.93 171.06 498.82 173.27 498.82 173.27 500.72 185.51 500.72 185.51 498.82 187.72 498.82 187.72 502.93"
            />
            <path
              className="st3"
              d="M153.35,531.48h1.51l3.74,6.03h.02v-6.03h1.37v8.19h-1.51l-3.73-6.02h-.03v6.02h-1.37v-8.19h0Z"
            />
            <path
              className="st3"
              d="M165.17,531.29c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.36.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66-.44.97-.77,1.36c-.34.39-.75.7-1.23.92-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34ZM165.17,532.46c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1s.46.53.77.71c.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1,.1-.37.14-.76.14-1.15s-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1s-.46-.53-.77-.71c-.32-.18-.69-.26-1.13-.26Z"
            />
            <path
              className="st3"
              d="M170.35,531.48h1.51l3.74,6.03h.02v-6.03h1.37v8.19h-1.51l-3.73-6.02h-.03v6.02h-1.37v-8.19h0Z"
            />
            <path className="st3" d="M178.37,535.93h3.34v1.24h-3.34v-1.24Z" />
            <path
              className="st3"
              d="M184.09,536.94c0,.31.05.58.16.8s.26.4.45.54c.19.14.41.24.66.31s.52.1.81.1c.31,0,.58-.04.8-.11s.4-.17.54-.28c.14-.11.24-.25.3-.4s.09-.3.09-.45c0-.31-.07-.54-.21-.69s-.3-.25-.46-.32c-.29-.11-.63-.21-1.01-.3-.39-.1-.86-.22-1.43-.37-.35-.09-.64-.21-.88-.36-.23-.15-.42-.32-.56-.5s-.24-.38-.29-.58-.09-.42-.09-.63c0-.41.09-.77.26-1.07s.4-.55.68-.75.6-.35.96-.44.72-.14,1.09-.14c.43,0,.83.06,1.21.17s.71.28,1,.5.51.49.68.82c.17.32.25.7.25,1.13h-1.43c-.04-.53-.22-.9-.54-1.12-.32-.22-.73-.33-1.23-.33-.17,0-.34.02-.52.05s-.34.09-.48.17c-.15.08-.27.19-.36.33-.1.14-.14.31-.14.52,0,.29.09.52.27.68s.41.29.71.37c.03,0,.15.04.36.1s.45.12.71.19c.26.07.51.14.76.2.25.07.43.11.53.14.27.08.5.2.7.34.2.15.36.31.5.5s.23.39.3.6.1.43.1.64c0,.46-.09.85-.28,1.18s-.43.59-.74.8-.65.36-1.04.45c-.39.1-.79.14-1.19.14-.47,0-.91-.06-1.32-.17s-.77-.29-1.08-.53-.55-.54-.73-.91-.28-.81-.29-1.31h1.43-.01Z"
            />
            <path
              className="st3"
              d="M190.58,531.48h1.43v6.95h4.16v1.24h-5.6v-8.19h.01Z"
            />
            <path className="st3" d="M197.16,531.48h1.43v8.19h-1.43v-8.19Z" />
            <path
              className="st3"
              d="M200.35,531.48h3.61c.58,0,1.05.08,1.42.25s.65.38.85.63c.2.25.33.53.41.83.07.3.11.57.11.83s-.04.53-.11.82-.21.57-.41.82-.48.46-.85.63c-.37.16-.84.25-1.42.25h-2.18v3.14h-1.43v-8.19h0ZM201.78,535.36h2.1c.16,0,.32-.02.49-.07s.32-.12.46-.22.26-.24.34-.41.13-.39.13-.65-.04-.49-.12-.67-.18-.32-.31-.42-.28-.17-.45-.21c-.17-.04-.35-.06-.54-.06h-2.12v2.71h.02Z"
            />
            <path
              className="st3"
              d="M128.95,550.7c0,.31.05.58.16.8s.26.4.45.54c.19.14.41.24.66.31s.52.1.81.1c.31,0,.58-.04.8-.11s.4-.17.54-.28c.14-.11.24-.25.3-.4s.09-.3.09-.45c0-.31-.07-.54-.21-.69s-.3-.25-.46-.32c-.29-.11-.63-.21-1.01-.3-.39-.1-.86-.22-1.43-.37-.35-.09-.64-.21-.88-.36-.23-.15-.42-.32-.56-.5s-.24-.38-.29-.58-.09-.42-.09-.63c0-.41.09-.77.26-1.07.17-.3.4-.55.68-.75s.6-.35.96-.44.72-.14,1.09-.14c.43,0,.83.06,1.21.17s.71.28,1,.5.51.49.68.82c.17.32.25.7.25,1.13h-1.43c-.04-.53-.22-.9-.54-1.12-.32-.22-.73-.33-1.23-.33-.17,0-.34.02-.52.05s-.34.09-.48.17c-.15.08-.27.19-.36.33-.1.14-.14.31-.14.52,0,.29.09.52.27.68s.41.29.71.37c.03,0,.15.04.36.1s.45.12.71.19c.26.07.51.14.76.2.25.07.43.11.53.14.27.08.5.2.7.34.2.15.36.31.5.5s.23.39.3.6.1.43.1.64c0,.46-.09.85-.28,1.18s-.43.59-.74.8-.65.36-1.04.45c-.39.1-.79.14-1.19.14-.47,0-.91-.06-1.32-.17s-.77-.29-1.08-.53-.55-.54-.73-.91-.28-.81-.29-1.31h1.43-.01Z"
            />
            <path className="st3" d="M135.44,545.25h1.43v8.19h-1.43v-8.19Z" />
            <path
              className="st3"
              d="M138.63,545.25h1.43v6.95h4.16v1.24h-5.6v-8.19h.01Z"
            />
            <path className="st3" d="M145.21,545.25h1.43v8.19h-1.43v-8.19Z" />
            <path
              className="st3"
              d="M153.93,547.85c-.06-.24-.15-.45-.25-.65-.11-.2-.24-.37-.41-.52-.17-.14-.37-.26-.59-.34-.23-.08-.49-.12-.79-.12-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1s.46.53.77.71c.32.18.69.26,1.13.26.32,0,.6-.06.85-.17s.45-.26.63-.46c.18-.2.31-.42.41-.68s.16-.54.2-.84h1.4c-.03.49-.14.94-.32,1.34-.18.41-.42.76-.73,1.05s-.67.52-1.08.68-.87.24-1.36.24c-.61,0-1.16-.11-1.65-.34-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34.46,0,.89.06,1.3.19.4.13.76.31,1.07.55s.56.53.75.88c.19.34.31.74.36,1.18h-1.44Z"
            />
            <path
              className="st3"
              d="M160.17,545.05c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.36.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66-.44.97-.77,1.36c-.34.39-.75.7-1.23.92-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34ZM160.17,546.22c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1s.46.53.77.71c.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1,.1-.37.14-.76.14-1.15s-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1s-.46-.53-.77-.71c-.32-.18-.69-.26-1.13-.26Z"
            />
            <path
              className="st3"
              d="M165.34,545.25h1.51l3.74,6.03h.02v-6.03h1.37v8.19h-1.51l-3.73-6.02h-.03v6.02h-1.37v-8.19h0Z"
            />
            <path
              className="st3"
              d="M173.68,545.25h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19h0Z"
            />
            <path
              className="st3"
              d="M184.09,545.25h3.98c.73,0,1.32.17,1.77.5.44.34.67.84.67,1.53,0,.41-.1.77-.3,1.06s-.49.52-.87.68v.02c.5.11.89.35,1.15.72s.39.84.39,1.39c0,.32-.06.62-.17.9s-.29.52-.54.72c-.25.2-.56.36-.94.48s-.84.18-1.36.18h-3.76v-8.19h-.02ZM185.52,548.67h2.34c.34,0,.63-.1.86-.29s.34-.48.34-.84c0-.41-.1-.7-.31-.87-.21-.17-.5-.25-.89-.25h-2.34v2.26h0ZM185.52,552.26h2.53c.44,0,.77-.11,1.02-.34.24-.23.36-.54.36-.96s-.12-.72-.36-.93c-.24-.22-.58-.33-1.02-.33h-2.53v2.56h0Z"
            />
            <path
              className="st3"
              d="M195.65,545.05c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.36.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66-.44.97-.77,1.36c-.34.39-.75.7-1.23.92-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34ZM195.65,546.22c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1s.46.53.77.71c.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1,.1-.37.14-.76.14-1.15s-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1s-.46-.53-.77-.71c-.32-.18-.69-.26-1.13-.26Z"
            />
            <path
              className="st3"
              d="M200.1,545.25h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24h-.01Z"
            />
            <path
              className="st3"
              d="M206.9,545.25h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24h-.01Z"
            />
            <path
              className="st3"
              d="M217.97,545.05c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.36.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66-.44.97-.77,1.36c-.34.39-.75.7-1.23.92-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34ZM217.97,546.22c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1s.46.53.77.71c.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1,.1-.37.14-.76.14-1.15s-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1s-.46-.53-.77-.71c-.32-.18-.69-.26-1.13-.26Z"
            />
            <path
              className="st3"
              d="M223.18,545.25h2.02l2.26,6.41h.02l2.2-6.41h2v8.19h-1.37v-6.32h-.02l-2.27,6.32h-1.18l-2.27-6.32h-.02v6.32h-1.36v-8.19h0Z"
            />
            <rect
              className="st0"
              x="142.09"
              y="451.37"
              width="74.6"
              height="74.6"
            />
          </g>
          <g>
            <polygon
              className="st1"
              points="353.16 502.21 350.96 502.21 350.96 466.42 306.87 466.42 306.87 464.21 353.16 464.21 353.16 502.21"
            />
            <path
              className="st3"
              d="M353.16,511.61h-47.4v-41.03h2.21v35.14h45.19v5.88h0ZM307.97,509.4h42.99v-1.47h-42.99v1.47Z"
            />
            <path
              className="st3"
              d="M326.08,546.65h-.92l-.22-.96c-.38.44-.76.74-1.15.91-.38.17-.82.25-1.32.25-.61,0-1.16-.11-1.65-.34-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65.44-.97.77-1.37c.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34.44,0,.87.06,1.27.18s.76.29,1.07.53c.31.23.57.53.78.88s.34.76.39,1.22h-1.4c-.04-.27-.12-.5-.25-.71s-.28-.37-.48-.51c-.19-.14-.4-.24-.64-.31-.24-.07-.49-.1-.75-.1-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15.24.71.44,1,.46.53.77.71.69.26,1.13.26c.37,0,.69-.04.98-.14.28-.1.52-.25.72-.45.19-.2.34-.43.44-.72.1-.28.15-.6.16-.94h-2.18v-1.09h3.49v4.31-.02Z"
            />
            <path
              className="st3"
              d="M329.83,538.46h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19h0ZM329.32,543.39h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
            />
            <path
              className="st3"
              d="M336.23,543.92c0,.31.05.58.16.8.11.22.26.4.45.54.19.14.41.24.66.31s.52.1.81.1c.31,0,.58-.04.8-.11s.4-.17.54-.28c.14-.11.24-.25.3-.4s.09-.3.09-.45c0-.31-.07-.54-.21-.69s-.3-.25-.46-.32c-.29-.11-.63-.21-1.02-.3-.39-.1-.86-.22-1.43-.37-.35-.09-.64-.21-.88-.36-.23-.15-.42-.32-.56-.5s-.24-.38-.29-.58c-.06-.21-.09-.42-.09-.63,0-.41.09-.77.26-1.07s.4-.55.68-.75.6-.35.96-.44c.36-.1.72-.14,1.09-.14.43,0,.83.06,1.21.17s.71.28,1,.5.51.5.68.82c.17.33.25.7.25,1.13h-1.43c-.04-.53-.22-.9-.54-1.12s-.73-.33-1.23-.33c-.17,0-.34.02-.52.05-.18.03-.34.09-.48.17s-.27.19-.36.33c-.1.14-.14.31-.14.52,0,.29.09.52.27.68s.41.29.71.37c.03,0,.15.04.36.1s.45.12.71.19c.26.07.51.14.76.2s.43.11.53.14c.27.08.5.2.7.34.2.15.36.31.5.5.13.19.23.39.3.6.06.21.1.43.1.64,0,.46-.09.85-.28,1.18s-.43.59-.74.8c-.31.21-.65.36-1.04.45-.39.1-.79.14-1.19.14-.47,0-.91-.06-1.32-.17s-.77-.29-1.08-.53-.55-.54-.73-.91-.28-.81-.29-1.31h1.43Z"
            />
            <path
              className="st2"
              d="M329.46,500.13c-3.5,0-6.79-1.36-9.27-3.84-2.48-2.48-3.84-5.77-3.84-9.27s1.36-6.79,3.84-9.27c2.48-2.48,5.77-3.84,9.27-3.84s6.79,1.36,9.27,3.84,3.84,5.77,3.84,9.27-1.36,6.79-3.84,9.27c-2.48,2.48-5.77,3.84-9.27,3.84ZM329.46,476.13c-2.79,0-5.58,1.06-7.71,3.19s-3.19,4.8-3.19,7.71,1.13,5.65,3.19,7.71c4.25,4.25,11.17,4.25,15.41,0,4.25-4.25,4.25-11.16,0-15.41-2.13-2.13-4.92-3.19-7.71-3.19h0Z"
            />
            <path
              className="st2"
              d="M329.46,492.86c-1.5,0-2.99-.57-4.13-1.71-2.28-2.28-2.28-5.98,0-8.26s5.98-2.28,8.26,0,2.28,5.98,0,8.26c-1.14,1.14-2.63,1.71-4.13,1.71ZM329.46,483.39c-.93,0-1.86.35-2.57,1.06-1.42,1.42-1.42,3.72,0,5.14s3.72,1.42,5.14,0,1.42-3.72,0-5.14c-.71-.71-1.64-1.06-2.57-1.06Z"
            />
            <rect
              className="st2"
              x="319.63"
              y="473.98"
              width="2.21"
              height="8.69"
              transform="translate(-244.29 366.89) rotate(-45)"
            />
            <rect
              className="st2"
              x="337.09"
              y="491.41"
              width="2.21"
              height="8.69"
              transform="translate(-251.5 384.34) rotate(-45)"
            />
            <rect
              className="st2"
              x="333.86"
              y="477.2"
              width="8.69"
              height="2.21"
              transform="translate(-239.15 379.24) rotate(-45)"
            />
            <rect
              className="st2"
              x="316.39"
              y="494.65"
              width="8.69"
              height="2.21"
              transform="translate(-256.61 372) rotate(-45)"
            />
            <rect
              className="st0"
              x="292.17"
              y="451.37"
              width="74.6"
              height="74.6"
            />
          </g>
          <g>
            <polygon
              className="st1"
              points="37.19 630.26 34.99 630.26 34.99 591.98 14.84 591.98 14.84 589.78 37.19 589.78 37.19 630.26"
            />
            <polygon
              className="st3"
              points="36.09 637.17 13.74 637.17 13.74 596.15 15.95 596.15 15.95 634.97 36.09 634.97 36.09 637.17"
            />
            <path
              className="st3"
              d="M44.45,608.95h-18.96v-2.21h18.96c1.89,0,3.43-1.54,3.43-3.43s-1.54-3.43-3.43-3.43c-.29,0-1.9.13-1.9,1.44h-2.21c0-2.81,2.67-3.61,4.08-3.64,3.13,0,5.66,2.53,5.66,5.63s-2.53,5.64-5.63,5.64Z"
            />
            <path
              className="st3"
              d="M44.4,631.41c-1.43-.03-4.11-.83-4.11-3.64h2.21c0,.23.09,1.38,1.93,1.44,1.86,0,3.4-1.54,3.4-3.43s-1.54-3.43-3.43-3.43h-18.96v-2.21h18.96c3.11,0,5.63,2.53,5.63,5.63s-2.53,5.64-5.63,5.64Z"
            />
            <path
              className="st3"
              d="M55.8,616.2h-30.31v-2.21h30.31c1.89,0,3.43-1.54,3.43-3.43s-1.54-3.43-3.43-3.43c-.29,0-1.9.13-1.9,1.44h-2.21c0-2.81,2.67-3.61,4.08-3.64,3.13,0,5.66,2.53,5.66,5.63s-2.53,5.63-5.64,5.63h.01Z"
            />
            <rect
              className="st3"
              x="5.79"
              y="606.75"
              width="5.5"
              height="2.21"
            />
            <rect
              className="st3"
              x="-2.22"
              y="606.75"
              width="5.5"
              height="2.21"
            />
            <rect className="st3" x="5.79" y="614" width="5.5" height="2.21" />
            <rect className="st3" x="-2.22" y="614" width="5.5" height="2.21" />
            <rect
              className="st3"
              x="5.79"
              y="620.14"
              width="5.5"
              height="2.21"
            />
            <rect
              className="st3"
              x="-2.22"
              y="620.14"
              width="5.5"
              height="2.21"
            />
            <rect
              className="st0"
              x="-7.98"
              y="576.16"
              width="74.6"
              height="74.6"
            />
          </g>
          <g>
            <polygon
              className="st3"
              points="170.2 608.77 156.64 608.77 156.64 593.21 158.85 593.21 158.85 606.57 170.2 606.57 170.2 608.77"
            />
            <polygon
              className="st1"
              points="202.14 603.79 199.93 603.79 199.93 590.12 157.74 590.12 157.74 587.91 202.14 587.91 202.14 603.79"
            />
            <path
              className="st3"
              d="M193.44,637.99h-2.21v-2.02c0-1.93.55-3.57,1.08-5.16.55-1.64,1.12-3.33,1.12-5.46v-11.74c0-1.01-.82-1.83-1.83-1.83s-1.83.82-1.83,1.83c0,.61-.49,1.1-1.1,1.1s-1.1-.49-1.1-1.1v-2.2c0-1.01-.82-1.83-1.83-1.83s-1.83.82-1.83,1.83c0,.61-.49,1.1-1.1,1.1s-1.1-.49-1.1-1.1v-2.2c0-1.01-.82-1.83-1.83-1.83s-1.83.82-1.83,1.83c0,.61-.49,1.1-1.1,1.1s-1.1-.49-1.1-1.1v-10.27c0-1.01-.82-1.83-1.83-1.83s-1.83.82-1.83,1.83v20.55c0,.47-.3.89-.74,1.04-.44.16-.93.01-1.23-.36-1.8-2.27-2.91-3.63-3.58-4.31-.84-.85-1.69-1.15-2.16-1.15-1.12,0-1.83.29-2.25.55.8,1.44,2.12,4.4,4.73,10.38.71,1.61,1.63,2.88,2.53,4.1,1.39,1.89,2.7,3.68,2.7,6.22v2.02h-2.21v-2.02c0-1.82-1-3.19-2.27-4.92-.92-1.26-1.97-2.69-2.77-4.52-3.77-8.63-4.71-10.35-4.91-10.69-.05-.05-.1-.11-.14-.17-.24-.37-.23-.85.02-1.22.22-.32,1.49-1.94,4.57-1.94,1.21,0,2.6.67,3.72,1.79.45.44,1.01,1.1,1.79,2.04v-17.41c0-2.23,1.81-4.04,4.04-4.04s4.04,1.81,4.04,4.04v6.68c.55-.28,1.17-.44,1.83-.44,1.78,0,3.29,1.16,3.83,2.76.6-.35,1.3-.55,2.04-.55,1.78,0,3.29,1.16,3.83,2.76.6-.35,1.3-.55,2.04-.55,2.23,0,4.04,1.81,4.04,4.04v11.74c0,2.48-.65,4.43-1.23,6.16-.5,1.48-.97,2.89-.97,4.46v2.02h-.04ZM160.51,616.14c.14.04.29.05.46.02-.16.03-.31.02-.46-.02Z"
            />
            <rect
              className="st3"
              x="181.02"
              y="606.01"
              width="21.08"
              height="2.21"
            />
            <rect
              className="st0"
              x="142.09"
              y="576.16"
              width="74.6"
              height="74.6"
            />
          </g>
          <g>
            <polygon
              className="st1"
              points="346.92 632.76 344.71 632.76 344.71 593.86 313.07 593.86 313.07 591.65 346.92 591.65 346.92 632.76"
            />
            <polygon
              className="st3"
              points="345.82 637.8 311.97 637.8 311.97 597.02 314.18 597.02 314.18 635.6 345.82 635.6 345.82 637.8"
            />
            <path
              className="st2"
              d="M320.68,608.93h8.24v1.63c-.63.71-1.2,1.45-1.72,2.21s-.97,1.57-1.35,2.43c-.38.85-.7,1.76-.94,2.71s-.4,1.97-.48,3.06h-2.15c.07-.95.23-1.89.49-2.82.26-.93.59-1.83,1-2.7s.88-1.71,1.42-2.51,1.12-1.55,1.74-2.25h-6.24v-1.75h0Z"
            />
            <path
              className="st2"
              d="M330.95,608.69h2.15v10.43h6.24v1.86h-8.4v-12.28h.01Z"
            />
            <rect
              className="st3"
              x="314.65"
              y="637.44"
              width="2.21"
              height="2.41"
            />
            <rect
              className="st3"
              x="340.72"
              y="637.44"
              width="2.21"
              height="2.41"
            />
            <rect
              className="st0"
              x="292.17"
              y="576.16"
              width="74.6"
              height="74.6"
            />
          </g>
        </g>
      </svg>
    );
  }
  return (
    <svg
      className="section_bg"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 1366 768"
    >
      <defs>
        <style>
          {`.st0, .st1, .st2, .st3, .st4, .st5 {
        fill: none;
      }

      .st6 {
        fill: #3a32f5;
      }

      .st1 {
        stroke-linejoin: bevel;
      }

      .st1, .st2, .st3 {
        stroke-width: 5px;
      }

      .st1, .st3 {
        stroke: #221714;
      }

      .st7 {
        fill: #040000;
      }

      .st2 {
        stroke: #344d9e;
      }

      .st2, .st3, .st4 {
        stroke-miterlimit: 10;
      }

      .st8 {
        fill: #221714;
      }

      .st4 {
        stroke: #040000;
        stroke-width: .75px;
      }

      .st5 {
        opacity: .37;
      }`}
        </style>
      </defs>
      <g
        className={clsx({
          animation_left: showAnimation,
          complete: !showAnimation,
        })}
      >
        <g>
          <polygon
            className="st6"
            points="110.45 81.8 108.24 81.8 108.24 42.1 63.27 42.1 63.27 39.9 110.45 39.9 110.45 81.8"
          />
          <polygon
            className="st8"
            points="110.23 87.3 63.05 87.3 63.05 44.31 65.25 44.31 65.25 85.09 110.23 85.09 110.23 87.3"
          />
          <path
            className="st8"
            d="M86.59,79.06c-5.65,0-10.25-4.6-10.25-10.25,0-5.21,8.36-18.94,9.31-20.49l.94-1.53.94,1.53c.95,1.55,9.31,15.28,9.31,20.49,0,5.65-4.6,10.25-10.25,10.25ZM86.59,51.04c-2.89,4.88-8.04,14.31-8.04,17.77,0,4.44,3.61,8.04,8.04,8.04s8.04-3.61,8.04-8.04c0-3.47-5.16-12.89-8.04-17.77Z"
          />
          <path
            className="st8"
            d="M48.66,114.18h1.46l1.48,6.26h.02l1.65-6.26h1.47l1.61,6.26h.02l1.53-6.26h1.46l-2.26,8.19h-1.46l-1.64-6.26h-.02l-1.67,6.26h-1.48l-2.16-8.19Z"
          />
          <path
            className="st8"
            d="M62.2,114.18h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM61.69,119.11h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st8"
            d="M65.82,114.18h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <path
            className="st8"
            d="M73.4,114.18h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st8"
            d="M80.63,114.18h3.91c.9,0,1.58.19,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97-.11.26-.25.46-.4.62s-.3.27-.45.34c-.15.07-.26.11-.33.14v.02c.12.02.25.05.4.11.14.06.27.16.4.29.12.13.22.31.3.52.08.21.12.48.12.8,0,.48.04.92.11,1.31.07.39.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58-.02-.21-.03-.42-.03-.62,0-.37-.02-.7-.07-.97-.05-.27-.13-.5-.25-.68s-.29-.31-.5-.4c-.21-.08-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19ZM82.06,117.9h2.35c.46,0,.81-.11,1.04-.33s.36-.54.36-.98c0-.26-.04-.47-.11-.64-.08-.16-.18-.29-.32-.38-.13-.09-.29-.15-.46-.18-.17-.03-.35-.05-.53-.05h-2.33v2.56Z"
          />
          <path
            className="st8"
            d="M91.11,114.18h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <path className="st8" d="M98.69,114.18h1.43v8.19h-1.43v-8.19Z" />
          <path
            className="st8"
            d="M109.02,122.36h-.92l-.22-.96c-.38.44-.76.74-1.15.91-.38.17-.82.25-1.32.25-.61,0-1.16-.11-1.65-.34-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36c-.18-.52-.27-1.07-.27-1.66s.09-1.13.27-1.65c.18-.52.44-.97.77-1.36.34-.39.75-.7,1.23-.93s1.03-.34,1.65-.34c.44,0,.87.06,1.27.18.4.12.76.29,1.07.53.31.23.57.53.78.88.21.35.34.76.39,1.22h-1.4c-.04-.27-.12-.5-.25-.71-.13-.2-.29-.37-.48-.51-.19-.14-.41-.24-.64-.31-.24-.07-.49-.1-.75-.1-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1s-.14.76-.14,1.15.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26.37,0,.69-.04.98-.14.28-.1.52-.25.72-.45.19-.2.34-.43.44-.72.1-.28.15-.6.16-.94h-2.18v-1.09h3.49v4.31Z"
          />
          <path
            className="st8"
            d="M110.55,114.18h1.43v3.26h3.73v-3.26h1.43v8.19h-1.43v-3.69h-3.73v3.69h-1.43v-8.19Z"
          />
          <path
            className="st8"
            d="M118.08,114.18h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <rect
            className="st8"
            x="63.56"
            y="63.02"
            width="46.15"
            height="2.21"
            transform="translate(-19.97 80.04) rotate(-45)"
          />
          <rect className="st5" x="49.74" y="25" width="74.6" height="74.6" />
        </g>
        <g>
          <path
            className="st8"
            d="M230.87,114.18h3.98c.73,0,1.32.17,1.77.5s.67.84.67,1.53c0,.41-.1.77-.3,1.06-.2.29-.49.52-.87.68v.02c.5.11.89.35,1.15.72.26.37.39.84.39,1.39,0,.32-.06.62-.17.9s-.29.52-.54.72c-.24.2-.56.36-.94.48-.38.12-.84.18-1.37.18h-3.76v-8.19ZM232.3,117.61h2.34c.34,0,.63-.1.86-.29.23-.19.34-.48.34-.84,0-.41-.1-.7-.31-.87-.21-.17-.5-.25-.89-.25h-2.34v2.26ZM232.3,121.19h2.53c.44,0,.77-.11,1.01-.34.24-.23.36-.54.36-.96s-.12-.72-.36-.93c-.24-.22-.58-.33-1.01-.33h-2.53v2.56Z"
          />
          <path
            className="st8"
            d="M238.94,114.18h3.61c.58,0,1.06.08,1.42.25.37.17.65.38.85.63.2.25.33.53.41.83.07.3.11.57.11.83s-.04.53-.11.82c-.07.29-.21.57-.41.82-.2.25-.48.46-.85.63-.37.16-.84.25-1.42.25h-2.18v3.14h-1.43v-8.19ZM240.38,118.05h2.1c.16,0,.32-.02.49-.07s.32-.12.46-.22c.14-.1.26-.24.34-.41.09-.17.13-.39.13-.65s-.04-.49-.11-.67c-.08-.18-.18-.32-.31-.42-.13-.1-.28-.17-.45-.21-.17-.04-.35-.06-.54-.06h-2.12v2.71Z"
          />
          <path
            className="st8"
            d="M247.93,114.18h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM247.43,119.11h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st8"
            d="M256.58,114.18h5.65v1.24h-4.22v2.14h3.7v1.17h-3.7v3.64h-1.43v-8.19Z"
          />
          <path
            className="st8"
            d="M263.38,114.18h3.91c.9,0,1.58.19,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97-.11.26-.25.46-.4.62-.15.16-.3.27-.45.34-.15.07-.26.11-.33.14v.02c.12.02.25.05.4.11.14.06.27.16.4.29.12.13.22.31.3.52.08.21.12.48.12.8,0,.48.04.92.11,1.31.07.39.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58-.02-.21-.03-.42-.03-.62,0-.37-.02-.7-.07-.97-.05-.27-.13-.5-.25-.68-.12-.18-.29-.31-.5-.4-.21-.08-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19ZM264.82,117.9h2.35c.46,0,.81-.11,1.04-.33s.36-.54.36-.98c0-.26-.04-.47-.12-.64-.08-.16-.18-.29-.32-.38-.13-.09-.29-.15-.46-.18-.17-.03-.35-.05-.53-.05h-2.33v2.56Z"
          />
          <path
            className="st8"
            d="M271.46,114.18h5.89v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st8"
            d="M278.68,114.18h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st8"
            d="M247.55,54.66c.3,0,.63,0,.98,0,.35,0,.7.03,1.04.06.34.03.67.08.96.15.3.07.55.17.76.3.46.28.86.66,1.18,1.15.32.49.49,1.09.49,1.81,0,.75-.18,1.41-.55,1.96-.36.55-.88.96-1.56,1.22v.04c.87.19,1.54.58,2,1.19.46.61.69,1.35.69,2.22,0,.52-.09,1.02-.28,1.51-.19.49-.46.92-.82,1.3-.36.38-.81.68-1.35.91-.54.23-1.15.35-1.86.35h-6.85v-14.17h5.14ZM248.06,60.75c1.07,0,1.84-.19,2.31-.57.47-.38.7-.94.7-1.7,0-.5-.08-.9-.24-1.19-.16-.29-.38-.52-.66-.67-.28-.16-.6-.26-.96-.31-.36-.05-.75-.07-1.16-.07h-3.77v4.51h3.77ZM249.02,67.24c.83,0,1.49-.22,1.96-.67.47-.45.7-1.07.7-1.87,0-.46-.09-.85-.26-1.15-.17-.3-.4-.55-.68-.72-.28-.18-.61-.3-.98-.38-.37-.07-.75-.11-1.15-.11h-4.31v4.9h4.72Z"
          />
          <path
            className="st8"
            d="M262.22,54.66c1.43,0,2.51.37,3.25,1.1.73.73,1.1,1.76,1.1,3.09s-.37,2.36-1.1,3.1c-.73.74-1.82,1.11-3.25,1.09h-4.33v5.8h-1.89v-14.17h6.21ZM261.58,61.45c1.07.01,1.86-.2,2.35-.65.5-.45.74-1.1.74-1.95s-.25-1.49-.74-1.94c-.5-.44-1.28-.66-2.35-.66h-3.69v5.2h3.69Z"
          />
          <path
            className="st8"
            d="M273.33,54.66l5.54,14.17h-2.08l-1.55-4.27h-6l-1.59,4.27h-1.93l5.52-14.17h2.08ZM274.64,62.97l-2.36-6.61h-.04l-2.4,6.61h4.8Z"
          />
          <polygon
            className="st6"
            points="289.51 81.43 287.3 81.43 287.3 43.44 230.94 43.44 230.94 41.24 289.51 41.24 289.51 81.43"
          />
          <polygon
            className="st8"
            points="283.83 84.35 225.54 84.35 225.54 42.34 227.75 42.34 227.75 82.15 283.83 82.15 283.83 84.35"
          />
          <path className="st1" d="M235.24,48.93" />
          <rect
            className="st8"
            x="230.14"
            y="61.65"
            width="54.57"
            height="2.21"
            transform="translate(1.82 132.55) rotate(-28.97)"
          />
          <rect className="st5" x="219.81" y="25" width="74.6" height="74.6" />
        </g>
        <g>
          <path
            className="st8"
            d="M399.82,113.98c.61,0,1.16.11,1.65.34s.9.54,1.23.93c.34.39.59.84.77,1.36.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66c-.18.52-.44.98-.77,1.36s-.75.7-1.23.92c-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36c-.18-.52-.27-1.07-.27-1.66s.09-1.13.27-1.65.44-.97.77-1.36c.34-.39.75-.7,1.23-.93s1.03-.34,1.65-.34ZM399.82,115.15c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1s-.14.76-.14,1.15.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1,.1-.37.14-.76.14-1.15s-.05-.77-.14-1.15-.24-.71-.44-1c-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st8"
            d="M404.12,114.18h1.49l2.05,6.48h.02l2.1-6.48h1.46l-2.8,8.19h-1.59l-2.73-8.19Z"
          />
          <path
            className="st8"
            d="M412.05,114.18h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st8"
            d="M419.22,114.18h1.51l3.74,6.03h.02v-6.03h1.36v8.19h-1.51l-3.73-6.02h-.03v6.02h-1.36v-8.19Z"
          />
          <path
            className="st8"
            d="M431.69,119.64c0,.31.05.58.16.8.11.22.26.4.45.54.19.14.41.24.66.31.25.07.52.1.81.1.31,0,.58-.04.8-.11.22-.07.4-.17.54-.28.14-.11.24-.25.3-.4.06-.15.09-.3.09-.45,0-.31-.07-.54-.21-.69-.14-.15-.3-.25-.46-.32-.29-.11-.63-.21-1.01-.3-.39-.1-.86-.22-1.43-.37-.35-.09-.64-.21-.88-.36-.23-.15-.42-.32-.56-.5-.14-.18-.24-.38-.29-.58-.06-.21-.09-.42-.09-.63,0-.41.09-.77.26-1.07.17-.3.4-.55.68-.75.28-.2.6-.35.96-.44.36-.1.72-.14,1.09-.14.43,0,.83.06,1.21.17.38.11.71.28,1,.5.29.22.51.5.68.82.17.33.25.7.25,1.13h-1.43c-.04-.53-.22-.9-.54-1.12-.32-.22-.73-.33-1.23-.33-.17,0-.34.02-.52.05-.18.03-.34.09-.48.17-.15.08-.27.19-.36.33s-.14.31-.14.52c0,.29.09.52.27.68.18.16.41.29.71.37.03,0,.15.04.36.1.21.06.45.12.71.19.26.07.51.14.76.2.25.07.43.11.53.14.27.08.5.2.7.34.2.15.37.31.5.5.13.19.23.39.3.6.06.21.1.43.1.64,0,.46-.09.85-.28,1.18-.19.33-.43.59-.74.8-.31.21-.65.36-1.04.45-.39.1-.79.14-1.19.14-.47,0-.91-.06-1.32-.17-.41-.11-.77-.29-1.08-.53-.31-.24-.55-.54-.73-.91s-.28-.81-.29-1.31h1.43Z"
          />
          <path
            className="st8"
            d="M440.37,114.18h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM439.86,119.11h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st8"
            d="M445.83,114.18h5.65v1.24h-4.22v2.14h3.7v1.17h-3.7v3.64h-1.43v-8.19Z"
          />
          <path
            className="st8"
            d="M452.63,114.18h5.89v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path className="st2" d="M403.7,52.25" />
          <polygon
            className="st6"
            points="451.77 79.92 449.56 79.92 449.56 44.34 403.26 44.34 403.26 42.14 451.77 42.14 451.77 79.92"
          />
          <polygon
            className="st8"
            points="451.11 85.06 402.6 85.06 402.6 47.43 404.8 47.43 404.8 82.85 451.11 82.85 451.11 85.06"
          />
          <path
            className="st8"
            d="M444.91,77.47h-35.46v-20.49h35.46v20.49ZM411.66,75.27h31.04v-16.08h-31.04v16.08Z"
          />
          <rect
            className="st8"
            x="409.31"
            y="49.62"
            width="35.54"
            height="2.21"
          />
          <rect className="st5" x="389.89" y="25" width="74.6" height="74.6" />
        </g>
        <g>
          <path
            className="st8"
            d="M548.78,114.18h2.02l2.26,6.41h.02l2.2-6.41h2v8.19h-1.36v-6.32h-.02l-2.27,6.32h-1.18l-2.27-6.32h-.02v6.32h-1.36v-8.19Z"
          />
          <path className="st8" d="M559,114.18h1.43v8.19h-1.43v-8.19Z" />
          <path
            className="st8"
            d="M567.72,116.78c-.06-.24-.15-.45-.25-.65-.11-.2-.24-.37-.41-.52-.17-.15-.37-.26-.59-.34-.23-.08-.49-.12-.79-.12-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1s-.14.76-.14,1.15.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26.32,0,.6-.06.85-.17.24-.11.45-.26.63-.46s.31-.42.41-.68c.1-.26.16-.54.19-.84h1.4c-.03.49-.14.94-.32,1.34s-.42.76-.73,1.05c-.31.29-.67.52-1.08.68-.41.16-.87.24-1.36.24-.61,0-1.16-.11-1.65-.34-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36c-.18-.52-.27-1.07-.27-1.66s.09-1.13.27-1.65.44-.97.77-1.36c.34-.39.75-.7,1.23-.93s1.03-.34,1.65-.34c.46,0,.89.06,1.3.19.41.13.76.31,1.07.55s.56.53.75.88c.19.34.31.74.36,1.18h-1.43Z"
          />
          <path
            className="st8"
            d="M570.47,114.18h3.91c.9,0,1.58.19,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97-.11.26-.25.46-.4.62s-.3.27-.45.34c-.15.07-.26.11-.33.14v.02c.12.02.25.05.4.11.14.06.27.16.4.29.12.13.22.31.3.52.08.21.12.48.12.8,0,.48.04.92.11,1.31.07.39.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58-.02-.21-.03-.42-.03-.62,0-.37-.02-.7-.07-.97-.05-.27-.13-.5-.25-.68s-.29-.31-.5-.4c-.21-.08-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19ZM571.9,117.9h2.35c.46,0,.81-.11,1.04-.33s.36-.54.36-.98c0-.26-.04-.47-.11-.64-.08-.16-.18-.29-.32-.38-.13-.09-.29-.15-.46-.18-.17-.03-.35-.05-.53-.05h-2.33v2.56Z"
          />
          <path
            className="st8"
            d="M582.03,113.98c.61,0,1.16.11,1.65.34s.9.54,1.23.93c.34.39.59.84.77,1.36s.27,1.07.27,1.65-.09,1.14-.27,1.66c-.18.52-.44.98-.77,1.36s-.75.7-1.23.92c-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92-.34-.39-.59-.84-.77-1.36-.18-.52-.27-1.07-.27-1.66s.09-1.13.27-1.65c.18-.52.44-.97.77-1.36.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34ZM582.03,115.15c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1,.1-.37.14-.76.14-1.15s-.05-.77-.14-1.15-.24-.71-.44-1c-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st8"
            d="M586.46,114.18h1.46l1.48,6.26h.02l1.65-6.26h1.47l1.61,6.26h.02l1.53-6.26h1.46l-2.26,8.19h-1.46l-1.64-6.26h-.02l-1.67,6.26h-1.48l-2.16-8.19Z"
          />
          <path
            className="st8"
            d="M599.99,114.18h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM599.48,119.11h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st8"
            d="M603.81,114.18h1.49l2.05,6.48h.02l2.1-6.48h1.46l-2.8,8.19h-1.59l-2.73-8.19Z"
          />
          <path
            className="st8"
            d="M611.74,114.18h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st8"
            d="M623.1,119.64c0,.31.05.58.16.8.11.22.26.4.45.54.19.14.41.24.66.31.25.07.52.1.81.1.31,0,.58-.04.8-.11.22-.07.4-.17.54-.28.14-.11.24-.25.3-.4.06-.15.09-.3.09-.45,0-.31-.07-.54-.21-.69-.14-.15-.3-.25-.46-.32-.29-.11-.63-.21-1.01-.3-.39-.1-.86-.22-1.43-.37-.35-.09-.64-.21-.88-.36-.23-.15-.42-.32-.56-.5-.14-.18-.24-.38-.29-.58-.06-.21-.09-.42-.09-.63,0-.41.09-.77.26-1.07.17-.3.4-.55.68-.75.28-.2.6-.35.96-.44.36-.1.72-.14,1.09-.14.43,0,.83.06,1.21.17.38.11.71.28,1,.5.29.22.51.5.68.82.17.33.25.7.25,1.13h-1.43c-.04-.53-.22-.9-.54-1.12-.32-.22-.73-.33-1.23-.33-.17,0-.34.02-.52.05-.18.03-.34.09-.48.17-.15.08-.27.19-.36.33s-.14.31-.14.52c0,.29.09.52.27.68.18.16.41.29.71.37.03,0,.15.04.36.1.21.06.45.12.71.19.26.07.51.14.76.2.25.07.43.11.53.14.27.08.5.2.7.34.2.15.37.31.5.5.13.19.23.39.3.6.06.21.1.43.1.64,0,.46-.09.85-.28,1.18-.19.33-.43.59-.74.8-.31.21-.65.36-1.04.45-.39.1-.79.14-1.19.14-.47,0-.91-.06-1.32-.17-.41-.11-.77-.29-1.08-.53-.31-.24-.55-.54-.73-.91s-.28-.81-.29-1.31h1.43Z"
          />
          <path
            className="st8"
            d="M631.78,114.18h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM631.28,119.11h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st8"
            d="M637.24,114.18h5.65v1.24h-4.22v2.14h3.7v1.17h-3.7v3.64h-1.43v-8.19Z"
          />
          <path
            className="st8"
            d="M644.04,114.18h5.89v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <polygon
            className="st6"
            points="623.16 77.78 620.96 77.78 620.96 47.07 572.02 47.07 572.02 44.86 623.16 44.86 623.16 77.78"
          />
          <polygon
            className="st8"
            points="622.5 82.34 571.36 82.34 571.36 49.66 573.56 49.66 573.56 80.13 622.5 80.13 622.5 82.34"
          />
          <path
            className="st8"
            d="M610.49,76.59h-33.19v-25.24h33.19v25.24ZM579.5,74.38h28.78v-20.83h-28.78v20.83Z"
          />
          <rect
            className="st8"
            x="614.1"
            y="51.78"
            width="3.69"
            height="2.21"
          />
          <rect
            className="st8"
            x="614.1"
            y="57.35"
            width="3.69"
            height="2.21"
          />
          <rect
            className="st8"
            x="614.1"
            y="62.92"
            width="3.69"
            height="2.21"
          />
          <rect className="st5" x="559.96" y="25" width="74.6" height="74.6" />
        </g>
        <g>
          <path
            className="st8"
            d="M716.36,114.18h3.39c.63,0,1.17.11,1.63.32.46.21.83.51,1.12.88.29.37.51.8.65,1.3.14.5.21,1.03.21,1.59s-.07,1.1-.21,1.59c-.14.5-.36.93-.65,1.3-.29.37-.67.66-1.12.88-.46.21-1,.32-1.63.32h-3.39v-8.19ZM717.8,121.19h1.41c.56,0,1.01-.07,1.37-.22.36-.15.63-.36.84-.62.2-.26.34-.57.41-.93.07-.36.11-.74.11-1.15s-.04-.8-.11-1.15c-.07-.36-.21-.67-.41-.93-.2-.26-.48-.47-.84-.62-.36-.15-.81-.22-1.37-.22h-1.41v5.85Z"
          />
          <path className="st8" d="M724.65,114.18h1.43v8.19h-1.43v-8.19Z" />
          <path
            className="st8"
            d="M728.77,119.64c0,.31.05.58.16.8.11.22.26.4.45.54.19.14.41.24.66.31.25.07.52.1.81.1.31,0,.58-.04.8-.11.22-.07.4-.17.54-.28.14-.11.24-.25.3-.4.06-.15.09-.3.09-.45,0-.31-.07-.54-.21-.69-.14-.15-.3-.25-.46-.32-.29-.11-.63-.21-1.01-.3-.39-.1-.86-.22-1.43-.37-.35-.09-.64-.21-.88-.36-.23-.15-.42-.32-.56-.5s-.24-.38-.29-.58c-.06-.21-.09-.42-.09-.63,0-.41.09-.77.26-1.07.17-.3.4-.55.68-.75.28-.2.6-.35.96-.44.36-.1.72-.14,1.09-.14.43,0,.83.06,1.21.17.38.11.71.28,1,.5.29.22.51.5.68.82.17.33.25.7.25,1.13h-1.43c-.04-.53-.22-.9-.54-1.12-.32-.22-.73-.33-1.23-.33-.17,0-.34.02-.52.05-.18.03-.34.09-.48.17-.15.08-.27.19-.36.33s-.14.31-.14.52c0,.29.09.52.27.68.18.16.41.29.71.37.03,0,.15.04.36.1.21.06.45.12.71.19.26.07.51.14.76.2.25.07.43.11.53.14.27.08.5.2.7.34.2.15.37.31.5.5.13.19.23.39.3.6.07.21.1.43.1.64,0,.46-.09.85-.28,1.18-.19.33-.43.59-.74.8-.31.21-.65.36-1.04.45-.39.1-.79.14-1.19.14-.47,0-.91-.06-1.32-.17-.41-.11-.77-.29-1.08-.53-.31-.24-.55-.54-.73-.91s-.28-.81-.29-1.31h1.43Z"
          />
          <path
            className="st8"
            d="M735.23,114.18h1.43v3.26h3.73v-3.26h1.43v8.19h-1.43v-3.69h-3.73v3.69h-1.43v-8.19Z"
          />
          <path
            className="st8"
            d="M742.74,114.18h1.46l1.48,6.26h.02l1.65-6.26h1.47l1.61,6.26h.02l1.53-6.26h1.46l-2.26,8.19h-1.46l-1.64-6.26h-.02l-1.67,6.26h-1.48l-2.16-8.19Z"
          />
          <path
            className="st8"
            d="M756.28,114.18h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM755.77,119.11h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st8"
            d="M762.68,119.64c0,.31.05.58.16.8.11.22.26.4.45.54s.41.24.66.31c.25.07.52.1.81.1.31,0,.58-.04.8-.11.22-.07.4-.17.54-.28.14-.11.24-.25.3-.4.06-.15.09-.3.09-.45,0-.31-.07-.54-.21-.69-.14-.15-.3-.25-.46-.32-.29-.11-.63-.21-1.02-.3-.39-.1-.86-.22-1.43-.37-.35-.09-.64-.21-.88-.36-.23-.15-.42-.32-.56-.5-.14-.18-.24-.38-.29-.58-.06-.21-.09-.42-.09-.63,0-.41.09-.77.26-1.07.17-.3.4-.55.68-.75.28-.2.6-.35.96-.44.36-.1.72-.14,1.09-.14.43,0,.83.06,1.21.17.38.11.71.28,1,.5.29.22.51.5.68.82.17.33.25.7.25,1.13h-1.43c-.04-.53-.22-.9-.54-1.12-.32-.22-.73-.33-1.23-.33-.17,0-.34.02-.52.05-.18.03-.34.09-.48.17-.15.08-.27.19-.36.33s-.14.31-.14.52c0,.29.09.52.27.68.18.16.41.29.71.37.03,0,.15.04.36.1.21.06.45.12.71.19.26.07.51.14.76.2.25.07.43.11.53.14.27.08.5.2.7.34.2.15.36.31.5.5.13.19.23.39.3.6.06.21.1.43.1.64,0,.46-.09.85-.28,1.18-.19.33-.43.59-.74.8-.31.21-.65.36-1.04.45-.39.1-.79.14-1.19.14-.47,0-.91-.06-1.32-.17-.41-.11-.77-.29-1.08-.53-.31-.24-.55-.54-.73-.91s-.28-.81-.29-1.31h1.43Z"
          />
          <path
            className="st8"
            d="M769.13,114.18h1.43v3.26h3.73v-3.26h1.43v8.19h-1.43v-3.69h-3.73v3.69h-1.43v-8.19Z"
          />
          <path
            className="st8"
            d="M777.45,114.18h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st8"
            d="M784.67,114.18h3.91c.9,0,1.58.19,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97-.11.26-.25.46-.4.62s-.3.27-.45.34c-.15.07-.26.11-.33.14v.02c.12.02.25.05.4.11.14.06.27.16.4.29.12.13.22.31.3.52.08.21.12.48.12.8,0,.48.04.92.11,1.31.07.39.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58-.02-.21-.03-.42-.03-.62,0-.37-.02-.7-.07-.97s-.13-.5-.25-.68c-.12-.18-.29-.31-.5-.4-.21-.08-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19ZM786.11,117.9h2.35c.46,0,.81-.11,1.04-.33s.36-.54.36-.98c0-.26-.04-.47-.12-.64-.08-.16-.18-.29-.32-.38s-.29-.15-.46-.18c-.17-.03-.35-.05-.53-.05h-2.33v2.56Z"
          />
          <path
            className="st8"
            d="M796.88,119.64c0,.31.05.58.16.8.11.22.26.4.45.54s.41.24.66.31c.25.07.52.1.81.1.31,0,.58-.04.8-.11.22-.07.4-.17.54-.28.14-.11.24-.25.3-.4.06-.15.09-.3.09-.45,0-.31-.07-.54-.21-.69-.14-.15-.3-.25-.46-.32-.29-.11-.63-.21-1.02-.3-.39-.1-.86-.22-1.43-.37-.35-.09-.64-.21-.88-.36-.23-.15-.42-.32-.56-.5-.14-.18-.24-.38-.29-.58-.06-.21-.09-.42-.09-.63,0-.41.09-.77.26-1.07.17-.3.4-.55.68-.75.28-.2.6-.35.96-.44.36-.1.72-.14,1.09-.14.43,0,.83.06,1.21.17.38.11.71.28,1,.5.29.22.51.5.68.82.17.33.25.7.25,1.13h-1.43c-.04-.53-.22-.9-.54-1.12-.32-.22-.73-.33-1.23-.33-.17,0-.34.02-.52.05-.18.03-.34.09-.48.17-.15.08-.27.19-.36.33s-.14.31-.14.52c0,.29.09.52.27.68.18.16.41.29.71.37.03,0,.15.04.36.1.21.06.45.12.71.19.26.07.51.14.76.2.25.07.43.11.53.14.27.08.5.2.7.34.2.15.36.31.5.5.13.19.23.39.3.6.06.21.1.43.1.64,0,.46-.09.85-.28,1.18-.19.33-.43.59-.74.8-.31.21-.65.36-1.04.45-.39.1-.79.14-1.19.14-.47,0-.91-.06-1.32-.17-.41-.11-.77-.29-1.08-.53-.31-.24-.55-.54-.73-.91s-.28-.81-.29-1.31h1.43Z"
          />
          <path
            className="st8"
            d="M805.56,114.18h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM805.05,119.11h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st8"
            d="M811.02,114.18h5.65v1.24h-4.22v2.14h3.7v1.17h-3.7v3.64h-1.43v-8.19Z"
          />
          <path
            className="st8"
            d="M817.82,114.18h5.89v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <polygon
            className="st6"
            points="790.23 82.11 788.02 82.11 788.02 42.1 743.49 42.1 743.49 39.9 790.23 39.9 790.23 82.11"
          />
          <polygon
            className="st8"
            points="789.57 87.3 742.83 87.3 742.83 45.52 745.04 45.52 745.04 85.09 789.57 85.09 789.57 87.3"
          />
          <path
            className="st8"
            d="M785.04,82.75h-37.02v-31.04h37.02v31.04ZM750.23,80.55h32.61v-26.62h-32.61v26.62Z"
          />
          <rect
            className="st8"
            x="765.43"
            y="52.81"
            width="2.21"
            height="8.06"
          />
          <rect
            className="st8"
            x="755.25"
            y="54.57"
            width="8.07"
            height="2.21"
            transform="translate(183.03 553.2) rotate(-45)"
          />
          <rect
            className="st8"
            x="772.67"
            y="51.63"
            width="2.21"
            height="8.07"
            transform="translate(187.27 563.45) rotate(-45)"
          />
          <path
            className="st8"
            d="M774.59,82.26l-1.76-1.33c1.03-1.37,1.58-3.01,1.58-4.73,0-4.34-3.53-7.87-7.87-7.87s-7.87,3.53-7.87,7.87c0,1.72.54,3.36,1.58,4.73l-1.76,1.33c-1.32-1.76-2.02-3.85-2.02-6.05,0-5.56,4.52-10.08,10.08-10.08s10.08,4.52,10.08,10.08c0,2.2-.7,4.3-2.02,6.05Z"
          />
          <rect
            className="st8"
            x="748.51"
            y="45.8"
            width="36.25"
            height="2.21"
          />
          <rect className="st5" x="730.04" y="25" width="74.6" height="74.6" />
        </g>
        <g>
          <path
            className="st8"
            d="M909.97,114.18h2.02l2.26,6.41h.02l2.2-6.41h2v8.19h-1.36v-6.32h-.02l-2.27,6.32h-1.18l-2.27-6.32h-.02v6.32h-1.36v-8.19Z"
          />
          <path
            className="st8"
            d="M923.68,113.98c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.84.77,1.36s.27,1.07.27,1.65-.09,1.14-.27,1.66c-.18.52-.44.98-.77,1.36-.34.39-.75.7-1.23.92-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92-.34-.39-.59-.84-.77-1.36-.18-.52-.27-1.07-.27-1.66s.09-1.13.27-1.65c.18-.52.44-.97.77-1.36.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34ZM923.68,115.15c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1s-.14.76-.14,1.15.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1,.1-.37.14-.76.14-1.15s-.05-.77-.14-1.15-.24-.71-.44-1c-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st8"
            d="M928.91,114.18h3.39c.63,0,1.17.11,1.63.32.46.21.83.51,1.12.88.29.37.51.8.65,1.3.14.5.21,1.03.21,1.59s-.07,1.1-.21,1.59c-.14.5-.36.93-.65,1.3-.29.37-.67.66-1.12.88-.46.21-1,.32-1.63.32h-3.39v-8.19ZM930.34,121.19h1.41c.56,0,1.01-.07,1.37-.22.36-.15.63-.36.84-.62.2-.26.34-.57.41-.93.07-.36.11-.74.11-1.15s-.04-.8-.11-1.15c-.07-.36-.21-.67-.41-.93-.2-.26-.48-.47-.84-.62-.36-.15-.81-.22-1.37-.22h-1.41v5.85Z"
          />
          <path
            className="st8"
            d="M937.1,114.18h1.43v4.77c0,.28.01.55.04.84.03.28.1.54.23.76.13.23.32.41.57.56.26.15.62.22,1.08.22s.83-.07,1.08-.22c.26-.15.45-.33.57-.56.13-.23.2-.48.23-.76.03-.28.04-.56.04-.84v-4.77h1.43v5.24c0,.53-.08.99-.24,1.38-.16.39-.39.72-.68.98-.29.26-.65.46-1.06.59-.41.13-.87.19-1.38.19s-.96-.07-1.38-.19-.77-.33-1.06-.59c-.29-.26-.52-.59-.68-.98-.16-.39-.24-.85-.24-1.38v-5.24Z"
          />
          <path
            className="st8"
            d="M945.47,114.18h1.43v6.95h4.16v1.24h-5.6v-8.19Z"
          />
          <path
            className="st8"
            d="M954.24,114.18h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM953.74,119.11h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st8"
            d="M959.7,114.18h3.91c.9,0,1.58.19,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97-.11.26-.25.46-.4.62s-.3.27-.45.34c-.15.07-.26.11-.33.14v.02c.12.02.25.05.4.11.14.06.27.16.4.29.12.13.22.31.3.52.08.21.12.48.12.8,0,.48.04.92.11,1.31.07.39.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58-.02-.21-.03-.42-.03-.62,0-.37-.02-.7-.07-.97-.05-.27-.13-.5-.25-.68s-.29-.31-.5-.4c-.21-.08-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19ZM961.13,117.9h2.35c.46,0,.81-.11,1.04-.33s.36-.54.36-.98c0-.26-.04-.47-.11-.64-.08-.16-.18-.29-.32-.38-.13-.09-.29-.15-.46-.18-.17-.03-.35-.05-.53-.05h-2.33v2.56Z"
          />
          <path
            className="st8"
            d="M961.56,85.06h-49.17v-30.03h22.62v19.45l26.55-.27v10.85ZM914.59,82.85h44.76v-6.42l-26.55.27v-19.47h-18.21v25.62Z"
          />
          <path
            className="st6"
            d="M961.56,72.3h-24.81v-19.38h-24.37v-10.78h49.17v30.16ZM938.95,70.09h20.4v-17.18h-20.4v17.18ZM914.59,50.71h44.76v-6.37h-44.76v6.37Z"
          />
          <rect className="st8" x="932.8" y="75.6" width="2.21" height="8.36" />
          <rect className="st5" x="900.11" y="25" width="74.6" height="74.6" />
        </g>
        <g>
          <path
            className="st8"
            d="M1062.89,118.75c0,.31.05.58.16.8.11.22.26.4.45.54.19.14.41.24.66.31.25.07.52.1.81.1.31,0,.58-.04.8-.11.22-.07.4-.17.54-.28.14-.11.24-.25.3-.4.06-.15.09-.3.09-.45,0-.31-.07-.54-.21-.69-.14-.15-.3-.25-.46-.32-.29-.11-.63-.21-1.01-.3-.39-.1-.86-.22-1.43-.37-.35-.09-.64-.21-.88-.36-.23-.15-.42-.32-.56-.5-.14-.18-.24-.38-.29-.58-.06-.21-.09-.42-.09-.63,0-.41.09-.77.26-1.07.17-.3.4-.55.68-.75.28-.2.6-.35.96-.44s.72-.14,1.09-.14c.43,0,.83.06,1.21.17.38.11.71.28,1,.5.29.22.51.5.68.82.17.33.25.7.25,1.13h-1.43c-.04-.53-.22-.9-.54-1.12-.32-.22-.73-.33-1.23-.33-.17,0-.34.02-.52.05-.18.03-.34.09-.48.17s-.27.19-.36.33c-.1.14-.14.31-.14.52,0,.29.09.52.27.68s.41.29.71.37c.03,0,.15.04.36.1.21.06.45.12.71.19.26.07.51.14.76.2s.43.11.53.14c.27.08.5.2.7.34.2.15.37.31.5.5.13.19.23.39.3.6.06.21.1.43.1.64,0,.46-.09.85-.28,1.18-.19.33-.43.59-.74.8-.31.21-.65.36-1.04.45-.39.1-.79.14-1.19.14-.47,0-.91-.06-1.32-.17-.41-.11-.77-.29-1.08-.53s-.55-.54-.73-.91-.28-.81-.29-1.31h1.43Z"
          />
          <path
            className="st8"
            d="M1068.61,113.29h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <path
            className="st8"
            d="M1077.32,113.29h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM1076.82,118.22h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st8"
            d="M1084.07,118.26l-3.07-4.98h1.66l2.17,3.67,2.13-3.67h1.61l-3.06,4.98v3.21h-1.43v-3.21Z"
          />
          <path
            className="st8"
            d="M1092.52,113.29h1.43v3.26h3.73v-3.26h1.43v8.19h-1.43v-3.69h-3.73v3.69h-1.43v-8.19Z"
          />
          <path
            className="st8"
            d="M1104.32,113.09c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.37.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66c-.18.52-.44.97-.77,1.36s-.75.7-1.23.92c-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65.44-.97.77-1.37c.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34ZM1104.32,114.26c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15.24.71.44,1c.2.29.46.53.77.71.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1s.14-.76.14-1.15-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st8"
            d="M1108.77,113.29h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <path
            className="st8"
            d="M1120.72,120.56c-.31.37-.64.65-1.01.82-.37.17-.8.26-1.28.26-.37,0-.72-.06-1.04-.17-.32-.11-.59-.27-.82-.48-.23-.21-.41-.46-.53-.76s-.19-.64-.19-1.03c0-.29.05-.55.16-.79.11-.24.25-.45.42-.65.18-.19.38-.37.6-.52.23-.15.46-.29.69-.41-.11-.14-.21-.27-.31-.41-.1-.13-.19-.27-.26-.42-.08-.15-.14-.3-.18-.46-.05-.16-.07-.33-.07-.5,0-.3.05-.57.16-.8.1-.24.25-.44.43-.61s.4-.3.64-.4.5-.14.78-.14c.26,0,.51.04.76.12.25.08.47.2.65.37s.34.37.45.61.17.53.17.86c0,.24-.04.47-.12.68-.08.21-.19.4-.32.57-.13.17-.29.33-.47.46-.18.14-.37.26-.57.37l1.27,1.54c.05-.13.09-.28.14-.45.05-.17.08-.39.11-.65h1.15c-.04.36-.11.71-.21,1.06-.1.34-.25.66-.43.95l1.57,1.9h-1.61l-.75-.92ZM1118.42,117.69c-.12.08-.26.15-.4.23-.15.08-.28.17-.41.29-.13.12-.23.25-.32.41s-.13.36-.13.61c0,.44.12.78.37,1.02.25.24.56.36.95.36.24,0,.44-.03.61-.1.17-.07.31-.14.43-.24s.22-.19.3-.3c.08-.11.15-.2.21-.29l-1.61-2ZM1118.94,114.07c-.24,0-.45.08-.62.25-.17.16-.25.38-.25.66,0,.14.02.27.07.38.05.12.11.23.18.34.07.11.15.22.24.33s.17.21.25.31c.12-.08.24-.17.36-.26.11-.09.22-.18.31-.29s.16-.22.22-.35.08-.28.08-.44c0-.27-.08-.49-.23-.67s-.36-.27-.61-.27Z"
          />
          <path
            className="st8"
            d="M1129.31,115.89c-.06-.24-.15-.45-.25-.65s-.24-.37-.41-.52c-.17-.15-.37-.26-.59-.34-.23-.08-.49-.12-.79-.12-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15.24.71.44,1c.2.29.46.53.77.71.32.18.69.26,1.13.26.32,0,.6-.06.85-.17.24-.11.45-.26.63-.46.18-.19.31-.42.41-.68.1-.26.16-.54.19-.84h1.4c-.03.49-.14.94-.32,1.34s-.42.76-.73,1.05c-.31.29-.67.52-1.08.68-.41.16-.87.24-1.36.24-.61,0-1.16-.11-1.65-.34-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.37.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34.46,0,.89.06,1.3.19.41.13.76.31,1.07.55s.56.53.75.88c.19.34.31.74.36,1.18h-1.43Z"
          />
          <path
            className="st8"
            d="M1135.55,113.09c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.37.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66c-.18.52-.44.97-.77,1.36s-.75.7-1.23.92c-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65.44-.97.77-1.37c.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34ZM1135.55,114.26c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15.24.71.44,1c.2.29.46.53.77.71.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1s.14-.76.14-1.15-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st8"
            d="M1140.78,113.29h1.43v6.95h4.16v1.24h-5.6v-8.19Z"
          />
          <path
            className="st8"
            d="M1147.36,113.29h3.39c.63,0,1.17.11,1.63.32.46.21.83.51,1.12.88.29.37.51.8.65,1.3.14.5.21,1.03.21,1.59s-.07,1.1-.21,1.59c-.14.5-.36.93-.65,1.3-.29.37-.67.66-1.12.88-.46.21-1,.32-1.63.32h-3.39v-8.19ZM1148.8,120.31h1.41c.56,0,1.01-.07,1.37-.22.36-.15.63-.36.84-.62.2-.26.34-.57.41-.93.07-.36.11-.74.11-1.15s-.04-.8-.11-1.15c-.07-.36-.21-.67-.41-.93-.2-.26-.48-.47-.84-.62-.36-.15-.81-.22-1.37-.22h-1.41v5.85Z"
          />
          <rect
            className="st6"
            x="1108.6"
            y="35.72"
            width="2.21"
            height="23.46"
          />
          <rect
            className="st6"
            x="1108.48"
            y="42.08"
            width="9.55"
            height="2.21"
            transform="translate(295.53 799.84) rotate(-45)"
          />
          <rect
            className="st6"
            x="1105.4"
            y="38.41"
            width="2.21"
            height="9.55"
            transform="translate(293.58 795.09) rotate(-45)"
          />
          <rect
            className="st6"
            x="1095.86"
            y="43.71"
            width="2.21"
            height="9.55"
            transform="translate(24.83 285.55) rotate(-15)"
          />
          <path className="st2" d="M1098.2,53.1" />
          <path className="st2" d="M1088.98,55.57" />
          <rect
            className="st6"
            x="1108.6"
            y="35.72"
            width="2.21"
            height="48.45"
            transform="translate(502.94 991) rotate(-60)"
          />
          <path className="st2" d="M1121.21,66.79" />
          <path className="st2" d="M1123.68,76.02" />
          <rect
            className="st6"
            x="1121.04"
            y="64.46"
            width="9.55"
            height="2.21"
            transform="translate(21.42 293.77) rotate(-15.01)"
          />
          <rect
            className="st6"
            x="1108.8"
            y="52.59"
            width="23.46"
            height="2.21"
            transform="translate(123.28 567.46) rotate(-30)"
          />
          <rect
            className="st6"
            x="1124.89"
            y="49.87"
            width="2.21"
            height="9.55"
            transform="translate(781.81 1128.14) rotate(-75)"
          />
          <rect
            className="st6"
            x="1117.85"
            y="47.69"
            width="9.55"
            height="2.21"
            transform="translate(784.79 1120.49) rotate(-74.99)"
          />
          <path className="st2" d="M1128.08,76.56" />
          <rect
            className="st7"
            x="1104.48"
            y="79.93"
            width="2.21"
            height="9.7"
          />
          <path
            className="st7"
            d="M1106.52,80.65c-2.58,0-5.19-.65-7.58-2.03-6.94-4.01-9.53-12.69-6.08-19.79l-7.62-4.39,1.1-1.91,9.5,5.47-.55.96c-3.58,6.21-1.45,14.17,4.76,17.76,6.21,3.58,14.17,1.45,17.76-4.76l.55-.95,9.82,5.65-1.1,1.91-7.94-4.57c-2.9,4.28-7.7,6.66-12.61,6.66Z"
          />
          <rect
            className="st7"
            x="1085.01"
            y="73.29"
            width="9.35"
            height="2.21"
            transform="translate(108.12 553.43) rotate(-29.92)"
          />
          <path className="st2" d="M1082.53,69.52" />
          <path className="st2" d="M1090.17,67.38" />
          <rect className="st5" x="1070.19" y="25" width="74.6" height="74.6" />
        </g>
        <g>
          <polygon
            className="st6"
            points="1301.26 79.08 1299.06 79.08 1299.06 40.8 1254.97 40.8 1254.97 38.6 1301.26 38.6 1301.26 79.08"
          />
          <path className="st2" d="M1254.97,47.21" />
          <polygon
            className="st8"
            points="1300.16 86 1253.86 86 1253.86 44.97 1256.07 44.97 1256.07 83.79 1300.16 83.79 1300.16 86"
          />
          <path className="st3" d="M1300.16,76.24" />
          <path
            className="st8"
            d="M1277.41,71.42c-4.48,0-8.12-3.64-8.12-8.12,0-4.07,6.45-14.66,7.18-15.85l.94-1.53.94,1.53c.73,1.19,7.18,11.78,7.18,15.85,0,4.48-3.64,8.12-8.12,8.12ZM1277.41,50.18c-2.24,3.81-5.91,10.61-5.91,13.13,0,3.26,2.65,5.91,5.91,5.91s5.91-2.65,5.91-5.91c0-2.52-3.68-9.32-5.91-13.13Z"
          />
          <path
            className="st8"
            d="M1248.96,113.29h1.51l3.74,6.03h.02v-6.03h1.36v8.19h-1.51l-3.73-6.02h-.03v6.02h-1.36v-8.19Z"
          />
          <path
            className="st8"
            d="M1260.78,113.09c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.37.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66c-.18.52-.44.97-.77,1.36s-.75.7-1.23.92c-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92-.34-.39-.59-.84-.77-1.36-.18-.52-.27-1.07-.27-1.66s.09-1.13.27-1.65.44-.97.77-1.37c.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34ZM1260.78,114.26c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15.24.71.44,1c.2.29.46.53.77.71s.69.26,1.13.26.81-.09,1.13-.26.58-.41.77-.71c.2-.29.35-.63.44-1s.14-.76.14-1.15-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st8"
            d="M1270.14,118.75c0,.31.05.58.16.8.11.22.26.4.45.54.19.14.41.24.66.31.25.07.52.1.81.1.31,0,.58-.04.8-.11.22-.07.4-.17.54-.28.14-.11.24-.25.3-.4.06-.15.09-.3.09-.45,0-.31-.07-.54-.21-.69s-.3-.25-.46-.32c-.29-.11-.63-.21-1.01-.3-.39-.1-.86-.22-1.43-.37-.35-.09-.64-.21-.88-.36-.23-.15-.42-.32-.56-.5s-.24-.38-.29-.58c-.06-.21-.09-.42-.09-.63,0-.41.09-.77.26-1.07.17-.3.4-.55.68-.75.28-.2.6-.35.96-.44s.72-.14,1.09-.14c.43,0,.83.06,1.21.17.38.11.71.28,1,.5.29.22.51.5.68.82.17.33.25.7.25,1.13h-1.43c-.04-.53-.22-.9-.54-1.12-.32-.22-.73-.33-1.23-.33-.17,0-.34.02-.52.05-.18.03-.34.09-.48.17-.15.08-.27.19-.36.33-.1.14-.14.31-.14.52,0,.29.09.52.27.68s.41.29.71.37c.03,0,.15.04.36.1.21.06.45.12.71.19.26.07.51.14.76.2.25.07.43.11.53.14.27.08.5.2.7.34.2.15.37.31.5.5.13.19.23.39.3.6.07.21.1.43.1.64,0,.46-.09.85-.28,1.18-.19.33-.43.59-.74.8-.31.21-.65.36-1.04.45-.39.1-.79.14-1.19.14-.47,0-.91-.06-1.32-.17-.41-.11-.77-.29-1.08-.53s-.55-.54-.73-.91-.28-.81-.29-1.31h1.43Z"
          />
          <path
            className="st8"
            d="M1275.83,113.29h1.46l1.48,6.26h.02l1.65-6.26h1.47l1.61,6.26h.02l1.53-6.26h1.46l-2.26,8.19h-1.46l-1.64-6.26h-.02l-1.67,6.26h-1.48l-2.16-8.19Z"
          />
          <path
            className="st8"
            d="M1287.46,113.29h5.89v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.97v-8.19Z"
          />
          <path
            className="st8"
            d="M1296.88,113.29h1.52l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM1296.37,118.22h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st8"
            d="M1300.5,113.29h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <polygon
            className="st8"
            points="1277.36 80.79 1260.18 71.63 1261.22 69.68 1277.3 78.26 1291.73 69.71 1292.85 71.6 1277.36 80.79"
          />
          <polygon
            className="st8"
            points="1261.3 75.84 1259.72 70.06 1265.51 68.48 1266.09 70.6 1262.43 71.6 1263.43 75.26 1261.3 75.84"
          />
          <rect className="st5" x="1240.26" y="25" width="74.6" height="74.6" />
        </g>
        <g>
          <path
            className="st8"
            d="M93.6,185.67c-2.07,0-3.12-1.18-3.97-2.13-.79-.89-1.29-1.39-2.32-1.39s-1.53.5-2.32,1.39c-.85.95-1.9,2.13-3.97,2.13s-3.12-1.18-3.97-2.13c-.79-.89-1.29-1.39-2.32-1.39v-2.21c2.07,0,3.12,1.18,3.97,2.13.79.89,1.29,1.39,2.32,1.39s1.53-.5,2.32-1.39c.85-.95,1.9-2.13,3.97-2.13s3.12,1.18,3.97,2.13c.79.89,1.29,1.39,2.32,1.39s1.53-.5,2.32-1.39c.85-.95,1.9-2.13,3.97-2.13v2.21c-1.03,0-1.53.5-2.32,1.39-.85.95-1.9,2.13-3.97,2.13Z"
          />
          <polygon
            className="st6"
            points="106.08 200.78 103.87 200.78 103.87 160.87 69.09 160.87 69.09 158.66 106.08 158.66 106.08 200.78"
          />
          <polygon
            className="st8"
            points="105.86 206.25 68.43 206.25 68.43 165.05 70.64 165.05 70.64 204.05 105.86 204.05 105.86 206.25"
          />
          <path
            className="st8"
            d="M47.25,233.35h3.39c.63,0,1.17.11,1.63.32.46.21.83.51,1.12.88.29.37.51.8.65,1.3.14.5.21,1.03.21,1.59s-.07,1.1-.21,1.59c-.14.5-.36.93-.65,1.3-.29.37-.67.66-1.12.88-.46.21-1,.32-1.63.32h-3.39v-8.19ZM48.69,240.37h1.41c.56,0,1.01-.07,1.37-.22.36-.15.63-.36.84-.62.2-.26.34-.57.41-.93.07-.36.11-.74.11-1.15s-.04-.8-.11-1.15c-.07-.36-.21-.67-.41-.93-.2-.26-.48-.47-.84-.62-.36-.15-.81-.22-1.37-.22h-1.41v5.85Z"
          />
          <path
            className="st8"
            d="M59.02,233.15c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.37.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66c-.18.52-.44.97-.77,1.36s-.75.7-1.23.92c-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65.44-.97.77-1.37c.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34ZM59.02,234.32c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15.24.71.44,1c.2.29.46.53.77.71.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1s.14-.76.14-1.15-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st8"
            d="M64.16,233.35h1.43v4.77c0,.28.01.55.04.84s.1.54.23.76c.13.23.32.41.57.56s.62.22,1.08.22.83-.07,1.08-.22c.26-.15.45-.33.57-.56.13-.23.2-.48.23-.76.03-.28.04-.56.04-.84v-4.77h1.43v5.24c0,.53-.08.99-.24,1.38-.16.39-.39.72-.68.98-.29.26-.65.46-1.06.59-.41.13-.87.2-1.38.2s-.96-.07-1.38-.2c-.41-.13-.77-.33-1.06-.59s-.52-.59-.68-.98c-.16-.39-.24-.85-.24-1.38v-5.24Z"
          />
          <path
            className="st8"
            d="M72.53,233.35h3.98c.73,0,1.32.17,1.77.5s.67.85.67,1.53c0,.41-.1.77-.3,1.06-.2.29-.49.52-.87.68v.02c.5.11.89.35,1.15.72.26.37.39.84.39,1.39,0,.32-.06.62-.17.9s-.29.52-.54.72c-.24.2-.56.36-.94.48-.38.12-.84.18-1.37.18h-3.76v-8.19ZM73.97,236.78h2.34c.34,0,.63-.1.86-.29.23-.19.34-.48.34-.84,0-.41-.1-.7-.31-.87-.21-.17-.5-.25-.89-.25h-2.34v2.26ZM73.97,240.37h2.53c.44,0,.77-.11,1.01-.34.24-.23.36-.54.36-.96s-.12-.72-.36-.93-.58-.33-1.01-.33h-2.53v2.56Z"
          />
          <path
            className="st8"
            d="M80.61,233.35h1.43v6.95h4.16v1.24h-5.6v-8.19Z"
          />
          <path
            className="st8"
            d="M87.19,233.35h5.89v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st8"
            d="M96.8,233.35h1.46l1.48,6.26h.02l1.65-6.26h1.47l1.61,6.26h.02l1.53-6.26h1.46l-2.26,8.19h-1.46l-1.64-6.26h-.02l-1.67,6.26h-1.48l-2.16-8.19Z"
          />
          <path
            className="st8"
            d="M110.33,233.35h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM109.83,238.28h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st8"
            d="M115.79,233.35h1.43v6.95h4.16v1.24h-5.6v-8.19Z"
          />
          <path
            className="st8"
            d="M122.38,233.35h1.43v6.95h4.16v1.24h-5.6v-8.19Z"
          />
          <path
            className="st8"
            d="M101,200.34h-27.37v-35.07h27.37v35.07ZM75.83,198.14h22.96v-30.66h-22.96v30.66Z"
          />
          <rect
            className="st5"
            x="49.74"
            y="145.05"
            width="74.6"
            height="74.6"
          />
        </g>
        <g>
          <polygon
            className="st8"
            points="277.64 204.07 235.72 204.07 235.72 166.11 237.92 166.11 237.92 201.86 277.64 201.86 277.64 204.07"
          />
          <path
            className="st8"
            d="M217.17,233.35h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <path
            className="st8"
            d="M224.72,233.35h1.43v3.26h3.73v-3.26h1.43v8.19h-1.43v-3.69h-3.73v3.69h-1.43v-8.19Z"
          />
          <path
            className="st8"
            d="M233.03,233.35h3.91c.9,0,1.58.19,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97-.11.26-.25.46-.4.62-.15.16-.3.27-.45.34s-.26.11-.33.14v.02c.12.02.25.05.4.11.14.06.27.16.4.29.12.13.22.31.3.52.08.21.12.48.12.8,0,.48.04.92.11,1.31.07.39.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58-.02-.21-.03-.42-.03-.62,0-.37-.02-.7-.07-.97s-.13-.5-.25-.68-.29-.31-.5-.4-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19ZM234.47,237.08h2.35c.46,0,.81-.11,1.04-.33s.36-.54.36-.98c0-.26-.04-.47-.11-.64s-.18-.29-.32-.38-.29-.15-.46-.18-.35-.05-.53-.05h-2.33v2.56Z"
          />
          <path
            className="st8"
            d="M241.11,233.35h5.89v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.97v-8.19Z"
          />
          <path
            className="st8"
            d="M248.33,233.35h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st8"
            d="M258.75,233.35h1.43v6.95h4.16v1.24h-5.6v-8.19Z"
          />
          <path
            className="st8"
            d="M267.52,233.35h1.52l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM267.02,238.28h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st8"
            d="M274.26,238.33l-3.07-4.98h1.66l2.17,3.67,2.13-3.67h1.61l-3.06,4.98v3.21h-1.43v-3.21Z"
          />
          <path
            className="st8"
            d="M279.56,233.35h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st8"
            d="M286.79,233.35h3.91c.9,0,1.58.19,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97s-.25.46-.4.62-.3.27-.45.34-.26.11-.33.14v.02c.12.02.25.05.4.11s.27.16.4.29c.12.13.22.31.3.52.08.21.12.48.12.8,0,.48.04.92.11,1.31.07.39.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58-.02-.21-.03-.42-.03-.62,0-.37-.02-.7-.07-.97s-.13-.5-.25-.68c-.12-.18-.29-.31-.5-.4s-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19ZM288.22,237.08h2.35c.46,0,.81-.11,1.04-.33s.36-.54.36-.98c0-.26-.04-.47-.12-.64s-.18-.29-.32-.38-.29-.15-.46-.18c-.17-.03-.35-.05-.53-.05h-2.33v2.56Z"
          />
          <path
            className="st8"
            d="M295.8,238.81c0,.31.05.58.16.8.11.22.26.4.45.54.19.14.41.24.66.31.25.07.52.1.81.1.31,0,.58-.04.8-.11.22-.07.4-.17.54-.28s.24-.25.3-.4c.06-.15.09-.3.09-.45,0-.31-.07-.54-.21-.69-.14-.15-.3-.25-.46-.32-.29-.11-.63-.21-1.01-.3-.39-.1-.86-.22-1.43-.37-.35-.09-.64-.21-.88-.36-.23-.15-.42-.32-.56-.5-.14-.18-.24-.38-.29-.58-.06-.21-.09-.42-.09-.63,0-.41.09-.77.26-1.07s.4-.55.68-.75c.28-.2.6-.35.96-.44s.72-.14,1.09-.14c.43,0,.83.06,1.21.17.38.11.71.28,1,.5.29.22.51.5.68.82.17.33.25.7.25,1.13h-1.43c-.04-.53-.22-.9-.54-1.12-.32-.22-.73-.33-1.23-.33-.17,0-.34.02-.52.05-.18.03-.34.09-.48.17-.15.08-.27.19-.36.33-.1.14-.14.31-.14.52,0,.29.09.52.27.68.18.16.41.29.71.37.03,0,.15.04.36.1.21.06.45.12.71.19.26.07.51.14.76.2.25.07.43.11.53.14.27.08.5.2.7.34.2.15.37.31.5.5.13.19.23.39.3.6s.1.43.1.64c0,.46-.09.85-.28,1.18-.19.33-.43.59-.74.8-.31.21-.65.36-1.04.45s-.79.14-1.19.14c-.47,0-.91-.06-1.32-.17-.41-.11-.77-.29-1.08-.53s-.55-.54-.73-.91-.28-.81-.29-1.31h1.43Z"
          />
          <path
            className="st8"
            d="M276.63,177.95h-13.36c-.61,0-1.1-.49-1.1-1.1v-13.36h2.21v12.26h12.26v2.21Z"
          />
          <path
            className="st8"
            d="M276.63,186.44h-21.85c-.61,0-1.1-.49-1.1-1.1v-21.85h2.21v20.75h20.75v2.21Z"
          />
          <path
            className="st8"
            d="M276.63,197.05h-32.46c-.61,0-1.1-.49-1.1-1.1v-32.46h2.21v31.36h31.36v2.21Z"
          />
          <rect
            className="st8"
            x="253.61"
            y="169.41"
            width="11.23"
            height="2.21"
            transform="translate(-45.71 227.86) rotate(-43.99)"
          />
          <rect
            className="st8"
            x="253.61"
            y="178.61"
            width="11.23"
            height="2.21"
            transform="translate(-52.1 230.44) rotate(-43.99)"
          />
          <rect
            className="st8"
            x="261.24"
            y="180.09"
            width="12.6"
            height="2.21"
            transform="translate(-50.67 237.33) rotate(-44.11)"
          />
          <rect
            className="st8"
            x="247.85"
            y="165.58"
            width="2.21"
            height="2.87"
          />
          <rect
            className="st8"
            x="249.79"
            y="171.62"
            width="2.21"
            height="2.87"
          />
          <rect
            className="st8"
            x="247.85"
            y="177.66"
            width="2.21"
            height="2.87"
          />
          <rect
            className="st8"
            x="249.56"
            y="183.71"
            width="2.21"
            height="2.87"
          />
          <rect
            className="st8"
            x="247.85"
            y="189.75"
            width="2.21"
            height="2.87"
          />
          <rect
            className="st8"
            x="259.21"
            y="189.75"
            width="2.21"
            height="2.87"
          />
          <rect
            className="st8"
            x="270.57"
            y="189.75"
            width="2.21"
            height="2.87"
          />
          <rect
            className="st8"
            x="253.53"
            y="188.32"
            width="2.21"
            height="2.87"
          />
          <rect
            className="st8"
            x="264.89"
            y="188.32"
            width="2.21"
            height="2.87"
          />
          <polygon
            className="st6"
            points="278.74 199.31 276.53 199.31 276.53 163.25 236.82 163.25 236.82 161.04 278.74 161.04 278.74 199.31"
          />
          <rect
            className="st5"
            x="219.81"
            y="145.05"
            width="74.6"
            height="74.6"
          />
        </g>
        <g>
          <path
            className="st8"
            d="M1421.02,114.18h3.98c.73,0,1.32.17,1.77.5s.67.84.67,1.53c0,.41-.1.77-.3,1.06-.2.29-.49.52-.87.68v.02c.5.11.89.35,1.15.72.26.37.39.84.39,1.39,0,.32-.06.62-.17.9s-.29.52-.54.72c-.24.2-.56.36-.94.48-.38.12-.84.18-1.37.18h-3.76v-8.19ZM1422.45,117.61h2.34c.34,0,.63-.1.86-.29.23-.19.34-.48.34-.84,0-.41-.1-.7-.31-.87-.21-.17-.5-.25-.89-.25h-2.34v2.26ZM1422.45,121.19h2.53c.44,0,.77-.11,1.01-.34.24-.23.36-.54.36-.96s-.12-.72-.36-.93c-.24-.22-.58-.33-1.01-.33h-2.53v2.56Z"
          />
          <path
            className="st8"
            d="M1429.09,114.18h3.61c.58,0,1.06.08,1.42.25.37.17.65.38.85.63.2.25.33.53.41.83.07.3.11.57.11.83s-.04.53-.11.82c-.07.29-.21.57-.41.82-.2.25-.48.46-.85.63-.37.16-.84.25-1.42.25h-2.18v3.14h-1.43v-8.19ZM1430.53,118.05h2.1c.16,0,.32-.02.49-.07s.32-.12.46-.22c.14-.1.26-.24.34-.41.09-.17.13-.39.13-.65s-.04-.49-.11-.67c-.08-.18-.18-.32-.31-.42-.13-.1-.28-.17-.45-.21-.17-.04-.35-.06-.54-.06h-2.12v2.71Z"
          />
          <path
            className="st8"
            d="M1438.08,114.18h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM1437.58,119.11h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st8"
            d="M1446.73,114.18h5.65v1.24h-4.22v2.14h3.7v1.17h-3.7v3.64h-1.43v-8.19Z"
          />
          <path
            className="st8"
            d="M1453.53,114.18h3.91c.9,0,1.58.19,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97-.11.26-.25.46-.4.62-.15.16-.3.27-.45.34-.15.07-.26.11-.33.14v.02c.12.02.25.05.4.11.14.06.27.16.4.29.12.13.22.31.3.52.08.21.12.48.12.8,0,.48.04.92.11,1.31.07.39.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58-.02-.21-.03-.42-.03-.62,0-.37-.02-.7-.07-.97-.05-.27-.13-.5-.25-.68-.12-.18-.29-.31-.5-.4-.21-.08-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19ZM1454.97,117.9h2.35c.46,0,.81-.11,1.04-.33s.36-.54.36-.98c0-.26-.04-.47-.12-.64-.08-.16-.18-.29-.32-.38-.13-.09-.29-.15-.46-.18-.17-.03-.35-.05-.53-.05h-2.33v2.56Z"
          />
          <path
            className="st8"
            d="M1461.61,114.18h5.89v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st8"
            d="M1468.83,114.18h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st8"
            d="M1437.7,54.66c.3,0,.63,0,.98,0,.35,0,.7.03,1.04.06.34.03.67.08.96.15.3.07.55.17.76.3.46.28.86.66,1.18,1.15.32.49.49,1.09.49,1.81,0,.75-.18,1.41-.55,1.96-.36.55-.88.96-1.56,1.22v.04c.87.19,1.54.58,2,1.19.46.61.69,1.35.69,2.22,0,.52-.09,1.02-.28,1.51-.19.49-.46.92-.82,1.3-.36.38-.81.68-1.35.91-.54.23-1.15.35-1.86.35h-6.85v-14.17h5.14ZM1438.21,60.75c1.07,0,1.84-.19,2.31-.57.47-.38.7-.94.7-1.7,0-.5-.08-.9-.24-1.19-.16-.29-.38-.52-.66-.67-.28-.16-.6-.26-.96-.31-.36-.05-.75-.07-1.16-.07h-3.77v4.51h3.77ZM1439.17,67.24c.83,0,1.49-.22,1.96-.67.47-.45.7-1.07.7-1.87,0-.46-.09-.85-.26-1.15-.17-.3-.4-.55-.68-.72-.28-.18-.61-.3-.98-.38-.37-.07-.75-.11-1.15-.11h-4.31v4.9h4.72Z"
          />
          <path
            className="st8"
            d="M1452.37,54.66c1.43,0,2.51.37,3.25,1.1s1.1,1.76,1.1,3.09-.37,2.36-1.1,3.1c-.73.74-1.82,1.11-3.25,1.09h-4.33v5.8h-1.89v-14.17h6.21ZM1451.73,61.45c1.07.01,1.86-.2,2.35-.65.5-.45.74-1.1.74-1.95s-.25-1.49-.74-1.94c-.5-.44-1.28-.66-2.35-.66h-3.69v5.2h3.69Z"
          />
          <path
            className="st8"
            d="M1463.48,54.66l5.54,14.17h-2.08l-1.55-4.27h-6l-1.59,4.27h-1.93l5.52-14.17h2.08ZM1464.79,62.97l-2.36-6.61h-.04l-2.4,6.61h4.8Z"
          />
          <polygon
            className="st6"
            points="1479.66 81.43 1477.45 81.43 1477.45 43.44 1421.09 43.44 1421.09 41.24 1479.66 41.24 1479.66 81.43"
          />
          <polygon
            className="st8"
            points="1473.98 84.35 1415.69 84.35 1415.69 42.34 1417.9 42.34 1417.9 82.15 1473.98 82.15 1473.98 84.35"
          />
          <path className="st1" d="M1425.39,48.93" />
          <rect
            className="st8"
            x="1420.29"
            y="61.65"
            width="54.57"
            height="2.21"
            transform="translate(150.77 709.06) rotate(-28.97)"
          />
          <rect className="st5" x="1409.96" y="25" width="74.6" height="74.6" />
        </g>
        <g>
          <polygon
            className="st8"
            points="1467.79 204.07 1425.87 204.07 1425.87 166.11 1428.07 166.11 1428.07 201.86 1467.79 201.86 1467.79 204.07"
          />
          <path
            className="st8"
            d="M1414.87,233.35h1.43v3.26h3.73v-3.26h1.43v8.19h-1.43v-3.69h-3.73v3.69h-1.43v-8.19Z"
          />
          <path
            className="st8"
            d="M1423.18,233.35h3.91c.9,0,1.58.19,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97-.11.26-.25.46-.4.62-.15.16-.3.27-.45.34s-.26.11-.33.14v.02c.12.02.25.05.4.11.14.06.27.16.4.29.12.13.22.31.3.52.08.21.12.48.12.8,0,.48.04.92.11,1.31.07.39.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58-.02-.21-.03-.42-.03-.62,0-.37-.02-.7-.07-.97s-.13-.5-.25-.68-.29-.31-.5-.4-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19ZM1424.62,237.08h2.35c.46,0,.81-.11,1.04-.33s.36-.54.36-.98c0-.26-.04-.47-.11-.64s-.18-.29-.32-.38-.29-.15-.46-.18-.35-.05-.53-.05h-2.33v2.56Z"
          />
          <path
            className="st8"
            d="M1431.26,233.35h5.89v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.97v-8.19Z"
          />
          <path
            className="st8"
            d="M1438.48,233.35h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st8"
            d="M1448.9,233.35h1.43v6.95h4.16v1.24h-5.6v-8.19Z"
          />
          <path
            className="st8"
            d="M1457.67,233.35h1.52l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM1457.17,238.28h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st8"
            d="M1464.41,238.33l-3.07-4.98h1.66l2.17,3.67,2.13-3.67h1.61l-3.06,4.98v3.21h-1.43v-3.21Z"
          />
          <path
            className="st8"
            d="M1469.71,233.35h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st8"
            d="M1476.94,233.35h3.91c.9,0,1.58.19,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97s-.25.46-.4.62-.3.27-.45.34-.26.11-.33.14v.02c.12.02.25.05.4.11s.27.16.4.29c.12.13.22.31.3.52.08.21.12.48.12.8,0,.48.04.92.11,1.31.07.39.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58-.02-.21-.03-.42-.03-.62,0-.37-.02-.7-.07-.97s-.13-.5-.25-.68c-.12-.18-.29-.31-.5-.4s-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19ZM1478.37,237.08h2.35c.46,0,.81-.11,1.04-.33s.36-.54.36-.98c0-.26-.04-.47-.12-.64s-.18-.29-.32-.38-.29-.15-.46-.18c-.17-.03-.35-.05-.53-.05h-2.33v2.56Z"
          />
          <path
            className="st8"
            d="M1485.95,238.81c0,.31.05.58.16.8.11.22.26.4.45.54.19.14.41.24.66.31.25.07.52.1.81.1.31,0,.58-.04.8-.11.22-.07.4-.17.54-.28s.24-.25.3-.4c.06-.15.09-.3.09-.45,0-.31-.07-.54-.21-.69-.14-.15-.3-.25-.46-.32-.29-.11-.63-.21-1.01-.3-.39-.1-.86-.22-1.43-.37-.35-.09-.64-.21-.88-.36-.23-.15-.42-.32-.56-.5-.14-.18-.24-.38-.29-.58-.06-.21-.09-.42-.09-.63,0-.41.09-.77.26-1.07s.4-.55.68-.75c.28-.2.6-.35.96-.44s.72-.14,1.09-.14c.43,0,.83.06,1.21.17.38.11.71.28,1,.5.29.22.51.5.68.82.17.33.25.7.25,1.13h-1.43c-.04-.53-.22-.9-.54-1.12-.32-.22-.73-.33-1.23-.33-.17,0-.34.02-.52.05-.18.03-.34.09-.48.17-.15.08-.27.19-.36.33-.1.14-.14.31-.14.52,0,.29.09.52.27.68.18.16.41.29.71.37.03,0,.15.04.36.1.21.06.45.12.71.19.26.07.51.14.76.2.25.07.43.11.53.14.27.08.5.2.7.34.2.15.37.31.5.5.13.19.23.39.3.6s.1.43.1.64c0,.46-.09.85-.28,1.18-.19.33-.43.59-.74.8-.31.21-.65.36-1.04.45s-.79.14-1.19.14c-.47,0-.91-.06-1.32-.17-.41-.11-.77-.29-1.08-.53s-.55-.54-.73-.91-.28-.81-.29-1.31h1.43Z"
          />
          <path
            className="st8"
            d="M1466.77,177.95h-13.36c-.61,0-1.1-.49-1.1-1.1v-13.36h2.21v12.26h12.26v2.21Z"
          />
          <path
            className="st8"
            d="M1466.77,186.44h-21.85c-.61,0-1.1-.49-1.1-1.1v-21.85h2.21v20.75h20.75v2.21Z"
          />
          <path
            className="st8"
            d="M1466.77,197.05h-32.46c-.61,0-1.1-.49-1.1-1.1v-32.46h2.21v31.36h31.36v2.21Z"
          />
          <rect
            className="st8"
            x="1443.76"
            y="169.41"
            width="11.23"
            height="2.21"
            transform="translate(288.14 1054.42) rotate(-43.99)"
          />
          <rect
            className="st8"
            x="1443.76"
            y="178.61"
            width="11.23"
            height="2.21"
            transform="translate(281.74 1057) rotate(-43.99)"
          />
          <rect
            className="st8"
            x="1451.38"
            y="180.09"
            width="12.6"
            height="2.21"
            transform="translate(285 1065.78) rotate(-44.11)"
          />
          <rect
            className="st8"
            x="1438"
            y="165.58"
            width="2.21"
            height="2.87"
          />
          <rect
            className="st8"
            x="1439.94"
            y="171.62"
            width="2.21"
            height="2.87"
          />
          <rect
            className="st8"
            x="1438"
            y="177.66"
            width="2.21"
            height="2.87"
          />
          <rect
            className="st8"
            x="1439.7"
            y="183.71"
            width="2.21"
            height="2.87"
          />
          <rect
            className="st8"
            x="1438"
            y="189.75"
            width="2.21"
            height="2.87"
          />
          <rect
            className="st8"
            x="1449.36"
            y="189.75"
            width="2.21"
            height="2.87"
          />
          <rect
            className="st8"
            x="1460.72"
            y="189.75"
            width="2.21"
            height="2.87"
          />
          <rect
            className="st8"
            x="1443.68"
            y="188.32"
            width="2.21"
            height="2.87"
          />
          <rect
            className="st8"
            x="1455.04"
            y="188.32"
            width="2.21"
            height="2.87"
          />
          <polygon
            className="st6"
            points="1468.89 199.31 1466.68 199.31 1466.68 163.25 1426.97 163.25 1426.97 161.04 1468.89 161.04 1468.89 199.31"
          />
          <rect
            className="st5"
            x="1409.96"
            y="145.05"
            width="74.6"
            height="74.6"
          />
        </g>
        <g>
          <path
            className="st8"
            d="M402.45,233.35h5.65v1.24h-4.22v2.14h3.7v1.17h-3.7v3.64h-1.43v-8.19Z"
          />
          <path
            className="st8"
            d="M409.25,233.35h3.91c.9,0,1.58.19,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97-.11.26-.25.46-.4.62-.15.16-.3.27-.45.34s-.26.11-.33.14v.02c.12.02.25.05.4.11.14.06.27.16.4.29.12.13.22.31.3.52.08.21.12.48.12.8,0,.48.04.92.11,1.31.07.39.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58-.02-.21-.03-.42-.03-.62,0-.37-.02-.7-.07-.97s-.13-.5-.25-.68-.29-.31-.5-.4-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19ZM410.68,237.08h2.35c.46,0,.81-.11,1.04-.33s.36-.54.36-.98c0-.26-.04-.47-.11-.64s-.18-.29-.32-.38-.29-.15-.46-.18-.35-.05-.53-.05h-2.33v2.56Z"
          />
          <path
            className="st8"
            d="M417.33,233.35h5.89v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st8"
            d="M424.55,233.35h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st8"
            d="M431.54,233.35h6.23v1.09l-4.77,5.86h4.89v1.24h-6.71v-1.17l4.77-5.78h-4.4v-1.24Z"
          />
          <path
            className="st8"
            d="M439,233.35h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st8"
            d="M446.23,233.35h3.91c.9,0,1.58.19,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97s-.25.46-.4.62c-.15.16-.3.27-.45.34s-.26.11-.33.14v.02c.12.02.25.05.4.11.14.06.27.16.4.29.12.13.22.31.3.52.08.21.12.48.12.8,0,.48.04.92.11,1.31.07.39.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58-.02-.21-.03-.42-.03-.62,0-.37-.02-.7-.07-.97-.05-.27-.13-.5-.25-.68-.12-.18-.29-.31-.5-.4s-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19ZM447.66,237.08h2.35c.46,0,.81-.11,1.04-.33s.36-.54.36-.98c0-.26-.04-.47-.12-.64-.08-.16-.18-.29-.32-.38-.13-.09-.29-.15-.46-.18-.17-.03-.35-.05-.53-.05h-2.33v2.56Z"
          />
          <rect
            className="st8"
            x="426.08"
            y="165.67"
            width="2.21"
            height="16.36"
          />
          <rect
            className="st8"
            x="426.33"
            y="169.77"
            width="6.66"
            height="2.21"
            transform="translate(5.02 353.87) rotate(-45)"
          />
          <rect
            className="st8"
            x="423.85"
            y="167.54"
            width="2.21"
            height="6.66"
            transform="translate(3.64 350.54) rotate(-45)"
          />
          <rect
            className="st8"
            x="419"
            y="169.76"
            width="2.21"
            height="16.36"
            transform="translate(55.96 452.79) rotate(-60)"
          />
          <rect
            className="st8"
            x="417.66"
            y="170.97"
            width="2.21"
            height="6.66"
            transform="translate(-30.85 114.34) rotate(-15)"
          />
          <rect
            className="st8"
            x="413.08"
            y="177.28"
            width="6.66"
            height="2.21"
            transform="translate(-31.99 113.91) rotate(-15.01)"
          />
          <rect
            className="st8"
            x="411.92"
            y="185.01"
            width="16.36"
            height="2.21"
            transform="translate(-36.78 234.99) rotate(-30)"
          />
          <rect
            className="st8"
            x="415.18"
            y="182.13"
            width="2.21"
            height="6.66"
            transform="translate(129.42 539.57) rotate(-75)"
          />
          <rect
            className="st8"
            x="415.31"
            y="188.43"
            width="6.66"
            height="2.21"
            transform="translate(127.3 544.93) rotate(-75.01)"
          />
          <rect
            className="st8"
            x="426.08"
            y="182.03"
            width="2.21"
            height="16.36"
          />
          <rect
            className="st8"
            x="421.38"
            y="192.08"
            width="6.66"
            height="2.21"
            transform="translate(-12.21 356.89) rotate(-45)"
          />
          <rect
            className="st8"
            x="428.31"
            y="189.85"
            width="2.21"
            height="6.66"
            transform="translate(-10.83 360.2) rotate(-45)"
          />
          <rect
            className="st8"
            x="433.17"
            y="177.94"
            width="2.21"
            height="16.36"
            transform="translate(55.95 469.14) rotate(-60)"
          />
          <rect
            className="st8"
            x="434.5"
            y="186.42"
            width="2.21"
            height="6.66"
            transform="translate(-34.27 119.23) rotate(-15)"
          />
          <rect
            className="st8"
            x="434.63"
            y="184.57"
            width="6.66"
            height="2.21"
            transform="translate(-33.14 119.74) rotate(-15.01)"
          />
          <rect
            className="st8"
            x="426.09"
            y="176.83"
            width="16.36"
            height="2.21"
            transform="translate(-30.79 240.98) rotate(-30)"
          />
          <rect
            className="st8"
            x="436.98"
            y="175.27"
            width="2.21"
            height="6.66"
            transform="translate(152.18 555.52) rotate(-75)"
          />
          <rect
            className="st8"
            x="432.4"
            y="173.42"
            width="6.66"
            height="2.21"
            transform="translate(154.33 550.19) rotate(-74.99)"
          />
          <path className="st3" d="M413.56,187.75" />
          <polygon
            className="st6"
            points="449.93 198.65 447.73 198.65 447.73 160.34 405.54 160.34 405.54 158.14 449.93 158.14 449.93 198.65"
          />
          <polygon
            className="st8"
            points="448.83 203.63 404.44 203.63 404.44 163.44 406.64 163.44 406.64 201.43 448.83 201.43 448.83 203.63"
          />
          <rect
            className="st5"
            x="389.89"
            y="145.05"
            width="74.6"
            height="74.6"
          />
        </g>
        <g>
          <polygon
            className="st6"
            points="620.01 198.65 617.8 198.65 617.8 160.34 575.62 160.34 575.62 158.14 620.01 158.14 620.01 198.65"
          />
          <polygon
            className="st8"
            points="618.9 203.63 574.51 203.63 574.51 163.44 576.72 163.44 576.72 201.43 618.9 201.43 618.9 203.63"
          />
          <path
            className="st7"
            d="M604.02,193.09h-13.52c-2.64,0-4.78-2.14-4.78-4.78v-18.4h2.21v18.4c0,1.42,1.15,2.57,2.57,2.57h13.52c1.42,0,2.57-1.15,2.57-2.57v-18.4h2.21v18.4c0,2.64-2.14,4.78-4.78,4.78Z"
          />
          <polygon
            className="st7"
            points="605.59 196.61 588.93 196.61 588.93 192.49 591.14 192.49 591.14 194.4 603.38 194.4 603.38 192.49 605.59 192.49 605.59 196.61"
          />
          <path
            className="st8"
            d="M571.22,225.16h1.51l3.74,6.03h.02v-6.03h1.37v8.19h-1.51l-3.73-6.02h-.03v6.02h-1.37v-8.19Z"
          />
          <path
            className="st8"
            d="M583.04,224.96c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.36.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66-.44.97-.77,1.36c-.34.39-.75.7-1.23.92-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34ZM583.04,226.13c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1,.1-.37.14-.76.14-1.15s-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st8"
            d="M588.22,225.16h1.51l3.74,6.03h.02v-6.03h1.37v8.19h-1.51l-3.73-6.02h-.03v6.02h-1.37v-8.19Z"
          />
          <path className="st8" d="M596.24,229.61h3.34v1.24h-3.34v-1.24Z" />
          <path
            className="st8"
            d="M601.96,230.62c0,.31.05.58.16.8.11.22.26.4.45.54.19.14.41.24.66.31.25.07.52.1.81.1.31,0,.58-.04.8-.11.22-.07.4-.17.54-.28.14-.11.24-.25.3-.4.06-.15.09-.3.09-.45,0-.31-.07-.54-.21-.69s-.3-.25-.46-.32c-.29-.11-.63-.21-1.01-.3-.39-.1-.86-.22-1.43-.37-.35-.09-.64-.21-.88-.36-.23-.15-.42-.32-.56-.5-.14-.18-.24-.38-.29-.58s-.09-.42-.09-.63c0-.41.09-.77.26-1.07.17-.3.4-.55.68-.75.28-.2.6-.35.96-.44s.72-.14,1.09-.14c.43,0,.83.06,1.21.17.38.11.71.28,1,.5.29.22.51.49.68.82.17.32.25.7.25,1.13h-1.43c-.04-.53-.22-.9-.54-1.12-.32-.22-.73-.33-1.23-.33-.17,0-.34.02-.52.05s-.34.09-.48.17c-.15.08-.27.19-.36.33-.1.14-.14.31-.14.52,0,.29.09.52.27.68s.41.29.71.37c.03,0,.15.04.36.1s.45.12.71.19c.26.07.51.14.76.2.25.07.43.11.53.14.27.08.5.2.7.34.2.15.36.31.5.5s.23.39.3.6.1.43.1.64c0,.46-.09.85-.28,1.18s-.43.59-.74.8-.65.36-1.04.45c-.39.1-.79.14-1.19.14-.47,0-.91-.06-1.32-.17-.41-.11-.77-.29-1.08-.53s-.55-.54-.73-.91-.28-.81-.29-1.31h1.43Z"
          />
          <path
            className="st8"
            d="M608.45,225.16h1.43v6.95h4.16v1.24h-5.6v-8.19Z"
          />
          <path className="st8" d="M615.03,225.16h1.43v8.19h-1.43v-8.19Z" />
          <path
            className="st8"
            d="M618.22,225.16h3.61c.58,0,1.05.08,1.42.25.37.17.65.38.85.63.2.25.33.53.41.83.07.3.11.57.11.83s-.04.53-.11.82c-.07.29-.21.57-.41.82-.2.25-.48.46-.85.63-.37.16-.84.25-1.42.25h-2.18v3.14h-1.43v-8.19ZM619.65,229.04h2.1c.16,0,.32-.02.49-.07.17-.05.32-.12.46-.22.14-.1.26-.24.34-.41s.13-.39.13-.65-.04-.49-.12-.67c-.08-.18-.18-.32-.31-.42-.13-.1-.28-.17-.45-.21-.17-.04-.35-.06-.54-.06h-2.12v2.71Z"
          />
          <path
            className="st8"
            d="M546.82,244.38c0,.31.05.58.16.8.11.22.26.4.45.54.19.14.41.24.66.31.25.07.52.1.81.1.31,0,.58-.04.8-.11.22-.07.4-.17.54-.28.14-.11.24-.25.3-.4.06-.15.09-.3.09-.45,0-.31-.07-.54-.21-.69s-.3-.25-.46-.32c-.29-.11-.63-.21-1.01-.3-.39-.1-.86-.22-1.43-.37-.35-.09-.64-.21-.88-.36-.23-.15-.42-.32-.56-.5-.14-.18-.24-.38-.29-.58s-.09-.42-.09-.63c0-.41.09-.77.26-1.07.17-.3.4-.55.68-.75.28-.2.6-.35.96-.44s.72-.14,1.09-.14c.43,0,.83.06,1.21.17.38.11.71.28,1,.5.29.22.51.49.68.82.17.32.25.7.25,1.13h-1.43c-.04-.53-.22-.9-.54-1.12-.32-.22-.73-.33-1.23-.33-.17,0-.34.02-.52.05s-.34.09-.48.17c-.15.08-.27.19-.36.33-.1.14-.14.31-.14.52,0,.29.09.52.27.68s.41.29.71.37c.03,0,.15.04.36.1s.45.12.71.19c.26.07.51.14.76.2.25.07.43.11.53.14.27.08.5.2.7.34.2.15.36.31.5.5s.23.39.3.6.1.43.1.64c0,.46-.09.85-.28,1.18s-.43.59-.74.8-.65.36-1.04.45c-.39.1-.79.14-1.19.14-.47,0-.91-.06-1.32-.17-.41-.11-.77-.29-1.08-.53s-.55-.54-.73-.91-.28-.81-.29-1.31h1.43Z"
          />
          <path className="st8" d="M553.31,238.92h1.43v8.19h-1.43v-8.19Z" />
          <path
            className="st8"
            d="M556.5,238.92h1.43v6.95h4.16v1.24h-5.6v-8.19Z"
          />
          <path className="st8" d="M563.08,238.92h1.43v8.19h-1.43v-8.19Z" />
          <path
            className="st8"
            d="M571.8,241.53c-.06-.24-.15-.45-.25-.65-.11-.2-.24-.37-.41-.52-.17-.14-.37-.26-.59-.34-.23-.08-.49-.12-.79-.12-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26.32,0,.6-.06.85-.17s.45-.26.63-.46c.18-.2.31-.42.41-.68s.16-.54.2-.84h1.4c-.03.49-.14.94-.32,1.34-.18.41-.42.76-.73,1.05-.31.29-.67.52-1.08.68-.41.16-.87.24-1.36.24-.61,0-1.16-.11-1.65-.34-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34.46,0,.89.06,1.3.19.4.13.76.31,1.07.55s.56.53.75.88c.19.34.31.74.36,1.18h-1.43Z"
          />
          <path
            className="st8"
            d="M578.04,238.73c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.36.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66-.44.97-.77,1.36c-.34.39-.75.7-1.23.92-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34ZM578.04,239.9c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1,.1-.37.14-.76.14-1.15s-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st8"
            d="M583.21,238.92h1.51l3.74,6.03h.02v-6.03h1.37v8.19h-1.51l-3.73-6.02h-.03v6.02h-1.37v-8.19Z"
          />
          <path
            className="st8"
            d="M591.55,238.92h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st8"
            d="M601.96,238.92h3.98c.73,0,1.32.17,1.77.5.44.34.67.84.67,1.53,0,.41-.1.77-.3,1.06-.2.29-.49.52-.87.68v.02c.5.11.89.35,1.15.72.26.37.39.84.39,1.39,0,.32-.06.62-.17.9s-.29.52-.54.72c-.25.2-.56.36-.94.48-.38.12-.84.18-1.36.18h-3.76v-8.19ZM603.4,242.35h2.34c.34,0,.63-.1.86-.29.23-.19.34-.48.34-.84,0-.41-.1-.7-.31-.87-.21-.17-.5-.25-.89-.25h-2.34v2.26ZM603.4,245.94h2.53c.44,0,.77-.11,1.02-.34.24-.23.36-.54.36-.96s-.12-.72-.36-.93c-.24-.22-.58-.33-1.02-.33h-2.53v2.56Z"
          />
          <path
            className="st8"
            d="M613.52,238.73c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.36.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66-.44.97-.77,1.36c-.34.39-.75.7-1.23.92-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34ZM613.52,239.9c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1,.1-.37.14-.76.14-1.15s-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st8"
            d="M617.97,238.92h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <path
            className="st8"
            d="M624.77,238.92h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <path
            className="st8"
            d="M635.84,238.73c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.36.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66-.44.97-.77,1.36c-.34.39-.75.7-1.23.92-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34ZM635.84,239.9c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1,.1-.37.14-.76.14-1.15s-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st8"
            d="M641.05,238.92h2.02l2.26,6.41h.02l2.2-6.41h2v8.19h-1.37v-6.32h-.02l-2.27,6.32h-1.18l-2.27-6.32h-.02v6.32h-1.36v-8.19Z"
          />
          <rect
            className="st5"
            x="559.96"
            y="145.05"
            width="74.6"
            height="74.6"
          />
        </g>
        <g>
          <polygon
            className="st6"
            points="791.03 195.89 788.83 195.89 788.83 160.09 744.74 160.09 744.74 157.89 791.03 157.89 791.03 195.89"
          />
          <path
            className="st8"
            d="M791.03,205.29h-47.4v-41.03h2.21v35.14h45.19v5.88ZM745.84,203.08h42.99v-1.47h-42.99v1.47Z"
          />
          <path
            className="st8"
            d="M763.95,240.32h-.92l-.22-.96c-.38.44-.76.74-1.15.91-.38.17-.82.25-1.32.25-.61,0-1.16-.11-1.65-.34-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65.44-.97.77-1.37c.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34.44,0,.87.06,1.27.18.4.12.76.29,1.07.53.31.23.57.53.78.88.21.35.34.76.39,1.22h-1.4c-.04-.27-.12-.5-.25-.71s-.28-.37-.48-.51c-.19-.14-.4-.24-.64-.31-.24-.07-.49-.1-.75-.1-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15.24.71.44,1c.2.29.46.53.77.71s.69.26,1.13.26c.37,0,.69-.04.98-.14.28-.1.52-.25.72-.45.19-.2.34-.43.44-.72.1-.28.15-.6.16-.94h-2.18v-1.09h3.49v4.31Z"
          />
          <path
            className="st8"
            d="M767.7,232.14h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM767.19,237.07h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st8"
            d="M774.1,237.59c0,.31.05.58.16.8.11.22.26.4.45.54.19.14.41.24.66.31.25.07.52.1.81.1.31,0,.58-.04.8-.11.22-.07.4-.17.54-.28.14-.11.24-.25.3-.4.06-.15.09-.3.09-.45,0-.31-.07-.54-.21-.69s-.3-.25-.46-.32c-.29-.11-.63-.21-1.02-.3-.39-.1-.86-.22-1.43-.37-.35-.09-.64-.21-.88-.36-.23-.15-.42-.32-.56-.5s-.24-.38-.29-.58c-.06-.21-.09-.42-.09-.63,0-.41.09-.77.26-1.07.17-.3.4-.55.68-.75.28-.2.6-.35.96-.44.36-.1.72-.14,1.09-.14.43,0,.83.06,1.21.17.38.11.71.28,1,.5.29.22.51.5.68.82.17.33.25.7.25,1.13h-1.43c-.04-.53-.22-.9-.54-1.12-.32-.22-.73-.33-1.23-.33-.17,0-.34.02-.52.05-.18.03-.34.09-.48.17s-.27.19-.36.33c-.1.14-.14.31-.14.52,0,.29.09.52.27.68s.41.29.71.37c.03,0,.15.04.36.1.21.06.45.12.71.19.26.07.51.14.76.2s.43.11.53.14c.27.08.5.2.7.34.2.15.36.31.5.5.13.19.23.39.3.6.06.21.1.43.1.64,0,.46-.09.85-.28,1.18-.19.33-.43.59-.74.8-.31.21-.65.36-1.04.45-.39.1-.79.14-1.19.14-.47,0-.91-.06-1.32-.17-.41-.11-.77-.29-1.08-.53s-.55-.54-.73-.91-.28-.81-.29-1.31h1.43Z"
          />
          <path
            className="st7"
            d="M767.34,193.81c-3.5,0-6.79-1.36-9.27-3.84-2.48-2.48-3.84-5.77-3.84-9.27s1.36-6.79,3.84-9.27c2.48-2.48,5.77-3.84,9.27-3.84s6.79,1.36,9.27,3.84c2.48,2.48,3.84,5.77,3.84,9.27s-1.36,6.79-3.84,9.27c-2.48,2.48-5.77,3.84-9.27,3.84ZM767.34,169.81c-2.79,0-5.58,1.06-7.71,3.19-2.06,2.06-3.19,4.8-3.19,7.71s1.13,5.65,3.19,7.71c4.25,4.25,11.17,4.25,15.41,0,4.25-4.25,4.25-11.16,0-15.41-2.13-2.13-4.92-3.19-7.71-3.19Z"
          />
          <path
            className="st7"
            d="M767.34,186.54c-1.5,0-2.99-.57-4.13-1.71-2.28-2.28-2.28-5.98,0-8.26,2.28-2.28,5.98-2.28,8.26,0,2.28,2.28,2.28,5.98,0,8.26-1.14,1.14-2.63,1.71-4.13,1.71ZM767.34,177.07c-.93,0-1.86.35-2.57,1.06-1.42,1.42-1.42,3.72,0,5.14,1.42,1.42,3.72,1.42,5.14,0,1.42-1.42,1.42-3.72,0-5.14-.71-.71-1.64-1.06-2.57-1.06Z"
          />
          <rect
            className="st7"
            x="757.5"
            y="167.63"
            width="2.21"
            height="8.69"
            transform="translate(100.6 586.81) rotate(-45)"
          />
          <rect
            className="st7"
            x="774.96"
            y="185.09"
            width="2.21"
            height="8.69"
            transform="translate(93.36 604.24) rotate(-45)"
          />
          <rect
            className="st7"
            x="771.72"
            y="170.87"
            width="8.69"
            height="2.21"
            transform="translate(105.7 599.13) rotate(-45)"
          />
          <rect
            className="st7"
            x="754.26"
            y="188.33"
            width="8.69"
            height="2.21"
            transform="translate(88.24 591.9) rotate(-45)"
          />
          <rect
            className="st5"
            x="730.04"
            y="145.05"
            width="74.6"
            height="74.6"
          />
        </g>
        <g>
          <path
            className="st8"
            d="M910.56,232.14h5.89v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.97v-8.19Z"
          />
          <path
            className="st8"
            d="M917.79,232.14h1.43v6.95h4.16v1.24h-5.6v-8.19Z"
          />
          <path
            className="st8"
            d="M924.37,232.14h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st8"
            d="M937.12,234.74c-.06-.24-.15-.45-.25-.65-.11-.2-.24-.37-.41-.52-.17-.15-.37-.26-.59-.34-.23-.08-.49-.12-.79-.12-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15.24.71.44,1c.2.29.46.53.77.71s.69.26,1.13.26c.32,0,.6-.06.85-.17.24-.11.45-.26.63-.46.18-.19.31-.42.41-.68.1-.26.16-.54.19-.84h1.4c-.03.49-.14.94-.32,1.34s-.42.76-.73,1.05c-.31.29-.67.52-1.08.68-.41.16-.87.24-1.37.24-.61,0-1.16-.11-1.65-.34-.49-.23-.9-.53-1.23-.92-.34-.39-.59-.84-.77-1.36s-.27-1.07-.27-1.66.09-1.13.27-1.65.44-.97.77-1.37c.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34.46,0,.89.06,1.3.19.41.13.76.31,1.07.55.31.24.56.53.75.88s.31.74.36,1.18h-1.43Z"
          />
          <path
            className="st8"
            d="M939.1,232.14h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <path
            className="st8"
            d="M946.68,232.14h3.91c.9,0,1.58.19,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97s-.25.46-.4.62c-.15.16-.3.27-.45.34s-.26.11-.33.14v.02c.12.02.25.05.4.11.14.06.27.16.4.29.12.13.22.31.3.52.08.21.12.48.12.8,0,.48.04.92.11,1.31.07.39.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58-.02-.21-.03-.42-.03-.62,0-.37-.02-.7-.07-.97-.05-.27-.13-.5-.25-.68-.12-.18-.29-.31-.5-.4s-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19ZM948.11,235.86h2.35c.46,0,.81-.11,1.04-.33s.36-.54.36-.98c0-.26-.04-.47-.12-.64-.08-.16-.18-.29-.32-.38-.13-.09-.29-.15-.46-.18-.17-.03-.35-.05-.53-.05h-2.33v2.56Z"
          />
          <path className="st8" d="M954.75,232.14h1.43v8.19h-1.43v-8.19Z" />
          <path
            className="st8"
            d="M963.47,234.74c-.06-.24-.15-.45-.25-.65-.11-.2-.24-.37-.41-.52s-.37-.26-.59-.34c-.23-.08-.49-.12-.79-.12-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15.24.71.44,1c.2.29.46.53.77.71.32.18.69.26,1.13.26.32,0,.6-.06.85-.17.24-.11.45-.26.63-.46.18-.19.31-.42.41-.68.1-.26.16-.54.19-.84h1.4c-.03.49-.14.94-.32,1.34-.18.41-.42.76-.73,1.05s-.67.52-1.08.68c-.41.16-.87.24-1.37.24-.61,0-1.16-.11-1.65-.34-.49-.23-.9-.53-1.23-.92-.34-.39-.59-.84-.77-1.36-.18-.52-.27-1.07-.27-1.66s.09-1.13.27-1.65c.18-.52.44-.97.77-1.37.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34.46,0,.89.06,1.3.19.4.13.76.31,1.07.55s.56.53.75.88c.19.34.31.74.36,1.18h-1.43Z"
          />
          <polygon
            className="st6"
            points="961.11 195.89 958.9 195.89 958.9 160.09 914.81 160.09 914.81 157.89 961.11 157.89 961.11 195.89"
          />
          <path
            className="st8"
            d="M961.11,205.29h-47.4v-41.03h2.21v35.14h45.19v5.88ZM915.92,203.08h42.99v-1.47h-42.99v1.47Z"
          />
          <path
            className="st7"
            d="M937.41,193.93c-3.39,0-6.78-1.29-9.36-3.87-5.16-5.16-5.16-13.56,0-18.72,5.16-5.16,13.56-5.16,18.72,0h0c5.16,5.16,5.16,13.56,0,18.72-2.58,2.58-5.97,3.87-9.36,3.87ZM937.41,169.68c-2.82,0-5.65,1.08-7.8,3.22-4.3,4.3-4.3,11.3,0,15.6,4.3,4.3,11.3,4.3,15.6,0,4.3-4.3,4.3-11.3,0-15.6-2.15-2.15-4.97-3.22-7.8-3.22Z"
          />
          <polygon
            className="st7"
            points="939.68 184.32 935.35 180 931.53 183.81 929.97 182.25 935.35 176.88 939.68 181.2 943.29 177.6 944.85 179.15 939.68 184.32"
          />
          <rect
            className="st5"
            x="900.11"
            y="145.05"
            width="74.6"
            height="74.6"
          />
        </g>
        <g>
          <path className="st8" d="M1076.85,232.14h1.43v8.19h-1.43v-8.19Z" />
          <path
            className="st8"
            d="M1079.98,232.14h1.51l3.74,6.03h.02v-6.03h1.36v8.19h-1.51l-3.73-6.02h-.03v6.02h-1.36v-8.19Z"
          />
          <path
            className="st8"
            d="M1088.32,232.14h3.39c.63,0,1.17.11,1.63.32.46.21.83.51,1.12.88.29.37.51.8.65,1.3.14.5.21,1.03.21,1.59s-.07,1.1-.21,1.59c-.14.5-.36.93-.65,1.3-.29.37-.67.66-1.12.88s-1,.32-1.63.32h-3.39v-8.19ZM1089.75,239.15h1.41c.56,0,1.02-.07,1.37-.22.36-.15.63-.36.84-.62.2-.26.34-.57.41-.93.07-.36.11-.74.11-1.15s-.04-.8-.11-1.15c-.07-.36-.21-.67-.41-.93-.2-.26-.48-.47-.84-.62-.36-.15-.81-.22-1.37-.22h-1.41v5.85Z"
          />
          <path
            className="st8"
            d="M1096.51,232.14h1.43v4.77c0,.28.01.55.04.84.03.28.1.54.23.76.13.23.32.41.57.56.26.15.62.22,1.08.22s.83-.07,1.08-.22c.26-.15.45-.33.57-.56.13-.23.2-.48.23-.76s.04-.56.04-.84v-4.77h1.43v5.24c0,.53-.08.99-.24,1.38-.16.39-.39.72-.68.98s-.65.46-1.06.59c-.41.13-.87.2-1.38.2s-.96-.07-1.38-.2c-.41-.13-.77-.33-1.06-.59-.29-.26-.52-.59-.68-.98s-.24-.85-.24-1.38v-5.24Z"
          />
          <path
            className="st8"
            d="M1110.41,234.74c-.06-.24-.15-.45-.25-.65s-.24-.37-.41-.52c-.17-.15-.37-.26-.59-.34-.23-.08-.49-.12-.79-.12-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15.24.71.44,1c.2.29.46.53.77.71.32.18.69.26,1.13.26.32,0,.6-.06.85-.17.24-.11.45-.26.63-.46.18-.19.31-.42.41-.68.1-.26.16-.54.19-.84h1.4c-.03.49-.14.94-.32,1.34s-.42.76-.73,1.05c-.31.29-.67.52-1.08.68-.41.16-.87.24-1.36.24-.61,0-1.16-.11-1.65-.34-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65.44-.97.77-1.37c.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34.46,0,.89.06,1.3.19.41.13.76.31,1.07.55s.56.53.75.88c.19.34.31.74.36,1.18h-1.43Z"
          />
          <path
            className="st8"
            d="M1112.38,232.14h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <path className="st8" d="M1119.96,232.14h1.43v8.19h-1.43v-8.19Z" />
          <path
            className="st8"
            d="M1126.63,231.94c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.37.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66c-.18.52-.44.97-.77,1.36s-.75.7-1.23.92c-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65.44-.97.77-1.37c.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34ZM1126.63,233.11c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15.24.71.44,1c.2.29.46.53.77.71.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1s.14-.76.14-1.15-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st8"
            d="M1131.81,232.14h1.51l3.74,6.03h.02v-6.03h1.36v8.19h-1.51l-3.73-6.02h-.03v6.02h-1.36v-8.19Z"
          />
          <polygon
            className="st6"
            points="1131.19 195.89 1128.98 195.89 1128.98 160.09 1084.89 160.09 1084.89 157.89 1131.19 157.89 1131.19 195.89"
          />
          <path
            className="st8"
            d="M1131.19,205.29h-47.4v-41.03h2.21v35.14h45.19v5.88ZM1085.99,203.08h42.99v-1.47h-42.99v1.47Z"
          />
          <path
            className="st7"
            d="M1111.89,190.55c-.22,0-.4-.03-.46-.04-.02,0-2.06-.31-4.02-2.02-1.96,1.71-4.01,2.02-4.05,2.03-.05,0-.37.06-.72,0h0c-.34-.06-2.2-.45-4-2.02-1.96,1.72-4.01,2.03-4.05,2.03l-.3-2.18c.12-.02,1.51-.25,2.9-1.47-1.19-1.68-2.11-4.13-2.11-7.66,0-4.65.64-7.53,1.95-8.8.48-.46,1.05-.71,1.62-.69.57,0,1.14.24,1.61.7,1.31,1.28,1.95,4.15,1.95,8.79,0,3.54-.91,5.98-2.11,7.66,1.38,1.22,2.78,1.45,2.9,1.47h.05c.12-.01,1.52-.25,2.91-1.47-1.19-1.68-2.11-4.13-2.11-7.66,0-4.65.64-7.53,1.95-8.8.48-.46,1.05-.7,1.62-.69.58,0,1.14.24,1.61.7,1.31,1.28,1.95,4.15,1.95,8.79,0,3.54-.91,5.98-2.11,7.66,1.38,1.22,2.78,1.45,2.9,1.47.07,0,.14.01.17,0h.06c.11-.03,1.51-.26,2.89-1.47-1.19-1.68-2.11-4.13-2.11-7.66,0-4.65.64-7.53,1.95-8.8.48-.46,1.05-.71,1.62-.69.56,0,1.14.24,1.61.7,1.31,1.28,1.95,4.15,1.95,8.79,0,3.54-.91,5.98-2.11,7.66,1.38,1.22,2.78,1.45,2.9,1.47l-.3,2.18s-2.09-.31-4.05-2.03c-1.78,1.55-3.63,1.95-3.99,2.02h0c-.16.03-.32.04-.46.04ZM1116.33,171.93c-.19.13-1.36,1.2-1.36,7.28,0,2.65.58,4.54,1.36,5.88.79-1.34,1.36-3.23,1.36-5.88,0-6.07-1.18-7.15-1.37-7.28ZM1098.63,171.93c-.19.13-1.36,1.21-1.36,7.28,0,2.65.58,4.54,1.36,5.88.79-1.34,1.36-3.23,1.36-5.88,0-6.07-1.18-7.15-1.37-7.28ZM1107.4,171.93c-.19.13-1.36,1.21-1.36,7.28,0,2.65.58,4.54,1.36,5.88.79-1.34,1.36-3.23,1.36-5.88,0-6.07-1.18-7.15-1.37-7.28Z"
          />
          <path className="st4" d="M1119.84,193.73" />
          <rect
            className="st5"
            x="1070.19"
            y="145.05"
            width="74.6"
            height="74.6"
          />
        </g>
        <g>
          <path
            className="st8"
            d="M1247.46,232.14h1.43v3.26h3.73v-3.26h1.43v8.19h-1.43v-3.69h-3.73v3.69h-1.43v-8.19Z"
          />
          <path className="st8" d="M1255.78,232.14h1.43v8.19h-1.43v-8.19Z" />
          <path
            className="st8"
            d="M1266.11,240.32h-.92l-.22-.96c-.38.44-.76.74-1.15.91-.38.17-.82.25-1.32.25-.61,0-1.16-.11-1.65-.34-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36c-.18-.52-.27-1.07-.27-1.66s.09-1.13.27-1.65c.18-.52.44-.97.77-1.37.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34.44,0,.87.06,1.27.18.4.12.76.29,1.07.53.31.23.57.53.78.88.21.35.34.76.39,1.22h-1.4c-.04-.27-.12-.5-.25-.71s-.29-.37-.48-.51c-.19-.14-.41-.24-.64-.31-.24-.07-.49-.1-.75-.1-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15.24.71.44,1c.2.29.46.53.77.71.32.18.69.26,1.13.26.37,0,.69-.04.98-.14.28-.1.52-.25.72-.45.19-.2.34-.43.44-.72.1-.28.15-.6.16-.94h-2.18v-1.09h3.49v4.31Z"
          />
          <path
            className="st8"
            d="M1267.63,232.14h1.43v3.26h3.73v-3.26h1.43v8.19h-1.43v-3.69h-3.73v3.69h-1.43v-8.19Z"
          />
          <path
            className="st8"
            d="M1275.95,232.14h1.43v6.95h4.16v1.24h-5.6v-8.19Z"
          />
          <path className="st8" d="M1282.53,232.14h1.43v8.19h-1.43v-8.19Z" />
          <path
            className="st8"
            d="M1292.87,240.32h-.92l-.22-.96c-.38.44-.76.74-1.15.91-.38.17-.82.25-1.32.25-.61,0-1.16-.11-1.65-.34-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36c-.18-.52-.27-1.07-.27-1.66s.09-1.13.27-1.65c.18-.52.44-.97.77-1.37.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34.44,0,.87.06,1.27.18.4.12.76.29,1.07.53.31.23.57.53.78.88.21.35.34.76.39,1.22h-1.4c-.04-.27-.12-.5-.25-.71s-.29-.37-.48-.51c-.19-.14-.41-.24-.64-.31-.24-.07-.49-.1-.75-.1-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15.24.71.44,1c.2.29.46.53.77.71.32.18.69.26,1.13.26.37,0,.69-.04.98-.14.28-.1.52-.25.72-.45.19-.2.34-.43.44-.72.1-.28.15-.6.16-.94h-2.18v-1.09h3.49v4.31Z"
          />
          <path
            className="st8"
            d="M1294.39,232.14h1.43v3.26h3.73v-3.26h1.43v8.19h-1.43v-3.69h-3.73v3.69h-1.43v-8.19Z"
          />
          <path
            className="st8"
            d="M1301.93,232.14h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <polygon
            className="st6"
            points="1301.26 195.89 1299.06 195.89 1299.06 160.09 1254.97 160.09 1254.97 157.89 1301.26 157.89 1301.26 195.89"
          />
          <path
            className="st8"
            d="M1301.26,205.29h-47.4v-41.03h2.21v35.14h45.19v5.88ZM1256.07,203.08h42.99v-1.47h-42.99v1.47Z"
          />
          <rect
            className="st8"
            x="1278.37"
            y="192.02"
            width="2.21"
            height="3.61"
          />
          <rect
            className="st8"
            x="1274.12"
            y="191.99"
            width="2.21"
            height="3.62"
          />
          <path
            className="st8"
            d="M1278.37,196.88v-5.8l.92-.16c5.24-.9,9.04-5.41,9.04-10.73,0-6-4.88-10.89-10.89-10.89s-10.89,4.88-10.89,10.89c0,5.24,3.74,9.74,8.88,10.7l.9.17v5.81l-1.26-.18c-8.15-1.16-14.3-8.25-14.3-16.49,0-9.19,7.48-16.66,16.66-16.66s16.66,7.48,16.66,16.66c0,8.34-6.23,15.44-14.48,16.52l-1.25.16ZM1280.58,192.91v1.4c6.53-1.45,11.32-7.31,11.32-14.11,0-7.97-6.49-14.46-14.46-14.46s-14.46,6.49-14.46,14.46c0,6.72,4.71,12.56,11.15,14.07v-1.41c-5.72-1.49-9.78-6.68-9.78-12.67,0-7.22,5.87-13.09,13.09-13.09s13.09,5.87,13.09,13.09c0,6.08-4.13,11.29-9.95,12.71Z"
          />
          <path
            className="st8"
            d="M1278.37,193.33v-6.1l.83-.21c3.1-.8,5.27-3.6,5.27-6.81,0-3.88-3.16-7.03-7.03-7.03s-7.03,3.16-7.03,7.03c0,3.14,2.11,5.92,5.12,6.77l.8.23v6.12l-1.3-.24c-6.19-1.15-10.68-6.57-10.68-12.87,0-7.22,5.87-13.09,13.09-13.09s13.09,5.87,13.09,13.09c0,6.4-4.57,11.82-10.87,12.9l-1.29.22ZM1280.58,188.89v1.73c4.56-1.36,7.75-5.56,7.75-10.43,0-6-4.88-10.89-10.89-10.89s-10.89,4.88-10.89,10.89c0,4.79,3.12,8.96,7.58,10.37v-1.75c-3.53-1.36-5.93-4.79-5.93-8.63,0-5.09,4.14-9.24,9.24-9.24s9.24,4.14,9.24,9.24c0,3.92-2.47,7.38-6.1,8.69Z"
          />
          <rect
            className="st8"
            x="1274.12"
            y="188.03"
            width="2.21"
            height="3.95"
          />
          <rect
            className="st8"
            x="1278.37"
            y="188.08"
            width="2.21"
            height="3.94"
          />
          <rect
            className="st8"
            x="1278.37"
            y="184.1"
            width="2.21"
            height="3.98"
          />
          <rect
            className="st8"
            x="1274.12"
            y="184.01"
            width="2.21"
            height="4.03"
          />
          <path
            className="st8"
            d="M1278.37,189.51v-6.07l.59-.31c1.09-.57,1.77-1.69,1.77-2.92,0-1.82-1.48-3.3-3.3-3.3s-3.3,1.48-3.3,3.3c0,1.17.63,2.26,1.64,2.85l.55.32v6.12l-1.4-.4c-3.96-1.12-6.73-4.77-6.73-8.89,0-5.09,4.14-9.24,9.24-9.24s9.24,4.14,9.24,9.24c0,4.22-2.85,7.89-6.92,8.95l-1.38.36ZM1280.58,184.72v1.78c2.35-1.17,3.89-3.59,3.89-6.3,0-3.88-3.16-7.03-7.03-7.03s-7.03,3.16-7.03,7.03c0,2.62,1.47,5,3.72,6.2v-1.81c-1.37-1.03-2.19-2.66-2.19-4.39,0-3.04,2.47-5.51,5.5-5.51s5.51,2.47,5.51,5.51c0,1.82-.89,3.5-2.36,4.52Z"
          />
          <path className="st3" d="M1275.23,184.01" />
          <path
            className="st8"
            d="M1279.99,185.08l-1.02-1.95c1.09-.57,1.77-1.69,1.77-2.92,0-1.82-1.48-3.3-3.3-3.3s-3.3,1.48-3.3,3.3c0,1.17.63,2.26,1.64,2.85l-1.11,1.91c-1.69-.98-2.74-2.81-2.74-4.76,0-3.04,2.47-5.51,5.5-5.51s5.51,2.47,5.51,5.51c0,2.05-1.13,3.92-2.95,4.88Z"
          />
          <path className="st3" d="M1279.47,184.1" />
          <rect
            className="st5"
            x="1240.26"
            y="145.05"
            width="74.6"
            height="74.6"
          />
        </g>
        <g>
          <polygon
            className="st6"
            points="-58.81 79.08 -61.02 79.08 -61.02 40.8 -105.11 40.8 -105.11 38.6 -58.81 38.6 -58.81 79.08"
          />
          <path className="st2" d="M-105.11,47.21" />
          <polygon
            className="st8"
            points="-59.92 86 -106.21 86 -106.21 44.97 -104.01 44.97 -104.01 83.79 -59.92 83.79 -59.92 86"
          />
          <path className="st3" d="M-59.92,76.24" />
          <path
            className="st8"
            d="M-82.67,71.42c-4.48,0-8.12-3.64-8.12-8.12,0-4.07,6.45-14.66,7.18-15.85l.94-1.53.94,1.53c.73,1.19,7.18,11.78,7.18,15.85,0,4.48-3.64,8.12-8.12,8.12ZM-82.67,50.17c-2.24,3.81-5.91,10.61-5.91,13.13,0,3.26,2.65,5.91,5.91,5.91s5.91-2.65,5.91-5.91c0-2.52-3.68-9.32-5.91-13.13Z"
          />
          <path
            className="st8"
            d="M-111.11,113.28h1.51l3.74,6.03h.02v-6.03h1.36v8.19h-1.51l-3.73-6.02h-.03v6.02h-1.36v-8.19Z"
          />
          <path
            className="st8"
            d="M-99.29,113.09c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.37s.27,1.07.27,1.65-.09,1.14-.27,1.66-.44.97-.77,1.36-.75.7-1.23.92c-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92-.34-.39-.59-.84-.77-1.36s-.27-1.07-.27-1.66.09-1.13.27-1.65.44-.97.77-1.37c.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34ZM-99.29,114.26c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15.24.71.44,1c.2.29.46.53.77.71s.69.26,1.13.26.81-.09,1.13-.26.58-.41.77-.71c.2-.29.35-.63.44-1s.14-.76.14-1.15-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st8"
            d="M-89.93,118.74c0,.31.05.58.16.8.11.22.26.4.45.54.19.14.41.24.66.31.25.07.52.1.81.1.31,0,.58-.04.8-.11.22-.07.4-.17.54-.28.14-.11.24-.25.3-.4.06-.15.09-.3.09-.45,0-.31-.07-.54-.21-.69s-.3-.25-.46-.32c-.29-.11-.63-.21-1.01-.3-.39-.1-.86-.22-1.43-.37-.35-.09-.64-.21-.88-.36-.23-.15-.42-.32-.56-.5s-.24-.38-.29-.58c-.06-.21-.09-.42-.09-.63,0-.41.09-.77.26-1.07.17-.3.4-.55.68-.75.28-.2.6-.35.96-.44s.72-.14,1.09-.14c.43,0,.83.06,1.21.17.38.11.71.28,1,.5.29.22.51.5.68.82.17.33.25.7.25,1.13h-1.43c-.04-.53-.22-.9-.54-1.12-.32-.22-.73-.33-1.23-.33-.17,0-.34.02-.52.05-.18.03-.34.09-.48.17-.15.08-.27.19-.36.33-.1.14-.14.31-.14.52,0,.29.09.52.27.68s.41.29.71.37c.03,0,.15.04.36.1.21.06.45.12.71.19.26.07.51.14.76.2.25.07.43.11.53.14.27.08.5.2.7.34.2.15.37.31.5.5.13.19.23.39.3.6.07.21.1.43.1.64,0,.46-.09.85-.28,1.18-.19.33-.43.59-.74.8-.31.21-.65.36-1.04.45-.39.1-.79.14-1.19.14-.47,0-.91-.06-1.32-.17-.41-.11-.77-.29-1.08-.53s-.55-.54-.73-.91-.28-.81-.29-1.31h1.43Z"
          />
          <path
            className="st8"
            d="M-84.24,113.28h1.46l1.48,6.26h.02l1.65-6.26h1.47l1.61,6.26h.02l1.53-6.26h1.46l-2.26,8.19h-1.46l-1.64-6.26h-.02l-1.67,6.26h-1.48l-2.16-8.19Z"
          />
          <path
            className="st8"
            d="M-72.61,113.28h5.89v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.97v-8.19Z"
          />
          <path
            className="st8"
            d="M-63.2,113.28h1.52l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM-63.7,118.22h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st8"
            d="M-59.57,113.28h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <polygon
            className="st8"
            points="-82.72 80.79 -99.89 71.63 -98.85 69.68 -82.77 78.26 -68.34 69.71 -67.22 71.6 -82.72 80.79"
          />
          <polygon
            className="st8"
            points="-98.77 75.84 -100.35 70.06 -94.56 68.47 -93.98 70.6 -97.64 71.6 -96.64 75.26 -98.77 75.84"
          />
          <rect className="st5" x="-119.81" y="25" width="74.6" height="74.6" />
        </g>
        <g>
          <path
            className="st8"
            d="M-112.61,232.13h1.43v3.26h3.73v-3.26h1.43v8.19h-1.43v-3.69h-3.73v3.69h-1.43v-8.19Z"
          />
          <path className="st8" d="M-104.3,232.13h1.43v8.19h-1.43v-8.19Z" />
          <path
            className="st8"
            d="M-93.96,240.32h-.92l-.22-.96c-.38.44-.76.74-1.15.91-.38.17-.82.25-1.32.25-.61,0-1.16-.11-1.65-.34-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36c-.18-.52-.27-1.07-.27-1.66s.09-1.13.27-1.65c.18-.52.44-.97.77-1.37.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34.44,0,.87.06,1.27.18.4.12.76.29,1.07.53.31.23.57.53.78.88.21.35.34.76.39,1.22h-1.4c-.04-.27-.12-.5-.25-.71s-.29-.37-.48-.51c-.19-.14-.41-.24-.64-.31-.24-.07-.49-.1-.75-.1-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15.24.71.44,1c.2.29.46.53.77.71.32.18.69.26,1.13.26.37,0,.69-.04.98-.14.28-.1.52-.25.72-.45.19-.2.34-.43.44-.72.1-.28.15-.6.16-.94h-2.18v-1.09h3.49v4.31Z"
          />
          <path
            className="st8"
            d="M-92.44,232.13h1.43v3.26h3.73v-3.26h1.43v8.19h-1.43v-3.69h-3.73v3.69h-1.43v-8.19Z"
          />
          <path
            className="st8"
            d="M-84.12,232.13h1.43v6.95h4.16v1.24h-5.6v-8.19Z"
          />
          <path className="st8" d="M-77.54,232.13h1.43v8.19h-1.43v-8.19Z" />
          <path
            className="st8"
            d="M-67.21,240.32h-.92l-.22-.96c-.38.44-.76.74-1.15.91-.38.17-.82.25-1.32.25-.61,0-1.16-.11-1.65-.34-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36c-.18-.52-.27-1.07-.27-1.66s.09-1.13.27-1.65c.18-.52.44-.97.77-1.37.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34.44,0,.87.06,1.27.18.4.12.76.29,1.07.53.31.23.57.53.78.88.21.35.34.76.39,1.22h-1.4c-.04-.27-.12-.5-.25-.71s-.29-.37-.48-.51c-.19-.14-.41-.24-.64-.31-.24-.07-.49-.1-.75-.1-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15.24.71.44,1c.2.29.46.53.77.71.32.18.69.26,1.13.26.37,0,.69-.04.98-.14.28-.1.52-.25.72-.45.19-.2.34-.43.44-.72.1-.28.15-.6.16-.94h-2.18v-1.09h3.49v4.31Z"
          />
          <path
            className="st8"
            d="M-65.68,232.13h1.43v3.26h3.73v-3.26h1.43v8.19h-1.43v-3.69h-3.73v3.69h-1.43v-8.19Z"
          />
          <path
            className="st8"
            d="M-58.15,232.13h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <polygon
            className="st6"
            points="-58.81 195.89 -61.02 195.89 -61.02 160.09 -105.11 160.09 -105.11 157.89 -58.81 157.89 -58.81 195.89"
          />
          <path
            className="st8"
            d="M-58.81,205.28h-47.4v-41.03h2.21v35.14h45.19v5.88ZM-104.01,203.08h42.99v-1.47h-42.99v1.47Z"
          />
          <rect
            className="st8"
            x="-81.7"
            y="192.02"
            width="2.21"
            height="3.61"
          />
          <rect
            className="st8"
            x="-85.95"
            y="191.99"
            width="2.21"
            height="3.62"
          />
          <path
            className="st8"
            d="M-81.7,196.88v-5.8l.92-.16c5.24-.9,9.04-5.41,9.04-10.73,0-6-4.88-10.89-10.89-10.89s-10.89,4.88-10.89,10.89c0,5.24,3.74,9.74,8.88,10.7l.9.17v5.81l-1.26-.18c-8.15-1.16-14.3-8.25-14.3-16.49,0-9.19,7.48-16.66,16.66-16.66s16.66,7.48,16.66,16.66c0,8.34-6.23,15.44-14.48,16.52l-1.25.16ZM-79.5,192.91v1.4c6.53-1.45,11.32-7.31,11.32-14.11,0-7.97-6.49-14.46-14.46-14.46s-14.46,6.49-14.46,14.46c0,6.72,4.71,12.56,11.15,14.07v-1.41c-5.72-1.49-9.78-6.68-9.78-12.67,0-7.22,5.87-13.09,13.09-13.09s13.09,5.87,13.09,13.09c0,6.08-4.13,11.29-9.95,12.71Z"
          />
          <path
            className="st8"
            d="M-81.7,193.32v-6.1l.83-.21c3.1-.8,5.27-3.6,5.27-6.81,0-3.88-3.16-7.03-7.03-7.03s-7.03,3.16-7.03,7.03c0,3.14,2.11,5.92,5.12,6.77l.8.23v6.12l-1.3-.24c-6.19-1.15-10.68-6.57-10.68-12.87,0-7.22,5.87-13.09,13.09-13.09s13.09,5.87,13.09,13.09c0,6.4-4.57,11.82-10.87,12.9l-1.29.22ZM-79.5,188.89v1.73c4.56-1.36,7.75-5.56,7.75-10.43,0-6-4.88-10.89-10.89-10.89s-10.89,4.88-10.89,10.89c0,4.79,3.12,8.96,7.58,10.37v-1.75c-3.53-1.36-5.93-4.79-5.93-8.63,0-5.09,4.14-9.24,9.24-9.24s9.24,4.14,9.24,9.24c0,3.92-2.47,7.38-6.1,8.69Z"
          />
          <rect
            className="st8"
            x="-85.95"
            y="188.03"
            width="2.21"
            height="3.95"
          />
          <rect
            className="st8"
            x="-81.7"
            y="188.08"
            width="2.21"
            height="3.94"
          />
          <rect
            className="st8"
            x="-81.7"
            y="184.1"
            width="2.21"
            height="3.98"
          />
          <rect className="st8" x="-85.95" y="184" width="2.21" height="4.03" />
          <path
            className="st8"
            d="M-81.7,189.5v-6.07l.59-.31c1.09-.57,1.77-1.69,1.77-2.92,0-1.82-1.48-3.3-3.3-3.3s-3.3,1.48-3.3,3.3c0,1.17.63,2.26,1.64,2.85l.55.32v6.12l-1.4-.4c-3.96-1.12-6.73-4.77-6.73-8.89,0-5.09,4.14-9.24,9.24-9.24s9.24,4.14,9.24,9.24c0,4.22-2.85,7.89-6.92,8.95l-1.38.36ZM-79.5,184.72v1.78c2.35-1.17,3.89-3.59,3.89-6.3,0-3.88-3.16-7.03-7.03-7.03s-7.03,3.16-7.03,7.03c0,2.62,1.47,5,3.72,6.2v-1.81c-1.37-1.03-2.19-2.66-2.19-4.39,0-3.04,2.47-5.51,5.5-5.51s5.51,2.47,5.51,5.51c0,1.82-.89,3.5-2.36,4.52Z"
          />
          <path className="st3" d="M-84.85,184" />
          <path
            className="st8"
            d="M-80.09,185.08l-1.02-1.95c1.09-.57,1.77-1.69,1.77-2.92,0-1.82-1.48-3.3-3.3-3.3s-3.3,1.48-3.3,3.3c0,1.17.63,2.26,1.64,2.85l-1.11,1.91c-1.69-.98-2.74-2.81-2.74-4.76,0-3.04,2.47-5.51,5.5-5.51s5.51,2.47,5.51,5.51c0,2.05-1.13,3.92-2.95,4.88Z"
          />
          <path className="st3" d="M-80.6,184.1" />
          <rect
            className="st5"
            x="-119.81"
            y="145.05"
            width="74.6"
            height="74.6"
          />
        </g>
      </g>
      <g
        className={clsx({
          animation_right: showAnimation,
          complete: !showAnimation,
        })}
      >
        <polygon
          className="st6"
          points="778.11 286.43 775.9 286.43 775.9 283.91 761.49 283.91 761.49 286.43 759.28 286.43 759.28 281.71 778.11 281.71 778.11 286.43"
        />
        <g>
          <polygon
            className="st6"
            points="960.99 325.02 958.78 325.02 958.78 286.71 916.6 286.71 916.6 284.5 960.99 284.5 960.99 325.02"
          />
          <polygon
            className="st8"
            points="959.88 330 915.49 330 915.49 289.81 917.7 289.81 917.7 327.79 959.88 327.79 959.88 330"
          />
          <polygon
            className="st6"
            points="785.62 326.44 783.41 326.44 783.41 287.54 751.77 287.54 751.77 285.33 785.62 285.33 785.62 326.44"
          />
          <polygon
            className="st8"
            points="784.52 331.48 750.67 331.48 750.67 290.7 752.88 290.7 752.88 329.27 784.52 329.27 784.52 331.48"
          />
          <path
            className="st8"
            d="M68.42,357.91h1.43v4.77c0,.28.01.55.04.84s.1.54.23.76c.13.23.32.41.57.56.26.15.62.22,1.08.22s.83-.07,1.08-.22c.26-.15.45-.33.57-.56.13-.23.2-.48.23-.76.03-.28.04-.56.04-.84v-4.77h1.43v5.24c0,.53-.08.99-.24,1.38-.16.39-.39.72-.68.98-.29.26-.65.46-1.06.59-.41.13-.87.2-1.38.2s-.96-.07-1.38-.2c-.41-.13-.77-.33-1.06-.59-.29-.26-.52-.59-.68-.98-.16-.39-.24-.85-.24-1.38v-5.24Z"
          />
          <path
            className="st8"
            d="M75.86,357.91h1.49l2.05,6.48h.02l2.1-6.48h1.46l-2.8,8.19h-1.59l-2.73-8.19Z"
          />
          <path className="st8" d="M82.85,362.36h3.34v1.24h-3.34v-1.24Z" />
          <path
            className="st8"
            d="M87.63,357.91h1.43v6.95h4.16v1.24h-5.6v-8.19Z"
          />
          <path
            className="st8"
            d="M94.21,357.91h5.89v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.97v-8.19Z"
          />
          <path
            className="st8"
            d="M101.43,357.91h3.39c.63,0,1.17.11,1.63.32.46.21.83.51,1.12.88.29.37.51.8.65,1.3s.21,1.03.21,1.59-.07,1.1-.21,1.59c-.14.5-.36.93-.65,1.3-.29.37-.67.66-1.12.88-.46.21-1,.32-1.63.32h-3.39v-8.19ZM102.87,364.93h1.41c.56,0,1.02-.07,1.37-.22.36-.15.63-.36.84-.62.2-.26.34-.57.41-.93.07-.36.11-.74.11-1.15s-.04-.8-.11-1.15c-.07-.36-.21-.67-.41-.93-.2-.26-.48-.47-.84-.62-.35-.15-.81-.22-1.37-.22h-1.41v5.85Z"
          />
          <polygon
            className="st6"
            points="111.56 323.31 109.36 323.31 109.36 285.04 65.27 285.04 65.27 282.83 111.56 282.83 111.56 323.31"
          />
          <polygon
            className="st8"
            points="110.46 330.23 64.16 330.23 64.16 289.2 66.37 289.2 66.37 328.02 110.46 328.02 110.46 330.23"
          />
          <polygon
            className="st6"
            points="435.89 323.94 433.69 323.94 433.69 285.66 413.54 285.66 413.54 283.45 435.89 283.45 435.89 323.94"
          />
          <polygon
            className="st8"
            points="434.79 330.85 412.44 330.85 412.44 289.82 414.64 289.82 414.64 328.65 434.79 328.65 434.79 330.85"
          />
          <path className="st3" d="M110.46,320.47" />
          <polygon
            className="st8"
            points="87.66 325.02 70.48 315.86 71.52 313.91 87.6 322.49 102.03 313.94 103.16 315.84 87.66 325.02"
          />
          <polygon
            className="st8"
            points="71.6 320.07 70.02 314.29 75.81 312.71 76.39 314.83 72.73 315.83 73.73 319.49 71.6 320.07"
          />
          <path
            className="st8"
            d="M934.3,321.95c-.15,0-.3-.03-.45-.1-.5-.22-.76-.78-.61-1.31l2.81-9.96h-4.08c-.39,0-.75-.21-.95-.54-.2-.34-.2-.75-.01-1.1l8.45-15.15c.27-.48.84-.69,1.35-.49.51.19.8.73.69,1.26l-2.04,9.45h4.75c.4,0,.77.22.97.57.19.35.18.78-.03,1.12l-9.91,15.73c-.21.33-.56.52-.93.52ZM933.84,308.38h3.66c.35,0,.67.16.88.44s.28.63.18.96l-1.13,4.02,4.78-7.59h-4.12c-.33,0-.65-.15-.86-.41-.21-.26-.29-.6-.22-.93l.77-3.55-3.93,7.05Z"
          />
          <path
            className="st8"
            d="M909.56,357.91h3.61c.58,0,1.05.08,1.42.25.37.17.65.38.85.63.2.25.33.53.41.83.07.3.11.57.11.83s-.04.53-.11.82-.21.57-.41.82c-.2.25-.48.46-.85.63-.37.16-.84.25-1.42.25h-2.18v3.14h-1.43v-8.19ZM911,361.79h2.1c.16,0,.32-.02.49-.07.17-.05.32-.12.46-.22.14-.1.26-.24.34-.41s.13-.39.13-.65-.04-.49-.12-.67c-.08-.18-.18-.32-.31-.42-.13-.1-.28-.17-.45-.21-.17-.04-.35-.06-.54-.06h-2.12v2.71Z"
          />
          <path
            className="st8"
            d="M920.7,357.72c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.36.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66c-.18.52-.44.97-.77,1.36-.34.39-.75.7-1.23.92-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92-.34-.39-.59-.84-.77-1.36-.18-.52-.27-1.07-.27-1.66s.09-1.13.27-1.65c.18-.52.44-.97.77-1.36.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34ZM920.7,358.89c-.44,0-.81.09-1.13.26s-.58.41-.77.71c-.2.29-.35.63-.44,1s-.14.76-.14,1.15.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71s.69.26,1.13.26.81-.09,1.13-.26c.32-.18.57-.41.77-.71.2-.29.35-.63.44-1,.09-.37.14-.76.14-1.15s-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st8"
            d="M925.93,357.91h3.91c.9,0,1.58.2,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97s-.25.46-.4.62c-.15.16-.3.27-.45.34-.15.07-.26.11-.33.14v.02c.12.02.25.05.4.12s.27.16.4.29c.12.13.22.31.3.52s.12.48.12.8c0,.48.04.92.11,1.31.07.39.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58-.02-.21-.03-.42-.03-.62,0-.37-.02-.7-.07-.97-.05-.27-.13-.5-.25-.68s-.29-.31-.5-.4c-.21-.08-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19ZM927.36,361.64h2.35c.46,0,.81-.11,1.04-.33.24-.22.35-.54.35-.98,0-.26-.04-.47-.11-.64-.08-.16-.18-.29-.32-.38s-.29-.15-.46-.18c-.17-.03-.35-.05-.53-.05h-2.33v2.56Z"
          />
          <path
            className="st8"
            d="M933.02,357.91h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <path
            className="st8"
            d="M941.74,357.91h1.52l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM941.23,362.84h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st8"
            d="M947.19,357.91h3.98c.73,0,1.32.17,1.77.5s.67.84.67,1.53c0,.41-.1.77-.3,1.06-.2.29-.49.52-.87.68v.02c.5.11.89.35,1.15.72.26.37.39.84.39,1.39,0,.32-.06.62-.17.9s-.29.52-.54.72c-.24.2-.56.36-.94.48-.38.12-.84.18-1.36.18h-3.76v-8.19ZM948.63,361.34h2.34c.34,0,.63-.1.86-.29.23-.19.34-.48.34-.84,0-.41-.1-.7-.31-.87s-.5-.25-.89-.25h-2.34v2.26ZM948.63,364.93h2.53c.44,0,.77-.11,1.01-.34.24-.23.36-.54.36-.96s-.12-.72-.36-.93-.58-.33-1.01-.33h-2.53v2.56Z"
          />
          <path
            className="st8"
            d="M955.27,357.91h1.43v6.95h4.16v1.24h-5.6v-8.19Z"
          />
          <path
            className="st8"
            d="M961.85,357.91h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st7"
            d="M723.35,357.91h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM722.84,362.84h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st7"
            d="M728.78,357.91h2.02l2.26,6.41h.02l2.2-6.41h2v8.19h-1.37v-6.32h-.02l-2.27,6.32h-1.18l-2.27-6.32h-.02v6.32h-1.36v-8.19Z"
          />
          <path
            className="st7"
            d="M739,357.91h3.61c.58,0,1.05.08,1.42.25.37.17.65.38.85.63.2.25.33.53.41.83.07.3.11.57.11.83s-.04.53-.11.82c-.07.29-.21.57-.41.82-.2.25-.48.46-.85.63-.37.16-.84.25-1.42.25h-2.18v3.14h-1.43v-8.19ZM740.44,361.79h2.1c.16,0,.32-.02.49-.07.17-.05.32-.12.46-.22.14-.1.26-.24.34-.41s.13-.39.13-.65-.04-.49-.12-.67c-.08-.18-.18-.32-.31-.42-.13-.1-.28-.17-.45-.21-.17-.04-.35-.06-.54-.06h-2.12v2.71Z"
          />
          <path
            className="st7"
            d="M746.65,357.91h1.43v6.95h4.16v1.24h-5.6v-8.19Z"
          />
          <path
            className="st7"
            d="M753.24,357.91h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st7"
            d="M769.18,360.52c-.06-.24-.15-.45-.25-.65-.11-.2-.24-.37-.41-.52-.17-.14-.37-.26-.59-.34-.23-.08-.49-.12-.79-.12-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26.32,0,.6-.06.85-.17s.45-.26.63-.46c.18-.2.31-.42.41-.68s.16-.54.2-.84h1.4c-.03.49-.14.94-.32,1.34-.18.41-.42.76-.73,1.05-.31.29-.67.52-1.08.68-.41.16-.87.24-1.36.24-.61,0-1.16-.11-1.65-.34-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34.46,0,.89.06,1.3.19.4.13.76.31,1.07.55s.56.53.75.88c.19.34.31.74.36,1.18h-1.43Z"
          />
          <path
            className="st7"
            d="M774.12,357.91h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM773.62,362.84h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st7"
            d="M779.58,357.91h3.61c.58,0,1.05.08,1.42.25.37.17.65.38.85.63.2.25.33.53.41.83.07.3.11.57.11.83s-.04.53-.11.82c-.07.29-.21.57-.41.82-.2.25-.48.46-.85.63-.37.16-.84.25-1.42.25h-2.18v3.14h-1.43v-8.19ZM781.01,361.79h2.1c.16,0,.32-.02.49-.07.17-.05.32-.12.46-.22.14-.1.26-.24.34-.41s.13-.39.13-.65-.04-.49-.12-.67c-.08-.18-.18-.32-.31-.42-.13-.1-.28-.17-.45-.21-.17-.04-.35-.06-.54-.06h-2.12v2.71Z"
          />
          <path
            className="st7"
            d="M788.57,357.91h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM788.07,362.84h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st7"
            d="M799.56,360.52c-.06-.24-.15-.45-.25-.65-.11-.2-.24-.37-.41-.52-.17-.14-.37-.26-.59-.34-.23-.08-.49-.12-.79-.12-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26.32,0,.6-.06.85-.17s.45-.26.63-.46c.18-.2.31-.42.41-.68s.16-.54.2-.84h1.4c-.03.49-.14.94-.32,1.34-.18.41-.42.76-.73,1.05-.31.29-.67.52-1.08.68-.41.16-.87.24-1.36.24-.61,0-1.16-.11-1.65-.34-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34.46,0,.89.06,1.3.19.4.13.76.31,1.07.55s.56.53.75.88c.19.34.31.74.36,1.18h-1.43Z"
          />
          <path className="st7" d="M802.31,357.91h1.43v8.19h-1.43v-8.19Z" />
          <path
            className="st7"
            d="M804.72,357.91h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <path
            className="st7"
            d="M814.43,362.89l-3.07-4.98h1.66l2.17,3.67,2.13-3.67h1.61l-3.06,4.98v3.21h-1.43v-3.21Z"
          />
          <path
            className="st7"
            d="M759.38,302.6h8.24v1.63c-.63.71-1.2,1.45-1.72,2.21-.52.76-.97,1.57-1.35,2.43-.38.85-.7,1.76-.94,2.71-.24.95-.4,1.97-.48,3.06h-2.15c.07-.95.23-1.89.49-2.82.26-.93.59-1.83,1-2.7s.88-1.71,1.42-2.51c.54-.8,1.12-1.55,1.74-2.25h-6.24v-1.75Z"
          />
          <path
            className="st7"
            d="M769.65,302.36h2.15v10.43h6.24v1.86h-8.4v-12.28Z"
          />
          <rect
            className="st8"
            x="753.35"
            y="331.12"
            width="2.21"
            height="2.41"
          />
          <rect
            className="st8"
            x="779.42"
            y="331.12"
            width="2.21"
            height="2.41"
          />
          <polygon
            className="st8"
            points="588.9 302.45 575.34 302.45 575.34 286.89 577.55 286.89 577.55 300.24 588.9 300.24 588.9 302.45"
          />
          <polygon
            className="st6"
            points="620.84 297.47 618.63 297.47 618.63 283.79 576.44 283.79 576.44 281.59 620.84 281.59 620.84 297.47"
          />
          <path
            className="st8"
            d="M87.86,309.32c-3.71,0-6.74-3.02-6.74-6.74s3.02-6.74,6.74-6.74,6.74,3.02,6.74,6.74-3.02,6.74-6.74,6.74ZM87.86,298.05c-2.5,0-4.53,2.03-4.53,4.53s2.03,4.53,4.53,4.53,4.53-2.03,4.53-4.53-2.03-4.53-4.53-4.53Z"
          />
          <rect
            className="st8"
            x="86.76"
            y="288.99"
            width="2.21"
            height="4.47"
          />
          <rect
            className="st8"
            x="76.92"
            y="294.67"
            width="2.21"
            height="4.47"
            transform="translate(-218.11 216.01) rotate(-60)"
          />
          <rect
            className="st8"
            x="75.79"
            y="307.16"
            width="4.47"
            height="2.21"
            transform="translate(-143.68 80.31) rotate(-30)"
          />
          <rect
            className="st8"
            x="86.76"
            y="311.71"
            width="2.21"
            height="4.47"
          />
          <rect
            className="st8"
            x="96.6"
            y="306.03"
            width="2.21"
            height="4.47"
            transform="translate(-218.12 238.77) rotate(-60)"
          />
          <rect
            className="st8"
            x="95.47"
            y="295.8"
            width="4.47"
            height="2.21"
            transform="translate(-135.36 88.63) rotate(-30)"
          />
          <path
            className="st8"
            d="M612.14,331.67h-2.21v-2.02c0-1.93.55-3.57,1.08-5.16.55-1.64,1.12-3.33,1.12-5.46v-11.74c0-1.01-.82-1.83-1.83-1.83s-1.83.82-1.83,1.83c0,.61-.49,1.1-1.1,1.1s-1.1-.49-1.1-1.1v-2.2c0-1.01-.82-1.83-1.83-1.83s-1.83.82-1.83,1.83c0,.61-.49,1.1-1.1,1.1s-1.1-.49-1.1-1.1v-2.2c0-1.01-.82-1.83-1.83-1.83s-1.83.82-1.83,1.83c0,.61-.49,1.1-1.1,1.1s-1.1-.49-1.1-1.1v-10.27c0-1.01-.82-1.83-1.83-1.83s-1.83.82-1.83,1.83v20.55c0,.47-.3.89-.74,1.04-.44.16-.93.01-1.23-.36-1.8-2.27-2.91-3.63-3.58-4.31-.84-.85-1.69-1.15-2.16-1.15-1.12,0-1.83.29-2.25.55.8,1.44,2.12,4.4,4.73,10.38.71,1.61,1.63,2.88,2.53,4.1,1.39,1.89,2.7,3.68,2.7,6.22v2.02h-2.21v-2.02c0-1.82-1-3.19-2.27-4.92-.92-1.26-1.97-2.69-2.77-4.52-3.77-8.63-4.71-10.35-4.91-10.69-.05-.05-.1-.11-.14-.17-.24-.37-.23-.85.02-1.22.22-.32,1.49-1.94,4.57-1.94,1.21,0,2.6.67,3.72,1.79.45.44,1.01,1.1,1.79,2.04v-17.41c0-2.23,1.81-4.04,4.04-4.04s4.04,1.81,4.04,4.04v6.68c.55-.28,1.17-.44,1.83-.44,1.78,0,3.29,1.16,3.83,2.76.6-.35,1.3-.55,2.04-.55,1.78,0,3.29,1.16,3.83,2.76.6-.35,1.3-.55,2.04-.55,2.23,0,4.04,1.81,4.04,4.04v11.74c0,2.48-.65,4.43-1.23,6.16-.5,1.48-.97,2.89-.97,4.46v2.02ZM579.21,309.82c.14.04.29.05.46.02-.16.03-.31.02-.46-.02Z"
          />
          <path
            className="st7"
            d="M567.63,350.84c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.36.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66-.44.97-.77,1.36c-.34.39-.75.7-1.23.92-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34ZM567.63,352.01c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1,.1-.37.14-.76.14-1.15s-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st7"
            d="M572.81,351.03h1.51l3.74,6.03h.02v-6.03h1.37v8.19h-1.51l-3.73-6.02h-.03v6.02h-1.37v-8.19Z"
          />
          <path
            className="st7"
            d="M581.14,351.03h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path className="st7" d="M588.06,355.48h3.34v1.24h-3.34v-1.24Z" />
          <path
            className="st7"
            d="M592.05,351.03h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <path
            className="st7"
            d="M603.12,350.84c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.36.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66-.44.97-.77,1.36c-.34.39-.75.7-1.23.92-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34ZM603.12,352.01c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1,.1-.37.14-.76.14-1.15s-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st7"
            d="M608.26,351.03h1.43v4.77c0,.28.01.55.04.84.03.28.1.54.23.76.13.23.32.41.57.56.26.15.62.22,1.08.22s.83-.07,1.08-.22c.26-.15.45-.33.57-.56.13-.23.2-.48.23-.76.03-.28.04-.56.04-.84v-4.77h1.43v5.24c0,.53-.08.99-.24,1.38-.16.39-.39.72-.68.98-.29.26-.65.46-1.06.59-.41.13-.87.2-1.38.2s-.96-.07-1.38-.2c-.41-.13-.77-.33-1.06-.59-.29-.26-.52-.59-.68-.98-.16-.39-.24-.85-.24-1.38v-5.24Z"
          />
          <path
            className="st7"
            d="M622.16,353.63c-.06-.24-.15-.45-.25-.65-.11-.2-.24-.37-.41-.52-.17-.14-.37-.26-.59-.34-.23-.08-.49-.12-.79-.12-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26.32,0,.6-.06.85-.17s.45-.26.63-.46c.18-.2.31-.42.41-.68s.16-.54.2-.84h1.4c-.03.49-.14.94-.32,1.34-.18.41-.42.76-.73,1.05-.31.29-.67.52-1.08.68-.41.16-.87.24-1.36.24-.61,0-1.16-.11-1.65-.34-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34.46,0,.89.06,1.3.19.4.13.76.31,1.07.55s.56.53.75.88c.19.34.31.74.36,1.18h-1.43Z"
          />
          <path
            className="st7"
            d="M624.87,351.03h1.43v3.26h3.73v-3.26h1.43v8.19h-1.43v-3.69h-3.73v3.69h-1.43v-8.19Z"
          />
          <path
            className="st7"
            d="M575.19,364.79h3.98c.73,0,1.32.17,1.77.5.44.34.67.84.67,1.53,0,.41-.1.77-.3,1.06-.2.29-.49.52-.87.68v.02c.5.11.89.35,1.15.72.26.37.39.84.39,1.39,0,.32-.06.62-.17.9s-.29.52-.54.72c-.25.2-.56.36-.94.48-.38.12-.84.18-1.36.18h-3.76v-8.19ZM576.63,368.22h2.34c.34,0,.63-.1.86-.29.23-.19.34-.48.34-.84,0-.41-.1-.7-.31-.87-.21-.17-.5-.25-.89-.25h-2.34v2.26ZM576.63,371.81h2.53c.44,0,.77-.11,1.02-.34.24-.23.36-.54.36-.96s-.12-.72-.36-.93c-.24-.22-.58-.33-1.02-.33h-2.53v2.56Z"
          />
          <path
            className="st7"
            d="M583.17,364.79h1.43v4.77c0,.28.01.55.04.84.03.28.1.54.23.76.13.23.32.41.57.56.26.15.62.22,1.08.22s.83-.07,1.08-.22c.26-.15.45-.33.57-.56.13-.23.2-.48.23-.76.03-.28.04-.56.04-.84v-4.77h1.43v5.24c0,.53-.08.99-.24,1.38-.16.39-.39.72-.68.98-.29.26-.65.46-1.06.59-.41.13-.87.2-1.38.2s-.96-.07-1.38-.2c-.41-.13-.77-.33-1.06-.59-.29-.26-.52-.59-.68-.98-.16-.39-.24-.85-.24-1.38v-5.24Z"
          />
          <path
            className="st7"
            d="M590.77,364.79h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <path
            className="st7"
            d="M597.57,364.79h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <path
            className="st7"
            d="M608.63,364.6c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.36.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66-.44.97-.77,1.36c-.34.39-.75.7-1.23.92-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34ZM608.63,365.77c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1,.1-.37.14-.76.14-1.15s-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st7"
            d="M613.81,364.79h1.51l3.74,6.03h.02v-6.03h1.37v8.19h-1.51l-3.73-6.02h-.03v6.02h-1.37v-8.19Z"
          />
          <rect
            className="st8"
            x="599.72"
            y="299.69"
            width="21.08"
            height="2.21"
          />
          <path
            className="st7"
            d="M225.75,351.03h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM225.25,355.96h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st7"
            d="M231.12,351.03h1.43v4.77c0,.28.01.55.04.84.03.28.1.54.23.76.13.23.32.41.57.56.26.15.62.22,1.08.22s.83-.07,1.08-.22c.26-.15.45-.33.57-.56.13-.23.2-.48.23-.76.03-.28.04-.56.04-.84v-4.77h1.43v5.24c0,.53-.08.99-.24,1.38-.16.39-.39.72-.68.98-.29.26-.65.46-1.06.59-.41.13-.87.2-1.38.2s-.96-.07-1.38-.2c-.41-.13-.77-.33-1.06-.59-.29-.26-.52-.59-.68-.98-.16-.39-.24-.85-.24-1.38v-5.24Z"
          />
          <path
            className="st7"
            d="M238.71,351.03h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <path
            className="st7"
            d="M249.78,350.84c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.36.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66-.44.97-.77,1.36c-.34.39-.75.7-1.23.92-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34ZM249.78,352.01c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1,.1-.37.14-.76.14-1.15s-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st7"
            d="M254.98,351.03h2.02l2.26,6.41h.02l2.2-6.41h2v8.19h-1.37v-6.32h-.02l-2.27,6.32h-1.18l-2.27-6.32h-.02v6.32h-1.36v-8.19Z"
          />
          <path
            className="st7"
            d="M267.39,351.03h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM266.89,355.96h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st7"
            d="M271.02,351.03h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <path className="st7" d="M278.6,351.03h1.43v8.19h-1.43v-8.19Z" />
          <path
            className="st7"
            d="M287.32,353.63c-.06-.24-.15-.45-.25-.65-.11-.2-.24-.37-.41-.52-.17-.14-.37-.26-.59-.34-.23-.08-.49-.12-.79-.12-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26.32,0,.6-.06.85-.17s.45-.26.63-.46c.18-.2.31-.42.41-.68s.16-.54.2-.84h1.4c-.03.49-.14.94-.32,1.34-.18.41-.42.76-.73,1.05-.31.29-.67.52-1.08.68-.41.16-.87.24-1.36.24-.61,0-1.16-.11-1.65-.34-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34.46,0,.89.06,1.3.19.4.13.76.31,1.07.55s.56.53.75.88c.19.34.31.74.36,1.18h-1.43Z"
          />
          <path
            className="st7"
            d="M229.27,364.6c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.36.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66-.44.97-.77,1.36c-.34.39-.75.7-1.23.92-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34ZM229.27,365.77c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1,.1-.37.14-.76.14-1.15s-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st7"
            d="M234.5,364.79h3.61c.58,0,1.05.08,1.42.25.37.17.65.38.85.63.2.25.33.53.41.83.07.3.11.57.11.83s-.04.53-.11.82c-.07.29-.21.57-.41.82-.2.25-.48.46-.85.63-.37.16-.84.25-1.42.25h-2.18v3.14h-1.43v-8.19ZM235.93,368.67h2.1c.16,0,.32-.02.49-.07.17-.05.32-.12.46-.22.14-.1.26-.24.34-.41s.13-.39.13-.65-.04-.49-.12-.67c-.08-.18-.18-.32-.31-.42-.13-.1-.28-.17-.45-.21-.17-.04-.35-.06-.54-.06h-2.12v2.71Z"
          />
          <path
            className="st7"
            d="M242.15,364.79h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st7"
            d="M249.38,364.79h3.91c.9,0,1.58.2,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97s-.25.46-.4.62c-.15.16-.3.27-.45.34-.15.07-.26.11-.33.14v.02c.12.02.25.05.4.12.14.06.27.16.4.29.12.13.22.31.3.52.08.21.12.48.12.8,0,.48.04.92.11,1.31.07.39.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58-.02-.21-.03-.42-.03-.62,0-.37-.02-.7-.07-.97-.05-.27-.13-.5-.25-.68s-.29-.31-.5-.4c-.21-.08-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19ZM250.81,368.52h2.35c.46,0,.81-.11,1.04-.33.24-.22.36-.54.36-.98,0-.26-.04-.47-.11-.64-.08-.16-.18-.29-.32-.38-.13-.09-.29-.15-.46-.18s-.35-.05-.53-.05h-2.33v2.56Z"
          />
          <path
            className="st7"
            d="M259.64,364.79h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM259.14,369.73h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st7"
            d="M263.27,364.79h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <path className="st7" d="M270.85,364.79h1.43v8.19h-1.43v-8.19Z" />
          <path
            className="st7"
            d="M277.52,364.6c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.36.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66-.44.97-.77,1.36c-.34.39-.75.7-1.23.92-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34ZM277.52,365.77c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1,.1-.37.14-.76.14-1.15s-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st7"
            d="M282.69,364.79h1.51l3.74,6.03h.02v-6.03h1.37v8.19h-1.51l-3.73-6.02h-.03v6.02h-1.37v-8.19Z"
          />
          <path
            className="st7"
            d="M259.87,286.2l2.33,6.23h-1.42l-.47-1.39h-2.33l-.49,1.39h-1.38l2.36-6.23h1.41ZM259.95,290.03l-.79-2.29h-.02l-.81,2.29h1.62Z"
          />
          <path
            className="st7"
            d="M267.33,291.96c-.47.41-1.12.62-1.96.62s-1.5-.2-1.96-.61c-.46-.41-.69-1.04-.69-1.89v-3.88h1.37v3.88c0,.17.01.33.04.5.03.16.09.31.18.43.09.13.22.23.39.31.17.08.39.12.67.12.49,0,.83-.11,1.01-.33.19-.22.28-.56.28-1.03v-3.88h1.37v3.88c0,.84-.24,1.47-.71,1.88Z"
          />
          <path
            className="st7"
            d="M268.73,287.35v-1.15h5.11v1.15h-1.87v5.08h-1.37v-5.08h-1.87Z"
          />
          <path
            className="st7"
            d="M274.49,288.05c.14-.4.34-.75.6-1.04.26-.3.58-.53.96-.7s.81-.25,1.29-.25.91.08,1.29.25.7.4.96.7c.26.3.46.64.6,1.04.14.4.21.83.21,1.3s-.07.88-.21,1.27-.34.73-.6,1.03c-.26.29-.58.52-.96.69s-.81.25-1.29.25-.91-.08-1.29-.25-.7-.39-.96-.69c-.26-.29-.46-.63-.6-1.03-.14-.39-.21-.82-.21-1.27s.07-.9.21-1.3ZM275.74,290.11c.06.25.16.47.29.67.13.2.31.36.52.48s.48.18.79.18.57-.06.79-.18.39-.28.52-.48c.13-.2.23-.42.29-.67s.09-.5.09-.76-.03-.54-.09-.79c-.06-.26-.16-.48-.29-.69-.13-.2-.31-.36-.52-.48s-.48-.18-.79-.18-.57.06-.79.18-.39.28-.52.48c-.13.2-.23.43-.29.69-.06.26-.09.52-.09.79s.03.52.09.76Z"
          />
          <path
            className="st7"
            d="M391.59,357.91h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM391.09,362.84h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path className="st7" d="M397.05,357.91h1.43v8.19h-1.43v-8.19Z" />
          <path
            className="st7"
            d="M400.24,357.91h3.91c.9,0,1.58.2,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97s-.25.46-.4.62c-.15.16-.3.27-.45.34-.15.07-.26.11-.33.14v.02c.12.02.25.05.4.12.14.06.27.16.4.29.12.13.22.31.3.52.08.21.12.48.12.8,0,.48.04.92.11,1.31.07.39.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58-.02-.21-.03-.42-.03-.62,0-.37-.02-.7-.07-.97-.05-.27-.13-.5-.25-.68s-.29-.31-.5-.4c-.21-.08-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19ZM401.67,361.64h2.35c.46,0,.81-.11,1.04-.33.24-.22.36-.54.36-.98,0-.26-.04-.47-.11-.64-.08-.16-.18-.29-.32-.38-.13-.09-.29-.15-.46-.18s-.35-.05-.53-.05h-2.33v2.56Z"
          />
          <path
            className="st7"
            d="M417.03,360.52c-.06-.24-.15-.45-.25-.65-.11-.2-.24-.37-.41-.52-.17-.14-.37-.26-.59-.34-.23-.08-.49-.12-.79-.12-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26.32,0,.6-.06.85-.17s.45-.26.63-.46c.18-.2.31-.42.41-.68s.16-.54.2-.84h1.4c-.03.49-.14.94-.32,1.34-.18.41-.42.76-.73,1.05-.31.29-.67.52-1.08.68-.41.16-.87.24-1.36.24-.61,0-1.16-.11-1.65-.34-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34.46,0,.89.06,1.3.19.4.13.76.31,1.07.55s.56.53.75.88c.19.34.31.74.36,1.18h-1.43Z"
          />
          <path
            className="st7"
            d="M419.78,357.91h1.43v6.95h4.16v1.24h-5.6v-8.19Z"
          />
          <path
            className="st7"
            d="M426.36,357.91h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st7"
            d="M435.78,357.91h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM435.28,362.84h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st7"
            d="M441.18,357.91h1.51l3.74,6.03h.02v-6.03h1.37v8.19h-1.51l-3.73-6.02h-.03v6.02h-1.37v-8.19Z"
          />
          <path className="st7" d="M449.52,357.91h1.43v8.19h-1.43v-8.19Z" />
          <path
            className="st7"
            d="M452.65,357.91h1.51l3.74,6.03h.02v-6.03h1.37v8.19h-1.51l-3.73-6.02h-.03v6.02h-1.37v-8.19Z"
          />
          <path
            className="st7"
            d="M468.13,366.1h-.92l-.22-.96c-.38.44-.76.74-1.15.91-.38.17-.82.25-1.32.25-.61,0-1.16-.11-1.65-.34-.49-.23-.9-.53-1.23-.92-.34-.39-.59-.84-.77-1.36s-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34.44,0,.87.06,1.27.18s.76.29,1.07.53c.31.23.57.53.78.88.21.35.34.76.39,1.22h-1.4c-.04-.27-.12-.5-.25-.71s-.29-.37-.48-.51c-.19-.14-.41-.24-.64-.31-.24-.07-.49-.1-.75-.1-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26.37,0,.69-.04.97-.14.28-.1.52-.25.72-.45s.34-.43.44-.72.15-.6.16-.94h-2.18v-1.09h3.49v4.31Z"
          />
          <path
            className="st8"
            d="M443.15,302.63h-18.96v-2.21h18.96c1.89,0,3.43-1.54,3.43-3.43s-1.54-3.43-3.43-3.43c-.29,0-1.9.13-1.9,1.44h-2.21c0-2.81,2.67-3.61,4.08-3.64,3.13,0,5.66,2.53,5.66,5.63s-2.53,5.64-5.63,5.64Z"
          />
          <path
            className="st8"
            d="M443.1,325.08c-1.43-.03-4.11-.83-4.11-3.64h2.21c0,.23.09,1.38,1.93,1.44,1.86,0,3.4-1.54,3.4-3.43s-1.54-3.43-3.43-3.43h-18.96v-2.21h18.96c3.11,0,5.63,2.53,5.63,5.63s-2.53,5.64-5.63,5.64Z"
          />
          <path
            className="st8"
            d="M454.5,309.88h-30.31v-2.21h30.31c1.89,0,3.43-1.54,3.43-3.43s-1.54-3.43-3.43-3.43c-.29,0-1.9.13-1.9,1.44h-2.21c0-2.81,2.67-3.61,4.08-3.64,3.13,0,5.66,2.53,5.66,5.63s-2.53,5.63-5.64,5.63Z"
          />
          <rect
            className="st8"
            x="404.49"
            y="300.42"
            width="5.5"
            height="2.21"
          />
          <rect
            className="st8"
            x="396.48"
            y="300.42"
            width="5.5"
            height="2.21"
          />
          <rect
            className="st8"
            x="404.49"
            y="307.68"
            width="5.5"
            height="2.21"
          />
          <rect
            className="st8"
            x="396.48"
            y="307.68"
            width="5.5"
            height="2.21"
          />
          <rect
            className="st8"
            x="404.49"
            y="313.81"
            width="5.5"
            height="2.21"
          />
          <rect
            className="st8"
            x="396.48"
            y="313.81"
            width="5.5"
            height="2.21"
          />
          <polygon
            className="st8"
            points="262.16 314.93 249.93 314.93 249.93 303.43 252.13 303.43 252.13 312.72 262.16 312.72 262.16 314.93"
          />
          <path
            className="st8"
            d="M250.49,332.95c-10.83,0-19.64-8.81-19.64-19.64s8.81-19.64,19.64-19.64,19.64,8.81,19.64,19.64c0,7.58-4.44,14.56-11.3,17.79l-.94-2c6.1-2.86,10.03-9.06,10.03-15.79,0-9.61-7.82-17.43-17.43-17.43s-17.43,7.82-17.43,17.43,7.82,17.43,17.43,17.43v2.21Z"
          />
          <polygon
            className="st8"
            points="262.68 332.94 256.43 331.83 257.49 325.86 259.66 326.24 258.99 330.04 263.06 330.76 262.68 332.94"
          />
          <polygon
            className="st6"
            points="285.04 293.4 282.83 293.4 282.83 282.85 255.77 282.85 255.77 280.65 285.04 280.65 285.04 293.4"
          />
          <polygon
            className="st8"
            points="1130.18 329.57 1085.79 329.57 1085.79 289.37 1087.99 289.37 1087.99 327.36 1130.18 327.36 1130.18 329.57"
          />
          <polygon
            className="st8"
            points="1098.64 312.46 1096.87 311.13 1105.21 300.06 1096.91 290.13 1098.6 288.72 1108.03 299.99 1098.64 312.46"
          />
          <polygon
            className="st8"
            points="1097.16 312.67 1095.59 308 1097.68 307.3 1098.7 310.32 1102.09 310.02 1102.29 312.21 1097.16 312.67"
          />
          <polygon
            className="st8"
            points="1098.41 321.42 1096.65 320.09 1104.99 309.02 1096.68 299.09 1098.37 297.68 1107.8 308.94 1098.41 321.42"
          />
          <polygon
            className="st8"
            points="1096.93 321.62 1095.37 316.95 1097.46 316.25 1098.47 319.27 1102.2 318.94 1102.4 321.14 1096.93 321.62"
          />
          <path
            className="st8"
            d="M1130.18,324.5h-21.86c-.61,0-1.1-.49-1.1-1.1v-37.76h2.21v36.66h20.76v2.21Z"
          />
          <polygon
            className="st6"
            points="1131.28 324.59 1129.08 324.59 1129.08 286.28 1086.89 286.28 1086.89 284.07 1131.28 284.07 1131.28 324.59"
          />
          <path
            className="st7"
            d="M1075.39,357.26h3.39c.63,0,1.17.11,1.63.32s.83.51,1.12.88c.29.37.51.8.65,1.3.14.5.21,1.03.21,1.59s-.07,1.1-.21,1.59-.36.93-.65,1.3c-.29.37-.67.66-1.12.88s-1,.32-1.63.32h-3.39v-8.19ZM1076.83,364.28h1.41c.56,0,1.01-.07,1.37-.22.36-.15.63-.36.84-.62.2-.26.34-.57.41-.93.07-.36.11-.74.11-1.15s-.04-.8-.11-1.15c-.07-.36-.21-.67-.41-.93s-.48-.47-.84-.62c-.36-.15-.81-.22-1.37-.22h-1.41v5.85Z"
          />
          <path
            className="st7"
            d="M1083.58,357.26h1.43v4.77c0,.28.01.55.04.84.03.28.1.54.23.76.13.23.32.41.57.56.26.15.62.22,1.08.22s.83-.07,1.08-.22c.26-.15.45-.33.57-.56.13-.23.2-.48.23-.76.03-.28.04-.56.04-.84v-4.77h1.43v5.24c0,.53-.08.99-.24,1.38-.16.39-.39.72-.68.98-.29.26-.65.46-1.06.59-.41.13-.87.2-1.38.2s-.96-.07-1.38-.2c-.41-.13-.77-.33-1.06-.59-.29-.26-.52-.59-.68-.98-.16-.39-.24-.85-.24-1.38v-5.24Z"
          />
          <path
            className="st7"
            d="M1091.95,357.26h3.91c.9,0,1.58.2,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97s-.25.46-.4.62c-.15.16-.3.27-.45.34-.15.07-.26.11-.33.14v.02c.12.02.25.05.4.12.14.06.27.16.4.29.12.13.22.31.3.52.08.21.12.48.12.8,0,.48.04.92.11,1.31.07.39.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58-.02-.21-.03-.42-.03-.62,0-.37-.02-.7-.07-.97-.05-.27-.13-.5-.25-.68s-.29-.31-.5-.4c-.21-.08-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19ZM1093.39,360.99h2.35c.46,0,.81-.11,1.04-.33.24-.22.36-.54.36-.98,0-.26-.04-.47-.11-.64-.08-.16-.18-.29-.32-.38-.13-.09-.29-.15-.46-.18s-.35-.05-.53-.05h-2.33v2.56Z"
          />
          <path
            className="st7"
            d="M1102.22,357.26h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM1101.71,362.19h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st7"
            d="M1107.68,357.26h3.98c.73,0,1.32.17,1.77.5.44.34.67.84.67,1.53,0,.41-.1.77-.3,1.06-.2.29-.49.52-.87.68v.02c.5.11.89.35,1.15.72.26.37.39.84.39,1.39,0,.32-.06.62-.17.9s-.29.52-.54.72c-.25.2-.56.36-.94.48-.38.12-.84.18-1.36.18h-3.76v-8.19ZM1109.11,360.69h2.34c.34,0,.63-.1.86-.29.23-.19.34-.48.34-.84,0-.41-.1-.7-.31-.87-.21-.17-.5-.25-.89-.25h-2.34v2.26ZM1109.11,364.28h2.53c.44,0,.77-.11,1.02-.34.24-.23.36-.54.36-.96s-.12-.72-.36-.93c-.24-.22-.58-.33-1.02-.33h-2.53v2.56Z"
          />
          <path className="st7" d="M1115.75,357.26h1.43v8.19h-1.43v-8.19Z" />
          <path
            className="st7"
            d="M1118.94,357.26h1.43v6.95h4.16v1.24h-5.6v-8.19Z"
          />
          <path className="st7" d="M1125.52,357.26h1.43v8.19h-1.43v-8.19Z" />
          <path
            className="st7"
            d="M1127.93,357.26h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <path
            className="st7"
            d="M1137.65,362.24l-3.07-4.98h1.66l2.17,3.67,2.13-3.67h1.61l-3.06,4.98v3.21h-1.43v-3.21Z"
          />
          <path
            className="st7"
            d="M1247.16,357.26h3.61c.58,0,1.05.08,1.42.25.37.17.65.38.85.63.2.25.33.53.41.83.07.3.11.57.11.83s-.04.53-.11.82c-.07.29-.21.57-.41.82-.2.25-.48.46-.85.63-.37.16-.84.25-1.42.25h-2.18v3.14h-1.43v-8.19ZM1248.59,361.14h2.1c.16,0,.32-.02.49-.07.17-.05.32-.12.46-.22.14-.1.26-.24.34-.41s.13-.39.13-.65-.04-.49-.12-.67c-.08-.18-.18-.32-.31-.42-.13-.1-.28-.17-.45-.21-.17-.04-.35-.06-.54-.06h-2.12v2.71Z"
          />
          <path
            className="st7"
            d="M1254.81,357.26h5.65v1.24h-4.22v2.14h3.7v1.17h-3.7v3.64h-1.43v-8.19Z"
          />
          <path
            className="st7"
            d="M1265.09,357.07c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.36.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66-.44.97-.77,1.36c-.34.39-.75.7-1.23.92-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34ZM1265.09,358.24c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1,.1-.37.14-.76.14-1.15s-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st7"
            d="M1272.51,357.26h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM1272.01,362.19h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st7"
            d="M1281.16,357.26h5.65v1.24h-4.22v2.14h3.7v1.17h-3.7v3.64h-1.43v-8.19Z"
          />
          <path
            className="st7"
            d="M1287.96,357.26h3.91c.9,0,1.58.2,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97s-.25.46-.4.62c-.15.16-.3.27-.45.34-.15.07-.26.11-.33.14v.02c.12.02.25.05.4.12.14.06.27.16.4.29.12.13.22.31.3.52.08.21.12.48.12.8,0,.48.04.92.11,1.31.07.39.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58-.02-.21-.03-.42-.03-.62,0-.37-.02-.7-.07-.97-.05-.27-.13-.5-.25-.68s-.29-.31-.5-.4c-.21-.08-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19ZM1289.4,360.99h2.35c.46,0,.81-.11,1.04-.33.24-.22.36-.54.36-.98,0-.26-.04-.47-.11-.64-.08-.16-.18-.29-.32-.38-.13-.09-.29-.15-.46-.18s-.35-.05-.53-.05h-2.33v2.56Z"
          />
          <path
            className="st7"
            d="M1296.04,357.26h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st7"
            d="M1303.26,357.26h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st8"
            d="M1260.8,300.04c1.43,0,2.51.37,3.25,1.1.73.73,1.1,1.76,1.1,3.09s-.37,2.36-1.1,3.1c-.73.74-1.82,1.11-3.25,1.09h-4.33v5.8h-1.89v-14.17h6.21ZM1260.17,306.83c1.07.01,1.86-.2,2.35-.65.5-.45.74-1.1.74-1.95s-.25-1.49-.74-1.94c-.5-.44-1.28-.66-2.35-.66h-3.69v5.2h3.69Z"
          />
          <path
            className="st8"
            d="M1276.76,300.04v1.59h-7.42v4.51h6.51v1.59h-6.51v6.49h-1.89v-14.17h9.31Z"
          />
          <path
            className="st8"
            d="M1278.48,304.34c.28-.89.71-1.68,1.28-2.37.57-.69,1.28-1.24,2.12-1.65.85-.41,1.83-.62,2.96-.62s2.11.21,2.96.62c.85.41,1.55.96,2.12,1.65.57.69,1,1.48,1.28,2.37.28.89.43,1.82.43,2.79s-.14,1.9-.43,2.79c-.29.89-.71,1.68-1.28,2.37-.57.69-1.28,1.23-2.12,1.64-.85.4-1.83.61-2.96.61s-2.11-.2-2.96-.61c-.85-.4-1.56-.95-2.12-1.64-.57-.69-1-1.48-1.28-2.37-.28-.89-.43-1.82-.43-2.79s.14-1.9.43-2.79ZM1280.21,309.24c.19.69.48,1.32.87,1.88s.91,1,1.53,1.34c.62.34,1.36.51,2.22.51s1.6-.17,2.22-.51c.62-.34,1.13-.78,1.53-1.34.4-.56.69-1.18.87-1.88.19-.69.28-1.4.28-2.11s-.09-1.42-.28-2.11c-.19-.69-.48-1.32-.87-1.88-.4-.56-.91-1-1.53-1.34-.62-.34-1.36-.51-2.22-.51s-1.6.17-2.22.51c-.62.34-1.13.78-1.53,1.34-.4.56-.69,1.18-.87,1.88s-.28,1.4-.28,2.11.09,1.42.28,2.11Z"
          />
          <path
            className="st8"
            d="M1299.87,300.04l5.54,14.17h-2.08l-1.55-4.27h-6l-1.59,4.27h-1.93l5.52-14.17h2.08ZM1301.18,308.36l-2.36-6.61h-.04l-2.4,6.61h4.8Z"
          />
          <polygon
            className="st6"
            points="1310.34 325.93 1308.13 325.93 1308.13 287.94 1251.77 287.94 1251.77 285.74 1310.34 285.74 1310.34 325.93"
          />
          <polygon
            className="st8"
            points="1304.67 328.85 1246.37 328.85 1246.37 286.84 1248.58 286.84 1248.58 326.65 1304.67 326.65 1304.67 328.85"
          />
          <path className="st1" d="M1256.07,293.42" />
          <rect
            className="st8"
            x="1250.97"
            y="306.53"
            width="54.57"
            height="2.21"
            transform="translate(10.93 657.57) rotate(-28.97)"
          />
          <polygon
            className="st6"
            points="111.28 451.62 109.07 451.62 109.07 411.93 64.1 411.93 64.1 409.72 111.28 409.72 111.28 451.62"
          />
          <polygon
            className="st8"
            points="111.05 457.12 63.88 457.12 63.88 414.13 66.08 414.13 66.08 454.91 111.05 454.91 111.05 457.12"
          />
          <path
            className="st8"
            d="M87.42,448.89c-5.65,0-10.25-4.6-10.25-10.25,0-5.21,8.36-18.94,9.31-20.49l.94-1.53.94,1.53c.95,1.55,9.31,15.28,9.31,20.49,0,5.65-4.6,10.25-10.25,10.25ZM87.42,420.86c-2.89,4.88-8.04,14.31-8.04,17.77,0,4.44,3.61,8.04,8.04,8.04s8.04-3.61,8.04-8.04c0-3.47-5.16-12.89-8.04-17.77Z"
          />
          <path
            className="st8"
            d="M49.49,484h1.46l1.48,6.26h.02l1.65-6.26h1.47l1.61,6.26h.02l1.53-6.26h1.46l-2.26,8.19h-1.46l-1.64-6.26h-.02l-1.67,6.26h-1.48l-2.16-8.19Z"
          />
          <path
            className="st8"
            d="M63.02,484h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM62.52,488.93h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st8"
            d="M66.65,484h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <path
            className="st8"
            d="M74.23,484h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st8"
            d="M81.45,484h3.91c.9,0,1.58.19,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97-.11.26-.25.46-.4.62s-.3.27-.45.34c-.15.07-.26.11-.33.14v.02c.12.02.25.05.4.11.14.06.27.16.4.29.12.13.22.31.3.52.08.21.12.48.12.8,0,.48.04.92.11,1.31.07.39.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58-.02-.21-.03-.42-.03-.62,0-.37-.02-.7-.07-.97-.05-.27-.13-.5-.25-.68s-.29-.31-.5-.4c-.21-.08-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19ZM82.89,487.73h2.35c.46,0,.81-.11,1.04-.33s.36-.54.36-.98c0-.26-.04-.47-.11-.64-.08-.16-.18-.29-.32-.38-.13-.09-.29-.15-.46-.18-.17-.03-.35-.05-.53-.05h-2.33v2.56Z"
          />
          <path
            className="st8"
            d="M91.94,484h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <path className="st8" d="M99.52,484h1.43v8.19h-1.43v-8.19Z" />
          <path
            className="st8"
            d="M109.85,492.19h-.92l-.22-.96c-.38.44-.76.74-1.15.91-.38.17-.82.25-1.32.25-.61,0-1.16-.11-1.65-.34-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36c-.18-.52-.27-1.07-.27-1.66s.09-1.13.27-1.65c.18-.52.44-.97.77-1.36.34-.39.75-.7,1.23-.93s1.03-.34,1.65-.34c.44,0,.87.06,1.27.18.4.12.76.29,1.07.53.31.23.57.53.78.88.21.35.34.76.39,1.22h-1.4c-.04-.27-.12-.5-.25-.71-.13-.2-.29-.37-.48-.51-.19-.14-.41-.24-.64-.31-.24-.07-.49-.1-.75-.1-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1s-.14.76-.14,1.15.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26.37,0,.69-.04.98-.14.28-.1.52-.25.72-.45.19-.2.34-.43.44-.72.1-.28.15-.6.16-.94h-2.18v-1.09h3.49v4.31Z"
          />
          <path
            className="st8"
            d="M111.38,484h1.43v3.26h3.73v-3.26h1.43v8.19h-1.43v-3.69h-3.73v3.69h-1.43v-8.19Z"
          />
          <path
            className="st8"
            d="M118.91,484h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <path
            className="st8"
            d="M717.19,484h3.39c.63,0,1.17.11,1.63.32.46.21.83.51,1.12.88.29.37.51.8.65,1.3.14.5.21,1.03.21,1.59s-.07,1.1-.21,1.59c-.14.5-.36.93-.65,1.3-.29.37-.67.66-1.12.88-.46.21-1,.32-1.63.32h-3.39v-8.19ZM718.63,491.02h1.41c.56,0,1.01-.07,1.37-.22.36-.15.63-.36.84-.62.2-.26.34-.57.41-.93.07-.36.11-.74.11-1.15s-.04-.8-.11-1.15c-.07-.36-.21-.67-.41-.93-.2-.26-.48-.47-.84-.62-.36-.15-.81-.22-1.37-.22h-1.41v5.85Z"
          />
          <path className="st8" d="M725.47,484h1.43v8.19h-1.43v-8.19Z" />
          <path
            className="st8"
            d="M729.6,489.46c0,.31.05.58.16.8.11.22.26.4.45.54.19.14.41.24.66.31.25.07.52.1.81.1.31,0,.58-.04.8-.11.22-.07.4-.17.54-.28.14-.11.24-.25.3-.4.06-.15.09-.3.09-.45,0-.31-.07-.54-.21-.69-.14-.15-.3-.25-.46-.32-.29-.11-.63-.21-1.01-.3-.39-.1-.86-.22-1.43-.37-.35-.09-.64-.21-.88-.36-.23-.15-.42-.32-.56-.5s-.24-.38-.29-.58c-.06-.21-.09-.42-.09-.63,0-.41.09-.77.26-1.07.17-.3.4-.55.68-.75.28-.2.6-.35.96-.44.36-.1.72-.14,1.09-.14.43,0,.83.06,1.21.17.38.11.71.28,1,.5.29.22.51.5.68.82.17.33.25.7.25,1.13h-1.43c-.04-.53-.22-.9-.54-1.12-.32-.22-.73-.33-1.23-.33-.17,0-.34.02-.52.05-.18.03-.34.09-.48.17-.15.08-.27.19-.36.33s-.14.31-.14.52c0,.29.09.52.27.68.18.16.41.29.71.37.03,0,.15.04.36.1.21.06.45.12.71.19.26.07.51.14.76.2.25.07.43.11.53.14.27.08.5.2.7.34.2.15.37.31.5.5.13.19.23.39.3.6.07.21.1.43.1.64,0,.46-.09.85-.28,1.18-.19.33-.43.59-.74.8-.31.21-.65.36-1.04.45-.39.1-.79.14-1.19.14-.47,0-.91-.06-1.32-.17-.41-.11-.77-.29-1.08-.53-.31-.24-.55-.54-.73-.91s-.28-.81-.29-1.31h1.43Z"
          />
          <path
            className="st8"
            d="M736.06,484h1.43v3.26h3.73v-3.26h1.43v8.19h-1.43v-3.69h-3.73v3.69h-1.43v-8.19Z"
          />
          <path
            className="st8"
            d="M743.57,484h1.46l1.48,6.26h.02l1.65-6.26h1.47l1.61,6.26h.02l1.53-6.26h1.46l-2.26,8.19h-1.46l-1.64-6.26h-.02l-1.67,6.26h-1.48l-2.16-8.19Z"
          />
          <path
            className="st8"
            d="M757.1,484h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM756.6,488.93h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st8"
            d="M763.5,489.46c0,.31.05.58.16.8.11.22.26.4.45.54s.41.24.66.31c.25.07.52.1.81.1.31,0,.58-.04.8-.11.22-.07.4-.17.54-.28.14-.11.24-.25.3-.4.06-.15.09-.3.09-.45,0-.31-.07-.54-.21-.69-.14-.15-.3-.25-.46-.32-.29-.11-.63-.21-1.02-.3-.39-.1-.86-.22-1.43-.37-.35-.09-.64-.21-.88-.36-.23-.15-.42-.32-.56-.5-.14-.18-.24-.38-.29-.58-.06-.21-.09-.42-.09-.63,0-.41.09-.77.26-1.07.17-.3.4-.55.68-.75.28-.2.6-.35.96-.44.36-.1.72-.14,1.09-.14.43,0,.83.06,1.21.17.38.11.71.28,1,.5.29.22.51.5.68.82.17.33.25.7.25,1.13h-1.43c-.04-.53-.22-.9-.54-1.12-.32-.22-.73-.33-1.23-.33-.17,0-.34.02-.52.05-.18.03-.34.09-.48.17-.15.08-.27.19-.36.33s-.14.31-.14.52c0,.29.09.52.27.68.18.16.41.29.71.37.03,0,.15.04.36.1.21.06.45.12.71.19.26.07.51.14.76.2.25.07.43.11.53.14.27.08.5.2.7.34.2.15.36.31.5.5.13.19.23.39.3.6.06.21.1.43.1.64,0,.46-.09.85-.28,1.18-.19.33-.43.59-.74.8-.31.21-.65.36-1.04.45-.39.1-.79.14-1.19.14-.47,0-.91-.06-1.32-.17-.41-.11-.77-.29-1.08-.53-.31-.24-.55-.54-.73-.91s-.28-.81-.29-1.31h1.43Z"
          />
          <path
            className="st8"
            d="M769.96,484h1.43v3.26h3.73v-3.26h1.43v8.19h-1.43v-3.69h-3.73v3.69h-1.43v-8.19Z"
          />
          <path
            className="st8"
            d="M778.28,484h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st8"
            d="M785.5,484h3.91c.9,0,1.58.19,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97-.11.26-.25.46-.4.62s-.3.27-.45.34c-.15.07-.26.11-.33.14v.02c.12.02.25.05.4.11.14.06.27.16.4.29.12.13.22.31.3.52.08.21.12.48.12.8,0,.48.04.92.11,1.31.07.39.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58-.02-.21-.03-.42-.03-.62,0-.37-.02-.7-.07-.97s-.13-.5-.25-.68c-.12-.18-.29-.31-.5-.4-.21-.08-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19ZM786.94,487.73h2.35c.46,0,.81-.11,1.04-.33s.36-.54.36-.98c0-.26-.04-.47-.12-.64-.08-.16-.18-.29-.32-.38s-.29-.15-.46-.18c-.17-.03-.35-.05-.53-.05h-2.33v2.56Z"
          />
          <path
            className="st8"
            d="M797.7,489.46c0,.31.05.58.16.8.11.22.26.4.45.54s.41.24.66.31c.25.07.52.1.81.1.31,0,.58-.04.8-.11.22-.07.4-.17.54-.28.14-.11.24-.25.3-.4.06-.15.09-.3.09-.45,0-.31-.07-.54-.21-.69-.14-.15-.3-.25-.46-.32-.29-.11-.63-.21-1.02-.3-.39-.1-.86-.22-1.43-.37-.35-.09-.64-.21-.88-.36-.23-.15-.42-.32-.56-.5-.14-.18-.24-.38-.29-.58-.06-.21-.09-.42-.09-.63,0-.41.09-.77.26-1.07.17-.3.4-.55.68-.75.28-.2.6-.35.96-.44.36-.1.72-.14,1.09-.14.43,0,.83.06,1.21.17.38.11.71.28,1,.5.29.22.51.5.68.82.17.33.25.7.25,1.13h-1.43c-.04-.53-.22-.9-.54-1.12-.32-.22-.73-.33-1.23-.33-.17,0-.34.02-.52.05-.18.03-.34.09-.48.17-.15.08-.27.19-.36.33s-.14.31-.14.52c0,.29.09.52.27.68.18.16.41.29.71.37.03,0,.15.04.36.1.21.06.45.12.71.19.26.07.51.14.76.2.25.07.43.11.53.14.27.08.5.2.7.34.2.15.36.31.5.5.13.19.23.39.3.6.06.21.1.43.1.64,0,.46-.09.85-.28,1.18-.19.33-.43.59-.74.8-.31.21-.65.36-1.04.45-.39.1-.79.14-1.19.14-.47,0-.91-.06-1.32-.17-.41-.11-.77-.29-1.08-.53-.31-.24-.55-.54-.73-.91s-.28-.81-.29-1.31h1.43Z"
          />
          <path
            className="st8"
            d="M806.39,484h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM805.88,488.93h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st8"
            d="M811.85,484h5.65v1.24h-4.22v2.14h3.7v1.17h-3.7v3.64h-1.43v-8.19Z"
          />
          <path
            className="st8"
            d="M818.65,484h5.89v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st8"
            d="M910.8,484h2.02l2.26,6.41h.02l2.2-6.41h2v8.19h-1.36v-6.32h-.02l-2.27,6.32h-1.18l-2.27-6.32h-.02v6.32h-1.36v-8.19Z"
          />
          <path
            className="st8"
            d="M924.51,483.8c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.84.77,1.36s.27,1.07.27,1.65-.09,1.14-.27,1.66c-.18.52-.44.98-.77,1.36-.34.39-.75.7-1.23.92-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92-.34-.39-.59-.84-.77-1.36-.18-.52-.27-1.07-.27-1.66s.09-1.13.27-1.65c.18-.52.44-.97.77-1.36.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34ZM924.51,484.97c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1s-.14.76-.14,1.15.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1,.1-.37.14-.76.14-1.15s-.05-.77-.14-1.15-.24-.71-.44-1c-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st8"
            d="M929.74,484h3.39c.63,0,1.17.11,1.63.32.46.21.83.51,1.12.88.29.37.51.8.65,1.3.14.5.21,1.03.21,1.59s-.07,1.1-.21,1.59c-.14.5-.36.93-.65,1.3-.29.37-.67.66-1.12.88-.46.21-1,.32-1.63.32h-3.39v-8.19ZM931.17,491.02h1.41c.56,0,1.01-.07,1.37-.22.36-.15.63-.36.84-.62.2-.26.34-.57.41-.93.07-.36.11-.74.11-1.15s-.04-.8-.11-1.15c-.07-.36-.21-.67-.41-.93-.2-.26-.48-.47-.84-.62-.36-.15-.81-.22-1.37-.22h-1.41v5.85Z"
          />
          <path
            className="st8"
            d="M937.93,484h1.43v4.77c0,.28.01.55.04.84.03.28.1.54.23.76.13.23.32.41.57.56.26.15.62.22,1.08.22s.83-.07,1.08-.22c.26-.15.45-.33.57-.56.13-.23.2-.48.23-.76.03-.28.04-.56.04-.84v-4.77h1.43v5.24c0,.53-.08.99-.24,1.38-.16.39-.39.72-.68.98-.29.26-.65.46-1.06.59-.41.13-.87.19-1.38.19s-.96-.07-1.38-.19-.77-.33-1.06-.59c-.29-.26-.52-.59-.68-.98-.16-.39-.24-.85-.24-1.38v-5.24Z"
          />
          <path
            className="st8"
            d="M946.3,484h1.43v6.95h4.16v1.24h-5.6v-8.19Z"
          />
          <path
            className="st8"
            d="M955.07,484h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM954.57,488.93h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st8"
            d="M960.53,484h3.91c.9,0,1.58.19,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97-.11.26-.25.46-.4.62s-.3.27-.45.34c-.15.07-.26.11-.33.14v.02c.12.02.25.05.4.11.14.06.27.16.4.29.12.13.22.31.3.52.08.21.12.48.12.8,0,.48.04.92.11,1.31.07.39.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58-.02-.21-.03-.42-.03-.62,0-.37-.02-.7-.07-.97-.05-.27-.13-.5-.25-.68s-.29-.31-.5-.4c-.21-.08-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19ZM961.96,487.73h2.35c.46,0,.81-.11,1.04-.33s.36-.54.36-.98c0-.26-.04-.47-.11-.64-.08-.16-.18-.29-.32-.38-.13-.09-.29-.15-.46-.18-.17-.03-.35-.05-.53-.05h-2.33v2.56Z"
          />
          <path
            className="st8"
            d="M231.7,484h3.98c.73,0,1.32.17,1.77.5s.67.84.67,1.53c0,.41-.1.77-.3,1.06-.2.29-.49.52-.87.68v.02c.5.11.89.35,1.15.72.26.37.39.84.39,1.39,0,.32-.06.62-.17.9s-.29.52-.54.72c-.24.2-.56.36-.94.48-.38.12-.84.18-1.37.18h-3.76v-8.19ZM233.13,487.43h2.34c.34,0,.63-.1.86-.29.23-.19.34-.48.34-.84,0-.41-.1-.7-.31-.87-.21-.17-.5-.25-.89-.25h-2.34v2.26ZM233.13,491.02h2.53c.44,0,.77-.11,1.01-.34.24-.23.36-.54.36-.96s-.12-.72-.36-.93c-.24-.22-.58-.33-1.01-.33h-2.53v2.56Z"
          />
          <path
            className="st8"
            d="M239.77,484h3.61c.58,0,1.06.08,1.42.25.37.17.65.38.85.63.2.25.33.53.41.83.07.3.11.57.11.83s-.04.53-.11.82c-.07.29-.21.57-.41.82-.2.25-.48.46-.85.63-.37.16-.84.25-1.42.25h-2.18v3.14h-1.43v-8.19ZM241.21,487.88h2.1c.16,0,.32-.02.49-.07s.32-.12.46-.22c.14-.1.26-.24.34-.41.09-.17.13-.39.13-.65s-.04-.49-.11-.67c-.08-.18-.18-.32-.31-.42-.13-.1-.28-.17-.45-.21-.17-.04-.35-.06-.54-.06h-2.12v2.71Z"
          />
          <path
            className="st8"
            d="M248.76,484h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM248.26,488.93h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st8"
            d="M257.41,484h5.65v1.24h-4.22v2.14h3.7v1.17h-3.7v3.64h-1.43v-8.19Z"
          />
          <path
            className="st8"
            d="M264.21,484h3.91c.9,0,1.58.19,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97-.11.26-.25.46-.4.62-.15.16-.3.27-.45.34-.15.07-.26.11-.33.14v.02c.12.02.25.05.4.11.14.06.27.16.4.29.12.13.22.31.3.52.08.21.12.48.12.8,0,.48.04.92.11,1.31.07.39.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58-.02-.21-.03-.42-.03-.62,0-.37-.02-.7-.07-.97-.05-.27-.13-.5-.25-.68-.12-.18-.29-.31-.5-.4-.21-.08-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19ZM265.65,487.73h2.35c.46,0,.81-.11,1.04-.33s.36-.54.36-.98c0-.26-.04-.47-.12-.64-.08-.16-.18-.29-.32-.38-.13-.09-.29-.15-.46-.18-.17-.03-.35-.05-.53-.05h-2.33v2.56Z"
          />
          <path
            className="st8"
            d="M272.29,484h5.89v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st8"
            d="M279.51,484h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st8"
            d="M400.64,483.8c.61,0,1.16.11,1.65.34s.9.54,1.23.93c.34.39.59.84.77,1.36.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66c-.18.52-.44.98-.77,1.36s-.75.7-1.23.92c-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36c-.18-.52-.27-1.07-.27-1.66s.09-1.13.27-1.65.44-.97.77-1.36c.34-.39.75-.7,1.23-.93s1.03-.34,1.65-.34ZM400.64,484.97c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1s-.14.76-.14,1.15.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1,.1-.37.14-.76.14-1.15s-.05-.77-.14-1.15-.24-.71-.44-1c-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st8"
            d="M404.94,484h1.49l2.05,6.48h.02l2.1-6.48h1.46l-2.8,8.19h-1.59l-2.73-8.19Z"
          />
          <path
            className="st8"
            d="M412.88,484h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st8"
            d="M420.05,484h1.51l3.74,6.03h.02v-6.03h1.36v8.19h-1.51l-3.73-6.02h-.03v6.02h-1.36v-8.19Z"
          />
          <path
            className="st8"
            d="M432.52,489.46c0,.31.05.58.16.8.11.22.26.4.45.54.19.14.41.24.66.31.25.07.52.1.81.1.31,0,.58-.04.8-.11.22-.07.4-.17.54-.28.14-.11.24-.25.3-.4.06-.15.09-.3.09-.45,0-.31-.07-.54-.21-.69-.14-.15-.3-.25-.46-.32-.29-.11-.63-.21-1.01-.3-.39-.1-.86-.22-1.43-.37-.35-.09-.64-.21-.88-.36-.23-.15-.42-.32-.56-.5-.14-.18-.24-.38-.29-.58-.06-.21-.09-.42-.09-.63,0-.41.09-.77.26-1.07.17-.3.4-.55.68-.75.28-.2.6-.35.96-.44.36-.1.72-.14,1.09-.14.43,0,.83.06,1.21.17.38.11.71.28,1,.5.29.22.51.5.68.82.17.33.25.7.25,1.13h-1.43c-.04-.53-.22-.9-.54-1.12-.32-.22-.73-.33-1.23-.33-.17,0-.34.02-.52.05-.18.03-.34.09-.48.17-.15.08-.27.19-.36.33s-.14.31-.14.52c0,.29.09.52.27.68.18.16.41.29.71.37.03,0,.15.04.36.1.21.06.45.12.71.19.26.07.51.14.76.2.25.07.43.11.53.14.27.08.5.2.7.34.2.15.37.31.5.5.13.19.23.39.3.6.06.21.1.43.1.64,0,.46-.09.85-.28,1.18-.19.33-.43.59-.74.8-.31.21-.65.36-1.04.45-.39.1-.79.14-1.19.14-.47,0-.91-.06-1.32-.17-.41-.11-.77-.29-1.08-.53-.31-.24-.55-.54-.73-.91s-.28-.81-.29-1.31h1.43Z"
          />
          <path
            className="st8"
            d="M441.2,484h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM440.69,488.93h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st8"
            d="M446.66,484h5.65v1.24h-4.22v2.14h3.7v1.17h-3.7v3.64h-1.43v-8.19Z"
          />
          <path
            className="st8"
            d="M453.46,484h5.89v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st8"
            d="M549.61,484h2.02l2.26,6.41h.02l2.2-6.41h2v8.19h-1.36v-6.32h-.02l-2.27,6.32h-1.18l-2.27-6.32h-.02v6.32h-1.36v-8.19Z"
          />
          <path className="st8" d="M559.83,484h1.43v8.19h-1.43v-8.19Z" />
          <path
            className="st8"
            d="M568.54,486.6c-.06-.24-.15-.45-.25-.65-.11-.2-.24-.37-.41-.52-.17-.15-.37-.26-.59-.34-.23-.08-.49-.12-.79-.12-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1s-.14.76-.14,1.15.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26.32,0,.6-.06.85-.17.24-.11.45-.26.63-.46s.31-.42.41-.68c.1-.26.16-.54.19-.84h1.4c-.03.49-.14.94-.32,1.34s-.42.76-.73,1.05c-.31.29-.67.52-1.08.68-.41.16-.87.24-1.36.24-.61,0-1.16-.11-1.65-.34-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36c-.18-.52-.27-1.07-.27-1.66s.09-1.13.27-1.65.44-.97.77-1.36c.34-.39.75-.7,1.23-.93s1.03-.34,1.65-.34c.46,0,.89.06,1.3.19.41.13.76.31,1.07.55s.56.53.75.88c.19.34.31.74.36,1.18h-1.43Z"
          />
          <path
            className="st8"
            d="M571.3,484h3.91c.9,0,1.58.19,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97-.11.26-.25.46-.4.62s-.3.27-.45.34c-.15.07-.26.11-.33.14v.02c.12.02.25.05.4.11.14.06.27.16.4.29.12.13.22.31.3.52.08.21.12.48.12.8,0,.48.04.92.11,1.31.07.39.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58-.02-.21-.03-.42-.03-.62,0-.37-.02-.7-.07-.97-.05-.27-.13-.5-.25-.68s-.29-.31-.5-.4c-.21-.08-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19ZM572.73,487.73h2.35c.46,0,.81-.11,1.04-.33s.36-.54.36-.98c0-.26-.04-.47-.11-.64-.08-.16-.18-.29-.32-.38-.13-.09-.29-.15-.46-.18-.17-.03-.35-.05-.53-.05h-2.33v2.56Z"
          />
          <path
            className="st8"
            d="M582.86,483.8c.61,0,1.16.11,1.65.34s.9.54,1.23.93c.34.39.59.84.77,1.36s.27,1.07.27,1.65-.09,1.14-.27,1.66c-.18.52-.44.98-.77,1.36s-.75.7-1.23.92c-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92-.34-.39-.59-.84-.77-1.36-.18-.52-.27-1.07-.27-1.66s.09-1.13.27-1.65c.18-.52.44-.97.77-1.36.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34ZM582.86,484.97c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1,.1-.37.14-.76.14-1.15s-.05-.77-.14-1.15-.24-.71-.44-1c-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st8"
            d="M587.28,484h1.46l1.48,6.26h.02l1.65-6.26h1.47l1.61,6.26h.02l1.53-6.26h1.46l-2.26,8.19h-1.46l-1.64-6.26h-.02l-1.67,6.26h-1.48l-2.16-8.19Z"
          />
          <path
            className="st8"
            d="M600.82,484h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM600.31,488.93h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st8"
            d="M604.64,484h1.49l2.05,6.48h.02l2.1-6.48h1.46l-2.8,8.19h-1.59l-2.73-8.19Z"
          />
          <path
            className="st8"
            d="M612.57,484h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st8"
            d="M623.93,489.46c0,.31.05.58.16.8.11.22.26.4.45.54.19.14.41.24.66.31.25.07.52.1.81.1.31,0,.58-.04.8-.11.22-.07.4-.17.54-.28.14-.11.24-.25.3-.4.06-.15.09-.3.09-.45,0-.31-.07-.54-.21-.69-.14-.15-.3-.25-.46-.32-.29-.11-.63-.21-1.01-.3-.39-.1-.86-.22-1.43-.37-.35-.09-.64-.21-.88-.36-.23-.15-.42-.32-.56-.5-.14-.18-.24-.38-.29-.58-.06-.21-.09-.42-.09-.63,0-.41.09-.77.26-1.07.17-.3.4-.55.68-.75.28-.2.6-.35.96-.44.36-.1.72-.14,1.09-.14.43,0,.83.06,1.21.17.38.11.71.28,1,.5.29.22.51.5.68.82.17.33.25.7.25,1.13h-1.43c-.04-.53-.22-.9-.54-1.12-.32-.22-.73-.33-1.23-.33-.17,0-.34.02-.52.05-.18.03-.34.09-.48.17-.15.08-.27.19-.36.33s-.14.31-.14.52c0,.29.09.52.27.68.18.16.41.29.71.37.03,0,.15.04.36.1.21.06.45.12.71.19.26.07.51.14.76.2.25.07.43.11.53.14.27.08.5.2.7.34.2.15.37.31.5.5.13.19.23.39.3.6.06.21.1.43.1.64,0,.46-.09.85-.28,1.18-.19.33-.43.59-.74.8-.31.21-.65.36-1.04.45-.39.1-.79.14-1.19.14-.47,0-.91-.06-1.32-.17-.41-.11-.77-.29-1.08-.53-.31-.24-.55-.54-.73-.91s-.28-.81-.29-1.31h1.43Z"
          />
          <path
            className="st8"
            d="M632.61,484h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM632.1,488.93h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st8"
            d="M638.07,484h5.65v1.24h-4.22v2.14h3.7v1.17h-3.7v3.64h-1.43v-8.19Z"
          />
          <path
            className="st8"
            d="M644.87,484h5.89v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path className="st2" d="M404.53,422.08" />
          <polygon
            className="st6"
            points="452.6 449.74 450.39 449.74 450.39 414.17 404.09 414.17 404.09 411.96 452.6 411.96 452.6 449.74"
          />
          <polygon
            className="st8"
            points="451.94 454.88 403.43 454.88 403.43 417.25 405.63 417.25 405.63 452.68 451.94 452.68 451.94 454.88"
          />
          <path
            className="st8"
            d="M445.74,447.3h-35.46v-20.49h35.46v20.49ZM412.49,445.09h31.04v-16.08h-31.04v16.08Z"
          />
          <rect
            className="st8"
            x="410.14"
            y="419.44"
            width="35.54"
            height="2.21"
          />
          <path
            className="st8"
            d="M962.38,454.88h-49.17v-30.03h22.62v19.45l26.55-.27v10.85ZM915.42,452.68h44.76v-6.42l-26.55.27v-19.47h-18.21v25.62Z"
          />
          <polygon
            className="st6"
            points="623.99 447.6 621.79 447.6 621.79 416.89 572.85 416.89 572.85 414.68 623.99 414.68 623.99 447.6"
          />
          <polygon
            className="st8"
            points="623.33 452.16 572.18 452.16 572.18 419.49 574.39 419.49 574.39 449.95 623.33 449.95 623.33 452.16"
          />
          <path
            className="st8"
            d="M611.32,446.41h-33.19v-25.24h33.19v25.24ZM580.33,444.2h28.78v-20.83h-28.78v20.83Z"
          />
          <rect
            className="st8"
            x="614.93"
            y="421.61"
            width="3.69"
            height="2.21"
          />
          <rect
            className="st8"
            x="614.93"
            y="427.17"
            width="3.69"
            height="2.21"
          />
          <rect
            className="st8"
            x="614.93"
            y="432.74"
            width="3.69"
            height="2.21"
          />
          <polygon
            className="st6"
            points="791.06 451.94 788.85 451.94 788.85 411.93 744.32 411.93 744.32 409.72 791.06 409.72 791.06 451.94"
          />
          <polygon
            className="st8"
            points="790.4 457.12 743.66 457.12 743.66 415.35 745.87 415.35 745.87 454.91 790.4 454.91 790.4 457.12"
          />
          <path
            className="st8"
            d="M785.87,452.57h-37.02v-31.04h37.02v31.04ZM751.06,450.37h32.61v-26.62h-32.61v26.62Z"
          />
          <rect
            className="st8"
            x="766.26"
            y="422.64"
            width="2.21"
            height="8.06"
          />
          <rect
            className="st8"
            x="756.08"
            y="424.39"
            width="8.07"
            height="2.21"
            transform="translate(-78.23 662.11) rotate(-45)"
          />
          <rect
            className="st8"
            x="773.5"
            y="421.46"
            width="2.21"
            height="8.07"
            transform="translate(-73.99 672.35) rotate(-45)"
          />
          <path
            className="st8"
            d="M775.42,452.08l-1.76-1.33c1.03-1.37,1.58-3.01,1.58-4.73,0-4.34-3.53-7.87-7.87-7.87s-7.87,3.53-7.87,7.87c0,1.72.54,3.36,1.58,4.73l-1.76,1.33c-1.32-1.76-2.02-3.85-2.02-6.05,0-5.56,4.52-10.08,10.08-10.08s10.08,4.52,10.08,10.08c0,2.2-.7,4.3-2.02,6.05Z"
          />
          <rect
            className="st8"
            x="749.34"
            y="415.62"
            width="36.25"
            height="2.21"
          />
          <path
            className="st6"
            d="M962.38,442.12h-24.81v-19.38h-24.37v-10.78h49.17v30.16ZM939.78,439.92h20.4v-17.18h-20.4v17.18ZM915.42,420.53h44.76v-6.37h-44.76v6.37Z"
          />
          <rect
            className="st8"
            x="933.63"
            y="445.42"
            width="2.21"
            height="8.36"
          />
          <polygon
            className="st6"
            points="1302.09 448.9 1299.88 448.9 1299.88 410.63 1255.79 410.63 1255.79 408.42 1302.09 408.42 1302.09 448.9"
          />
          <path className="st2" d="M1255.79,417.04" />
          <polygon
            className="st8"
            points="1300.99 455.82 1254.69 455.82 1254.69 414.79 1256.9 414.79 1256.9 453.61 1300.99 453.61 1300.99 455.82"
          />
          <path className="st3" d="M1300.99,446.06" />
          <path
            className="st8"
            d="M1278.24,441.25c-4.48,0-8.12-3.64-8.12-8.12,0-4.07,6.45-14.66,7.18-15.85l.94-1.53.94,1.53c.73,1.19,7.18,11.78,7.18,15.85,0,4.48-3.64,8.12-8.12,8.12ZM1278.24,420c-2.24,3.81-5.91,10.61-5.91,13.13,0,3.26,2.65,5.91,5.91,5.91s5.91-2.65,5.91-5.91c0-2.52-3.68-9.32-5.91-13.13Z"
          />
          <path
            className="st8"
            d="M1063.72,488.57c0,.31.05.58.16.8.11.22.26.4.45.54.19.14.41.24.66.31.25.07.52.1.81.1.31,0,.58-.04.8-.11.22-.07.4-.17.54-.28.14-.11.24-.25.3-.4.06-.15.09-.3.09-.45,0-.31-.07-.54-.21-.69-.14-.15-.3-.25-.46-.32-.29-.11-.63-.21-1.01-.3-.39-.1-.86-.22-1.43-.37-.35-.09-.64-.21-.88-.36-.23-.15-.42-.32-.56-.5-.14-.18-.24-.38-.29-.58-.06-.21-.09-.42-.09-.63,0-.41.09-.77.26-1.07.17-.3.4-.55.68-.75.28-.2.6-.35.96-.44s.72-.14,1.09-.14c.43,0,.83.06,1.21.17.38.11.71.28,1,.5.29.22.51.5.68.82.17.33.25.7.25,1.13h-1.43c-.04-.53-.22-.9-.54-1.12-.32-.22-.73-.33-1.23-.33-.17,0-.34.02-.52.05-.18.03-.34.09-.48.17s-.27.19-.36.33c-.1.14-.14.31-.14.52,0,.29.09.52.27.68s.41.29.71.37c.03,0,.15.04.36.1.21.06.45.12.71.19.26.07.51.14.76.2s.43.11.53.14c.27.08.5.2.7.34.2.15.37.31.5.5.13.19.23.39.3.6.06.21.1.43.1.64,0,.46-.09.85-.28,1.18-.19.33-.43.59-.74.8-.31.21-.65.36-1.04.45-.39.1-.79.14-1.19.14-.47,0-.91-.06-1.32-.17-.41-.11-.77-.29-1.08-.53s-.55-.54-.73-.91-.28-.81-.29-1.31h1.43Z"
          />
          <path
            className="st8"
            d="M1069.44,483.11h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <path
            className="st8"
            d="M1078.15,483.11h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM1077.65,488.04h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st8"
            d="M1084.9,488.09l-3.07-4.98h1.66l2.17,3.67,2.13-3.67h1.61l-3.06,4.98v3.21h-1.43v-3.21Z"
          />
          <path
            className="st8"
            d="M1093.35,483.11h1.43v3.26h3.73v-3.26h1.43v8.19h-1.43v-3.69h-3.73v3.69h-1.43v-8.19Z"
          />
          <path
            className="st8"
            d="M1105.15,482.91c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.37.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66c-.18.52-.44.97-.77,1.36s-.75.7-1.23.92c-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65.44-.97.77-1.37c.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34ZM1105.15,484.08c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15.24.71.44,1c.2.29.46.53.77.71.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1s.14-.76.14-1.15-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st8"
            d="M1109.6,483.11h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <path
            className="st8"
            d="M1121.55,490.38c-.31.37-.64.65-1.01.82-.37.17-.8.26-1.28.26-.37,0-.72-.06-1.04-.17-.32-.11-.59-.27-.82-.48-.23-.21-.41-.46-.53-.76s-.19-.64-.19-1.03c0-.29.05-.55.16-.79.11-.24.25-.45.42-.65.18-.19.38-.37.6-.52.23-.15.46-.29.69-.41-.11-.14-.21-.27-.31-.41-.1-.13-.19-.27-.26-.42-.08-.15-.14-.3-.18-.46-.05-.16-.07-.33-.07-.5,0-.3.05-.57.16-.8.1-.24.25-.44.43-.61s.4-.3.64-.4.5-.14.78-.14c.26,0,.51.04.76.12.25.08.47.2.65.37s.34.37.45.61.17.53.17.86c0,.24-.04.47-.12.68-.08.21-.19.4-.32.57-.13.17-.29.33-.47.46-.18.14-.37.26-.57.37l1.27,1.54c.05-.13.09-.28.14-.45.05-.17.08-.39.11-.65h1.15c-.04.36-.11.71-.21,1.06-.1.34-.25.66-.43.95l1.57,1.9h-1.61l-.75-.92ZM1119.24,487.51c-.12.08-.26.15-.4.23-.15.08-.28.17-.41.29-.13.12-.23.25-.32.41s-.13.36-.13.61c0,.44.12.78.37,1.02.25.24.56.36.95.36.24,0,.44-.03.61-.1.17-.07.31-.14.43-.24s.22-.19.3-.3c.08-.11.15-.2.21-.29l-1.61-2ZM1119.77,483.89c-.24,0-.45.08-.62.25-.17.16-.25.38-.25.66,0,.14.02.27.07.38.05.12.11.23.18.34.07.11.15.22.24.33s.17.21.25.31c.12-.08.24-.17.36-.26.11-.09.22-.18.31-.29s.16-.22.22-.35.08-.28.08-.44c0-.27-.08-.49-.23-.67s-.36-.27-.61-.27Z"
          />
          <path
            className="st8"
            d="M1130.14,485.71c-.06-.24-.15-.45-.25-.65s-.24-.37-.41-.52c-.17-.15-.37-.26-.59-.34-.23-.08-.49-.12-.79-.12-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15.24.71.44,1c.2.29.46.53.77.71.32.18.69.26,1.13.26.32,0,.6-.06.85-.17.24-.11.45-.26.63-.46.18-.19.31-.42.41-.68.1-.26.16-.54.19-.84h1.4c-.03.49-.14.94-.32,1.34s-.42.76-.73,1.05c-.31.29-.67.52-1.08.68-.41.16-.87.24-1.36.24-.61,0-1.16-.11-1.65-.34-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65.44-.97.77-1.37c.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34.46,0,.89.06,1.3.19.41.13.76.31,1.07.55s.56.53.75.88c.19.34.31.74.36,1.18h-1.43Z"
          />
          <path
            className="st8"
            d="M1136.38,482.91c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.37.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66c-.18.52-.44.97-.77,1.36s-.75.7-1.23.92c-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65.44-.97.77-1.37c.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34ZM1136.38,484.08c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15.24.71.44,1c.2.29.46.53.77.71.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1s.14-.76.14-1.15-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st8"
            d="M1141.61,483.11h1.43v6.95h4.16v1.24h-5.6v-8.19Z"
          />
          <path
            className="st8"
            d="M1148.19,483.11h3.39c.63,0,1.17.11,1.63.32.46.21.83.51,1.12.88.29.37.51.8.65,1.3.14.5.21,1.03.21,1.59s-.07,1.1-.21,1.59c-.14.5-.36.93-.65,1.3-.29.37-.67.66-1.12.88-.46.21-1,.32-1.63.32h-3.39v-8.19ZM1149.62,490.13h1.41c.56,0,1.01-.07,1.37-.22.36-.15.63-.36.84-.62.2-.26.34-.57.41-.93.07-.36.11-.74.11-1.15s-.04-.8-.11-1.15c-.07-.36-.21-.67-.41-.93-.2-.26-.48-.47-.84-.62-.36-.15-.81-.22-1.37-.22h-1.41v5.85Z"
          />
          <path
            className="st8"
            d="M1249.79,483.11h1.51l3.74,6.03h.02v-6.03h1.36v8.19h-1.51l-3.73-6.02h-.03v6.02h-1.36v-8.19Z"
          />
          <path
            className="st8"
            d="M1261.61,482.91c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.37s.27,1.07.27,1.65-.09,1.14-.27,1.66-.44.97-.77,1.36-.75.7-1.23.92c-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92-.34-.39-.59-.84-.77-1.36s-.27-1.07-.27-1.66.09-1.13.27-1.65.44-.97.77-1.37c.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34ZM1261.61,484.08c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15.24.71.44,1c.2.29.46.53.77.71s.69.26,1.13.26.81-.09,1.13-.26.58-.41.77-.71c.2-.29.35-.63.44-1s.14-.76.14-1.15-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st8"
            d="M1270.97,488.57c0,.31.05.58.16.8.11.22.26.4.45.54.19.14.41.24.66.31.25.07.52.1.81.1.31,0,.58-.04.8-.11.22-.07.4-.17.54-.28.14-.11.24-.25.3-.4.06-.15.09-.3.09-.45,0-.31-.07-.54-.21-.69s-.3-.25-.46-.32c-.29-.11-.63-.21-1.01-.3-.39-.1-.86-.22-1.43-.37-.35-.09-.64-.21-.88-.36-.23-.15-.42-.32-.56-.5s-.24-.38-.29-.58c-.06-.21-.09-.42-.09-.63,0-.41.09-.77.26-1.07.17-.3.4-.55.68-.75.28-.2.6-.35.96-.44s.72-.14,1.09-.14c.43,0,.83.06,1.21.17.38.11.71.28,1,.5.29.22.51.5.68.82.17.33.25.7.25,1.13h-1.43c-.04-.53-.22-.9-.54-1.12-.32-.22-.73-.33-1.23-.33-.17,0-.34.02-.52.05-.18.03-.34.09-.48.17-.15.08-.27.19-.36.33-.1.14-.14.31-.14.52,0,.29.09.52.27.68s.41.29.71.37c.03,0,.15.04.36.1.21.06.45.12.71.19.26.07.51.14.76.2.25.07.43.11.53.14.27.08.5.2.7.34.2.15.37.31.5.5.13.19.23.39.3.6.07.21.1.43.1.64,0,.46-.09.85-.28,1.18-.19.33-.43.59-.74.8-.31.21-.65.36-1.04.45-.39.1-.79.14-1.19.14-.47,0-.91-.06-1.32-.17-.41-.11-.77-.29-1.08-.53s-.55-.54-.73-.91-.28-.81-.29-1.31h1.43Z"
          />
          <path
            className="st8"
            d="M1276.66,483.11h1.46l1.48,6.26h.02l1.65-6.26h1.47l1.61,6.26h.02l1.53-6.26h1.46l-2.26,8.19h-1.46l-1.64-6.26h-.02l-1.67,6.26h-1.48l-2.16-8.19Z"
          />
          <path
            className="st8"
            d="M1288.29,483.11h5.89v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.97v-8.19Z"
          />
          <path
            className="st8"
            d="M1297.71,483.11h1.52l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM1297.2,488.04h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st8"
            d="M1301.33,483.11h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <rect
            className="st6"
            x="1109.43"
            y="405.54"
            width="2.21"
            height="23.46"
          />
          <rect
            className="st6"
            x="1109.31"
            y="411.9"
            width="9.55"
            height="2.21"
            transform="translate(34.27 908.74) rotate(-45)"
          />
          <rect
            className="st6"
            x="1106.23"
            y="408.23"
            width="2.21"
            height="9.55"
            transform="translate(32.31 904) rotate(-45)"
          />
          <rect
            className="st6"
            x="1096.69"
            y="413.54"
            width="2.21"
            height="9.55"
            transform="translate(-70.86 298.37) rotate(-15)"
          />
          <path className="st2" d="M1099.03,422.92" />
          <path className="st2" d="M1089.8,425.39" />
          <rect
            className="st6"
            x="1109.43"
            y="405.54"
            width="2.21"
            height="48.45"
            transform="translate(183.07 1176.63) rotate(-60)"
          />
          <path className="st2" d="M1122.04,436.62" />
          <path className="st2" d="M1124.51,445.84" />
          <rect
            className="st6"
            x="1121.87"
            y="434.28"
            width="9.55"
            height="2.21"
            transform="translate(-74.31 306.6) rotate(-15.01)"
          />
          <rect
            className="st6"
            x="1109.63"
            y="422.42"
            width="23.46"
            height="2.21"
            transform="translate(-61.53 617.42) rotate(-30)"
          />
          <rect
            className="st6"
            x="1125.72"
            y="419.69"
            width="2.21"
            height="9.55"
            transform="translate(425.2 1403.05) rotate(-75)"
          />
          <rect
            className="st6"
            x="1118.67"
            y="417.52"
            width="9.55"
            height="2.21"
            transform="translate(428.19 1395.35) rotate(-74.99)"
          />
          <path className="st2" d="M1128.91,446.39" />
          <rect
            className="st7"
            x="1105.31"
            y="449.75"
            width="2.21"
            height="9.7"
          />
          <path
            className="st7"
            d="M1107.35,450.47c-2.58,0-5.19-.65-7.58-2.03-6.94-4.01-9.53-12.69-6.08-19.79l-7.62-4.39,1.1-1.91,9.5,5.47-.55.96c-3.58,6.21-1.45,14.17,4.76,17.76,6.21,3.58,14.17,1.45,17.76-4.76l.55-.95,9.82,5.65-1.1,1.91-7.94-4.57c-2.9,4.28-7.7,6.66-12.61,6.66Z"
          />
          <rect
            className="st7"
            x="1085.84"
            y="443.11"
            width="9.35"
            height="2.21"
            transform="translate(-76.23 603.14) rotate(-29.92)"
          />
          <path className="st2" d="M1083.36,439.34" />
          <path className="st2" d="M1091,437.21" />
          <polygon
            className="st8"
            points="1278.19 450.61 1261.01 441.45 1262.05 439.51 1278.13 448.08 1292.56 439.53 1293.68 441.43 1278.19 450.61"
          />
          <polygon
            className="st8"
            points="1262.13 445.67 1260.55 439.88 1266.34 438.3 1266.92 440.43 1263.26 441.43 1264.26 445.08 1262.13 445.67"
          />
          <path
            className="st8"
            d="M248.38,424.48c.3,0,.63,0,.98,0,.35,0,.7.03,1.04.06.34.03.67.08.96.15.3.07.55.17.76.3.46.28.86.66,1.18,1.15.32.49.49,1.09.49,1.81,0,.75-.18,1.41-.55,1.96-.36.55-.88.96-1.56,1.22v.04c.87.19,1.54.58,2,1.19.46.61.69,1.35.69,2.22,0,.52-.09,1.02-.28,1.51-.19.49-.46.92-.82,1.3-.36.38-.81.68-1.35.91-.54.23-1.15.35-1.86.35h-6.85v-14.17h5.14ZM248.89,430.57c1.07,0,1.84-.19,2.31-.57.47-.38.7-.94.7-1.7,0-.5-.08-.9-.24-1.19-.16-.29-.38-.52-.66-.67-.28-.16-.6-.26-.96-.31-.36-.05-.75-.07-1.16-.07h-3.77v4.51h3.77ZM249.85,437.07c.83,0,1.49-.22,1.96-.67.47-.45.7-1.07.7-1.87,0-.46-.09-.85-.26-1.15-.17-.3-.4-.55-.68-.72-.28-.18-.61-.3-.98-.38-.37-.07-.75-.11-1.15-.11h-4.31v4.9h4.72Z"
          />
          <path
            className="st8"
            d="M263.05,424.48c1.43,0,2.51.37,3.25,1.1.73.73,1.1,1.76,1.1,3.09s-.37,2.36-1.1,3.1c-.73.74-1.82,1.11-3.25,1.09h-4.33v5.8h-1.89v-14.17h6.21ZM262.41,431.27c1.07.01,1.86-.2,2.35-.65.5-.45.74-1.1.74-1.95s-.25-1.49-.74-1.94c-.5-.44-1.28-.66-2.35-.66h-3.69v5.2h3.69Z"
          />
          <path
            className="st8"
            d="M274.16,424.48l5.54,14.17h-2.08l-1.55-4.27h-6l-1.59,4.27h-1.93l5.52-14.17h2.08ZM275.47,432.8l-2.36-6.61h-.04l-2.4,6.61h4.8Z"
          />
          <polygon
            className="st6"
            points="290.34 451.25 288.13 451.25 288.13 413.27 231.77 413.27 231.77 411.06 290.34 411.06 290.34 451.25"
          />
          <polygon
            className="st8"
            points="284.66 454.18 226.37 454.18 226.37 412.16 228.58 412.16 228.58 451.97 284.66 451.97 284.66 454.18"
          />
          <path className="st1" d="M236.07,418.75" />
          <rect
            className="st8"
            x="230.97"
            y="431.48"
            width="54.57"
            height="2.21"
            transform="translate(-177.22 179.24) rotate(-28.97)"
          />
          <rect
            className="st8"
            x="64.39"
            y="432.84"
            width="46.15"
            height="2.21"
            transform="translate(-281.23 188.95) rotate(-45)"
          />
          <rect
            className="st5"
            x="50.56"
            y="269.84"
            width="74.6"
            height="74.6"
          />
          <rect
            className="st5"
            x="220.64"
            y="269.84"
            width="74.6"
            height="74.6"
          />
          <rect
            className="st5"
            x="390.72"
            y="269.84"
            width="74.6"
            height="74.6"
          />
          <rect
            className="st5"
            x="560.79"
            y="269.84"
            width="74.6"
            height="74.6"
          />
          <rect
            className="st5"
            x="730.87"
            y="269.84"
            width="74.6"
            height="74.6"
          />
          <rect
            className="st5"
            x="900.94"
            y="269.84"
            width="74.6"
            height="74.6"
          />
          <rect
            className="st5"
            x="1071.02"
            y="269.84"
            width="74.6"
            height="74.6"
          />
          <rect
            className="st5"
            x="1241.09"
            y="269.84"
            width="74.6"
            height="74.6"
          />
          <rect
            className="st5"
            x="50.56"
            y="394.82"
            width="74.6"
            height="74.6"
          />
          <path
            className="st8"
            d="M1429.03,357.91h1.43v4.77c0,.28.01.55.04.84s.1.54.23.76c.13.23.32.41.57.56.26.15.62.22,1.08.22s.83-.07,1.08-.22c.26-.15.45-.33.57-.56.13-.23.2-.48.23-.76.03-.28.04-.56.04-.84v-4.77h1.43v5.24c0,.53-.08.99-.24,1.38-.16.39-.39.72-.68.98-.29.26-.65.46-1.06.59-.41.13-.87.2-1.38.2s-.96-.07-1.38-.2c-.41-.13-.77-.33-1.06-.59-.29-.26-.52-.59-.68-.98-.16-.39-.24-.85-.24-1.38v-5.24Z"
          />
          <path
            className="st8"
            d="M1436.48,357.91h1.49l2.05,6.48h.02l2.1-6.48h1.46l-2.8,8.19h-1.59l-2.73-8.19Z"
          />
          <path className="st8" d="M1443.47,362.36h3.34v1.24h-3.34v-1.24Z" />
          <path
            className="st8"
            d="M1448.24,357.91h1.43v6.95h4.16v1.24h-5.6v-8.19Z"
          />
          <path
            className="st8"
            d="M1454.83,357.91h5.89v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.97v-8.19Z"
          />
          <path
            className="st8"
            d="M1462.05,357.91h3.39c.63,0,1.17.11,1.63.32.46.21.83.51,1.12.88.29.37.51.8.65,1.3s.21,1.03.21,1.59-.07,1.1-.21,1.59c-.14.5-.36.93-.65,1.3-.29.37-.67.66-1.12.88-.46.21-1,.32-1.63.32h-3.39v-8.19ZM1463.48,364.93h1.41c.56,0,1.02-.07,1.37-.22.36-.15.63-.36.84-.62.2-.26.34-.57.41-.93.07-.36.11-.74.11-1.15s-.04-.8-.11-1.15c-.07-.36-.21-.67-.41-.93-.2-.26-.48-.47-.84-.62-.35-.15-.81-.22-1.37-.22h-1.41v5.85Z"
          />
          <polygon
            className="st6"
            points="1472.18 323.31 1469.97 323.31 1469.97 285.04 1425.88 285.04 1425.88 282.83 1472.18 282.83 1472.18 323.31"
          />
          <polygon
            className="st8"
            points="1471.08 330.23 1424.78 330.23 1424.78 289.2 1426.99 289.2 1426.99 328.02 1471.08 328.02 1471.08 330.23"
          />
          <path className="st3" d="M1471.08,320.47" />
          <polygon
            className="st8"
            points="1448.28 325.02 1431.1 315.86 1432.14 313.91 1448.22 322.49 1462.65 313.94 1463.77 315.84 1448.28 325.02"
          />
          <polygon
            className="st8"
            points="1432.22 320.07 1430.64 314.29 1436.43 312.71 1437.01 314.83 1433.35 315.83 1434.35 319.49 1432.22 320.07"
          />
          <path
            className="st8"
            d="M1448.48,309.32c-3.71,0-6.74-3.02-6.74-6.74s3.02-6.74,6.74-6.74,6.74,3.02,6.74,6.74-3.02,6.74-6.74,6.74ZM1448.48,298.05c-2.5,0-4.53,2.03-4.53,4.53s2.03,4.53,4.53,4.53,4.53-2.03,4.53-4.53-2.03-4.53-4.53-4.53Z"
          />
          <rect
            className="st8"
            x="1447.38"
            y="288.99"
            width="2.21"
            height="4.47"
          />
          <rect
            className="st8"
            x="1437.54"
            y="294.67"
            width="2.21"
            height="4.47"
            transform="translate(462.17 1394.33) rotate(-60)"
          />
          <rect
            className="st8"
            x="1436.4"
            y="307.16"
            width="4.47"
            height="2.21"
            transform="translate(38.61 760.63) rotate(-30)"
          />
          <rect
            className="st8"
            x="1447.38"
            y="311.71"
            width="2.21"
            height="4.47"
          />
          <rect
            className="st8"
            x="1457.22"
            y="306.03"
            width="2.21"
            height="4.47"
            transform="translate(462.26 1417.14) rotate(-60)"
          />
          <rect
            className="st8"
            x="1456.09"
            y="295.8"
            width="4.47"
            height="2.21"
            transform="translate(46.93 768.94) rotate(-30)"
          />
          <polygon
            className="st6"
            points="1471.89 451.62 1469.69 451.62 1469.69 411.93 1424.71 411.93 1424.71 409.72 1471.89 409.72 1471.89 451.62"
          />
          <polygon
            className="st8"
            points="1471.67 457.12 1424.49 457.12 1424.49 414.13 1426.7 414.13 1426.7 454.91 1471.67 454.91 1471.67 457.12"
          />
          <path
            className="st8"
            d="M1448.04,448.89c-5.65,0-10.25-4.6-10.25-10.25,0-5.21,8.36-18.94,9.31-20.49l.94-1.53.94,1.53c.95,1.55,9.31,15.28,9.31,20.49,0,5.65-4.6,10.25-10.25,10.25ZM1448.04,420.86c-2.89,4.88-8.04,14.31-8.04,17.77,0,4.44,3.61,8.04,8.04,8.04s8.04-3.61,8.04-8.04c0-3.47-5.16-12.89-8.04-17.77Z"
          />
          <path
            className="st8"
            d="M1410.11,484h1.46l1.48,6.26h.02l1.65-6.26h1.47l1.61,6.26h.02l1.53-6.26h1.46l-2.26,8.19h-1.46l-1.64-6.26h-.02l-1.67,6.26h-1.48l-2.16-8.19Z"
          />
          <path
            className="st8"
            d="M1423.64,484h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM1423.14,488.93h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st8"
            d="M1427.27,484h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <path
            className="st8"
            d="M1434.85,484h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st8"
            d="M1442.07,484h3.91c.9,0,1.58.19,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97-.11.26-.25.46-.4.62s-.3.27-.45.34c-.15.07-.26.11-.33.14v.02c.12.02.25.05.4.11.14.06.27.16.4.29.12.13.22.31.3.52.08.21.12.48.12.8,0,.48.04.92.11,1.31.07.39.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58-.02-.21-.03-.42-.03-.62,0-.37-.02-.7-.07-.97-.05-.27-.13-.5-.25-.68s-.29-.31-.5-.4c-.21-.08-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19ZM1443.5,487.73h2.35c.46,0,.81-.11,1.04-.33s.36-.54.36-.98c0-.26-.04-.47-.11-.64-.08-.16-.18-.29-.32-.38-.13-.09-.29-.15-.46-.18-.17-.03-.35-.05-.53-.05h-2.33v2.56Z"
          />
          <path
            className="st8"
            d="M1452.55,484h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <path className="st8" d="M1460.13,484h1.43v8.19h-1.43v-8.19Z" />
          <path
            className="st8"
            d="M1470.47,492.19h-.92l-.22-.96c-.38.44-.76.74-1.15.91-.38.17-.82.25-1.32.25-.61,0-1.16-.11-1.65-.34-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36c-.18-.52-.27-1.07-.27-1.66s.09-1.13.27-1.65c.18-.52.44-.97.77-1.36.34-.39.75-.7,1.23-.93s1.03-.34,1.65-.34c.44,0,.87.06,1.27.18.4.12.76.29,1.07.53.31.23.57.53.78.88.21.35.34.76.39,1.22h-1.4c-.04-.27-.12-.5-.25-.71-.13-.2-.29-.37-.48-.51-.19-.14-.41-.24-.64-.31-.24-.07-.49-.1-.75-.1-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1s-.14.76-.14,1.15.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26.37,0,.69-.04.98-.14.28-.1.52-.25.72-.45.19-.2.34-.43.44-.72.1-.28.15-.6.16-.94h-2.18v-1.09h3.49v4.31Z"
          />
          <path
            className="st8"
            d="M1471.99,484h1.43v3.26h3.73v-3.26h1.43v8.19h-1.43v-3.69h-3.73v3.69h-1.43v-8.19Z"
          />
          <path
            className="st8"
            d="M1479.53,484h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <rect
            className="st8"
            x="1425.01"
            y="432.84"
            width="46.15"
            height="2.21"
            transform="translate(117.29 1151.05) rotate(-45)"
          />
          <rect
            className="st5"
            x="1411.18"
            y="269.84"
            width="74.6"
            height="74.6"
          />
          <rect
            className="st5"
            x="1411.18"
            y="394.82"
            width="74.6"
            height="74.6"
          />
          <rect
            className="st5"
            x="220.64"
            y="394.82"
            width="74.6"
            height="74.6"
          />
          <rect
            className="st5"
            x="390.72"
            y="394.82"
            width="74.6"
            height="74.6"
          />
          <rect
            className="st5"
            x="560.79"
            y="394.82"
            width="74.6"
            height="74.6"
          />
          <rect
            className="st5"
            x="730.87"
            y="394.82"
            width="74.6"
            height="74.6"
          />
          <rect
            className="st5"
            x="900.94"
            y="394.82"
            width="74.6"
            height="74.6"
          />
          <rect
            className="st5"
            x="1071.02"
            y="394.82"
            width="74.6"
            height="74.6"
          />
          <rect
            className="st5"
            x="1241.09"
            y="394.82"
            width="74.6"
            height="74.6"
          />
          <polygon
            className="st8"
            points="-230.42 329.57 -274.81 329.57 -274.81 289.37 -272.61 289.37 -272.61 327.36 -230.42 327.36 -230.42 329.57"
          />
          <polygon
            className="st8"
            points="-261.96 312.46 -263.72 311.13 -255.38 300.06 -263.69 290.13 -262 288.72 -252.57 299.99 -261.96 312.46"
          />
          <polygon
            className="st8"
            points="-263.44 312.67 -265 308 -262.91 307.3 -261.9 310.32 -258.51 310.02 -258.31 312.21 -263.44 312.67"
          />
          <polygon
            className="st8"
            points="-262.19 321.42 -263.95 320.09 -255.61 309.02 -263.92 299.09 -262.23 297.68 -252.8 308.94 -262.19 321.42"
          />
          <polygon
            className="st8"
            points="-263.67 321.62 -265.23 316.95 -263.14 316.25 -262.13 319.27 -258.39 318.94 -258.2 321.14 -263.67 321.62"
          />
          <path
            className="st8"
            d="M-230.42,324.5h-21.86c-.61,0-1.1-.49-1.1-1.1v-37.76h2.21v36.66h20.76v2.21Z"
          />
          <polygon
            className="st6"
            points="-229.32 324.59 -231.52 324.59 -231.52 286.28 -273.71 286.28 -273.71 284.07 -229.32 284.07 -229.32 324.59"
          />
          <path
            className="st7"
            d="M-285.21,357.26h3.39c.63,0,1.17.11,1.63.32s.83.51,1.12.88c.29.37.51.8.65,1.3.14.5.21,1.03.21,1.59s-.07,1.1-.21,1.59-.36.93-.65,1.3c-.29.37-.67.66-1.12.88s-1,.32-1.63.32h-3.39v-8.19ZM-283.77,364.28h1.41c.56,0,1.01-.07,1.37-.22.36-.15.63-.36.84-.62.2-.26.34-.57.41-.93.07-.36.11-.74.11-1.15s-.04-.8-.11-1.15c-.07-.36-.21-.67-.41-.93s-.48-.47-.84-.62c-.36-.15-.81-.22-1.37-.22h-1.41v5.85Z"
          />
          <path
            className="st7"
            d="M-277.02,357.26h1.43v4.77c0,.28.01.55.04.84.03.28.1.54.23.76.13.23.32.41.57.56.26.15.62.22,1.08.22s.83-.07,1.08-.22c.26-.15.45-.33.57-.56.13-.23.2-.48.23-.76.03-.28.04-.56.04-.84v-4.77h1.43v5.24c0,.53-.08.99-.24,1.38-.16.39-.39.72-.68.98-.29.26-.65.46-1.06.59-.41.13-.87.2-1.38.2s-.96-.07-1.38-.2c-.41-.13-.77-.33-1.06-.59-.29-.26-.52-.59-.68-.98-.16-.39-.24-.85-.24-1.38v-5.24Z"
          />
          <path
            className="st7"
            d="M-268.64,357.26h3.91c.9,0,1.58.2,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97s-.25.46-.4.62c-.15.16-.3.27-.45.34-.15.07-.26.11-.33.14v.02c.12.02.25.05.4.12.14.06.27.16.4.29.12.13.22.31.3.52.08.21.12.48.12.8,0,.48.04.92.11,1.31.07.39.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58-.02-.21-.03-.42-.03-.62,0-.37-.02-.7-.07-.97-.05-.27-.13-.5-.25-.68s-.29-.31-.5-.4c-.21-.08-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19ZM-267.21,360.99h2.35c.46,0,.81-.11,1.04-.33.24-.22.36-.54.36-.98,0-.26-.04-.47-.11-.64-.08-.16-.18-.29-.32-.38-.13-.09-.29-.15-.46-.18s-.35-.05-.53-.05h-2.33v2.56Z"
          />
          <path
            className="st7"
            d="M-258.38,357.26h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM-258.88,362.19h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st7"
            d="M-252.92,357.26h3.98c.73,0,1.32.17,1.77.5.44.34.67.84.67,1.53,0,.41-.1.77-.3,1.06-.2.29-.49.52-.87.68v.02c.5.11.89.35,1.15.72.26.37.39.84.39,1.39,0,.32-.06.62-.17.9s-.29.52-.54.72c-.25.2-.56.36-.94.48-.38.12-.84.18-1.36.18h-3.76v-8.19ZM-251.49,360.69h2.34c.34,0,.63-.1.86-.29.23-.19.34-.48.34-.84,0-.41-.1-.7-.31-.87-.21-.17-.5-.25-.89-.25h-2.34v2.26ZM-251.49,364.28h2.53c.44,0,.77-.11,1.02-.34.24-.23.36-.54.36-.96s-.12-.72-.36-.93c-.24-.22-.58-.33-1.02-.33h-2.53v2.56Z"
          />
          <path className="st7" d="M-244.85,357.26h1.43v8.19h-1.43v-8.19Z" />
          <path
            className="st7"
            d="M-241.66,357.26h1.43v6.95h4.16v1.24h-5.6v-8.19Z"
          />
          <path className="st7" d="M-235.08,357.26h1.43v8.19h-1.43v-8.19Z" />
          <path
            className="st7"
            d="M-232.67,357.26h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <path
            className="st7"
            d="M-222.95,362.24l-3.07-4.98h1.66l2.17,3.67,2.13-3.67h1.61l-3.06,4.98v3.21h-1.43v-3.21Z"
          />
          <path
            className="st7"
            d="M-113.44,357.26h3.61c.58,0,1.05.08,1.42.25.37.17.65.38.85.63.2.25.33.53.41.83.07.3.11.57.11.83s-.04.53-.11.82c-.07.29-.21.57-.41.82-.2.25-.48.46-.85.63-.37.16-.84.25-1.42.25h-2.18v3.14h-1.43v-8.19ZM-112.01,361.14h2.1c.16,0,.32-.02.49-.07.17-.05.32-.12.46-.22.14-.1.26-.24.34-.41s.13-.39.13-.65-.04-.49-.12-.67c-.08-.18-.18-.32-.31-.42-.13-.1-.28-.17-.45-.21-.17-.04-.35-.06-.54-.06h-2.12v2.71Z"
          />
          <path
            className="st7"
            d="M-105.79,357.26h5.65v1.24h-4.22v2.14h3.7v1.17h-3.7v3.64h-1.43v-8.19Z"
          />
          <path
            className="st7"
            d="M-95.5,357.07c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.36.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66-.44.97-.77,1.36c-.34.39-.75.7-1.23.92-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34ZM-95.5,358.24c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1,.1-.37.14-.76.14-1.15s-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st7"
            d="M-88.08,357.26h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM-88.59,362.19h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st7"
            d="M-79.44,357.26h5.65v1.24h-4.22v2.14h3.7v1.17h-3.7v3.64h-1.43v-8.19Z"
          />
          <path
            className="st7"
            d="M-72.64,357.26h3.91c.9,0,1.58.2,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97s-.25.46-.4.62c-.15.16-.3.27-.45.34-.15.07-.26.11-.33.14v.02c.12.02.25.05.4.12.14.06.27.16.4.29.12.13.22.31.3.52.08.21.12.48.12.8,0,.48.04.92.11,1.31.07.39.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58-.02-.21-.03-.42-.03-.62,0-.37-.02-.7-.07-.97-.05-.27-.13-.5-.25-.68s-.29-.31-.5-.4c-.21-.08-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19ZM-71.2,360.99h2.35c.46,0,.81-.11,1.04-.33.24-.22.36-.54.36-.98,0-.26-.04-.47-.11-.64-.08-.16-.18-.29-.32-.38-.13-.09-.29-.15-.46-.18s-.35-.05-.53-.05h-2.33v2.56Z"
          />
          <path
            className="st7"
            d="M-64.56,357.26h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st7"
            d="M-57.34,357.26h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st8"
            d="M-99.8,300.04c1.43,0,2.51.37,3.25,1.1.73.73,1.1,1.76,1.1,3.09s-.37,2.36-1.1,3.1c-.73.74-1.82,1.11-3.25,1.09h-4.33v5.8h-1.89v-14.17h6.21ZM-100.43,306.83c1.07.01,1.86-.2,2.35-.65.5-.45.74-1.1.74-1.95s-.25-1.49-.74-1.94c-.5-.44-1.28-.66-2.35-.66h-3.69v5.2h3.69Z"
          />
          <path
            className="st8"
            d="M-83.84,300.04v1.59h-7.42v4.51h6.51v1.59h-6.51v6.49h-1.89v-14.17h9.31Z"
          />
          <path
            className="st8"
            d="M-82.12,304.34c.28-.89.71-1.68,1.28-2.37.57-.69,1.28-1.24,2.12-1.65.85-.41,1.83-.62,2.96-.62s2.11.21,2.96.62c.85.41,1.55.96,2.12,1.65.57.69,1,1.48,1.28,2.37.28.89.43,1.82.43,2.79s-.14,1.9-.43,2.79c-.29.89-.71,1.68-1.28,2.37-.57.69-1.28,1.23-2.12,1.64-.85.4-1.83.61-2.96.61s-2.11-.2-2.96-.61c-.85-.4-1.56-.95-2.12-1.64-.57-.69-1-1.48-1.28-2.37-.28-.89-.43-1.82-.43-2.79s.14-1.9.43-2.79ZM-80.38,309.24c.19.69.48,1.32.87,1.88s.91,1,1.53,1.34c.62.34,1.36.51,2.22.51s1.6-.17,2.22-.51c.62-.34,1.13-.78,1.53-1.34.4-.56.69-1.18.87-1.88.19-.69.28-1.4.28-2.11s-.09-1.42-.28-2.11c-.19-.69-.48-1.32-.87-1.88-.4-.56-.91-1-1.53-1.34-.62-.34-1.36-.51-2.22-.51s-1.6.17-2.22.51c-.62.34-1.13.78-1.53,1.34-.4.56-.69,1.18-.87,1.88s-.28,1.4-.28,2.11.09,1.42.28,2.11Z"
          />
          <path
            className="st8"
            d="M-60.73,300.04l5.54,14.17h-2.08l-1.55-4.27h-6l-1.59,4.27h-1.93l5.52-14.17h2.08ZM-59.42,308.36l-2.36-6.61h-.04l-2.4,6.61h4.8Z"
          />
          <polygon
            className="st6"
            points="-50.26 325.93 -52.46 325.93 -52.46 287.94 -108.82 287.94 -108.82 285.74 -50.26 285.74 -50.26 325.93"
          />
          <polygon
            className="st8"
            points="-55.93 328.85 -114.22 328.85 -114.22 286.84 -112.02 286.84 -112.02 326.65 -55.93 326.65 -55.93 328.85"
          />
          <path className="st1" d="M-104.52,293.42" />
          <rect
            className="st8"
            x="-109.63"
            y="306.53"
            width="54.57"
            height="2.21"
            transform="translate(-159.29 -1.39) rotate(-28.97)"
          />
          <polygon
            className="st6"
            points="-58.51 448.9 -60.71 448.9 -60.71 410.63 -104.8 410.63 -104.8 408.42 -58.51 408.42 -58.51 448.9"
          />
          <path className="st2" d="M-104.8,417.04" />
          <polygon
            className="st8"
            points="-59.61 455.82 -105.91 455.82 -105.91 414.79 -103.7 414.79 -103.7 453.61 -59.61 453.61 -59.61 455.82"
          />
          <path className="st3" d="M-59.61,446.06" />
          <path
            className="st8"
            d="M-82.36,441.25c-4.48,0-8.12-3.64-8.12-8.12,0-4.07,6.45-14.66,7.18-15.85l.94-1.53.94,1.53c.73,1.19,7.18,11.78,7.18,15.85,0,4.48-3.64,8.12-8.12,8.12ZM-82.36,420c-2.24,3.81-5.91,10.61-5.91,13.13,0,3.26,2.65,5.91,5.91,5.91s5.91-2.65,5.91-5.91c0-2.52-3.68-9.32-5.91-13.13Z"
          />
          <path
            className="st8"
            d="M-296.87,488.57c0,.31.05.58.16.8.11.22.26.4.45.54.19.14.41.24.66.31.25.07.52.1.81.1.31,0,.58-.04.8-.11.22-.07.4-.17.54-.28.14-.11.24-.25.3-.4.06-.15.09-.3.09-.45,0-.31-.07-.54-.21-.69-.14-.15-.3-.25-.46-.32-.29-.11-.63-.21-1.01-.3-.39-.1-.86-.22-1.43-.37-.35-.09-.64-.21-.88-.36-.23-.15-.42-.32-.56-.5-.14-.18-.24-.38-.29-.58-.06-.21-.09-.42-.09-.63,0-.41.09-.77.26-1.07.17-.3.4-.55.68-.75.28-.2.6-.35.96-.44s.72-.14,1.09-.14c.43,0,.83.06,1.21.17.38.11.71.28,1,.5.29.22.51.5.68.82.17.33.25.7.25,1.13h-1.43c-.04-.53-.22-.9-.54-1.12-.32-.22-.73-.33-1.23-.33-.17,0-.34.02-.52.05-.18.03-.34.09-.48.17s-.27.19-.36.33c-.1.14-.14.31-.14.52,0,.29.09.52.27.68s.41.29.71.37c.03,0,.15.04.36.1.21.06.45.12.71.19.26.07.51.14.76.2s.43.11.53.14c.27.08.5.2.7.34.2.15.37.31.5.5.13.19.23.39.3.6.06.21.1.43.1.64,0,.46-.09.85-.28,1.18-.19.33-.43.59-.74.8-.31.21-.65.36-1.04.45-.39.1-.79.14-1.19.14-.47,0-.91-.06-1.32-.17-.41-.11-.77-.29-1.08-.53s-.55-.54-.73-.91-.28-.81-.29-1.31h1.43Z"
          />
          <path
            className="st8"
            d="M-291.16,483.11h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <path
            className="st8"
            d="M-282.45,483.11h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM-282.95,488.04h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st8"
            d="M-275.7,488.09l-3.07-4.98h1.66l2.17,3.67,2.13-3.67h1.61l-3.06,4.98v3.21h-1.43v-3.21Z"
          />
          <path
            className="st8"
            d="M-267.25,483.11h1.43v3.26h3.73v-3.26h1.43v8.19h-1.43v-3.69h-3.73v3.69h-1.43v-8.19Z"
          />
          <path
            className="st8"
            d="M-255.45,482.91c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.37.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66c-.18.52-.44.97-.77,1.36s-.75.7-1.23.92c-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65.44-.97.77-1.37c.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34ZM-255.45,484.08c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15.24.71.44,1c.2.29.46.53.77.71.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1s.14-.76.14-1.15-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st8"
            d="M-251,483.11h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <path
            className="st8"
            d="M-239.05,490.38c-.31.37-.64.65-1.01.82-.37.17-.8.26-1.28.26-.37,0-.72-.06-1.04-.17-.32-.11-.59-.27-.82-.48-.23-.21-.41-.46-.53-.76s-.19-.64-.19-1.03c0-.29.05-.55.16-.79.11-.24.25-.45.42-.65.18-.19.38-.37.6-.52.23-.15.46-.29.69-.41-.11-.14-.21-.27-.31-.41-.1-.13-.19-.27-.26-.42-.08-.15-.14-.3-.18-.46-.05-.16-.07-.33-.07-.5,0-.3.05-.57.16-.8.1-.24.25-.44.43-.61s.4-.3.64-.4.5-.14.78-.14c.26,0,.51.04.76.12.25.08.47.2.65.37s.34.37.45.61.17.53.17.86c0,.24-.04.47-.12.68-.08.21-.19.4-.32.57-.13.17-.29.33-.47.46-.18.14-.37.26-.57.37l1.27,1.54c.05-.13.09-.28.14-.45.05-.17.08-.39.11-.65h1.15c-.04.36-.11.71-.21,1.06-.1.34-.25.66-.43.95l1.57,1.9h-1.61l-.75-.92ZM-241.35,487.51c-.12.08-.26.15-.4.23-.15.08-.28.17-.41.29-.13.12-.23.25-.32.41s-.13.36-.13.61c0,.44.12.78.37,1.02.25.24.56.36.95.36.24,0,.44-.03.61-.1.17-.07.31-.14.43-.24s.22-.19.3-.3c.08-.11.15-.2.21-.29l-1.61-2ZM-240.83,483.89c-.24,0-.45.08-.62.25-.17.16-.25.38-.25.66,0,.14.02.27.07.38.05.12.11.23.18.34.07.11.15.22.24.33s.17.21.25.31c.12-.08.24-.17.36-.26.11-.09.22-.18.31-.29s.16-.22.22-.35.08-.28.08-.44c0-.27-.08-.49-.23-.67s-.36-.27-.61-.27Z"
          />
          <path
            className="st8"
            d="M-230.46,485.71c-.06-.24-.15-.45-.25-.65s-.24-.37-.41-.52c-.17-.15-.37-.26-.59-.34-.23-.08-.49-.12-.79-.12-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15.24.71.44,1c.2.29.46.53.77.71.32.18.69.26,1.13.26.32,0,.6-.06.85-.17.24-.11.45-.26.63-.46.18-.19.31-.42.41-.68.1-.26.16-.54.19-.84h1.4c-.03.49-.14.94-.32,1.34s-.42.76-.73,1.05c-.31.29-.67.52-1.08.68-.41.16-.87.24-1.36.24-.61,0-1.16-.11-1.65-.34-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65.44-.97.77-1.37c.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34.46,0,.89.06,1.3.19.41.13.76.31,1.07.55s.56.53.75.88c.19.34.31.74.36,1.18h-1.43Z"
          />
          <path
            className="st8"
            d="M-224.22,482.91c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.37.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66c-.18.52-.44.97-.77,1.36s-.75.7-1.23.92c-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65.44-.97.77-1.37c.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34ZM-224.22,484.08c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15.24.71.44,1c.2.29.46.53.77.71.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1s.14-.76.14-1.15-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st8"
            d="M-218.99,483.11h1.43v6.95h4.16v1.24h-5.6v-8.19Z"
          />
          <path
            className="st8"
            d="M-212.41,483.11h3.39c.63,0,1.17.11,1.63.32.46.21.83.51,1.12.88.29.37.51.8.65,1.3.14.5.21,1.03.21,1.59s-.07,1.1-.21,1.59c-.14.5-.36.93-.65,1.3-.29.37-.67.66-1.12.88-.46.21-1,.32-1.63.32h-3.39v-8.19ZM-210.97,490.13h1.41c.56,0,1.01-.07,1.37-.22.36-.15.63-.36.84-.62.2-.26.34-.57.41-.93.07-.36.11-.74.11-1.15s-.04-.8-.11-1.15c-.07-.36-.21-.67-.41-.93-.2-.26-.48-.47-.84-.62-.36-.15-.81-.22-1.37-.22h-1.41v5.85Z"
          />
          <path
            className="st8"
            d="M-110.81,483.11h1.51l3.74,6.03h.02v-6.03h1.36v8.19h-1.51l-3.73-6.02h-.03v6.02h-1.36v-8.19Z"
          />
          <path
            className="st8"
            d="M-98.98,482.91c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.37s.27,1.07.27,1.65-.09,1.14-.27,1.66-.44.97-.77,1.36-.75.7-1.23.92c-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92-.34-.39-.59-.84-.77-1.36s-.27-1.07-.27-1.66.09-1.13.27-1.65.44-.97.77-1.37c.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34ZM-98.98,484.08c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15.24.71.44,1c.2.29.46.53.77.71s.69.26,1.13.26.81-.09,1.13-.26.58-.41.77-.71c.2-.29.35-.63.44-1s.14-.76.14-1.15-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st8"
            d="M-89.63,488.57c0,.31.05.58.16.8.11.22.26.4.45.54.19.14.41.24.66.31.25.07.52.1.81.1.31,0,.58-.04.8-.11.22-.07.4-.17.54-.28.14-.11.24-.25.3-.4.06-.15.09-.3.09-.45,0-.31-.07-.54-.21-.69s-.3-.25-.46-.32c-.29-.11-.63-.21-1.01-.3-.39-.1-.86-.22-1.43-.37-.35-.09-.64-.21-.88-.36-.23-.15-.42-.32-.56-.5s-.24-.38-.29-.58c-.06-.21-.09-.42-.09-.63,0-.41.09-.77.26-1.07.17-.3.4-.55.68-.75.28-.2.6-.35.96-.44s.72-.14,1.09-.14c.43,0,.83.06,1.21.17.38.11.71.28,1,.5.29.22.51.5.68.82.17.33.25.7.25,1.13h-1.43c-.04-.53-.22-.9-.54-1.12-.32-.22-.73-.33-1.23-.33-.17,0-.34.02-.52.05-.18.03-.34.09-.48.17-.15.08-.27.19-.36.33-.1.14-.14.31-.14.52,0,.29.09.52.27.68s.41.29.71.37c.03,0,.15.04.36.1.21.06.45.12.71.19.26.07.51.14.76.2.25.07.43.11.53.14.27.08.5.2.7.34.2.15.37.31.5.5.13.19.23.39.3.6.07.21.1.43.1.64,0,.46-.09.85-.28,1.18-.19.33-.43.59-.74.8-.31.21-.65.36-1.04.45-.39.1-.79.14-1.19.14-.47,0-.91-.06-1.32-.17-.41-.11-.77-.29-1.08-.53s-.55-.54-.73-.91-.28-.81-.29-1.31h1.43Z"
          />
          <path
            className="st8"
            d="M-83.94,483.11h1.46l1.48,6.26h.02l1.65-6.26h1.47l1.61,6.26h.02l1.53-6.26h1.46l-2.26,8.19h-1.46l-1.64-6.26h-.02l-1.67,6.26h-1.48l-2.16-8.19Z"
          />
          <path
            className="st8"
            d="M-72.31,483.11h5.89v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.97v-8.19Z"
          />
          <path
            className="st8"
            d="M-62.89,483.11h1.52l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM-63.4,488.04h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st8"
            d="M-59.27,483.11h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <rect
            className="st6"
            x="-251.17"
            y="405.54"
            width="2.21"
            height="23.46"
          />
          <rect
            className="st6"
            x="-251.29"
            y="411.9"
            width="9.55"
            height="2.21"
            transform="translate(-364.24 -53.34) rotate(-45)"
          />
          <rect
            className="st6"
            x="-254.37"
            y="408.23"
            width="2.21"
            height="9.55"
            transform="translate(-366.23 -58.11) rotate(-45)"
          />
          <rect
            className="st6"
            x="-263.91"
            y="413.54"
            width="2.21"
            height="9.55"
            transform="translate(-117.21 -53.76) rotate(-15)"
          />
          <path className="st2" d="M-261.57,422.92" />
          <path className="st2" d="M-270.79,425.39" />
          <rect
            className="st6"
            x="-251.17"
            y="405.54"
            width="2.21"
            height="48.45"
            transform="translate(-497.22 -1.68) rotate(-60)"
          />
          <path className="st2" d="M-238.56,436.62" />
          <path className="st2" d="M-236.09,445.84" />
          <rect
            className="st6"
            x="-238.72"
            y="434.28"
            width="9.55"
            height="2.21"
            transform="translate(-120.72 -45.73) rotate(-15.01)"
          />
          <rect
            className="st6"
            x="-250.97"
            y="422.42"
            width="23.46"
            height="2.21"
            transform="translate(-243.81 -62.88) rotate(-30)"
          />
          <rect
            className="st6"
            x="-234.88"
            y="419.69"
            width="2.21"
            height="9.55"
            transform="translate(-583.28 88.81) rotate(-75)"
          />
          <rect
            className="st6"
            x="-241.92"
            y="417.52"
            width="9.55"
            height="2.21"
            transform="translate(-580.08 81.16) rotate(-74.99)"
          />
          <path className="st2" d="M-231.69,446.39" />
          <rect
            className="st7"
            x="-255.29"
            y="449.75"
            width="2.21"
            height="9.7"
          />
          <path
            className="st7"
            d="M-253.25,450.47c-2.58,0-5.19-.65-7.58-2.03-6.94-4.01-9.53-12.69-6.08-19.79l-7.62-4.39,1.1-1.91,9.5,5.47-.55.96c-3.58,6.21-1.45,14.17,4.76,17.76,6.21,3.58,14.17,1.45,17.76-4.76l.55-.95,9.82,5.65-1.1,1.91-7.94-4.57c-2.9,4.28-7.7,6.66-12.61,6.66Z"
          />
          <rect
            className="st7"
            x="-274.76"
            y="443.11"
            width="9.35"
            height="2.21"
            transform="translate(-257.56 -75.51) rotate(-29.92)"
          />
          <path className="st2" d="M-277.24,439.34" />
          <path className="st2" d="M-269.6,437.21" />
          <polygon
            className="st8"
            points="-82.41 450.61 -99.58 441.45 -98.55 439.51 -82.47 448.08 -68.04 439.53 -66.91 441.43 -82.41 450.61"
          />
          <polygon
            className="st8"
            points="-98.47 445.67 -100.05 439.88 -94.26 438.3 -93.68 440.43 -97.34 441.43 -96.34 445.08 -98.47 445.67"
          />
          <rect
            className="st5"
            x="-289.58"
            y="269.84"
            width="74.6"
            height="74.6"
          />
          <rect
            className="st5"
            x="-119.51"
            y="269.84"
            width="74.6"
            height="74.6"
          />
          <rect
            className="st5"
            x="-289.58"
            y="394.82"
            width="74.6"
            height="74.6"
          />
          <rect
            className="st5"
            x="-119.51"
            y="394.82"
            width="74.6"
            height="74.6"
          />
        </g>
      </g>
      <g
        className={clsx({
          animation_left: showAnimation,
          complete: !showAnimation,
        })}
      >
        <polygon
          className="st6"
          points="777.68 656.26 775.47 656.26 775.47 653.74 761.05 653.74 761.05 656.26 758.85 656.26 758.85 651.53 777.68 651.53 777.68 656.26"
        />
        <g>
          <path
            className="st8"
            d="M94.31,555.49c-2.07,0-3.12-1.18-3.97-2.13-.79-.89-1.29-1.39-2.32-1.39s-1.53.5-2.32,1.39c-.85.95-1.9,2.13-3.97,2.13s-3.12-1.18-3.97-2.13c-.79-.89-1.29-1.39-2.32-1.39v-2.21c2.07,0,3.12,1.18,3.97,2.13.79.89,1.29,1.39,2.32,1.39s1.53-.5,2.32-1.39c.85-.95,1.9-2.13,3.97-2.13s3.12,1.18,3.97,2.13c.79.89,1.29,1.39,2.32,1.39s1.53-.5,2.32-1.39c.85-.95,1.9-2.13,3.97-2.13v2.21c-1.03,0-1.53.5-2.32,1.39-.85.95-1.9,2.13-3.97,2.13Z"
          />
          <polygon
            className="st6"
            points="106.79 570.6 104.58 570.6 104.58 530.69 69.8 530.69 69.8 528.48 106.79 528.48 106.79 570.6"
          />
          <polygon
            className="st8"
            points="106.56 576.07 69.14 576.07 69.14 534.87 71.35 534.87 71.35 573.87 106.56 573.87 106.56 576.07"
          />
          <path
            className="st8"
            d="M47.96,603.17h3.39c.63,0,1.17.11,1.63.32.46.21.83.51,1.12.88.29.37.51.8.65,1.3.14.5.21,1.03.21,1.59s-.07,1.1-.21,1.59c-.14.5-.36.93-.65,1.3-.29.37-.67.66-1.12.88-.46.21-1,.32-1.63.32h-3.39v-8.19ZM49.4,610.19h1.41c.56,0,1.01-.07,1.37-.22.36-.15.63-.36.84-.62.2-.26.34-.57.41-.93.07-.36.11-.74.11-1.15s-.04-.8-.11-1.15c-.07-.36-.21-.67-.41-.93-.2-.26-.48-.47-.84-.62-.36-.15-.81-.22-1.37-.22h-1.41v5.85Z"
          />
          <path
            className="st8"
            d="M59.73,602.98c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.37.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66c-.18.52-.44.97-.77,1.36s-.75.7-1.23.92c-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65.44-.97.77-1.37c.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34ZM59.73,604.15c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15.24.71.44,1c.2.29.46.53.77.71.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1s.14-.76.14-1.15-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st8"
            d="M64.87,603.17h1.43v4.77c0,.28.01.55.04.84s.1.54.23.76c.13.23.32.41.57.56s.62.22,1.08.22.83-.07,1.08-.22c.26-.15.45-.33.57-.56.13-.23.2-.48.23-.76.03-.28.04-.56.04-.84v-4.77h1.43v5.24c0,.53-.08.99-.24,1.38-.16.39-.39.72-.68.98-.29.26-.65.46-1.06.59-.41.13-.87.2-1.38.2s-.96-.07-1.38-.2c-.41-.13-.77-.33-1.06-.59s-.52-.59-.68-.98c-.16-.39-.24-.85-.24-1.38v-5.24Z"
          />
          <path
            className="st8"
            d="M73.24,603.17h3.98c.73,0,1.32.17,1.77.5s.67.85.67,1.53c0,.41-.1.77-.3,1.06-.2.29-.49.52-.87.68v.02c.5.11.89.35,1.15.72.26.37.39.84.39,1.39,0,.32-.06.62-.17.9s-.29.52-.54.72c-.24.2-.56.36-.94.48-.38.12-.84.18-1.37.18h-3.76v-8.19ZM74.67,606.6h2.34c.34,0,.63-.1.86-.29.23-.19.34-.48.34-.84,0-.41-.1-.7-.31-.87-.21-.17-.5-.25-.89-.25h-2.34v2.26ZM74.67,610.19h2.53c.44,0,.77-.11,1.01-.34.24-.23.36-.54.36-.96s-.12-.72-.36-.93-.58-.33-1.01-.33h-2.53v2.56Z"
          />
          <path
            className="st8"
            d="M81.31,603.17h1.43v6.95h4.16v1.24h-5.6v-8.19Z"
          />
          <path
            className="st8"
            d="M87.9,603.17h5.89v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st8"
            d="M97.51,603.17h1.46l1.48,6.26h.02l1.65-6.26h1.47l1.61,6.26h.02l1.53-6.26h1.46l-2.26,8.19h-1.46l-1.64-6.26h-.02l-1.67,6.26h-1.48l-2.16-8.19Z"
          />
          <path
            className="st8"
            d="M111.04,603.17h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM110.54,608.1h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st8"
            d="M116.5,603.17h1.43v6.95h4.16v1.24h-5.6v-8.19Z"
          />
          <path
            className="st8"
            d="M123.08,603.17h1.43v6.95h4.16v1.24h-5.6v-8.19Z"
          />
          <path
            className="st8"
            d="M101.71,570.16h-27.37v-35.07h27.37v35.07ZM76.54,567.96h22.96v-30.66h-22.96v30.66Z"
          />
          <rect
            className="st5"
            x="50.44"
            y="514.87"
            width="74.6"
            height="74.6"
          />
        </g>
        <g>
          <polygon
            className="st8"
            points="278.35 573.89 236.43 573.89 236.43 535.93 238.63 535.93 238.63 571.68 278.35 571.68 278.35 573.89"
          />
          <path
            className="st8"
            d="M217.88,603.17h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <path
            className="st8"
            d="M225.43,603.17h1.43v3.26h3.73v-3.26h1.43v8.19h-1.43v-3.69h-3.73v3.69h-1.43v-8.19Z"
          />
          <path
            className="st8"
            d="M233.74,603.17h3.91c.9,0,1.58.19,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97-.11.26-.25.46-.4.62-.15.16-.3.27-.45.34s-.26.11-.33.14v.02c.12.02.25.05.4.11.14.06.27.16.4.29.12.13.22.31.3.52.08.21.12.48.12.8,0,.48.04.92.11,1.31.07.39.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58-.02-.21-.03-.42-.03-.62,0-.37-.02-.7-.07-.97s-.13-.5-.25-.68-.29-.31-.5-.4-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19ZM235.18,606.9h2.35c.46,0,.81-.11,1.04-.33s.36-.54.36-.98c0-.26-.04-.47-.11-.64s-.18-.29-.32-.38-.29-.15-.46-.18-.35-.05-.53-.05h-2.33v2.56Z"
          />
          <path
            className="st8"
            d="M241.82,603.17h5.89v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.97v-8.19Z"
          />
          <path
            className="st8"
            d="M249.04,603.17h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st8"
            d="M259.46,603.17h1.43v6.95h4.16v1.24h-5.6v-8.19Z"
          />
          <path
            className="st8"
            d="M268.23,603.17h1.52l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM267.72,608.1h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st8"
            d="M274.97,608.15l-3.07-4.98h1.66l2.17,3.67,2.13-3.67h1.61l-3.06,4.98v3.21h-1.43v-3.21Z"
          />
          <path
            className="st8"
            d="M280.27,603.17h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st8"
            d="M287.5,603.17h3.91c.9,0,1.58.19,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97s-.25.46-.4.62-.3.27-.45.34-.26.11-.33.14v.02c.12.02.25.05.4.11s.27.16.4.29c.12.13.22.31.3.52.08.21.12.48.12.8,0,.48.04.92.11,1.31.07.39.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58-.02-.21-.03-.42-.03-.62,0-.37-.02-.7-.07-.97s-.13-.5-.25-.68c-.12-.18-.29-.31-.5-.4s-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19ZM288.93,606.9h2.35c.46,0,.81-.11,1.04-.33s.36-.54.36-.98c0-.26-.04-.47-.12-.64s-.18-.29-.32-.38-.29-.15-.46-.18c-.17-.03-.35-.05-.53-.05h-2.33v2.56Z"
          />
          <path
            className="st8"
            d="M296.51,608.63c0,.31.05.58.16.8.11.22.26.4.45.54.19.14.41.24.66.31.25.07.52.1.81.1.31,0,.58-.04.8-.11.22-.07.4-.17.54-.28s.24-.25.3-.4c.06-.15.09-.3.09-.45,0-.31-.07-.54-.21-.69-.14-.15-.3-.25-.46-.32-.29-.11-.63-.21-1.01-.3-.39-.1-.86-.22-1.43-.37-.35-.09-.64-.21-.88-.36-.23-.15-.42-.32-.56-.5-.14-.18-.24-.38-.29-.58-.06-.21-.09-.42-.09-.63,0-.41.09-.77.26-1.07s.4-.55.68-.75c.28-.2.6-.35.96-.44s.72-.14,1.09-.14c.43,0,.83.06,1.21.17.38.11.71.28,1,.5.29.22.51.5.68.82.17.33.25.7.25,1.13h-1.43c-.04-.53-.22-.9-.54-1.12-.32-.22-.73-.33-1.23-.33-.17,0-.34.02-.52.05-.18.03-.34.09-.48.17-.15.08-.27.19-.36.33-.1.14-.14.31-.14.52,0,.29.09.52.27.68.18.16.41.29.71.37.03,0,.15.04.36.1.21.06.45.12.71.19.26.07.51.14.76.2.25.07.43.11.53.14.27.08.5.2.7.34.2.15.37.31.5.5.13.19.23.39.3.6s.1.43.1.64c0,.46-.09.85-.28,1.18-.19.33-.43.59-.74.8-.31.21-.65.36-1.04.45s-.79.14-1.19.14c-.47,0-.91-.06-1.32-.17-.41-.11-.77-.29-1.08-.53s-.55-.54-.73-.91-.28-.81-.29-1.31h1.43Z"
          />
          <path
            className="st8"
            d="M277.33,547.77h-13.36c-.61,0-1.1-.49-1.1-1.1v-13.36h2.21v12.26h12.26v2.21Z"
          />
          <path
            className="st8"
            d="M277.33,556.27h-21.85c-.61,0-1.1-.49-1.1-1.1v-21.85h2.21v20.75h20.75v2.21Z"
          />
          <path
            className="st8"
            d="M277.33,566.87h-32.46c-.61,0-1.1-.49-1.1-1.1v-32.46h2.21v31.36h31.36v2.21Z"
          />
          <rect
            className="st8"
            x="254.32"
            y="539.23"
            width="11.23"
            height="2.21"
            transform="translate(-302.35 332.09) rotate(-43.99)"
          />
          <rect
            className="st8"
            x="254.32"
            y="548.44"
            width="11.23"
            height="2.21"
            transform="translate(-308.74 334.67) rotate(-43.99)"
          />
          <rect
            className="st8"
            x="261.94"
            y="549.92"
            width="12.6"
            height="2.21"
            transform="translate(-307.9 342.13) rotate(-44.11)"
          />
          <rect
            className="st8"
            x="250.5"
            y="541.44"
            width="2.21"
            height="2.87"
          />
          <rect
            className="st8"
            x="248.56"
            y="547.49"
            width="2.21"
            height="2.87"
          />
          <rect
            className="st8"
            x="250.26"
            y="553.53"
            width="2.21"
            height="2.87"
          />
          <rect
            className="st8"
            x="248.56"
            y="559.57"
            width="2.21"
            height="2.87"
          />
          <rect
            className="st8"
            x="259.92"
            y="559.57"
            width="2.21"
            height="2.87"
          />
          <rect
            className="st8"
            x="271.28"
            y="559.57"
            width="2.21"
            height="2.87"
          />
          <rect
            className="st8"
            x="254.24"
            y="558.14"
            width="2.21"
            height="2.87"
          />
          <rect
            className="st8"
            x="265.6"
            y="558.14"
            width="2.21"
            height="2.87"
          />
          <polygon
            className="st6"
            points="279.45 569.13 277.24 569.13 277.24 533.07 237.53 533.07 237.53 530.87 279.45 530.87 279.45 569.13"
          />
          <rect
            className="st5"
            x="220.52"
            y="514.87"
            width="74.6"
            height="74.6"
          />
        </g>
        <g>
          <path
            className="st8"
            d="M403.16,603.17h5.65v1.24h-4.22v2.14h3.7v1.17h-3.7v3.64h-1.43v-8.19Z"
          />
          <path
            className="st8"
            d="M409.96,603.17h3.91c.9,0,1.58.19,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97-.11.26-.25.46-.4.62-.15.16-.3.27-.45.34s-.26.11-.33.14v.02c.12.02.25.05.4.11.14.06.27.16.4.29.12.13.22.31.3.52.08.21.12.48.12.8,0,.48.04.92.11,1.31.07.39.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58-.02-.21-.03-.42-.03-.62,0-.37-.02-.7-.07-.97s-.13-.5-.25-.68-.29-.31-.5-.4-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19ZM411.39,606.9h2.35c.46,0,.81-.11,1.04-.33s.36-.54.36-.98c0-.26-.04-.47-.11-.64s-.18-.29-.32-.38-.29-.15-.46-.18-.35-.05-.53-.05h-2.33v2.56Z"
          />
          <path
            className="st8"
            d="M418.03,603.17h5.89v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st8"
            d="M425.26,603.17h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st8"
            d="M432.24,603.17h6.23v1.09l-4.77,5.86h4.89v1.24h-6.71v-1.17l4.77-5.78h-4.4v-1.24Z"
          />
          <path
            className="st8"
            d="M439.71,603.17h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st8"
            d="M446.94,603.17h3.91c.9,0,1.58.19,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97s-.25.46-.4.62c-.15.16-.3.27-.45.34s-.26.11-.33.14v.02c.12.02.25.05.4.11.14.06.27.16.4.29.12.13.22.31.3.52.08.21.12.48.12.8,0,.48.04.92.11,1.31.07.39.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58-.02-.21-.03-.42-.03-.62,0-.37-.02-.7-.07-.97-.05-.27-.13-.5-.25-.68-.12-.18-.29-.31-.5-.4s-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19ZM448.37,606.9h2.35c.46,0,.81-.11,1.04-.33s.36-.54.36-.98c0-.26-.04-.47-.12-.64-.08-.16-.18-.29-.32-.38-.13-.09-.29-.15-.46-.18-.17-.03-.35-.05-.53-.05h-2.33v2.56Z"
          />
          <rect
            className="st8"
            x="426.79"
            y="535.49"
            width="2.21"
            height="16.36"
          />
          <rect
            className="st8"
            x="427.04"
            y="539.59"
            width="6.66"
            height="2.21"
            transform="translate(-256.28 462.68) rotate(-45)"
          />
          <rect
            className="st8"
            x="424.56"
            y="537.37"
            width="2.21"
            height="6.66"
            transform="translate(-257.66 459.35) rotate(-45)"
          />
          <rect
            className="st8"
            x="419.71"
            y="539.58"
            width="2.21"
            height="16.36"
            transform="translate(-263.97 638.33) rotate(-60)"
          />
          <rect
            className="st8"
            x="418.37"
            y="540.8"
            width="2.21"
            height="6.66"
            transform="translate(-126.55 127.12) rotate(-15)"
          />
          <rect
            className="st8"
            x="413.79"
            y="547.1"
            width="6.66"
            height="2.21"
            transform="translate(-127.73 126.71) rotate(-15.01)"
          />
          <rect
            className="st8"
            x="412.63"
            y="554.84"
            width="16.36"
            height="2.21"
            transform="translate(-221.59 284.89) rotate(-30)"
          />
          <rect
            className="st8"
            x="415.89"
            y="551.95"
            width="2.21"
            height="6.66"
            transform="translate(-227.28 814.37) rotate(-75)"
          />
          <rect
            className="st8"
            x="416.02"
            y="558.26"
            width="6.66"
            height="2.21"
            transform="translate(-229.42 819.8) rotate(-75.01)"
          />
          <rect
            className="st8"
            x="426.79"
            y="551.85"
            width="2.21"
            height="16.36"
          />
          <rect
            className="st8"
            x="422.08"
            y="561.9"
            width="6.66"
            height="2.21"
            transform="translate(-273.5 465.71) rotate(-45)"
          />
          <rect
            className="st8"
            x="429.02"
            y="559.67"
            width="2.21"
            height="6.66"
            transform="translate(-272.12 469.01) rotate(-45)"
          />
          <rect
            className="st8"
            x="433.87"
            y="547.76"
            width="2.21"
            height="16.36"
            transform="translate(-263.97 654.66) rotate(-60)"
          />
          <rect
            className="st8"
            x="435.21"
            y="556.24"
            width="2.21"
            height="6.66"
            transform="translate(-129.98 132.02) rotate(-15)"
          />
          <rect
            className="st8"
            x="435.34"
            y="554.39"
            width="6.66"
            height="2.21"
            transform="translate(-128.88 132.54) rotate(-15.01)"
          />
          <rect
            className="st8"
            x="426.8"
            y="546.66"
            width="16.36"
            height="2.21"
            transform="translate(-215.61 290.88) rotate(-30)"
          />
          <rect
            className="st8"
            x="437.69"
            y="545.09"
            width="2.21"
            height="6.66"
            transform="translate(-204.52 830.3) rotate(-75)"
          />
          <rect
            className="st8"
            x="433.11"
            y="543.24"
            width="6.66"
            height="2.21"
            transform="translate(-202.35 824.93) rotate(-74.99)"
          />
          <path className="st3" d="M414.27,557.57" />
          <polygon
            className="st6"
            points="450.64 568.47 448.43 568.47 448.43 530.16 406.25 530.16 406.25 527.96 450.64 527.96 450.64 568.47"
          />
          <polygon
            className="st8"
            points="449.54 573.45 405.15 573.45 405.15 533.26 407.35 533.26 407.35 571.25 449.54 571.25 449.54 573.45"
          />
          <rect
            className="st5"
            x="390.59"
            y="514.87"
            width="74.6"
            height="74.6"
          />
        </g>
        <g>
          <polygon
            className="st6"
            points="620.71 568.47 618.5 568.47 618.5 530.16 576.32 530.16 576.32 527.96 620.71 527.96 620.71 568.47"
          />
          <polygon
            className="st8"
            points="619.6 573.45 575.21 573.45 575.21 533.26 577.42 533.26 577.42 571.25 619.6 571.25 619.6 573.45"
          />
          <path
            className="st7"
            d="M604.72,562.92h-13.52c-2.64,0-4.78-2.14-4.78-4.78v-18.4h2.21v18.4c0,1.42,1.15,2.57,2.57,2.57h13.52c1.42,0,2.57-1.15,2.57-2.57v-18.4h2.21v18.4c0,2.64-2.14,4.78-4.78,4.78Z"
          />
          <polygon
            className="st7"
            points="606.29 566.43 589.63 566.43 589.63 562.32 591.84 562.32 591.84 564.22 604.08 564.22 604.08 562.32 606.29 562.32 606.29 566.43"
          />
          <path
            className="st8"
            d="M571.92,594.98h1.51l3.74,6.03h.02v-6.03h1.37v8.19h-1.51l-3.73-6.02h-.03v6.02h-1.37v-8.19Z"
          />
          <path
            className="st8"
            d="M583.74,594.79c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.36.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66-.44.97-.77,1.36c-.34.39-.75.7-1.23.92-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34ZM583.74,595.96c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1,.1-.37.14-.76.14-1.15s-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st8"
            d="M588.92,594.98h1.51l3.74,6.03h.02v-6.03h1.37v8.19h-1.51l-3.73-6.02h-.03v6.02h-1.37v-8.19Z"
          />
          <path className="st8" d="M596.94,599.43h3.34v1.24h-3.34v-1.24Z" />
          <path
            className="st8"
            d="M602.66,600.44c0,.31.05.58.16.8.11.22.26.4.45.54.19.14.41.24.66.31.25.07.52.1.81.1.31,0,.58-.04.8-.11.22-.07.4-.17.54-.28.14-.11.24-.25.3-.4.06-.15.09-.3.09-.45,0-.31-.07-.54-.21-.69s-.3-.25-.46-.32c-.29-.11-.63-.21-1.01-.3-.39-.1-.86-.22-1.43-.37-.35-.09-.64-.21-.88-.36-.23-.15-.42-.32-.56-.5-.14-.18-.24-.38-.29-.58s-.09-.42-.09-.63c0-.41.09-.77.26-1.07.17-.3.4-.55.68-.75.28-.2.6-.35.96-.44s.72-.14,1.09-.14c.43,0,.83.06,1.21.17.38.11.71.28,1,.5.29.22.51.49.68.82.17.32.25.7.25,1.13h-1.43c-.04-.53-.22-.9-.54-1.12-.32-.22-.73-.33-1.23-.33-.17,0-.34.02-.52.05s-.34.09-.48.17c-.15.08-.27.19-.36.33-.1.14-.14.31-.14.52,0,.29.09.52.27.68s.41.29.71.37c.03,0,.15.04.36.1s.45.12.71.19c.26.07.51.14.76.2.25.07.43.11.53.14.27.08.5.2.7.34.2.15.36.31.5.5s.23.39.3.6.1.43.1.64c0,.46-.09.85-.28,1.18s-.43.59-.74.8-.65.36-1.04.45c-.39.1-.79.14-1.19.14-.47,0-.91-.06-1.32-.17-.41-.11-.77-.29-1.08-.53s-.55-.54-.73-.91-.28-.81-.29-1.31h1.43Z"
          />
          <path
            className="st8"
            d="M609.15,594.98h1.43v6.95h4.16v1.24h-5.6v-8.19Z"
          />
          <path className="st8" d="M615.73,594.98h1.43v8.19h-1.43v-8.19Z" />
          <path
            className="st8"
            d="M618.92,594.98h3.61c.58,0,1.05.08,1.42.25.37.17.65.38.85.63.2.25.33.53.41.83.07.3.11.57.11.83s-.04.53-.11.82c-.07.29-.21.57-.41.82-.2.25-.48.46-.85.63-.37.16-.84.25-1.42.25h-2.18v3.14h-1.43v-8.19ZM620.35,598.86h2.1c.16,0,.32-.02.49-.07.17-.05.32-.12.46-.22.14-.1.26-.24.34-.41s.13-.39.13-.65-.04-.49-.12-.67c-.08-.18-.18-.32-.31-.42-.13-.1-.28-.17-.45-.21-.17-.04-.35-.06-.54-.06h-2.12v2.71Z"
          />
          <path
            className="st8"
            d="M547.52,614.2c0,.31.05.58.16.8.11.22.26.4.45.54.19.14.41.24.66.31.25.07.52.1.81.1.31,0,.58-.04.8-.11.22-.07.4-.17.54-.28.14-.11.24-.25.3-.4.06-.15.09-.3.09-.45,0-.31-.07-.54-.21-.69s-.3-.25-.46-.32c-.29-.11-.63-.21-1.01-.3-.39-.1-.86-.22-1.43-.37-.35-.09-.64-.21-.88-.36-.23-.15-.42-.32-.56-.5-.14-.18-.24-.38-.29-.58s-.09-.42-.09-.63c0-.41.09-.77.26-1.07.17-.3.4-.55.68-.75.28-.2.6-.35.96-.44s.72-.14,1.09-.14c.43,0,.83.06,1.21.17.38.11.71.28,1,.5.29.22.51.49.68.82.17.32.25.7.25,1.13h-1.43c-.04-.53-.22-.9-.54-1.12-.32-.22-.73-.33-1.23-.33-.17,0-.34.02-.52.05s-.34.09-.48.17c-.15.08-.27.19-.36.33-.1.14-.14.31-.14.52,0,.29.09.52.27.68s.41.29.71.37c.03,0,.15.04.36.1s.45.12.71.19c.26.07.51.14.76.2.25.07.43.11.53.14.27.08.5.2.7.34.2.15.36.31.5.5s.23.39.3.6.1.43.1.64c0,.46-.09.85-.28,1.18s-.43.59-.74.8-.65.36-1.04.45c-.39.1-.79.14-1.19.14-.47,0-.91-.06-1.32-.17-.41-.11-.77-.29-1.08-.53s-.55-.54-.73-.91-.28-.81-.29-1.31h1.43Z"
          />
          <path className="st8" d="M554.01,608.74h1.43v8.19h-1.43v-8.19Z" />
          <path
            className="st8"
            d="M557.2,608.74h1.43v6.95h4.16v1.24h-5.6v-8.19Z"
          />
          <path className="st8" d="M563.78,608.74h1.43v8.19h-1.43v-8.19Z" />
          <path
            className="st8"
            d="M572.5,611.35c-.06-.24-.15-.45-.25-.65-.11-.2-.24-.37-.41-.52-.17-.14-.37-.26-.59-.34-.23-.08-.49-.12-.79-.12-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26.32,0,.6-.06.85-.17s.45-.26.63-.46c.18-.2.31-.42.41-.68s.16-.54.2-.84h1.4c-.03.49-.14.94-.32,1.34-.18.41-.42.76-.73,1.05-.31.29-.67.52-1.08.68-.41.16-.87.24-1.36.24-.61,0-1.16-.11-1.65-.34-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34.46,0,.89.06,1.3.19.4.13.76.31,1.07.55s.56.53.75.88c.19.34.31.74.36,1.18h-1.43Z"
          />
          <path
            className="st8"
            d="M578.74,608.55c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.36.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66-.44.97-.77,1.36c-.34.39-.75.7-1.23.92-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34ZM578.74,609.72c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1,.1-.37.14-.76.14-1.15s-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st8"
            d="M583.91,608.74h1.51l3.74,6.03h.02v-6.03h1.37v8.19h-1.51l-3.73-6.02h-.03v6.02h-1.37v-8.19Z"
          />
          <path
            className="st8"
            d="M592.25,608.74h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st8"
            d="M602.66,608.74h3.98c.73,0,1.32.17,1.77.5.44.34.67.84.67,1.53,0,.41-.1.77-.3,1.06-.2.29-.49.52-.87.68v.02c.5.11.89.35,1.15.72.26.37.39.84.39,1.39,0,.32-.06.62-.17.9s-.29.52-.54.72c-.25.2-.56.36-.94.48-.38.12-.84.18-1.36.18h-3.76v-8.19ZM604.1,612.17h2.34c.34,0,.63-.1.86-.29.23-.19.34-.48.34-.84,0-.41-.1-.7-.31-.87-.21-.17-.5-.25-.89-.25h-2.34v2.26ZM604.1,615.76h2.53c.44,0,.77-.11,1.02-.34.24-.23.36-.54.36-.96s-.12-.72-.36-.93c-.24-.22-.58-.33-1.02-.33h-2.53v2.56Z"
          />
          <path
            className="st8"
            d="M614.22,608.55c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.36.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66-.44.97-.77,1.36c-.34.39-.75.7-1.23.92-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34ZM614.22,609.72c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1,.1-.37.14-.76.14-1.15s-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st8"
            d="M618.67,608.74h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <path
            className="st8"
            d="M625.47,608.74h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <path
            className="st8"
            d="M636.54,608.55c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.36.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66-.44.97-.77,1.36c-.34.39-.75.7-1.23.92-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34ZM636.54,609.72c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1,.1-.37.14-.76.14-1.15s-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st8"
            d="M641.75,608.74h2.02l2.26,6.41h.02l2.2-6.41h2v8.19h-1.37v-6.32h-.02l-2.27,6.32h-1.18l-2.27-6.32h-.02v6.32h-1.36v-8.19Z"
          />
          <rect
            className="st5"
            x="560.66"
            y="514.87"
            width="74.6"
            height="74.6"
          />
        </g>
        <g>
          <polygon
            className="st6"
            points="791.74 565.71 789.54 565.71 789.54 529.92 745.45 529.92 745.45 527.71 791.74 527.71 791.74 565.71"
          />
          <path
            className="st8"
            d="M791.74,575.11h-47.4v-41.03h2.21v35.14h45.19v5.88ZM746.55,572.9h42.99v-1.47h-42.99v1.47Z"
          />
          <path
            className="st8"
            d="M764.65,610.15h-.92l-.22-.96c-.38.44-.76.74-1.15.91-.38.17-.82.25-1.32.25-.61,0-1.16-.11-1.65-.34-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65.44-.97.77-1.37c.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34.44,0,.87.06,1.27.18.4.12.76.29,1.07.53.31.23.57.53.78.88.21.35.34.76.39,1.22h-1.4c-.04-.27-.12-.5-.25-.71s-.28-.37-.48-.51c-.19-.14-.4-.24-.64-.31-.24-.07-.49-.1-.75-.1-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15.24.71.44,1c.2.29.46.53.77.71s.69.26,1.13.26c.37,0,.69-.04.98-.14.28-.1.52-.25.72-.45.19-.2.34-.43.44-.72.1-.28.15-.6.16-.94h-2.18v-1.09h3.49v4.31Z"
          />
          <path
            className="st8"
            d="M768.4,601.96h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM767.9,606.89h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st8"
            d="M774.8,607.42c0,.31.05.58.16.8.11.22.26.4.45.54.19.14.41.24.66.31.25.07.52.1.81.1.31,0,.58-.04.8-.11.22-.07.4-.17.54-.28.14-.11.24-.25.3-.4.06-.15.09-.3.09-.45,0-.31-.07-.54-.21-.69s-.3-.25-.46-.32c-.29-.11-.63-.21-1.02-.3-.39-.1-.86-.22-1.43-.37-.35-.09-.64-.21-.88-.36-.23-.15-.42-.32-.56-.5s-.24-.38-.29-.58c-.06-.21-.09-.42-.09-.63,0-.41.09-.77.26-1.07.17-.3.4-.55.68-.75.28-.2.6-.35.96-.44.36-.1.72-.14,1.09-.14.43,0,.83.06,1.21.17.38.11.71.28,1,.5.29.22.51.5.68.82.17.33.25.7.25,1.13h-1.43c-.04-.53-.22-.9-.54-1.12-.32-.22-.73-.33-1.23-.33-.17,0-.34.02-.52.05-.18.03-.34.09-.48.17s-.27.19-.36.33c-.1.14-.14.31-.14.52,0,.29.09.52.27.68s.41.29.71.37c.03,0,.15.04.36.1.21.06.45.12.71.19.26.07.51.14.76.2s.43.11.53.14c.27.08.5.2.7.34.2.15.36.31.5.5.13.19.23.39.3.6.06.21.1.43.1.64,0,.46-.09.85-.28,1.18-.19.33-.43.59-.74.8-.31.21-.65.36-1.04.45-.39.1-.79.14-1.19.14-.47,0-.91-.06-1.32-.17-.41-.11-.77-.29-1.08-.53s-.55-.54-.73-.91-.28-.81-.29-1.31h1.43Z"
          />
          <path
            className="st7"
            d="M768.04,563.63c-3.5,0-6.79-1.36-9.27-3.84-2.48-2.48-3.84-5.77-3.84-9.27s1.36-6.79,3.84-9.27c2.48-2.48,5.77-3.84,9.27-3.84s6.79,1.36,9.27,3.84c2.48,2.48,3.84,5.77,3.84,9.27s-1.36,6.79-3.84,9.27c-2.48,2.48-5.77,3.84-9.27,3.84ZM768.04,539.63c-2.79,0-5.58,1.06-7.71,3.19-2.06,2.06-3.19,4.8-3.19,7.71s1.13,5.65,3.19,7.71c4.25,4.25,11.17,4.25,15.41,0,4.25-4.25,4.25-11.16,0-15.41-2.13-2.13-4.92-3.19-7.71-3.19Z"
          />
          <path
            className="st7"
            d="M768.04,556.36c-1.5,0-2.99-.57-4.13-1.71-2.28-2.28-2.28-5.98,0-8.26,2.28-2.28,5.98-2.28,8.26,0,2.28,2.28,2.28,5.98,0,8.26-1.14,1.14-2.63,1.71-4.13,1.71ZM768.04,546.89c-.93,0-1.86.35-2.57,1.06-1.42,1.42-1.42,3.72,0,5.14,1.42,1.42,3.72,1.42,5.14,0,1.42-1.42,1.42-3.72,0-5.14-.71-.71-1.64-1.06-2.57-1.06Z"
          />
          <rect
            className="st7"
            x="758.21"
            y="537.45"
            width="2.21"
            height="8.69"
            transform="translate(-160.71 695.64) rotate(-45)"
          />
          <rect
            className="st7"
            x="775.67"
            y="554.91"
            width="2.21"
            height="8.69"
            transform="translate(-167.94 713.06) rotate(-45)"
          />
          <rect
            className="st7"
            x="772.43"
            y="540.7"
            width="8.69"
            height="2.21"
            transform="translate(-155.6 707.95) rotate(-45)"
          />
          <rect
            className="st7"
            x="754.97"
            y="558.15"
            width="8.69"
            height="2.21"
            transform="translate(-173.05 700.72) rotate(-45)"
          />
          <rect
            className="st5"
            x="730.75"
            y="514.87"
            width="74.6"
            height="74.6"
          />
        </g>
        <g>
          <path
            className="st8"
            d="M911.27,601.96h5.89v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.97v-8.19Z"
          />
          <path
            className="st8"
            d="M918.5,601.96h1.43v6.95h4.16v1.24h-5.6v-8.19Z"
          />
          <path
            className="st8"
            d="M925.08,601.96h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st8"
            d="M937.83,604.56c-.06-.24-.15-.45-.25-.65-.11-.2-.24-.37-.41-.52-.17-.15-.37-.26-.59-.34-.23-.08-.49-.12-.79-.12-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15.24.71.44,1c.2.29.46.53.77.71s.69.26,1.13.26c.32,0,.6-.06.85-.17.24-.11.45-.26.63-.46.18-.19.31-.42.41-.68.1-.26.16-.54.19-.84h1.4c-.03.49-.14.94-.32,1.34s-.42.76-.73,1.05c-.31.29-.67.52-1.08.68-.41.16-.87.24-1.37.24-.61,0-1.16-.11-1.65-.34-.49-.23-.9-.53-1.23-.92-.34-.39-.59-.84-.77-1.36s-.27-1.07-.27-1.66.09-1.13.27-1.65.44-.97.77-1.37c.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34.46,0,.89.06,1.3.19.41.13.76.31,1.07.55.31.24.56.53.75.88s.31.74.36,1.18h-1.43Z"
          />
          <path
            className="st8"
            d="M939.81,601.96h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <path
            className="st8"
            d="M947.39,601.96h3.91c.9,0,1.58.19,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97s-.25.46-.4.62c-.15.16-.3.27-.45.34s-.26.11-.33.14v.02c.12.02.25.05.4.11.14.06.27.16.4.29.12.13.22.31.3.52.08.21.12.48.12.8,0,.48.04.92.11,1.31.07.39.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58-.02-.21-.03-.42-.03-.62,0-.37-.02-.7-.07-.97-.05-.27-.13-.5-.25-.68-.12-.18-.29-.31-.5-.4s-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19ZM948.82,605.69h2.35c.46,0,.81-.11,1.04-.33s.36-.54.36-.98c0-.26-.04-.47-.12-.64-.08-.16-.18-.29-.32-.38-.13-.09-.29-.15-.46-.18-.17-.03-.35-.05-.53-.05h-2.33v2.56Z"
          />
          <path className="st8" d="M955.46,601.96h1.43v8.19h-1.43v-8.19Z" />
          <path
            className="st8"
            d="M964.18,604.56c-.06-.24-.15-.45-.25-.65-.11-.2-.24-.37-.41-.52s-.37-.26-.59-.34c-.23-.08-.49-.12-.79-.12-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15.24.71.44,1c.2.29.46.53.77.71.32.18.69.26,1.13.26.32,0,.6-.06.85-.17.24-.11.45-.26.63-.46.18-.19.31-.42.41-.68.1-.26.16-.54.19-.84h1.4c-.03.49-.14.94-.32,1.34-.18.41-.42.76-.73,1.05s-.67.52-1.08.68c-.41.16-.87.24-1.37.24-.61,0-1.16-.11-1.65-.34-.49-.23-.9-.53-1.23-.92-.34-.39-.59-.84-.77-1.36-.18-.52-.27-1.07-.27-1.66s.09-1.13.27-1.65c.18-.52.44-.97.77-1.37.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34.46,0,.89.06,1.3.19.4.13.76.31,1.07.55s.56.53.75.88c.19.34.31.74.36,1.18h-1.43Z"
          />
          <polygon
            className="st6"
            points="961.82 565.71 959.61 565.71 959.61 529.92 915.52 529.92 915.52 527.71 961.82 527.71 961.82 565.71"
          />
          <path
            className="st8"
            d="M961.82,575.11h-47.4v-41.03h2.21v35.14h45.19v5.88ZM916.63,572.9h42.99v-1.47h-42.99v1.47Z"
          />
          <path
            className="st7"
            d="M938.12,563.75c-3.39,0-6.78-1.29-9.36-3.87-5.16-5.16-5.16-13.56,0-18.72,5.16-5.16,13.56-5.16,18.72,0h0c5.16,5.16,5.16,13.56,0,18.72-2.58,2.58-5.97,3.87-9.36,3.87ZM938.12,539.5c-2.82,0-5.65,1.08-7.8,3.22-4.3,4.3-4.3,11.3,0,15.6,4.3,4.3,11.3,4.3,15.6,0,4.3-4.3,4.3-11.3,0-15.6-2.15-2.15-4.97-3.22-7.8-3.22Z"
          />
          <polygon
            className="st7"
            points="940.39 554.15 936.06 549.82 932.24 553.63 930.68 552.08 936.06 546.7 940.39 551.03 943.99 547.42 945.55 548.98 940.39 554.15"
          />
          <rect
            className="st5"
            x="900.82"
            y="514.87"
            width="74.6"
            height="74.6"
          />
        </g>
        <g>
          <path className="st8" d="M1077.56,601.96h1.43v8.19h-1.43v-8.19Z" />
          <path
            className="st8"
            d="M1080.69,601.96h1.51l3.74,6.03h.02v-6.03h1.36v8.19h-1.51l-3.73-6.02h-.03v6.02h-1.36v-8.19Z"
          />
          <path
            className="st8"
            d="M1089.03,601.96h3.39c.63,0,1.17.11,1.63.32.46.21.83.51,1.12.88.29.37.51.8.65,1.3.14.5.21,1.03.21,1.59s-.07,1.1-.21,1.59c-.14.5-.36.93-.65,1.3-.29.37-.67.66-1.12.88s-1,.32-1.63.32h-3.39v-8.19ZM1090.46,608.98h1.41c.56,0,1.02-.07,1.37-.22.36-.15.63-.36.84-.62.2-.26.34-.57.41-.93.07-.36.11-.74.11-1.15s-.04-.8-.11-1.15c-.07-.36-.21-.67-.41-.93-.2-.26-.48-.47-.84-.62-.36-.15-.81-.22-1.37-.22h-1.41v5.85Z"
          />
          <path
            className="st8"
            d="M1097.21,601.96h1.43v4.77c0,.28.01.55.04.84.03.28.1.54.23.76.13.23.32.41.57.56.26.15.62.22,1.08.22s.83-.07,1.08-.22c.26-.15.45-.33.57-.56.13-.23.2-.48.23-.76s.04-.56.04-.84v-4.77h1.43v5.24c0,.53-.08.99-.24,1.38-.16.39-.39.72-.68.98s-.65.46-1.06.59c-.41.13-.87.2-1.38.2s-.96-.07-1.38-.2c-.41-.13-.77-.33-1.06-.59-.29-.26-.52-.59-.68-.98s-.24-.85-.24-1.38v-5.24Z"
          />
          <path
            className="st8"
            d="M1111.11,604.56c-.06-.24-.15-.45-.25-.65s-.24-.37-.41-.52c-.17-.15-.37-.26-.59-.34-.23-.08-.49-.12-.79-.12-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15.24.71.44,1c.2.29.46.53.77.71.32.18.69.26,1.13.26.32,0,.6-.06.85-.17.24-.11.45-.26.63-.46.18-.19.31-.42.41-.68.1-.26.16-.54.19-.84h1.4c-.03.49-.14.94-.32,1.34s-.42.76-.73,1.05c-.31.29-.67.52-1.08.68-.41.16-.87.24-1.36.24-.61,0-1.16-.11-1.65-.34-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65.44-.97.77-1.37c.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34.46,0,.89.06,1.3.19.41.13.76.31,1.07.55s.56.53.75.88c.19.34.31.74.36,1.18h-1.43Z"
          />
          <path
            className="st8"
            d="M1113.09,601.96h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <path className="st8" d="M1120.67,601.96h1.43v8.19h-1.43v-8.19Z" />
          <path
            className="st8"
            d="M1127.34,601.76c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.37.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66c-.18.52-.44.97-.77,1.36s-.75.7-1.23.92c-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65.44-.97.77-1.37c.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34ZM1127.34,602.93c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15.24.71.44,1c.2.29.46.53.77.71.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1s.14-.76.14-1.15-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st8"
            d="M1132.52,601.96h1.51l3.74,6.03h.02v-6.03h1.36v8.19h-1.51l-3.73-6.02h-.03v6.02h-1.36v-8.19Z"
          />
          <polygon
            className="st6"
            points="1131.89 565.71 1129.69 565.71 1129.69 529.92 1085.6 529.92 1085.6 527.71 1131.89 527.71 1131.89 565.71"
          />
          <path
            className="st8"
            d="M1131.89,575.11h-47.4v-41.03h2.21v35.14h45.19v5.88ZM1086.7,572.9h42.99v-1.47h-42.99v1.47Z"
          />
          <path
            className="st7"
            d="M1112.59,560.37c-.22,0-.4-.03-.46-.04-.02,0-2.06-.31-4.02-2.02-1.96,1.71-4.01,2.02-4.05,2.03-.05,0-.37.06-.72,0h0c-.34-.06-2.2-.45-4-2.02-1.96,1.72-4.01,2.03-4.05,2.03l-.3-2.18c.12-.02,1.51-.25,2.9-1.47-1.19-1.68-2.11-4.13-2.11-7.66,0-4.65.64-7.53,1.95-8.8.48-.46,1.05-.71,1.62-.69.57,0,1.14.24,1.61.7,1.31,1.28,1.95,4.15,1.95,8.79,0,3.54-.91,5.98-2.11,7.66,1.38,1.22,2.78,1.45,2.9,1.47h.05c.12-.01,1.52-.25,2.91-1.47-1.19-1.68-2.11-4.13-2.11-7.66,0-4.65.64-7.53,1.95-8.8.48-.46,1.05-.7,1.62-.69.58,0,1.14.24,1.61.7,1.31,1.28,1.95,4.15,1.95,8.79,0,3.54-.91,5.98-2.11,7.66,1.38,1.22,2.78,1.45,2.9,1.47.07,0,.14.01.17,0h.06c.11-.03,1.51-.26,2.89-1.47-1.19-1.68-2.11-4.13-2.11-7.66,0-4.65.64-7.53,1.95-8.8.48-.46,1.05-.71,1.62-.69.56,0,1.14.24,1.61.7,1.31,1.28,1.95,4.15,1.95,8.79,0,3.54-.91,5.98-2.11,7.66,1.38,1.22,2.78,1.45,2.9,1.47l-.3,2.18s-2.09-.31-4.05-2.03c-1.78,1.55-3.63,1.95-3.99,2.02h0c-.16.03-.32.04-.46.04ZM1117.04,541.75c-.19.13-1.36,1.2-1.36,7.28,0,2.65.58,4.54,1.36,5.88.79-1.34,1.36-3.23,1.36-5.88,0-6.07-1.18-7.15-1.37-7.28ZM1099.34,541.75c-.19.13-1.36,1.21-1.36,7.28,0,2.65.58,4.54,1.36,5.88.79-1.34,1.36-3.23,1.36-5.88,0-6.07-1.18-7.15-1.37-7.28ZM1108.11,541.75c-.19.13-1.36,1.21-1.36,7.28,0,2.65.58,4.54,1.36,5.88.79-1.34,1.36-3.23,1.36-5.88,0-6.07-1.18-7.15-1.37-7.28Z"
          />
          <path className="st4" d="M1120.55,563.55" />
          <rect
            className="st5"
            x="1070.9"
            y="514.87"
            width="74.6"
            height="74.6"
          />
        </g>
        <g>
          <path
            className="st8"
            d="M1248.17,601.96h1.43v3.26h3.73v-3.26h1.43v8.19h-1.43v-3.69h-3.73v3.69h-1.43v-8.19Z"
          />
          <path className="st8" d="M1256.48,601.96h1.43v8.19h-1.43v-8.19Z" />
          <path
            className="st8"
            d="M1266.82,610.15h-.92l-.22-.96c-.38.44-.76.74-1.15.91-.38.17-.82.25-1.32.25-.61,0-1.16-.11-1.65-.34-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36c-.18-.52-.27-1.07-.27-1.66s.09-1.13.27-1.65c.18-.52.44-.97.77-1.37.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34.44,0,.87.06,1.27.18.4.12.76.29,1.07.53.31.23.57.53.78.88.21.35.34.76.39,1.22h-1.4c-.04-.27-.12-.5-.25-.71s-.29-.37-.48-.51c-.19-.14-.41-.24-.64-.31-.24-.07-.49-.1-.75-.1-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15.24.71.44,1c.2.29.46.53.77.71.32.18.69.26,1.13.26.37,0,.69-.04.98-.14.28-.1.52-.25.72-.45.19-.2.34-.43.44-.72.1-.28.15-.6.16-.94h-2.18v-1.09h3.49v4.31Z"
          />
          <path
            className="st8"
            d="M1268.34,601.96h1.43v3.26h3.73v-3.26h1.43v8.19h-1.43v-3.69h-3.73v3.69h-1.43v-8.19Z"
          />
          <path
            className="st8"
            d="M1276.66,601.96h1.43v6.95h4.16v1.24h-5.6v-8.19Z"
          />
          <path className="st8" d="M1283.24,601.96h1.43v8.19h-1.43v-8.19Z" />
          <path
            className="st8"
            d="M1293.57,610.15h-.92l-.22-.96c-.38.44-.76.74-1.15.91-.38.17-.82.25-1.32.25-.61,0-1.16-.11-1.65-.34-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36c-.18-.52-.27-1.07-.27-1.66s.09-1.13.27-1.65c.18-.52.44-.97.77-1.37.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34.44,0,.87.06,1.27.18.4.12.76.29,1.07.53.31.23.57.53.78.88.21.35.34.76.39,1.22h-1.4c-.04-.27-.12-.5-.25-.71s-.29-.37-.48-.51c-.19-.14-.41-.24-.64-.31-.24-.07-.49-.1-.75-.1-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15.24.71.44,1c.2.29.46.53.77.71.32.18.69.26,1.13.26.37,0,.69-.04.98-.14.28-.1.52-.25.72-.45.19-.2.34-.43.44-.72.1-.28.15-.6.16-.94h-2.18v-1.09h3.49v4.31Z"
          />
          <path
            className="st8"
            d="M1295.1,601.96h1.43v3.26h3.73v-3.26h1.43v8.19h-1.43v-3.69h-3.73v3.69h-1.43v-8.19Z"
          />
          <path
            className="st8"
            d="M1302.64,601.96h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <polygon
            className="st6"
            points="1301.97 565.71 1299.76 565.71 1299.76 529.92 1255.67 529.92 1255.67 527.71 1301.97 527.71 1301.97 565.71"
          />
          <path
            className="st8"
            d="M1301.97,575.11h-47.4v-41.03h2.21v35.14h45.19v5.88ZM1256.78,572.9h42.99v-1.47h-42.99v1.47Z"
          />
          <rect
            className="st8"
            x="1279.08"
            y="561.84"
            width="2.21"
            height="3.61"
          />
          <rect
            className="st8"
            x="1274.83"
            y="561.81"
            width="2.21"
            height="3.62"
          />
          <path
            className="st8"
            d="M1279.08,566.71v-5.8l.92-.16c5.24-.9,9.04-5.41,9.04-10.73,0-6-4.88-10.89-10.89-10.89s-10.89,4.88-10.89,10.89c0,5.24,3.74,9.74,8.88,10.7l.9.17v5.81l-1.26-.18c-8.15-1.16-14.3-8.25-14.3-16.49,0-9.19,7.48-16.66,16.66-16.66s16.66,7.48,16.66,16.66c0,8.34-6.23,15.44-14.48,16.52l-1.25.16ZM1281.29,562.74v1.4c6.53-1.45,11.32-7.31,11.32-14.11,0-7.97-6.49-14.46-14.46-14.46s-14.46,6.49-14.46,14.46c0,6.72,4.71,12.56,11.15,14.07v-1.41c-5.72-1.49-9.78-6.68-9.78-12.67,0-7.22,5.87-13.09,13.09-13.09s13.09,5.87,13.09,13.09c0,6.08-4.13,11.29-9.95,12.71Z"
          />
          <path
            className="st8"
            d="M1279.08,563.15v-6.1l.83-.21c3.1-.8,5.27-3.6,5.27-6.81,0-3.88-3.16-7.03-7.03-7.03s-7.03,3.16-7.03,7.03c0,3.14,2.11,5.92,5.12,6.77l.8.23v6.12l-1.3-.24c-6.19-1.15-10.68-6.57-10.68-12.87,0-7.22,5.87-13.09,13.09-13.09s13.09,5.87,13.09,13.09c0,6.4-4.57,11.82-10.87,12.9l-1.29.22ZM1281.29,558.72v1.73c4.56-1.36,7.75-5.56,7.75-10.43,0-6-4.88-10.89-10.89-10.89s-10.89,4.88-10.89,10.89c0,4.79,3.12,8.96,7.58,10.37v-1.75c-3.53-1.36-5.93-4.79-5.93-8.63,0-5.09,4.14-9.24,9.24-9.24s9.24,4.14,9.24,9.24c0,3.92-2.47,7.38-6.1,8.69Z"
          />
          <rect
            className="st8"
            x="1274.83"
            y="557.86"
            width="2.21"
            height="3.95"
          />
          <rect
            className="st8"
            x="1279.08"
            y="557.9"
            width="2.21"
            height="3.94"
          />
          <rect
            className="st8"
            x="1279.08"
            y="553.92"
            width="2.21"
            height="3.98"
          />
          <rect
            className="st8"
            x="1274.83"
            y="553.83"
            width="2.21"
            height="4.03"
          />
          <path
            className="st8"
            d="M1279.08,559.33v-6.07l.59-.31c1.09-.57,1.77-1.69,1.77-2.92,0-1.82-1.48-3.3-3.3-3.3s-3.3,1.48-3.3,3.3c0,1.17.63,2.26,1.64,2.85l.55.32v6.12l-1.4-.4c-3.96-1.12-6.73-4.77-6.73-8.89,0-5.09,4.14-9.24,9.24-9.24s9.24,4.14,9.24,9.24c0,4.22-2.85,7.89-6.92,8.95l-1.38.36ZM1281.29,554.54v1.78c2.35-1.17,3.89-3.59,3.89-6.3,0-3.88-3.16-7.03-7.03-7.03s-7.03,3.16-7.03,7.03c0,2.62,1.47,5,3.72,6.2v-1.81c-1.37-1.03-2.19-2.66-2.19-4.39,0-3.04,2.47-5.51,5.5-5.51s5.51,2.47,5.51,5.51c0,1.82-.89,3.5-2.36,4.52Z"
          />
          <path className="st3" d="M1275.93,553.83" />
          <path
            className="st8"
            d="M1280.69,554.9l-1.02-1.95c1.09-.57,1.77-1.69,1.77-2.92,0-1.82-1.48-3.3-3.3-3.3s-3.3,1.48-3.3,3.3c0,1.17.63,2.26,1.64,2.85l-1.11,1.91c-1.69-.98-2.74-2.81-2.74-4.76,0-3.04,2.47-5.51,5.5-5.51s5.51,2.47,5.51,5.51c0,2.05-1.13,3.92-2.95,4.88Z"
          />
          <path className="st3" d="M1280.18,553.92" />
          <rect
            className="st5"
            x="1240.97"
            y="514.87"
            width="74.6"
            height="74.6"
          />
        </g>
        <g>
          <path
            className="st8"
            d="M68.29,727.74h1.43v4.77c0,.28.01.55.04.84s.1.54.23.76c.13.23.32.41.57.56.26.15.62.22,1.08.22s.83-.07,1.08-.22c.26-.15.45-.33.57-.56.13-.23.2-.48.23-.76.03-.28.04-.56.04-.84v-4.77h1.43v5.24c0,.53-.08.99-.24,1.38-.16.39-.39.72-.68.98-.29.26-.65.46-1.06.59-.41.13-.87.2-1.38.2s-.96-.07-1.38-.2c-.41-.13-.77-.33-1.06-.59-.29-.26-.52-.59-.68-.98-.16-.39-.24-.85-.24-1.38v-5.24Z"
          />
          <path
            className="st8"
            d="M75.74,727.74h1.49l2.05,6.48h.02l2.1-6.48h1.46l-2.8,8.19h-1.59l-2.73-8.19Z"
          />
          <path className="st8" d="M82.73,732.19h3.34v1.24h-3.34v-1.24Z" />
          <path
            className="st8"
            d="M87.5,727.74h1.43v6.95h4.16v1.24h-5.6v-8.19Z"
          />
          <path
            className="st8"
            d="M94.09,727.74h5.89v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.97v-8.19Z"
          />
          <path
            className="st8"
            d="M101.31,727.74h3.39c.63,0,1.17.11,1.63.32.46.21.83.51,1.12.88.29.37.51.8.65,1.3s.21,1.03.21,1.59-.07,1.1-.21,1.59c-.14.5-.36.93-.65,1.3-.29.37-.67.66-1.12.88-.46.21-1,.32-1.63.32h-3.39v-8.19ZM102.75,734.75h1.41c.56,0,1.02-.07,1.37-.22.36-.15.63-.36.84-.62.2-.26.34-.57.41-.93.07-.36.11-.74.11-1.15s-.04-.8-.11-1.15c-.07-.36-.21-.67-.41-.93-.2-.26-.48-.47-.84-.62-.35-.15-.81-.22-1.37-.22h-1.41v5.85Z"
          />
          <polygon
            className="st6"
            points="111.44 693.14 109.24 693.14 109.24 654.86 65.15 654.86 65.15 652.65 111.44 652.65 111.44 693.14"
          />
          <path className="st2" d="M65.15,661.27" />
          <polygon
            className="st8"
            points="110.34 700.05 64.04 700.05 64.04 659.02 66.25 659.02 66.25 697.85 110.34 697.85 110.34 700.05"
          />
          <path className="st3" d="M110.34,690.29" />
          <polygon
            className="st8"
            points="87.54 694.84 70.36 685.68 71.4 683.74 87.48 692.31 101.91 683.76 103.04 685.66 87.54 694.84"
          />
          <polygon
            className="st8"
            points="71.48 689.9 69.9 684.11 75.69 682.53 76.27 684.66 72.61 685.66 73.61 689.32 71.48 689.9"
          />
          <path
            className="st8"
            d="M87.74,679.14c-3.71,0-6.74-3.02-6.74-6.74s3.02-6.74,6.74-6.74,6.74,3.02,6.74,6.74-3.02,6.74-6.74,6.74ZM87.74,667.88c-2.5,0-4.53,2.03-4.53,4.53s2.03,4.53,4.53,4.53,4.53-2.03,4.53-4.53-2.03-4.53-4.53-4.53Z"
          />
          <rect
            className="st8"
            x="86.64"
            y="658.81"
            width="2.21"
            height="4.47"
          />
          <rect
            className="st8"
            x="76.8"
            y="664.49"
            width="2.21"
            height="4.47"
            transform="translate(-538.45 400.81) rotate(-60)"
          />
          <rect
            className="st8"
            x="75.67"
            y="676.99"
            width="4.47"
            height="2.21"
            transform="translate(-328.61 129.8) rotate(-30)"
          />
          <rect
            className="st8"
            x="86.64"
            y="681.54"
            width="2.21"
            height="4.47"
          />
          <rect
            className="st8"
            x="96.48"
            y="675.86"
            width="2.21"
            height="4.47"
            transform="translate(-538.47 423.59) rotate(-60)"
          />
          <rect
            className="st8"
            x="95.35"
            y="665.62"
            width="4.47"
            height="2.21"
            transform="translate(-320.29 138.12) rotate(-30)"
          />
          <rect
            className="st5"
            x="50.44"
            y="639.66"
            width="74.6"
            height="74.6"
          />
        </g>
        <g>
          <path
            className="st7"
            d="M225.63,720.85h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM225.13,725.79h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st7"
            d="M231,720.85h1.43v4.77c0,.28.01.55.04.84.03.28.1.54.23.76.13.23.32.41.57.56.26.15.62.22,1.08.22s.83-.07,1.08-.22c.26-.15.45-.33.57-.56.13-.23.2-.48.23-.76.03-.28.04-.56.04-.84v-4.77h1.43v5.24c0,.53-.08.99-.24,1.38-.16.39-.39.72-.68.98-.29.26-.65.46-1.06.59-.41.13-.87.2-1.38.2s-.96-.07-1.38-.2c-.41-.13-.77-.33-1.06-.59-.29-.26-.52-.59-.68-.98-.16-.39-.24-.85-.24-1.38v-5.24Z"
          />
          <path
            className="st7"
            d="M238.59,720.85h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <path
            className="st7"
            d="M249.66,720.66c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.36.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66-.44.97-.77,1.36c-.34.39-.75.7-1.23.92-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34ZM249.66,721.83c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1,.1-.37.14-.76.14-1.15s-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st7"
            d="M254.86,720.85h2.02l2.26,6.41h.02l2.2-6.41h2v8.19h-1.37v-6.32h-.02l-2.27,6.32h-1.18l-2.27-6.32h-.02v6.32h-1.36v-8.19Z"
          />
          <path
            className="st7"
            d="M267.27,720.85h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM266.77,725.79h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st7"
            d="M270.9,720.85h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <path className="st7" d="M278.48,720.85h1.43v8.19h-1.43v-8.19Z" />
          <path
            className="st7"
            d="M287.19,723.46c-.06-.24-.15-.45-.25-.65-.11-.2-.24-.37-.41-.52-.17-.14-.37-.26-.59-.34-.23-.08-.49-.12-.79-.12-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26.32,0,.6-.06.85-.17s.45-.26.63-.46c.18-.2.31-.42.41-.68s.16-.54.2-.84h1.4c-.03.49-.14.94-.32,1.34-.18.41-.42.76-.73,1.05-.31.29-.67.52-1.08.68-.41.16-.87.24-1.36.24-.61,0-1.16-.11-1.65-.34-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34.46,0,.89.06,1.3.19.4.13.76.31,1.07.55s.56.53.75.88c.19.34.31.74.36,1.18h-1.43Z"
          />
          <path
            className="st7"
            d="M229.15,734.42c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.36.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66-.44.97-.77,1.36c-.34.39-.75.7-1.23.92-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36c-.18-.52-.27-1.07-.27-1.66s.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34ZM229.15,735.59c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1,.1-.37.14-.76.14-1.15s-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st7"
            d="M234.38,734.62h3.61c.58,0,1.05.08,1.42.25.37.17.65.38.85.63.2.25.33.53.41.83.07.3.11.57.11.83s-.04.53-.11.82c-.07.29-.21.57-.41.82-.2.25-.48.46-.85.63-.37.16-.84.25-1.42.25h-2.18v3.14h-1.43v-8.19ZM235.81,738.49h2.1c.16,0,.32-.02.49-.07.17-.05.32-.12.46-.22.14-.1.26-.24.34-.41s.13-.39.13-.65-.04-.49-.12-.67c-.08-.18-.18-.32-.31-.42-.13-.1-.28-.17-.45-.21-.17-.04-.35-.06-.54-.06h-2.12v2.71Z"
          />
          <path
            className="st7"
            d="M242.03,734.62h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st7"
            d="M249.26,734.62h3.91c.9,0,1.58.2,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97s-.25.46-.4.62c-.15.16-.3.27-.45.34-.15.07-.26.11-.33.14v.02c.12.02.25.05.4.12.14.06.27.16.4.29.12.13.22.31.3.52.08.21.12.48.12.8,0,.48.04.92.11,1.31.07.39.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58-.02-.21-.03-.42-.03-.62,0-.37-.02-.7-.07-.97-.05-.27-.13-.5-.25-.68s-.29-.31-.5-.4c-.21-.08-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19ZM250.69,738.34h2.35c.46,0,.81-.11,1.04-.33.24-.22.36-.54.36-.98,0-.26-.04-.47-.11-.64-.08-.16-.18-.29-.32-.38-.13-.09-.29-.15-.46-.18s-.35-.05-.53-.05h-2.33v2.56Z"
          />
          <path
            className="st7"
            d="M259.52,734.62h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM259.02,739.55h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st7"
            d="M263.14,734.62h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <path className="st7" d="M270.73,734.62h1.43v8.19h-1.43v-8.19Z" />
          <path
            className="st7"
            d="M277.4,734.42c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.36.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66-.44.97-.77,1.36c-.34.39-.75.7-1.23.92-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34ZM277.4,735.59c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1,.1-.37.14-.76.14-1.15s-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st7"
            d="M282.57,734.62h1.51l3.74,6.03h.02v-6.03h1.37v8.19h-1.51l-3.73-6.02h-.03v6.02h-1.37v-8.19Z"
          />
          <path
            className="st7"
            d="M259.75,656.02l2.33,6.23h-1.42l-.47-1.39h-2.33l-.49,1.39h-1.38l2.36-6.23h1.41ZM259.83,659.85l-.79-2.29h-.02l-.81,2.29h1.62Z"
          />
          <path
            className="st7"
            d="M267.21,661.78c-.47.41-1.12.62-1.96.62s-1.5-.2-1.96-.61c-.46-.41-.69-1.04-.69-1.89v-3.88h1.37v3.88c0,.17.01.33.04.5.03.16.09.31.18.43.09.13.22.23.39.31.17.08.39.12.67.12.49,0,.83-.11,1.01-.33.19-.22.28-.56.28-1.03v-3.88h1.37v3.88c0,.84-.24,1.47-.71,1.88Z"
          />
          <path
            className="st7"
            d="M268.61,657.18v-1.15h5.11v1.15h-1.87v5.08h-1.37v-5.08h-1.87Z"
          />
          <path
            className="st7"
            d="M274.37,657.87c.14-.4.34-.75.6-1.04.26-.3.58-.53.96-.7s.81-.25,1.29-.25.91.08,1.29.25.7.4.96.7c.26.3.46.64.6,1.04.14.4.21.83.21,1.3s-.07.88-.21,1.27-.34.73-.6,1.03c-.26.29-.58.52-.96.69s-.81.25-1.29.25-.91-.08-1.29-.25-.7-.39-.96-.69c-.26-.29-.46-.63-.6-1.03-.14-.39-.21-.82-.21-1.27s.07-.9.21-1.3ZM275.62,659.93c.06.25.16.47.29.67.13.2.31.36.52.48s.48.18.79.18.57-.06.79-.18.39-.28.52-.48c.13-.2.23-.42.29-.67s.09-.5.09-.76-.03-.54-.09-.79c-.06-.26-.16-.48-.29-.69-.13-.2-.31-.36-.52-.48s-.48-.18-.79-.18-.57.06-.79.18-.39.28-.52.48c-.13.2-.23.43-.29.69-.06.26-.09.52-.09.79s.03.52.09.76Z"
          />
          <polygon
            className="st8"
            points="262.04 684.75 249.81 684.75 249.81 673.26 252.01 673.26 252.01 682.54 262.04 682.54 262.04 684.75"
          />
          <path
            className="st8"
            d="M250.37,702.78c-10.83,0-19.64-8.81-19.64-19.64s8.81-19.64,19.64-19.64,19.64,8.81,19.64,19.64c0,7.58-4.44,14.56-11.3,17.79l-.94-2c6.1-2.86,10.03-9.06,10.03-15.79,0-9.61-7.82-17.43-17.43-17.43s-17.43,7.82-17.43,17.43,7.82,17.43,17.43,17.43v2.21Z"
          />
          <polygon
            className="st8"
            points="262.56 702.76 256.31 701.65 257.37 695.68 259.54 696.06 258.87 699.87 262.94 700.59 262.56 702.76"
          />
          <polygon
            className="st6"
            points="284.92 663.22 282.71 663.22 282.71 652.68 255.65 652.68 255.65 650.47 284.92 650.47 284.92 663.22"
          />
          <rect
            className="st5"
            x="220.52"
            y="639.66"
            width="74.6"
            height="74.6"
          />
        </g>
        <g>
          <polygon
            className="st8"
            points="1468.5 573.89 1426.58 573.89 1426.58 535.93 1428.79 535.93 1428.79 571.68 1468.5 571.68 1468.5 573.89"
          />
          <path
            className="st8"
            d="M1408.04,603.17h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <path
            className="st8"
            d="M1415.58,603.17h1.43v3.26h3.73v-3.26h1.43v8.19h-1.43v-3.69h-3.73v3.69h-1.43v-8.19Z"
          />
          <path
            className="st8"
            d="M1423.9,603.17h3.91c.9,0,1.58.19,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97-.11.26-.25.46-.4.62-.15.16-.3.27-.45.34s-.26.11-.33.14v.02c.12.02.25.05.4.11.14.06.27.16.4.29.12.13.22.31.3.52.08.21.12.48.12.8,0,.48.04.92.11,1.31.07.39.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58-.02-.21-.03-.42-.03-.62,0-.37-.02-.7-.07-.97s-.13-.5-.25-.68-.29-.31-.5-.4-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19ZM1425.33,606.9h2.35c.46,0,.81-.11,1.04-.33s.36-.54.36-.98c0-.26-.04-.47-.11-.64s-.18-.29-.32-.38-.29-.15-.46-.18-.35-.05-.53-.05h-2.33v2.56Z"
          />
          <path
            className="st8"
            d="M1431.97,603.17h5.89v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.97v-8.19Z"
          />
          <path
            className="st8"
            d="M1439.2,603.17h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st8"
            d="M1449.61,603.17h1.43v6.95h4.16v1.24h-5.6v-8.19Z"
          />
          <path
            className="st8"
            d="M1458.38,603.17h1.52l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM1457.88,608.1h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st8"
            d="M1465.13,608.15l-3.07-4.98h1.66l2.17,3.67,2.13-3.67h1.61l-3.06,4.98v3.21h-1.43v-3.21Z"
          />
          <path
            className="st8"
            d="M1470.43,603.17h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st8"
            d="M1477.65,603.17h3.91c.9,0,1.58.19,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97s-.25.46-.4.62-.3.27-.45.34-.26.11-.33.14v.02c.12.02.25.05.4.11s.27.16.4.29c.12.13.22.31.3.52.08.21.12.48.12.8,0,.48.04.92.11,1.31.07.39.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58-.02-.21-.03-.42-.03-.62,0-.37-.02-.7-.07-.97s-.13-.5-.25-.68c-.12-.18-.29-.31-.5-.4s-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19ZM1479.09,606.9h2.35c.46,0,.81-.11,1.04-.33s.36-.54.36-.98c0-.26-.04-.47-.12-.64s-.18-.29-.32-.38-.29-.15-.46-.18c-.17-.03-.35-.05-.53-.05h-2.33v2.56Z"
          />
          <path
            className="st8"
            d="M1486.67,608.63c0,.31.05.58.16.8.11.22.26.4.45.54.19.14.41.24.66.31.25.07.52.1.81.1.31,0,.58-.04.8-.11.22-.07.4-.17.54-.28s.24-.25.3-.4c.06-.15.09-.3.09-.45,0-.31-.07-.54-.21-.69-.14-.15-.3-.25-.46-.32-.29-.11-.63-.21-1.01-.3-.39-.1-.86-.22-1.43-.37-.35-.09-.64-.21-.88-.36-.23-.15-.42-.32-.56-.5-.14-.18-.24-.38-.29-.58-.06-.21-.09-.42-.09-.63,0-.41.09-.77.26-1.07s.4-.55.68-.75c.28-.2.6-.35.96-.44s.72-.14,1.09-.14c.43,0,.83.06,1.21.17.38.11.71.28,1,.5.29.22.51.5.68.82.17.33.25.7.25,1.13h-1.43c-.04-.53-.22-.9-.54-1.12-.32-.22-.73-.33-1.23-.33-.17,0-.34.02-.52.05-.18.03-.34.09-.48.17-.15.08-.27.19-.36.33-.1.14-.14.31-.14.52,0,.29.09.52.27.68.18.16.41.29.71.37.03,0,.15.04.36.1.21.06.45.12.71.19.26.07.51.14.76.2.25.07.43.11.53.14.27.08.5.2.7.34.2.15.37.31.5.5.13.19.23.39.3.6s.1.43.1.64c0,.46-.09.85-.28,1.18-.19.33-.43.59-.74.8-.31.21-.65.36-1.04.45s-.79.14-1.19.14c-.47,0-.91-.06-1.32-.17-.41-.11-.77-.29-1.08-.53s-.55-.54-.73-.91-.28-.81-.29-1.31h1.43Z"
          />
          <path
            className="st8"
            d="M1467.49,547.77h-13.36c-.61,0-1.1-.49-1.1-1.1v-13.36h2.21v12.26h12.26v2.21Z"
          />
          <path
            className="st8"
            d="M1467.49,556.27h-21.85c-.61,0-1.1-.49-1.1-1.1v-21.85h2.21v20.75h20.75v2.21Z"
          />
          <path
            className="st8"
            d="M1467.49,566.87h-32.46c-.61,0-1.1-.49-1.1-1.1v-32.46h2.21v31.36h31.36v2.21Z"
          />
          <rect
            className="st8"
            x="1444.47"
            y="539.23"
            width="11.23"
            height="2.21"
            transform="translate(31.5 1158.65) rotate(-43.99)"
          />
          <rect
            className="st8"
            x="1444.47"
            y="548.44"
            width="11.23"
            height="2.21"
            transform="translate(25.1 1161.23) rotate(-43.99)"
          />
          <rect
            className="st8"
            x="1452.1"
            y="549.92"
            width="12.6"
            height="2.21"
            transform="translate(27.77 1170.58) rotate(-44.11)"
          />
          <rect
            className="st8"
            x="1438.71"
            y="535.4"
            width="2.21"
            height="2.87"
          />
          <rect
            className="st8"
            x="1440.65"
            y="541.44"
            width="2.21"
            height="2.87"
          />
          <rect
            className="st8"
            x="1438.71"
            y="547.49"
            width="2.21"
            height="2.87"
          />
          <rect
            className="st8"
            x="1440.42"
            y="553.53"
            width="2.21"
            height="2.87"
          />
          <rect
            className="st8"
            x="1438.71"
            y="559.57"
            width="2.21"
            height="2.87"
          />
          <rect
            className="st8"
            x="1450.07"
            y="559.57"
            width="2.21"
            height="2.87"
          />
          <rect
            className="st8"
            x="1461.43"
            y="559.57"
            width="2.21"
            height="2.87"
          />
          <rect
            className="st8"
            x="1444.39"
            y="558.14"
            width="2.21"
            height="2.87"
          />
          <rect
            className="st8"
            x="1455.75"
            y="558.14"
            width="2.21"
            height="2.87"
          />
          <polygon
            className="st6"
            points="1469.6 569.13 1467.4 569.13 1467.4 533.07 1427.68 533.07 1427.68 530.87 1469.6 530.87 1469.6 569.13"
          />
          <rect
            className="st5"
            x="1410.67"
            y="514.87"
            width="74.6"
            height="74.6"
          />
        </g>
        <g>
          <path
            className="st7"
            d="M1415.79,720.85h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM1415.28,725.79h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st7"
            d="M1421.15,720.85h1.43v4.77c0,.28.01.55.04.84.03.28.1.54.23.76.13.23.32.41.57.56.26.15.62.22,1.08.22s.83-.07,1.08-.22c.26-.15.45-.33.57-.56.13-.23.2-.48.23-.76.03-.28.04-.56.04-.84v-4.77h1.43v5.24c0,.53-.08.99-.24,1.38-.16.39-.39.72-.68.98-.29.26-.65.46-1.06.59-.41.13-.87.2-1.38.2s-.96-.07-1.38-.2c-.41-.13-.77-.33-1.06-.59-.29-.26-.52-.59-.68-.98-.16-.39-.24-.85-.24-1.38v-5.24Z"
          />
          <path
            className="st7"
            d="M1428.74,720.85h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <path
            className="st7"
            d="M1439.81,720.66c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.36.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66-.44.97-.77,1.36c-.34.39-.75.7-1.23.92-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36c-.18-.52-.27-1.07-.27-1.66s.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34ZM1439.81,721.83c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1,.1-.37.14-.76.14-1.15s-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st7"
            d="M1445.02,720.85h2.02l2.26,6.41h.02l2.2-6.41h2v8.19h-1.37v-6.32h-.02l-2.27,6.32h-1.18l-2.27-6.32h-.02v6.32h-1.36v-8.19Z"
          />
          <path
            className="st7"
            d="M1457.43,720.85h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM1456.92,725.79h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st7"
            d="M1461.05,720.85h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <path className="st7" d="M1468.63,720.85h1.43v8.19h-1.43v-8.19Z" />
          <path
            className="st7"
            d="M1477.35,723.46c-.06-.24-.15-.45-.25-.65-.11-.2-.24-.37-.41-.52-.17-.14-.37-.26-.59-.34-.23-.08-.49-.12-.79-.12-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26.32,0,.6-.06.85-.17s.45-.26.63-.46c.18-.2.31-.42.41-.68s.16-.54.2-.84h1.4c-.03.49-.14.94-.32,1.34-.18.41-.42.76-.73,1.05-.31.29-.67.52-1.08.68-.41.16-.87.24-1.36.24-.61,0-1.16-.11-1.65-.34-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34.46,0,.89.06,1.3.19.4.13.76.31,1.07.55s.56.53.75.88c.19.34.31.74.36,1.18h-1.43Z"
          />
          <path
            className="st7"
            d="M1419.31,734.42c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.36.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66-.44.97-.77,1.36c-.34.39-.75.7-1.23.92-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36c-.18-.52-.27-1.07-.27-1.66s.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34ZM1419.31,735.59c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1,.1-.37.14-.76.14-1.15s-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st7"
            d="M1424.54,734.62h3.61c.58,0,1.05.08,1.42.25.37.17.65.38.85.63.2.25.33.53.41.83.07.3.11.57.11.83s-.04.53-.11.82c-.07.29-.21.57-.41.82-.2.25-.48.46-.85.63-.37.16-.84.25-1.42.25h-2.18v3.14h-1.43v-8.19ZM1425.97,738.49h2.1c.16,0,.32-.02.49-.07.17-.05.32-.12.46-.22.14-.1.26-.24.34-.41s.13-.39.13-.65-.04-.49-.12-.67c-.08-.18-.18-.32-.31-.42-.13-.1-.28-.17-.45-.21-.17-.04-.35-.06-.54-.06h-2.12v2.71Z"
          />
          <path
            className="st7"
            d="M1432.19,734.62h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st7"
            d="M1439.41,734.62h3.91c.9,0,1.58.2,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97s-.25.46-.4.62c-.15.16-.3.27-.45.34-.15.07-.26.11-.33.14v.02c.12.02.25.05.4.12.14.06.27.16.4.29.12.13.22.31.3.52.08.21.12.48.12.8,0,.48.04.92.11,1.31.07.39.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58-.02-.21-.03-.42-.03-.62,0-.37-.02-.7-.07-.97-.05-.27-.13-.5-.25-.68s-.29-.31-.5-.4c-.21-.08-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19ZM1440.84,738.34h2.35c.46,0,.81-.11,1.04-.33.24-.22.36-.54.36-.98,0-.26-.04-.47-.11-.64-.08-.16-.18-.29-.32-.38-.13-.09-.29-.15-.46-.18s-.35-.05-.53-.05h-2.33v2.56Z"
          />
          <path
            className="st7"
            d="M1449.68,734.62h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM1449.17,739.55h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st7"
            d="M1453.3,734.62h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <path className="st7" d="M1460.88,734.62h1.43v8.19h-1.43v-8.19Z" />
          <path
            className="st7"
            d="M1467.56,734.42c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.36.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66-.44.97-.77,1.36c-.34.39-.75.7-1.23.92-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34ZM1467.56,735.59c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1,.1-.37.14-.76.14-1.15s-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st7"
            d="M1472.73,734.62h1.51l3.74,6.03h.02v-6.03h1.37v8.19h-1.51l-3.73-6.02h-.03v6.02h-1.37v-8.19Z"
          />
          <path
            className="st7"
            d="M1449.91,656.02l2.33,6.23h-1.42l-.47-1.39h-2.33l-.49,1.39h-1.38l2.36-6.23h1.41ZM1449.99,659.85l-.79-2.29h-.02l-.81,2.29h1.62Z"
          />
          <path
            className="st7"
            d="M1457.36,661.78c-.47.41-1.12.62-1.96.62s-1.5-.2-1.96-.61c-.46-.41-.69-1.04-.69-1.89v-3.88h1.37v3.88c0,.17.01.33.04.5.03.16.09.31.18.43.09.13.22.23.39.31.17.08.39.12.67.12.49,0,.83-.11,1.01-.33.19-.22.28-.56.28-1.03v-3.88h1.37v3.88c0,.84-.24,1.47-.71,1.88Z"
          />
          <path
            className="st7"
            d="M1458.76,657.18v-1.15h5.11v1.15h-1.87v5.08h-1.37v-5.08h-1.87Z"
          />
          <path
            className="st7"
            d="M1464.52,657.87c.14-.4.34-.75.6-1.04.26-.3.58-.53.96-.7s.81-.25,1.29-.25.91.08,1.29.25.7.4.96.7c.26.3.46.64.6,1.04.14.4.21.83.21,1.3s-.07.88-.21,1.27-.34.73-.6,1.03c-.26.29-.58.52-.96.69s-.81.25-1.29.25-.91-.08-1.29-.25-.7-.39-.96-.69c-.26-.29-.46-.63-.6-1.03-.14-.39-.21-.82-.21-1.27s.07-.9.21-1.3ZM1465.78,659.93c.06.25.16.47.29.67.13.2.31.36.52.48s.48.18.79.18.57-.06.79-.18.39-.28.52-.48c.13-.2.23-.42.29-.67s.09-.5.09-.76-.03-.54-.09-.79c-.06-.26-.16-.48-.29-.69-.13-.2-.31-.36-.52-.48s-.48-.18-.79-.18-.57.06-.79.18-.39.28-.52.48c-.13.2-.23.43-.29.69-.06.26-.09.52-.09.79s.03.52.09.76Z"
          />
          <polygon
            className="st8"
            points="1452.19 684.75 1439.96 684.75 1439.96 673.26 1442.17 673.26 1442.17 682.54 1452.19 682.54 1452.19 684.75"
          />
          <path
            className="st8"
            d="M1440.52,702.78c-10.83,0-19.64-8.81-19.64-19.64s8.81-19.64,19.64-19.64,19.64,8.81,19.64,19.64c0,7.58-4.44,14.56-11.3,17.79l-.94-2c6.1-2.86,10.03-9.06,10.03-15.79,0-9.61-7.82-17.43-17.43-17.43s-17.43,7.82-17.43,17.43,7.82,17.43,17.43,17.43v2.21Z"
          />
          <polygon
            className="st8"
            points="1452.71 702.76 1446.46 701.65 1447.52 695.68 1449.69 696.06 1449.02 699.87 1453.1 700.59 1452.71 702.76"
          />
          <polygon
            className="st6"
            points="1475.07 663.22 1472.87 663.22 1472.87 652.68 1445.8 652.68 1445.8 650.47 1475.07 650.47 1475.07 663.22"
          />
          <rect
            className="st5"
            x="1410.67"
            y="639.66"
            width="74.6"
            height="74.6"
          />
        </g>
        <g>
          <polygon
            className="st6"
            points="435.77 693.76 433.56 693.76 433.56 655.48 413.42 655.48 413.42 653.28 435.77 653.28 435.77 693.76"
          />
          <polygon
            className="st8"
            points="434.67 700.67 412.32 700.67 412.32 659.64 414.52 659.64 414.52 698.47 434.67 698.47 434.67 700.67"
          />
          <path
            className="st7"
            d="M391.47,727.73h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM390.97,732.67h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path className="st7" d="M396.93,727.73h1.43v8.19h-1.43v-8.19Z" />
          <path
            className="st7"
            d="M400.12,727.73h3.91c.9,0,1.58.2,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97s-.25.46-.4.62c-.15.16-.3.27-.45.34-.15.07-.26.11-.33.14v.02c.12.02.25.05.4.12.14.06.27.16.4.29.12.13.22.31.3.52.08.21.12.48.12.8,0,.48.04.92.11,1.31.07.39.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58-.02-.21-.03-.42-.03-.62,0-.37-.02-.7-.07-.97-.05-.27-.13-.5-.25-.68s-.29-.31-.5-.4c-.21-.08-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19ZM401.55,731.46h2.35c.46,0,.81-.11,1.04-.33.24-.22.36-.54.36-.98,0-.26-.04-.47-.11-.64-.08-.16-.18-.29-.32-.38-.13-.09-.29-.15-.46-.18s-.35-.05-.53-.05h-2.33v2.56Z"
          />
          <path
            className="st7"
            d="M416.91,730.34c-.06-.24-.15-.45-.25-.65-.11-.2-.24-.37-.41-.52-.17-.14-.37-.26-.59-.34-.23-.08-.49-.12-.79-.12-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26.32,0,.6-.06.85-.17s.45-.26.63-.46c.18-.2.31-.42.41-.68s.16-.54.2-.84h1.4c-.03.49-.14.94-.32,1.34-.18.41-.42.76-.73,1.05-.31.29-.67.52-1.08.68-.41.16-.87.24-1.36.24-.61,0-1.16-.11-1.65-.34-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34.46,0,.89.06,1.3.19.4.13.76.31,1.07.55s.56.53.75.88c.19.34.31.74.36,1.18h-1.43Z"
          />
          <path
            className="st7"
            d="M419.66,727.73h1.43v6.95h4.16v1.24h-5.6v-8.19Z"
          />
          <path
            className="st7"
            d="M426.24,727.73h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st7"
            d="M435.66,727.73h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM435.15,732.67h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st7"
            d="M441.06,727.73h1.51l3.74,6.03h.02v-6.03h1.37v8.19h-1.51l-3.73-6.02h-.03v6.02h-1.37v-8.19Z"
          />
          <path className="st7" d="M449.4,727.73h1.43v8.19h-1.43v-8.19Z" />
          <path
            className="st7"
            d="M452.53,727.73h1.51l3.74,6.03h.02v-6.03h1.37v8.19h-1.51l-3.73-6.02h-.03v6.02h-1.37v-8.19Z"
          />
          <path
            className="st7"
            d="M468.01,735.92h-.92l-.22-.96c-.38.44-.76.74-1.15.91-.38.17-.82.25-1.32.25-.61,0-1.16-.11-1.65-.34-.49-.23-.9-.53-1.23-.92-.34-.39-.59-.84-.77-1.36-.18-.52-.27-1.07-.27-1.66s.09-1.13.27-1.65c.18-.52.44-.97.77-1.36.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34.44,0,.87.06,1.27.18s.76.29,1.07.53c.31.23.57.53.78.88.21.35.34.76.39,1.22h-1.4c-.04-.27-.12-.5-.25-.71s-.29-.37-.48-.51c-.19-.14-.41-.24-.64-.31-.24-.07-.49-.1-.75-.1-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26.37,0,.69-.04.97-.14.28-.1.52-.25.72-.45s.34-.43.44-.72.15-.6.16-.94h-2.18v-1.09h3.49v4.31Z"
          />
          <path
            className="st8"
            d="M443.03,672.45h-18.96v-2.21h18.96c1.89,0,3.43-1.54,3.43-3.43s-1.54-3.43-3.43-3.43c-.29,0-1.9.13-1.9,1.44h-2.21c0-2.81,2.67-3.61,4.08-3.64,3.13,0,5.66,2.53,5.66,5.63s-2.53,5.64-5.63,5.64Z"
          />
          <path
            className="st8"
            d="M442.98,694.91c-1.43-.03-4.11-.83-4.11-3.64h2.21c0,.23.09,1.38,1.93,1.44,1.86,0,3.4-1.54,3.4-3.43s-1.54-3.43-3.43-3.43h-18.96v-2.21h18.96c3.11,0,5.63,2.53,5.63,5.63s-2.53,5.64-5.63,5.64Z"
          />
          <path
            className="st8"
            d="M454.38,679.7h-30.31v-2.21h30.31c1.89,0,3.43-1.54,3.43-3.43s-1.54-3.43-3.43-3.43c-.29,0-1.9.13-1.9,1.44h-2.21c0-2.81,2.67-3.61,4.08-3.64,3.13,0,5.66,2.53,5.66,5.63s-2.53,5.63-5.64,5.63Z"
          />
          <rect
            className="st8"
            x="404.37"
            y="670.25"
            width="5.5"
            height="2.21"
          />
          <rect
            className="st8"
            x="396.36"
            y="670.25"
            width="5.5"
            height="2.21"
          />
          <rect
            className="st8"
            x="404.37"
            y="677.5"
            width="5.5"
            height="2.21"
          />
          <rect
            className="st8"
            x="396.36"
            y="677.5"
            width="5.5"
            height="2.21"
          />
          <rect
            className="st8"
            x="404.37"
            y="683.64"
            width="5.5"
            height="2.21"
          />
          <rect
            className="st8"
            x="396.36"
            y="683.64"
            width="5.5"
            height="2.21"
          />
          <rect
            className="st5"
            x="390.59"
            y="639.66"
            width="74.6"
            height="74.6"
          />
        </g>
        <g>
          <polygon
            className="st8"
            points="588.77 672.27 575.21 672.27 575.21 656.71 577.42 656.71 577.42 670.07 588.77 670.07 588.77 672.27"
          />
          <polygon
            className="st6"
            points="620.71 667.29 618.5 667.29 618.5 653.62 576.32 653.62 576.32 651.41 620.71 651.41 620.71 667.29"
          />
          <path
            className="st8"
            d="M612.01,701.49h-2.21v-2.02c0-1.93.55-3.57,1.08-5.16.55-1.64,1.12-3.33,1.12-5.46v-11.74c0-1.01-.82-1.83-1.83-1.83s-1.83.82-1.83,1.83c0,.61-.49,1.1-1.1,1.1s-1.1-.49-1.1-1.1v-2.2c0-1.01-.82-1.83-1.83-1.83s-1.83.82-1.83,1.83c0,.61-.49,1.1-1.1,1.1s-1.1-.49-1.1-1.1v-2.2c0-1.01-.82-1.83-1.83-1.83s-1.83.82-1.83,1.83c0,.61-.49,1.1-1.1,1.1s-1.1-.49-1.1-1.1v-10.27c0-1.01-.82-1.83-1.83-1.83s-1.83.82-1.83,1.83v20.55c0,.47-.3.89-.74,1.04-.44.16-.93.01-1.23-.36-1.8-2.27-2.91-3.63-3.58-4.31-.84-.85-1.69-1.15-2.16-1.15-1.12,0-1.83.29-2.25.55.8,1.44,2.12,4.4,4.73,10.38.71,1.61,1.63,2.88,2.53,4.1,1.39,1.89,2.7,3.68,2.7,6.22v2.02h-2.21v-2.02c0-1.82-1-3.19-2.27-4.92-.92-1.26-1.97-2.69-2.77-4.52-3.77-8.63-4.71-10.35-4.91-10.69-.05-.05-.1-.11-.14-.17-.24-.37-.23-.85.02-1.22.22-.32,1.49-1.94,4.57-1.94,1.21,0,2.6.67,3.72,1.79.45.44,1.01,1.1,1.79,2.04v-17.41c0-2.23,1.81-4.04,4.04-4.04s4.04,1.81,4.04,4.04v6.68c.55-.28,1.17-.44,1.83-.44,1.78,0,3.29,1.16,3.83,2.76.6-.35,1.3-.55,2.04-.55,1.78,0,3.29,1.16,3.83,2.76.6-.35,1.3-.55,2.04-.55,2.23,0,4.04,1.81,4.04,4.04v11.74c0,2.48-.65,4.43-1.23,6.16-.5,1.48-.97,2.89-.97,4.46v2.02ZM579.08,679.64c.14.04.29.05.46.02-.16.03-.31.02-.46-.02Z"
          />
          <path
            className="st7"
            d="M567.5,720.66c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.36.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66-.44.97-.77,1.36c-.34.39-.75.7-1.23.92-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34ZM567.5,721.83c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1,.1-.37.14-.76.14-1.15s-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st7"
            d="M572.68,720.85h1.51l3.74,6.03h.02v-6.03h1.37v8.19h-1.51l-3.73-6.02h-.03v6.02h-1.37v-8.19Z"
          />
          <path
            className="st7"
            d="M581.01,720.85h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path className="st7" d="M587.93,725.3h3.34v1.24h-3.34v-1.24Z" />
          <path
            className="st7"
            d="M591.92,720.85h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <path
            className="st7"
            d="M602.99,720.66c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.36.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66-.44.97-.77,1.36c-.34.39-.75.7-1.23.92-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34ZM602.99,721.83c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1,.1-.37.14-.76.14-1.15s-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st7"
            d="M608.13,720.85h1.43v4.77c0,.28.01.55.04.84.03.28.1.54.23.76.13.23.32.41.57.56.26.15.62.22,1.08.22s.83-.07,1.08-.22c.26-.15.45-.33.57-.56.13-.23.2-.48.23-.76.03-.28.04-.56.04-.84v-4.77h1.43v5.24c0,.53-.08.99-.24,1.38-.16.39-.39.72-.68.98-.29.26-.65.46-1.06.59-.41.13-.87.2-1.38.2s-.96-.07-1.38-.2c-.41-.13-.77-.33-1.06-.59-.29-.26-.52-.59-.68-.98-.16-.39-.24-.85-.24-1.38v-5.24Z"
          />
          <path
            className="st7"
            d="M622.03,723.46c-.06-.24-.15-.45-.25-.65-.11-.2-.24-.37-.41-.52-.17-.14-.37-.26-.59-.34-.23-.08-.49-.12-.79-.12-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26.32,0,.6-.06.85-.17s.45-.26.63-.46c.18-.2.31-.42.41-.68s.16-.54.2-.84h1.4c-.03.49-.14.94-.32,1.34-.18.41-.42.76-.73,1.05-.31.29-.67.52-1.08.68-.41.16-.87.24-1.36.24-.61,0-1.16-.11-1.65-.34-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34.46,0,.89.06,1.3.19.4.13.76.31,1.07.55s.56.53.75.88c.19.34.31.74.36,1.18h-1.43Z"
          />
          <path
            className="st7"
            d="M624.75,720.85h1.43v3.26h3.73v-3.26h1.43v8.19h-1.43v-3.69h-3.73v3.69h-1.43v-8.19Z"
          />
          <path
            className="st7"
            d="M575.06,734.62h3.98c.73,0,1.32.17,1.77.5.44.34.67.84.67,1.53,0,.41-.1.77-.3,1.06-.2.29-.49.52-.87.68v.02c.5.11.89.35,1.15.72.26.37.39.84.39,1.39,0,.32-.06.62-.17.9s-.29.52-.54.72c-.25.2-.56.36-.94.48-.38.12-.84.18-1.36.18h-3.76v-8.19ZM576.5,738.05h2.34c.34,0,.63-.1.86-.29.23-.19.34-.48.34-.84,0-.41-.1-.7-.31-.87-.21-.17-.5-.25-.89-.25h-2.34v2.26ZM576.5,741.63h2.53c.44,0,.77-.11,1.02-.34.24-.23.36-.54.36-.96s-.12-.72-.36-.93c-.24-.22-.58-.33-1.02-.33h-2.53v2.56Z"
          />
          <path
            className="st7"
            d="M583.05,734.62h1.43v4.77c0,.28.01.55.04.84.03.28.1.54.23.76.13.23.32.41.57.56.26.15.62.22,1.08.22s.83-.07,1.08-.22c.26-.15.45-.33.57-.56.13-.23.2-.48.23-.76.03-.28.04-.56.04-.84v-4.77h1.43v5.24c0,.53-.08.99-.24,1.38-.16.39-.39.72-.68.98-.29.26-.65.46-1.06.59-.41.13-.87.2-1.38.2s-.96-.07-1.38-.2c-.41-.13-.77-.33-1.06-.59-.29-.26-.52-.59-.68-.98-.16-.39-.24-.85-.24-1.38v-5.24Z"
          />
          <path
            className="st7"
            d="M590.64,734.62h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <path
            className="st7"
            d="M597.44,734.62h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <path
            className="st7"
            d="M608.51,734.42c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.36.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66-.44.97-.77,1.36c-.34.39-.75.7-1.23.92-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34ZM608.51,735.59c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1,.1-.37.14-.76.14-1.15s-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st7"
            d="M613.68,734.62h1.51l3.74,6.03h.02v-6.03h1.37v8.19h-1.51l-3.73-6.02h-.03v6.02h-1.37v-8.19Z"
          />
          <rect
            className="st8"
            x="599.6"
            y="669.51"
            width="21.08"
            height="2.21"
          />
          <rect
            className="st5"
            x="560.66"
            y="639.66"
            width="74.6"
            height="74.6"
          />
        </g>
        <g>
          <polygon
            className="st6"
            points="785.5 696.26 783.29 696.26 783.29 657.36 751.65 657.36 751.65 655.15 785.5 655.15 785.5 696.26"
          />
          <polygon
            className="st8"
            points="784.4 701.3 750.55 701.3 750.55 660.52 752.76 660.52 752.76 699.1 784.4 699.1 784.4 701.3"
          />
          <path
            className="st7"
            d="M723.23,727.73h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM722.72,732.67h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st7"
            d="M728.66,727.73h2.02l2.26,6.41h.02l2.2-6.41h2v8.19h-1.37v-6.32h-.02l-2.27,6.32h-1.18l-2.27-6.32h-.02v6.32h-1.36v-8.19Z"
          />
          <path
            className="st7"
            d="M738.88,727.73h3.61c.58,0,1.05.08,1.42.25.37.17.65.38.85.63.2.25.33.53.41.83.07.3.11.57.11.83s-.04.53-.11.82c-.07.29-.21.57-.41.82-.2.25-.48.46-.85.63-.37.16-.84.25-1.42.25h-2.18v3.14h-1.43v-8.19ZM740.32,731.61h2.1c.16,0,.32-.02.49-.07.17-.05.32-.12.46-.22.14-.1.26-.24.34-.41s.13-.39.13-.65-.04-.49-.12-.67c-.08-.18-.18-.32-.31-.42-.13-.1-.28-.17-.45-.21-.17-.04-.35-.06-.54-.06h-2.12v2.71Z"
          />
          <path
            className="st7"
            d="M746.53,727.73h1.43v6.95h4.16v1.24h-5.6v-8.19Z"
          />
          <path
            className="st7"
            d="M753.12,727.73h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st7"
            d="M769.06,730.34c-.06-.24-.15-.45-.25-.65-.11-.2-.24-.37-.41-.52-.17-.14-.37-.26-.59-.34-.23-.08-.49-.12-.79-.12-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26.32,0,.6-.06.85-.17s.45-.26.63-.46c.18-.2.31-.42.41-.68s.16-.54.2-.84h1.4c-.03.49-.14.94-.32,1.34-.18.41-.42.76-.73,1.05-.31.29-.67.52-1.08.68-.41.16-.87.24-1.36.24-.61,0-1.16-.11-1.65-.34-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34.46,0,.89.06,1.3.19.4.13.76.31,1.07.55s.56.53.75.88c.19.34.31.74.36,1.18h-1.43Z"
          />
          <path
            className="st7"
            d="M774,727.73h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM773.5,732.67h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st7"
            d="M779.46,727.73h3.61c.58,0,1.05.08,1.42.25.37.17.65.38.85.63.2.25.33.53.41.83.07.3.11.57.11.83s-.04.53-.11.82c-.07.29-.21.57-.41.82-.2.25-.48.46-.85.63-.37.16-.84.25-1.42.25h-2.18v3.14h-1.43v-8.19ZM780.89,731.61h2.1c.16,0,.32-.02.49-.07.17-.05.32-.12.46-.22.14-.1.26-.24.34-.41s.13-.39.13-.65-.04-.49-.12-.67c-.08-.18-.18-.32-.31-.42-.13-.1-.28-.17-.45-.21-.17-.04-.35-.06-.54-.06h-2.12v2.71Z"
          />
          <path
            className="st7"
            d="M788.45,727.73h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM787.95,732.67h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st7"
            d="M799.44,730.34c-.06-.24-.15-.45-.25-.65-.11-.2-.24-.37-.41-.52-.17-.14-.37-.26-.59-.34-.23-.08-.49-.12-.79-.12-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26.32,0,.6-.06.85-.17s.45-.26.63-.46c.18-.2.31-.42.41-.68s.16-.54.2-.84h1.4c-.03.49-.14.94-.32,1.34-.18.41-.42.76-.73,1.05-.31.29-.67.52-1.08.68-.41.16-.87.24-1.36.24-.61,0-1.16-.11-1.65-.34-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34.46,0,.89.06,1.3.19.4.13.76.31,1.07.55s.56.53.75.88c.19.34.31.74.36,1.18h-1.43Z"
          />
          <path className="st7" d="M802.19,727.73h1.43v8.19h-1.43v-8.19Z" />
          <path
            className="st7"
            d="M804.6,727.73h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <path
            className="st7"
            d="M814.31,732.71l-3.07-4.98h1.66l2.17,3.67,2.13-3.67h1.61l-3.06,4.98v3.21h-1.43v-3.21Z"
          />
          <path
            className="st7"
            d="M759.25,672.43h8.24v1.63c-.63.71-1.2,1.45-1.72,2.21-.52.76-.97,1.57-1.35,2.43-.38.85-.7,1.76-.94,2.71-.24.95-.4,1.97-.48,3.06h-2.15c.07-.95.23-1.89.49-2.82.26-.93.59-1.83,1-2.7s.88-1.71,1.42-2.51c.54-.8,1.12-1.55,1.74-2.25h-6.24v-1.75Z"
          />
          <path
            className="st7"
            d="M769.53,672.18h2.15v10.43h6.24v1.86h-8.4v-12.28Z"
          />
          <rect
            className="st8"
            x="753.23"
            y="700.94"
            width="2.21"
            height="2.41"
          />
          <rect
            className="st8"
            x="779.3"
            y="700.94"
            width="2.21"
            height="2.41"
          />
          <rect
            className="st5"
            x="730.75"
            y="639.66"
            width="74.6"
            height="74.6"
          />
        </g>
        <g>
          <polygon
            className="st6"
            points="960.87 694.84 958.66 694.84 958.66 656.53 916.47 656.53 916.47 654.33 960.87 654.33 960.87 694.84"
          />
          <polygon
            className="st8"
            points="959.76 699.82 915.37 699.82 915.37 659.63 917.58 659.63 917.58 697.62 959.76 697.62 959.76 699.82"
          />
          <path
            className="st8"
            d="M934.18,691.77c-.15,0-.3-.03-.45-.1-.5-.22-.76-.78-.61-1.31l2.81-9.96h-4.08c-.39,0-.75-.21-.95-.54-.2-.34-.2-.75-.01-1.1l8.45-15.15c.27-.48.84-.69,1.35-.49.51.19.8.73.69,1.26l-2.04,9.45h4.75c.4,0,.77.22.97.57.19.35.18.78-.03,1.12l-9.91,15.73c-.21.33-.56.52-.93.52ZM933.72,678.2h3.66c.35,0,.67.16.88.44s.28.63.18.96l-1.13,4.02,4.78-7.59h-4.12c-.33,0-.65-.15-.86-.41-.21-.26-.29-.6-.22-.93l.77-3.55-3.93,7.05Z"
          />
          <path
            className="st8"
            d="M909.44,727.73h3.61c.58,0,1.05.08,1.42.25.37.17.65.38.85.63.2.25.33.53.41.83.07.3.11.57.11.83s-.04.53-.11.82-.21.57-.41.82c-.2.25-.48.46-.85.63-.37.16-.84.25-1.42.25h-2.18v3.14h-1.43v-8.19ZM910.88,731.61h2.1c.16,0,.32-.02.49-.07.17-.05.32-.12.46-.22.14-.1.26-.24.34-.41s.13-.39.13-.65-.04-.49-.12-.67c-.08-.18-.18-.32-.31-.42-.13-.1-.28-.17-.45-.21-.17-.04-.35-.06-.54-.06h-2.12v2.71Z"
          />
          <path
            className="st8"
            d="M920.58,727.54c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.36.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66c-.18.52-.44.97-.77,1.36-.34.39-.75.7-1.23.92-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92-.34-.39-.59-.84-.77-1.36-.18-.52-.27-1.07-.27-1.66s.09-1.13.27-1.65c.18-.52.44-.97.77-1.36.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34ZM920.58,728.71c-.44,0-.81.09-1.13.26s-.58.41-.77.71c-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71s.69.26,1.13.26.81-.09,1.13-.26c.32-.18.57-.41.77-.71.2-.29.35-.63.44-1,.09-.37.14-.76.14-1.15s-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st8"
            d="M925.81,727.73h3.91c.9,0,1.58.2,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97s-.25.46-.4.62c-.15.16-.3.27-.45.34-.15.07-.26.11-.33.14v.02c.12.02.25.05.4.12s.27.16.4.29c.12.13.22.31.3.52s.12.48.12.8c0,.48.04.92.11,1.31.07.39.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58-.02-.21-.03-.42-.03-.62,0-.37-.02-.7-.07-.97-.05-.27-.13-.5-.25-.68s-.29-.31-.5-.4c-.21-.08-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19ZM927.24,731.46h2.35c.46,0,.81-.11,1.04-.33.24-.22.35-.54.35-.98,0-.26-.04-.47-.11-.64-.08-.16-.18-.29-.32-.38s-.29-.15-.46-.18c-.17-.03-.35-.05-.53-.05h-2.33v2.56Z"
          />
          <path
            className="st8"
            d="M932.9,727.73h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <path
            className="st8"
            d="M941.61,727.73h1.52l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM941.11,732.67h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st8"
            d="M947.07,727.73h3.98c.73,0,1.32.17,1.77.5s.67.84.67,1.53c0,.41-.1.77-.3,1.06-.2.29-.49.52-.87.68v.02c.5.11.89.35,1.15.72.26.37.39.84.39,1.39,0,.32-.06.62-.17.9s-.29.52-.54.72c-.24.2-.56.36-.94.48-.38.12-.84.18-1.36.18h-3.76v-8.19ZM948.51,731.16h2.34c.34,0,.63-.1.86-.29.23-.19.34-.48.34-.84,0-.41-.1-.7-.31-.87s-.5-.25-.89-.25h-2.34v2.26ZM948.51,734.75h2.53c.44,0,.77-.11,1.01-.34.24-.23.36-.54.36-.96s-.12-.72-.36-.93-.58-.33-1.01-.33h-2.53v2.56Z"
          />
          <path
            className="st8"
            d="M955.15,727.73h1.43v6.95h4.16v1.24h-5.6v-8.19Z"
          />
          <path
            className="st8"
            d="M961.73,727.73h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <rect
            className="st5"
            x="900.82"
            y="639.66"
            width="74.6"
            height="74.6"
          />
        </g>
        <g>
          <polygon
            className="st8"
            points="1130.06 699.39 1085.67 699.39 1085.67 659.2 1087.87 659.2 1087.87 697.18 1130.06 697.18 1130.06 699.39"
          />
          <polygon
            className="st8"
            points="1098.52 682.28 1096.75 680.96 1105.09 669.88 1096.79 659.96 1098.48 658.54 1107.91 669.81 1098.52 682.28"
          />
          <polygon
            className="st8"
            points="1097.04 682.49 1095.47 677.82 1097.56 677.12 1098.58 680.14 1101.97 679.84 1102.17 682.04 1097.04 682.49"
          />
          <polygon
            className="st8"
            points="1098.29 691.24 1096.52 689.91 1104.86 678.84 1096.56 668.92 1098.25 667.5 1107.68 678.77 1098.29 691.24"
          />
          <polygon
            className="st8"
            points="1096.81 691.45 1095.24 686.78 1097.34 686.08 1098.35 689.1 1102.08 688.77 1102.28 690.96 1096.81 691.45"
          />
          <path
            className="st8"
            d="M1130.06,694.32h-21.86c-.61,0-1.1-.49-1.1-1.1v-37.76h2.21v36.66h20.76v2.21Z"
          />
          <path className="st3" d="M1128.29,655" />
          <polygon
            className="st6"
            points="1131.16 694.41 1128.96 694.41 1128.96 656.1 1086.77 656.1 1086.77 653.89 1131.16 653.89 1131.16 694.41"
          />
          <path
            className="st7"
            d="M1075.27,727.08h3.39c.63,0,1.17.11,1.63.32s.83.51,1.12.88c.29.37.51.8.65,1.3.14.5.21,1.03.21,1.59s-.07,1.1-.21,1.59-.36.93-.65,1.3c-.29.37-.67.66-1.12.88s-1,.32-1.63.32h-3.39v-8.19ZM1076.71,734.1h1.41c.56,0,1.01-.07,1.37-.22.36-.15.63-.36.84-.62.2-.26.34-.57.41-.93.07-.36.11-.74.11-1.15s-.04-.8-.11-1.15c-.07-.36-.21-.67-.41-.93s-.48-.47-.84-.62c-.36-.15-.81-.22-1.37-.22h-1.41v5.85Z"
          />
          <path
            className="st7"
            d="M1083.46,727.08h1.43v4.77c0,.28.01.55.04.84.03.28.1.54.23.76.13.23.32.41.57.56.26.15.62.22,1.08.22s.83-.07,1.08-.22c.26-.15.45-.33.57-.56.13-.23.2-.48.23-.76.03-.28.04-.56.04-.84v-4.77h1.43v5.24c0,.53-.08.99-.24,1.38-.16.39-.39.72-.68.98-.29.26-.65.46-1.06.59-.41.13-.87.2-1.38.2s-.96-.07-1.38-.2c-.41-.13-.77-.33-1.06-.59-.29-.26-.52-.59-.68-.98-.16-.39-.24-.85-.24-1.38v-5.24Z"
          />
          <path
            className="st7"
            d="M1091.83,727.08h3.91c.9,0,1.58.2,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97s-.25.46-.4.62c-.15.16-.3.27-.45.34-.15.07-.26.11-.33.14v.02c.12.02.25.05.4.12.14.06.27.16.4.29.12.13.22.31.3.52.08.21.12.48.12.8,0,.48.04.92.11,1.31.07.39.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58-.02-.21-.03-.42-.03-.62,0-.37-.02-.7-.07-.97-.05-.27-.13-.5-.25-.68s-.29-.31-.5-.4c-.21-.08-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19ZM1093.27,730.81h2.35c.46,0,.81-.11,1.04-.33.24-.22.36-.54.36-.98,0-.26-.04-.47-.11-.64-.08-.16-.18-.29-.32-.38-.13-.09-.29-.15-.46-.18s-.35-.05-.53-.05h-2.33v2.56Z"
          />
          <path
            className="st7"
            d="M1102.1,727.08h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM1101.59,732.01h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st7"
            d="M1107.56,727.08h3.98c.73,0,1.32.17,1.77.5.44.34.67.84.67,1.53,0,.41-.1.77-.3,1.06-.2.29-.49.52-.87.68v.02c.5.11.89.35,1.15.72.26.37.39.84.39,1.39,0,.32-.06.62-.17.9s-.29.52-.54.72c-.25.2-.56.36-.94.48-.38.12-.84.18-1.36.18h-3.76v-8.19ZM1108.99,730.51h2.34c.34,0,.63-.1.86-.29.23-.19.34-.48.34-.84,0-.41-.1-.7-.31-.87-.21-.17-.5-.25-.89-.25h-2.34v2.26ZM1108.99,734.1h2.53c.44,0,.77-.11,1.02-.34.24-.23.36-.54.36-.96s-.12-.72-.36-.93c-.24-.22-.58-.33-1.02-.33h-2.53v2.56Z"
          />
          <path className="st7" d="M1115.63,727.08h1.43v8.19h-1.43v-8.19Z" />
          <path
            className="st7"
            d="M1118.82,727.08h1.43v6.95h4.16v1.24h-5.6v-8.19Z"
          />
          <path className="st7" d="M1125.4,727.08h1.43v8.19h-1.43v-8.19Z" />
          <path
            className="st7"
            d="M1127.81,727.08h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <path
            className="st7"
            d="M1137.52,732.06l-3.07-4.98h1.66l2.17,3.67,2.13-3.67h1.61l-3.06,4.98v3.21h-1.43v-3.21Z"
          />
          <rect
            className="st5"
            x="1070.9"
            y="639.66"
            width="74.6"
            height="74.6"
          />
        </g>
        <g>
          <path
            className="st7"
            d="M1247.04,727.08h3.61c.58,0,1.05.08,1.42.25.37.17.65.38.85.63.2.25.33.53.41.83.07.3.11.57.11.83s-.04.53-.11.82c-.07.29-.21.57-.41.82-.2.25-.48.46-.85.63-.37.16-.84.25-1.42.25h-2.18v3.14h-1.43v-8.19ZM1248.47,730.96h2.1c.16,0,.32-.02.49-.07.17-.05.32-.12.46-.22.14-.1.26-.24.34-.41s.13-.39.13-.65-.04-.49-.12-.67c-.08-.18-.18-.32-.31-.42-.13-.1-.28-.17-.45-.21-.17-.04-.35-.06-.54-.06h-2.12v2.71Z"
          />
          <path
            className="st7"
            d="M1254.69,727.08h5.65v1.24h-4.22v2.14h3.7v1.17h-3.7v3.64h-1.43v-8.19Z"
          />
          <path
            className="st7"
            d="M1264.97,726.89c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.36.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66-.44.97-.77,1.36c-.34.39-.75.7-1.23.92-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34ZM1264.97,728.06c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1,.1-.37.14-.76.14-1.15s-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st7"
            d="M1272.39,727.08h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM1271.89,732.01h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st7"
            d="M1281.04,727.08h5.65v1.24h-4.22v2.14h3.7v1.17h-3.7v3.64h-1.43v-8.19Z"
          />
          <path
            className="st7"
            d="M1287.84,727.08h3.91c.9,0,1.58.2,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97s-.25.46-.4.62c-.15.16-.3.27-.45.34-.15.07-.26.11-.33.14v.02c.12.02.25.05.4.12.14.06.27.16.4.29.12.13.22.31.3.52.08.21.12.48.12.8,0,.48.04.92.11,1.31.07.39.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58-.02-.21-.03-.42-.03-.62,0-.37-.02-.7-.07-.97-.05-.27-.13-.5-.25-.68s-.29-.31-.5-.4c-.21-.08-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19ZM1289.28,730.81h2.35c.46,0,.81-.11,1.04-.33.24-.22.36-.54.36-.98,0-.26-.04-.47-.11-.64-.08-.16-.18-.29-.32-.38-.13-.09-.29-.15-.46-.18s-.35-.05-.53-.05h-2.33v2.56Z"
          />
          <path
            className="st7"
            d="M1295.92,727.08h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st7"
            d="M1303.14,727.08h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st8"
            d="M1260.68,669.86c1.43,0,2.51.37,3.25,1.1.73.73,1.1,1.76,1.1,3.09s-.37,2.36-1.1,3.1c-.73.74-1.82,1.11-3.25,1.09h-4.33v5.8h-1.89v-14.17h6.21ZM1260.04,676.65c1.07.01,1.86-.2,2.35-.65.5-.45.74-1.1.74-1.95s-.25-1.49-.74-1.94c-.5-.44-1.28-.66-2.35-.66h-3.69v5.2h3.69Z"
          />
          <path
            className="st8"
            d="M1276.64,669.86v1.59h-7.42v4.51h6.51v1.59h-6.51v6.49h-1.89v-14.17h9.31Z"
          />
          <path
            className="st8"
            d="M1278.36,674.16c.28-.89.71-1.68,1.28-2.37.57-.69,1.28-1.24,2.12-1.65.85-.41,1.83-.62,2.96-.62s2.11.21,2.96.62c.85.41,1.55.96,2.12,1.65.57.69,1,1.48,1.28,2.37.28.89.43,1.82.43,2.79s-.14,1.9-.43,2.79c-.29.89-.71,1.68-1.28,2.37-.57.69-1.28,1.23-2.12,1.64-.85.4-1.83.61-2.96.61s-2.11-.2-2.96-.61c-.85-.4-1.56-.95-2.12-1.64-.57-.69-1-1.48-1.28-2.37s-.43-1.82-.43-2.79.14-1.9.43-2.79ZM1280.09,679.06c.19.69.48,1.32.87,1.88s.91,1,1.53,1.34c.62.34,1.36.51,2.22.51s1.6-.17,2.22-.51c.62-.34,1.13-.78,1.53-1.34.4-.56.69-1.18.87-1.88.19-.69.28-1.4.28-2.11s-.09-1.42-.28-2.11c-.19-.69-.48-1.32-.87-1.88-.4-.56-.91-1-1.53-1.34-.62-.34-1.36-.51-2.22-.51s-1.6.17-2.22.51c-.62.34-1.13.78-1.53,1.34-.4.56-.69,1.18-.87,1.88s-.28,1.4-.28,2.11.09,1.42.28,2.11Z"
          />
          <path
            className="st8"
            d="M1299.74,669.86l5.54,14.17h-2.08l-1.55-4.27h-6l-1.59,4.27h-1.93l5.52-14.17h2.08ZM1301.05,678.18l-2.36-6.61h-.04l-2.4,6.61h4.8Z"
          />
          <polygon
            className="st6"
            points="1310.22 695.75 1308.01 695.75 1308.01 657.76 1251.65 657.76 1251.65 655.56 1310.22 655.56 1310.22 695.75"
          />
          <polygon
            className="st8"
            points="1304.55 698.68 1246.25 698.68 1246.25 656.66 1248.46 656.66 1248.46 696.47 1304.55 696.47 1304.55 698.68"
          />
          <path className="st1" d="M1255.95,663.25" />
          <rect
            className="st8"
            x="1250.85"
            y="676.35"
            width="54.57"
            height="2.21"
            transform="translate(-168.2 703.77) rotate(-28.97)"
          />
          <rect
            className="st5"
            x="1240.97"
            y="639.66"
            width="74.6"
            height="74.6"
          />
        </g>
        <g>
          <path
            className="st8"
            d="M-111.9,601.96h1.43v3.26h3.73v-3.26h1.43v8.19h-1.43v-3.69h-3.73v3.69h-1.43v-8.19Z"
          />
          <path className="st8" d="M-103.59,601.96h1.43v8.19h-1.43v-8.19Z" />
          <path
            className="st8"
            d="M-93.26,610.15h-.92l-.22-.96c-.38.44-.76.74-1.15.91-.38.17-.82.25-1.32.25-.61,0-1.16-.11-1.65-.34-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36c-.18-.52-.27-1.07-.27-1.66s.09-1.13.27-1.65c.18-.52.44-.97.77-1.37.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34.44,0,.87.06,1.27.18.4.12.76.29,1.07.53.31.23.57.53.78.88.21.35.34.76.39,1.22h-1.4c-.04-.27-.12-.5-.25-.71s-.29-.37-.48-.51c-.19-.14-.41-.24-.64-.31-.24-.07-.49-.1-.75-.1-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15.24.71.44,1c.2.29.46.53.77.71.32.18.69.26,1.13.26.37,0,.69-.04.98-.14.28-.1.52-.25.72-.45.19-.2.34-.43.44-.72.1-.28.15-.6.16-.94h-2.18v-1.09h3.49v4.31Z"
          />
          <path
            className="st8"
            d="M-91.73,601.96h1.43v3.26h3.73v-3.26h1.43v8.19h-1.43v-3.69h-3.73v3.69h-1.43v-8.19Z"
          />
          <path
            className="st8"
            d="M-83.42,601.96h1.43v6.95h4.16v1.24h-5.6v-8.19Z"
          />
          <path className="st8" d="M-76.83,601.96h1.43v8.19h-1.43v-8.19Z" />
          <path
            className="st8"
            d="M-66.5,610.15h-.92l-.22-.96c-.38.44-.76.74-1.15.91-.38.17-.82.25-1.32.25-.61,0-1.16-.11-1.65-.34-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36c-.18-.52-.27-1.07-.27-1.66s.09-1.13.27-1.65c.18-.52.44-.97.77-1.37.34-.39.75-.7,1.23-.93.49-.23,1.03-.34,1.65-.34.44,0,.87.06,1.27.18.4.12.76.29,1.07.53.31.23.57.53.78.88.21.35.34.76.39,1.22h-1.4c-.04-.27-.12-.5-.25-.71s-.29-.37-.48-.51c-.19-.14-.41-.24-.64-.31-.24-.07-.49-.1-.75-.1-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15.24.71.44,1c.2.29.46.53.77.71.32.18.69.26,1.13.26.37,0,.69-.04.98-.14.28-.1.52-.25.72-.45.19-.2.34-.43.44-.72.1-.28.15-.6.16-.94h-2.18v-1.09h3.49v4.31Z"
          />
          <path
            className="st8"
            d="M-64.97,601.96h1.43v3.26h3.73v-3.26h1.43v8.19h-1.43v-3.69h-3.73v3.69h-1.43v-8.19Z"
          />
          <path
            className="st8"
            d="M-57.44,601.96h6.63v1.24h-2.6v6.95h-1.43v-6.95h-2.59v-1.24Z"
          />
          <polygon
            className="st6"
            points="-58.1 565.71 -60.31 565.71 -60.31 529.92 -104.4 529.92 -104.4 527.71 -58.1 527.71 -58.1 565.71"
          />
          <path
            className="st8"
            d="M-58.1,575.11h-47.4v-41.03h2.21v35.14h45.19v5.88ZM-103.3,572.9h42.99v-1.47h-42.99v1.47Z"
          />
          <rect
            className="st8"
            x="-80.99"
            y="561.84"
            width="2.21"
            height="3.61"
          />
          <rect
            className="st8"
            x="-85.24"
            y="561.81"
            width="2.21"
            height="3.62"
          />
          <path
            className="st8"
            d="M-80.99,566.71v-5.8l.92-.16c5.24-.9,9.04-5.41,9.04-10.73,0-6-4.88-10.89-10.89-10.89s-10.89,4.88-10.89,10.89c0,5.24,3.74,9.74,8.88,10.7l.9.17v5.81l-1.26-.18c-8.15-1.16-14.3-8.25-14.3-16.49,0-9.19,7.48-16.66,16.66-16.66s16.66,7.48,16.66,16.66c0,8.34-6.23,15.44-14.48,16.52l-1.25.16ZM-78.79,562.74v1.4c6.53-1.45,11.32-7.31,11.32-14.11,0-7.97-6.49-14.46-14.46-14.46s-14.46,6.49-14.46,14.46c0,6.72,4.71,12.56,11.15,14.07v-1.41c-5.72-1.49-9.78-6.68-9.78-12.67,0-7.22,5.87-13.09,13.09-13.09s13.09,5.87,13.09,13.09c0,6.08-4.13,11.29-9.95,12.71Z"
          />
          <path
            className="st8"
            d="M-80.99,563.15v-6.1l.83-.21c3.1-.8,5.27-3.6,5.27-6.81,0-3.88-3.16-7.03-7.03-7.03s-7.03,3.16-7.03,7.03c0,3.14,2.11,5.92,5.12,6.77l.8.23v6.12l-1.3-.24c-6.19-1.15-10.68-6.57-10.68-12.87,0-7.22,5.87-13.09,13.09-13.09s13.09,5.87,13.09,13.09c0,6.4-4.57,11.82-10.87,12.9l-1.29.22ZM-78.79,558.72v1.73c4.56-1.36,7.75-5.56,7.75-10.43,0-6-4.88-10.89-10.89-10.89s-10.89,4.88-10.89,10.89c0,4.79,3.12,8.96,7.58,10.37v-1.75c-3.53-1.36-5.93-4.79-5.93-8.63,0-5.09,4.14-9.24,9.24-9.24s9.24,4.14,9.24,9.24c0,3.92-2.47,7.38-6.1,8.69Z"
          />
          <rect
            className="st8"
            x="-85.24"
            y="557.86"
            width="2.21"
            height="3.95"
          />
          <rect
            className="st8"
            x="-80.99"
            y="557.9"
            width="2.21"
            height="3.94"
          />
          <rect
            className="st8"
            x="-80.99"
            y="553.92"
            width="2.21"
            height="3.98"
          />
          <rect
            className="st8"
            x="-85.24"
            y="553.83"
            width="2.21"
            height="4.03"
          />
          <path
            className="st8"
            d="M-80.99,559.33v-6.07l.59-.31c1.09-.57,1.77-1.69,1.77-2.92,0-1.82-1.48-3.3-3.3-3.3s-3.3,1.48-3.3,3.3c0,1.17.63,2.26,1.64,2.85l.55.32v6.12l-1.4-.4c-3.96-1.12-6.73-4.77-6.73-8.89,0-5.09,4.14-9.24,9.24-9.24s9.24,4.14,9.24,9.24c0,4.22-2.85,7.89-6.92,8.95l-1.38.36ZM-78.79,554.54v1.78c2.35-1.17,3.89-3.59,3.89-6.3,0-3.88-3.16-7.03-7.03-7.03s-7.03,3.16-7.03,7.03c0,2.62,1.47,5,3.72,6.2v-1.81c-1.37-1.03-2.19-2.66-2.19-4.39,0-3.04,2.47-5.51,5.5-5.51s5.51,2.47,5.51,5.51c0,1.82-.89,3.5-2.36,4.52Z"
          />
          <path className="st3" d="M-84.14,553.83" />
          <path
            className="st8"
            d="M-79.38,554.9l-1.02-1.95c1.09-.57,1.77-1.69,1.77-2.92,0-1.82-1.48-3.3-3.3-3.3s-3.3,1.48-3.3,3.3c0,1.17.63,2.26,1.64,2.85l-1.11,1.91c-1.69-.98-2.74-2.81-2.74-4.76,0-3.04,2.47-5.51,5.5-5.51s5.51,2.47,5.51,5.51c0,2.05-1.13,3.92-2.95,4.88Z"
          />
          <path className="st3" d="M-79.89,553.92" />
          <rect
            className="st5"
            x="-119.1"
            y="514.87"
            width="74.6"
            height="74.6"
          />
        </g>
        <g>
          <path
            className="st7"
            d="M-113.04,727.08h3.61c.58,0,1.05.08,1.42.25.37.17.65.38.85.63.2.25.33.53.41.83.07.3.11.57.11.83s-.04.53-.11.82c-.07.29-.21.57-.41.82-.2.25-.48.46-.85.63-.37.16-.84.25-1.42.25h-2.18v3.14h-1.43v-8.19ZM-111.6,730.96h2.1c.16,0,.32-.02.49-.07.17-.05.32-.12.46-.22.14-.1.26-.24.34-.41s.13-.39.13-.65-.04-.49-.12-.67c-.08-.18-.18-.32-.31-.42-.13-.1-.28-.17-.45-.21-.17-.04-.35-.06-.54-.06h-2.12v2.71Z"
          />
          <path
            className="st7"
            d="M-105.39,727.08h5.65v1.24h-4.22v2.14h3.7v1.17h-3.7v3.64h-1.43v-8.19Z"
          />
          <path
            className="st7"
            d="M-95.1,726.89c.61,0,1.16.11,1.65.34.49.23.9.54,1.23.93.34.39.59.85.77,1.36.18.52.27,1.07.27,1.65s-.09,1.14-.27,1.66-.44.97-.77,1.36c-.34.39-.75.7-1.23.92-.49.23-1.03.34-1.65.34s-1.16-.11-1.65-.34c-.49-.23-.9-.53-1.23-.92s-.59-.84-.77-1.36-.27-1.07-.27-1.66.09-1.13.27-1.65c.18-.52.44-.97.77-1.36s.75-.7,1.23-.93c.49-.23,1.03-.34,1.65-.34ZM-95.1,728.06c-.44,0-.81.09-1.13.26-.32.18-.58.41-.77.71-.2.29-.35.63-.44,1-.1.37-.14.76-.14,1.15s.05.77.14,1.15c.1.37.24.71.44,1,.2.29.46.53.77.71.32.18.69.26,1.13.26s.81-.09,1.13-.26c.32-.18.58-.41.77-.71.2-.29.35-.63.44-1,.1-.37.14-.76.14-1.15s-.05-.77-.14-1.15c-.1-.37-.24-.71-.44-1-.2-.29-.46-.53-.77-.71-.32-.18-.69-.26-1.13-.26Z"
          />
          <path
            className="st7"
            d="M-87.68,727.08h1.53l3.15,8.19h-1.54l-.77-2.17h-3.27l-.77,2.17h-1.48l3.14-8.19ZM-88.18,732.01h2.5l-1.23-3.52h-.03l-1.24,3.52Z"
          />
          <path
            className="st7"
            d="M-79.03,727.08h5.65v1.24h-4.22v2.14h3.7v1.17h-3.7v3.64h-1.43v-8.19Z"
          />
          <path
            className="st7"
            d="M-72.23,727.08h3.91c.9,0,1.58.2,2.03.58.45.39.68.93.68,1.63,0,.39-.06.71-.17.97s-.25.46-.4.62c-.15.16-.3.27-.45.34-.15.07-.26.11-.33.14v.02c.12.02.25.05.4.12.14.06.27.16.4.29.12.13.22.31.3.52.08.21.12.48.12.8,0,.48.04.92.11,1.31.07.39.19.68.34.84h-1.54c-.11-.18-.17-.37-.19-.58-.02-.21-.03-.42-.03-.62,0-.37-.02-.7-.07-.97-.05-.27-.13-.5-.25-.68s-.29-.31-.5-.4c-.21-.08-.48-.13-.81-.13h-2.11v3.37h-1.43v-8.19ZM-70.8,730.81h2.35c.46,0,.81-.11,1.04-.33.24-.22.36-.54.36-.98,0-.26-.04-.47-.11-.64-.08-.16-.18-.29-.32-.38-.13-.09-.29-.15-.46-.18s-.35-.05-.53-.05h-2.33v2.56Z"
          />
          <path
            className="st7"
            d="M-64.16,727.08h5.9v1.24h-4.46v2.14h4.13v1.17h-4.13v2.4h4.54v1.24h-5.98v-8.19Z"
          />
          <path
            className="st8"
            d="M-99.39,669.86c1.43,0,2.51.37,3.25,1.1.73.73,1.1,1.76,1.1,3.09s-.37,2.36-1.1,3.1c-.73.74-1.82,1.11-3.25,1.09h-4.33v5.8h-1.89v-14.17h6.21ZM-100.03,676.65c1.07.01,1.86-.2,2.35-.65.5-.45.74-1.1.74-1.95s-.25-1.49-.74-1.94c-.5-.44-1.28-.66-2.35-.66h-3.69v5.2h3.69Z"
          />
          <path
            className="st8"
            d="M-83.43,669.86v1.59h-7.42v4.51h6.51v1.59h-6.51v6.49h-1.89v-14.17h9.31Z"
          />
          <path
            className="st8"
            d="M-81.72,674.16c.28-.89.71-1.68,1.28-2.37.57-.69,1.28-1.24,2.12-1.65.85-.41,1.83-.62,2.96-.62s2.11.21,2.96.62c.85.41,1.55.96,2.12,1.65.57.69,1,1.48,1.28,2.37.28.89.43,1.82.43,2.79s-.14,1.9-.43,2.79c-.29.89-.71,1.68-1.28,2.37-.57.69-1.28,1.23-2.12,1.64-.85.4-1.83.61-2.96.61s-2.11-.2-2.96-.61c-.85-.4-1.56-.95-2.12-1.64-.57-.69-1-1.48-1.28-2.37-.28-.89-.43-1.82-.43-2.79s.14-1.9.43-2.79ZM-79.98,679.06c.19.69.48,1.32.87,1.88s.91,1,1.53,1.34c.62.34,1.36.51,2.22.51s1.6-.17,2.22-.51c.62-.34,1.13-.78,1.53-1.34s.69-1.18.87-1.88c.19-.69.28-1.4.28-2.11s-.09-1.42-.28-2.11c-.19-.69-.48-1.32-.87-1.88-.4-.56-.91-1-1.53-1.34-.62-.34-1.36-.51-2.22-.51s-1.6.17-2.22.51c-.62.34-1.13.78-1.53,1.34-.4.56-.69,1.18-.87,1.88s-.28,1.4-.28,2.11.09,1.42.28,2.11Z"
          />
          <path
            className="st8"
            d="M-60.33,669.86l5.54,14.17h-2.08l-1.55-4.27h-6l-1.59,4.27h-1.93l5.52-14.17h2.08ZM-59.02,678.18l-2.36-6.61h-.04l-2.4,6.61h4.8Z"
          />
          <polygon
            className="st6"
            points="-49.85 695.75 -52.06 695.75 -52.06 657.76 -108.42 657.76 -108.42 655.56 -49.85 655.56 -49.85 695.75"
          />
          <polygon
            className="st8"
            points="-55.53 698.68 -113.82 698.68 -113.82 656.66 -111.61 656.66 -111.61 696.47 -55.53 696.47 -55.53 698.68"
          />
          <path className="st1" d="M-104.12,663.25" />
          <rect
            className="st8"
            x="-109.22"
            y="676.35"
            width="54.57"
            height="2.21"
            transform="translate(-338.35 45.07) rotate(-28.97)"
          />
          <rect
            className="st5"
            x="-119.1"
            y="639.66"
            width="74.6"
            height="74.6"
          />
        </g>
      </g>
    </svg>
  );
};

export default IconBox;
